import rajasthan from "../assets/images/rajasthan.png";
import rajasthan3 from "../assets/images/rajasthan3.jpg";
import rajasthan4 from "../assets/images/rajasthan4.jpg";
import rajasthan5 from "../assets/images/rajasthan5.jpg";
import rajasthan6 from "../assets/images/rajasthan6.jpg";
import rajasthan7 from "../assets/images/rajasthan7.jpg";
import rajasthan8 from "../assets/images/rajasthan8.jpg";
import rajasthan9 from "../assets/images/rajasthan9.jpg";
import rajasthan10 from "../assets/images/rajasthan10.jpg";
import rajasthan11 from "../assets/images/rajasthan11.jpg";
import rajasthan12 from "../assets/images/rajasthan12.jpg";
import rajasthan13 from "../assets/images/rajasthan13.jpg";
import rajasthan14 from "../assets/images/rajasthan14.jpg";
import rajasthan15 from "../assets/images/rajasthan15.jpg";
import rajasthan16 from "../assets/images/rajasthan16.jpg";
// import kashmir from "../assets/images/kashmir.png";
// import manali3 from "../assets/images/manali3.png";
import forest from "../assets/images/forest.png";
import leaf from "../assets/images/leaf.png";
import coffee from "../assets/images/coffee.png";
import cream from "../assets/images/cream.png";
import bottles from "../assets/images/bottles.png";
import dodham1 from "../assets/images/dodham-1.jpg";
import dodham2 from "../assets/images/dodham-2.jpg";
import dodham3 from "../assets/images/dodham-3.jpg";
import dodham4 from "../assets/images/dodham-4.jpg";
import dodham5 from "../assets/images/dodham-5.jpg";
import udaipur from "../assets/images/udaipur.png";
import kashmir3 from "../assets/images/kashmir3.jpg";
import kashmir4 from "../assets/images/kashmir4.jpg";
import kashmir5 from "../assets/images/kashmir5.jpg";
import kashmir6 from "../assets/images/kashmir6.jpg";
import kashmir7 from "../assets/images/kashmir7.jpg";
import kashmir8 from "../assets/images/kashmir8.jpg";
import kashmir9 from "../assets/images/kashmir9.jpg";
import kashmir10 from "../assets/images/kashmir10.jpg";
import kashmir11 from "../assets/images/kashmir11.jpg";
import kashmir12 from "../assets/images/kashmir12.jpg";
import kashmir13 from "../assets/images/kashmir13.jpg";
import kashmir15 from "../assets/images/kashmir15.jpg";
import kashmir1 from "../assets/images/kashmir1.png";
// import jaipur1 from "../assets/images/jaipur1.png";
// import foundation from "../assets/images/foundation.png";
// import forest1 from "../assets/images/.png";
import europe1 from "../assets/images/europe1.jpg";
import europe2 from "../assets/images/europe2.jpg";
import europe3 from "../assets/images/europe3.jpg";
import europe4 from "../assets/images/europe4.jpg";
import europe5 from "../assets/images/europe5.jpg";
import europe6 from "../assets/images/europe6.jpg";
import europe7 from "../assets/images/europe7.jpg";
import europe8 from "../assets/images/europe8.jpg";
import europe9 from "../assets/images/europe9.jpg";
import europe10 from "../assets/images/europe10.jpg";
import europe11 from "../assets/images/europe11.jpg";
import europe12 from "../assets/images/europe12.jpg";
import europe13 from "../assets/images/europe13.jpg";
import europe14 from "../assets/images/europe14.jpg";
import europe15 from "../assets/images/europe15.jpg";
import europe16 from "../assets/images/europe16.jpg";
import europe17 from "../assets/images/europe17.jpg";
import europe18 from "../assets/images/europe18.jpg";
import europe19 from "../assets/images/europe19.jpg";
import europe20 from "../assets/images/europe20.jpg";

import andaman1 from "../assets/images/andaman-day1.jpg";
import andaman2 from "../assets/images/andaman-day2.jpg";
import andaman3 from "../assets/images/andaman-day3.jpg";
import andaman4 from "../assets/images/andaman-day4.jpg";
import andaman5 from "../assets/images/andaman-day5.jpg";
import andaman6 from "../assets/images/andaman-day6.webp";
import andaman7 from "../assets/images/andaman-day7.jpg";
// import andaman8 from "../assets/images/andaman8.jpg";

import assam1 from "../assets/images/day-1.jpg";
import assam2 from "../assets/images/day-2.jpg";
import assam3 from "../assets/images/day-3.jpg";
import assam4 from "../assets/images/day-4.jpg";
import assam5 from "../assets/images/day-5.jpg";
import assam6 from "../assets/images/day-6.jpg";

import chardham1 from "../assets/images/chardham-1.jpg";
import chardham2 from "../assets/images/chardham-2.jpg";
import chardham3 from "../assets/images/chardham-3.jpg";
import chardham4 from "../assets/images/chardham-4.jpg";
import chardham5 from "../assets/images/chardham-5.jpg";
import chardham6 from "../assets/images/chardham-6.jpg";
import chardham7 from "../assets/images/chardham-7.jpg";
import chardham8 from "../assets/images/chardham-8.jpg";
import chardham9 from "../assets/images/chardham-9.jpg";
import chardham10 from "../assets/images/chardham-10.jpg";
import chardham11 from "../assets/images/chardham-11.jpg";
import chardham12 from "../assets/images/chardham-12.jpg";

import golden1 from "../assets/images/goldenTriangle1.jpg";
import golden2 from "../assets/images/goldenTriangle2.jpg";
import golden3 from "../assets/images/goldenTriangle3.jpg";
import golden4 from "../assets/images/goldenTriangle4.jpg";
import golden5 from "../assets/images/goldenTriangle5.jpg";
import golden6 from "../assets/images/goldenTriangle6.jpg";

import gujarat1 from "../assets/images/gujarat1.jpg";
import gujarat2 from "../assets/images/gujarat2.jpg";
import gujarat3 from "../assets/images/gujarat3.jpg";
import gujarat4 from "../assets/images/gujarat4.jpg";
import gujarat5 from "../assets/images/gujarat5.jpg";

import himachal1 from "../assets/images/himachal1.jpg";
import himachal2 from "../assets/images/himachal2.jpg";
import himachal3 from "../assets/images/himachal3.jpg";
import himachal4 from "../assets/images/himachal4.jpg";
import himachal5 from "../assets/images/himachal5.jpg";
import himachal6 from "../assets/images/himachal6.jpg";
import manali1 from "../assets/images/manali1.jpg";
import manali2 from "../assets/images/manali2.jpg";
import manali3 from "../assets/images/manali3.jpg";
import manali4 from "../assets/images/manali4.jpg";
import manali5 from "../assets/images/manali5.jpg";

import himachall1 from "../assets/images/himachal-1.jpg";
import himachall2 from "../assets/images/himachal-2.jpg";
import himachall3 from "../assets/images/himachal-3.jpg";
import himachall5 from "../assets/images/himachal-5.jpg";
import himachall6 from "../assets/images/himachal-6.jpg";
import himachall7 from "../assets/images/himachal-7.jpg";
import himachall8 from "../assets/images/himachal-8.jpg";

import zurich1 from "../assets/images/zurich1.jpg";
import zurich2 from "../assets/images/zurich2.jpg";
import zurich3 from "../assets/images/zurich3.jpg";
import zurich4 from "../assets/images/zurich4.jpg";
import zurich5 from "../assets/images/zurich5.jpg";
import zurich6 from "../assets/images/zurich6.jpg";
import zurich7 from "../assets/images/zurich7.jpg";



export const tours = [

  //================================ Rajasthan =======================================

  {
    title: "Rajasthan Heritage Tour",
    slug: "rajasthan-heritage-tour",
    category: "Domestic",
    price: "₹36,750",
    days: "9 Days / 8 Nights",
    rating: "4.9",
    image: rajasthan6,
    location: "Jaipur, Pushkar, Ajmer, Udaipur, Jaisalmer, Jodhpur",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 State, 6 Cities",
        places: "Jaipur, Pushkar, Ajmer, Udaipur, Jaisalmer, Jodhpur",
      },

      pills: [
        "MAP Plan",
        "Breakfast Included",
        "Dinner Included",
      ],

      highlights: [
        "Nahargarh Fort",
        "Amer Fort",
        "Jaigarh Fort",
        "Albert Museum",
        "Hawa Mahal",
        "City Palace Jaipur",
        "Jantar Mantar",
        "Jal Mahal",
        "Brahma Temple",
        "Ajmer Dargah",
        "Fateh Sagar Lake",
        "City Palace Udaipur",
        "Jaisalmer Fort",
        "Sam Sand Dunes",
        "Mehrangarh Fort",
        "Umaid Bhawan Palace",
      ],

      experiences: [
        {
          title: "Jaipur Heritage",
          desc: "Visit Nahargarh Fort, Amer Fort, Jaigarh Fort, City Palace, Jantar Mantar and Jal Mahal.",
        },
        {
          title: "Pushkar & Ajmer",
          desc: "Visit Brahma Temple, Brahma Sarovar and Ajmer Dargah.",
        },
        {
          title: "Desert Experience",
          desc: "Enjoy Camel Ride and Folk Dance at Sam Sand Dunes.",
        },
        {
          title: "Royal Rajasthan",
          desc: "Explore Udaipur, Jaisalmer and Jodhpur.",
        },
      ],
    },
    itinerary: [
      {
        day: "01",
        title: "Jaipur Arrival – Local Sightseeing",
        desc: `Arrival at Jaipur Airport, transfer to hotel, check in hotel and proceed for beautiful Pink City Nahargarh Fort, Amer Fort, Jaigarh Fort and Market in the evening, back to hotel, stay at Jaipur.`,
      },

      {
        day: "02",
        title: "Jaipur Local Sightseeing",
        desc: `After breakfast, visit Albert Museum, Hawa Mahal (a picture stop), City Palace, Jantar Mantar, The Jal Mahal and the rest of the day is free to explore this vibrant and colourful city. Overnight stay at Jaipur.`,
      },

      {
        day: "03",
        title: "Jaipur – Pushkar – Ajmer",
        desc: `After breakfast, proceed for Pushkar visit - Brahma Temple and Brahma Sarovar and then Ajmer, visit Dargah and then check in hotel. Overnight stay at Ajmer.

Distance: 140 Kms / 3 Hours`,
      },

      {
        day: "04",
        title: "Ajmer – Udaipur",
        desc: `After breakfast, check out from hotel and proceed for Udaipur.

On arrival check in at hotel and visit Fateh Sagar Lake.

Overnight stay at Udaipur.

Distance: 280 Kms / 6 Hours`,
      },

      {
        day: "05",
        title: "Udaipur Local Sightseeing",
        desc: `After breakfast start for Udaipur city tour.

Visiting Maharana Pratap Memorial, take a photo stop at Nehru Garden, Sehelion-KI-Bari - Queen’s resort for their friends, Bhartiya Lok Kala Museum - a museum of folk and art, it displays a rich collection of folk dresses, ornaments, puppets, masks and dolls.

After that visit City Palace – The largest palace complex of Rajasthan, Vintage Car Museum and Gulab Bagh.

Overnight stay at Udaipur.`,
      },

      {
        day: "06",
        title: "Udaipur – Jaisalmer",
        desc: `Today, proceed to Jaisalmer - The Golden City, for around full day drive and on arrival check-in to your hotel.

Overnight stay at Jaisalmer.

Distance: 570 Kms / 10 Hours`,
      },

      {
        day: "07",
        title: "Jaisalmer Local Sightseeing",
        desc: `After breakfast visit Gadishar Lake & Folk Lore Museum.

(In Folk Lore Museum you can see famous Rajasthani Puppet Show at your own cost.)

Visit Jaisalmer Fort which is made by unique Golden Lime Stone, that’s why it is known as Golden Fort.

Later proceed to Sam Sand Dunes for around 1 hour drive and check in at camps.

Enjoy Camel Ride and Folk Dance in camp premises.

Dinner and Overnight stay at Jaisalmer Camps.`,
      },

      {
        day: "08",
        title: "Jaisalmer – Jodhpur",
        desc: `After breakfast transfer to Jodhpur for around 5 to 6 hours.

Visit half day sightseeing covering Mehrangarh Fort and Jaswant Thada.

Check in hotel and overnight stay at Jodhpur.

Distance: 280 Kms / 6 Hours`,
      },

      {
        day: "09",
        title: "Jodhpur Departure",
        desc: `After breakfast, visit Umaid Bhawan Palace and then drop at Jodhpur for onward journey.

End of tour with Happy Memory.`,
      },
    ],

    pointsToRemember: [
      "All Rates & Bookings Subject to Availability.",
      "Rates are Subject to Change Without Prior Notice.",
    ],

    inclusions: {
      included: [
        "MAP Plan (8 Breakfast + 8 Dinner)",
        "Rooms: 1 / 2 / 3 / 4 / 5",
        "Transportation as per Package",
        "Sedan - 2 & 4 Pax",
        "Crysta - 6 Pax",
        "Tempo - 12 Seater - 8/10 Pax",
        "All Sightseeing as per Package (Itinerary)",
        "Toll Tax",
        "Parking",
        "State Tax",
        "Driver Allowance",
        "All Taxes",
        "Pick & Drop - Delhi",
      ],

      excluded: [
        "Airfare",
        "Train Fare",
        "Activities",
        "Heater Charges",
        "Expenses of Personal Nature",
        "Tips",
        "Telephone Calls",
        "Laundry",
        "Liquor",
        "Guide Charges",
        "Entrance Fees During Sightseeing",
        "Any Other Item Not Specified in Includes",
      ],
    },

    pricing: {
      rows: [
        {
          category: "3 Star",
          price: "₹36,750",
          unit: "per person",
        },
      ],
      note: "PACKAGE TYPE (SEASON RATE) - MIN. (Per Person Rates)",
    },

    terms: [
      "All Rates & Bookings Subject to Availability.",
      "Rates are Subject to Change Without Prior Notice.",
    ],

    images: [
      rajasthan3,
      rajasthan4,
      rajasthan5,
      rajasthan6,
      rajasthan7,
      rajasthan8,
      rajasthan9,
      rajasthan10,
      rajasthan11,
      rajasthan12,
      rajasthan13,
      rajasthan14,
      rajasthan15,
      rajasthan16,
    ],
  },

  {
    /* ================= KASHMIR ================= */
    title: "Kashmir Valley Escape",
    slug: "kashmir-valley-escape",
    category: "Domestic",
    price: "On Request",
    days: "7 Days / 6 Nights",
    rating: "4.9",
    image: kashmir3,
    location: "Kashmir, India",
    nextDate: "February 10, 2025",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 8 Locations",
        places: "Srinagar, Gulmarg, Pahalgam",
      },
      pills: ["Breakfast Included", "Houseboat Stay", "Local Guide"],
      highlights: [
        "Dal Lake Shikara Ride",
        "Gulmarg Gondola",
        "Mughal Gardens",
        "Pahalgam Valley",
      ],
      experiences: [
        {
          title: "Shikara Ride",
          desc: "Peaceful Shikara ride on Dal Lake.",
        },
        {
          title: "Snow Activities",
          desc: "Snow fun and skiing experience in Gulmarg.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Srinagar",
        desc: "Arrival at Srinagar airport and transfer to hotel/houseboat.",
        tags: ["Dinner"],
      },
      {
        day: "02",
        title: "Srinagar – Gulmarg",
      },
    ],

    pointsToRemember: [
      "Houseboat stay",
      "Shikara ride",
      "Daily breakfast",
    ],

    inclusions: {
      included: [
        "Airport transfers",
        "Hotel stay",
        "Breakfast & Dinner",
      ],
      excluded: [
        "Airfare",
        "Personal expenses",
      ],
    },

    // pricing: {
    //   rows: [
    //     { category: "Single", price: "₹28,999", unit: "per head" },
    //     { category: "Couple", price: "₹25,999", unit: "per head" },
    //   ],
    //   note: "Prices may vary during peak snowfall season.",
    // },


    pricing: {
      rows: [{ category: "Standard", price: "On Request", unit: "per person" }],
      note: "Seasonal pricing."
    },

    terms: [
      "Weather conditions may affect sightseeing.",
      "Snow activities depend on local conditions.",
      "Houseboat allocation is subject to availability.",
      "Guests must carry valid ID proof.",
    ],

    images: [kashmir3, kashmir4, kashmir5, kashmir15, kashmir6, kashmir7, kashmir8, kashmir9, kashmir10, kashmir11, kashmir12, kashmir13,],
  },


  //--------------------------------------- Himachal -----------------------------------

  {
    title: "3 Manali / 2 Shimla",
    slug: "himachal-5nights-6days-package",
    price: "₹28,900",
    days: "05 Nights / 06 Days",
    rating: "4.9",
    image: himachal1,
    location: "Manali, Shimla",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations Covered",
        places: "Manali, Shimla",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Hadimba Temple",
        "Manu Temple",
        "Solang Valley",
        "Atal Tunnel",
        "Rohtang Pass",
        "Kufri",
        "The Mall Shimla",
        "Christ Church",
      ],

      experiences: [
        {
          title: "Manali & Shimla Hill Getaway",
          desc: "A scenic Himachal escape covering Manali's valleys and passes along with Shimla's colonial charm and panoramic views.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Delhi to Manali (520 Kms)",
        desc: `Pick up from Delhi Airport/Railways station drive to Manali.

Overnight hotel.`,
      },

      {
        day: "02",
        title: "Manali",
        desc: `After breakfast, sightseeing of places in and around Manali, Like Hadimba temple, Manu temple By walk, Van Vihar, Club House and evening shopping at the local market.

Overnight hotel.`,
      },

      {
        day: "03",
        title: "Manali",
        desc: `After breakfast excursion to Solang Valley & Attal tunnel till North pole and back to Hotel Overnight hotel.

OR

Excursion to Rohtang Pass till snow point (Excursion to Rohtang Pass (Guest Own on direct payment & Subject to Permit). Situated at an altitude of 3979 mtrs above sea level and 51 kms outside Manali is the mighty Rohtang Pass - the gateway to Lahaul-Spiti valley. It affords a wide panoramic view of the mountains. Here one sees the majesty of the mountains at its height and splendour. At the top of the pass the air seems to glitter against the snow as you look down over herringboned ridges into the Lahaul valley. Evening at Leisure. Overnight hotel.

Note: Rohtang Pass Closed from Nov to May Month due to snow`,
      },

      {
        day: "04",
        title: "Manali to Shimla",
        desc: `After breakfast check out from the hotel a distance of 265 km 8 hrs. On the way visit Sunder Nagar, Pandoh Dam, Kullu Valley.

Overnight hotel.`,
      },

      {
        day: "05",
        title: "Shimla",
        desc: `After Breakfast Excursion to Kufri. Kufri is famous for its Himalayan National Park, Poney and Yak Ride and One can see the endless Himalayan Panorama from Kufri, after lunch sightseeing of various places in and around.

Shimla mosques built in (1830), Vice regal Lodge built in (1885), Christ Church built in (1844), The Gaiety Theatre- the first beauty contest of world was supposed to start (1887), The Grindlays Bank (1912)- the world wide bank started by Robert Melville Grindlay, The Scandal Point and The famous Shopping Plaza of the North The Mall.

Overnight hotel.`,
      },

      {
        day: "06",
        title: "Shimla to Delhi Drop",
        desc: `After Breakfast check out from hotel drive to Delhi and drop at railways Station / Airport`,
      },
    ],

    pointsToRemember: [
      "Rohtang Pass Closed from Nov to May Month due to snow.",
      "Excursion to Rohtang Pass is Guest Own on direct payment & Subject to Permit.",
      "A/c not working in hilly area.",
    ],

    hotels: [
      {
        destination: "Manali",
        options: "Snow Peak Retreat / Manali Grand / Holidays Resort N Cottage",
        category: "S. Deluxe Room",
      },
      {
        destination: "Shimla",
        options: "Snow Lotus / Sukh Sagar Regency (Pure Veg)",
        category: "S. Deluxe Room / Deluxe Room",
      },
    ],

    inclusions: {
      included: [
        "Transportation by Tempo 12-Seater for the entire tour. A/c not working in hilly area.",
        "All sightseeing and excursions as per the itinerary.",
        "GST @5%.",
        "Mentioned or similar hotels as per the meal Plan.",
        "Child of the age of below 5 Years complimentary without extra bed.",
      ],

      excluded: [
        "Personal expenses of any nature.",
        "Train/Air fare.",
        "Guide.",
        "Entry Charges.",
        "Heater Charges.",
        "Unforeseen Expenses because of the weather conditions.",
        "Excursion to Rohtang Pass (Guest Own on direct payment & Subject to Permit).",
        "Any up gradation in Airline class or hotel room category.",
        "Cost of Insurance.",
        "Any extra expense such as route change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeure circumstances during the tour.",
        "Any services or activity charges other than those included in the tour itinerary/ Holiday Package Offer.",
      ],
    },

    pricing: {
      rows: [
        {
          category: "Standard (MAP)",
          price: "₹28,900",
          unit: "per person",
        },
      ],
      note: "Cost Per Person Meal Plan: 28,900/- MAP",
    },

    images: [
      himachal1,
      himachal2,
      himachal3,
      himachal4,
      himachal5,
      himachal6,
      manali1,
      manali2,
      manali3,
      manali4,
      manali5,
    ],
  },


  //--------------------------------------- Himachal 6N/7D -----------------------------------

  {
    title: "Exciting Himachal",
    slug: "himachal-6nights-7days-package",
    category: "Domestic",
    price: "₹42,000",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: himachall1,
    location: "Shimla, Manali, Kasol",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations Covered",
        places: "Shimla, Manali, Kasol",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Kufri",
        "The Mall Shimla",
        "Christ Church",
        "Vaishno Devi Temple",
        "Solang Valley",
        "Atal Tunnel",
        "Rohtang Pass",
        "Kasol",
      ],

      experiences: [
        {
          title: "Exciting Himachal Getaway",
          desc: "A scenic Himachal journey covering Shimla's colonial charm, Manali's valleys and passes, and the laid-back beauty of Kasol.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Delhi to Shimla",
        desc: `Pick up from Delhi airport /railway station and drive to Shimla.

O/N Hotel`,
      },

      {
        day: "02",
        title: "Shimla",
        desc: `After Breakfast Excursion to Kufri. Kufri is famous for its Himalayan National Park, Poney and Yak Ride and One can see the endless Himalayan Panorama from Kufri, after lunch sightseeing of various places in and around.

Shimla mosques built in (1830), Vice regal Lodge built in (1885), Christ Church built in (1844), The Gaiety Theatre- the first beauty contest of world was supposed to start (1887), The Grindlays Bank (1912)- the world wide bank started by Robert Melville Grindlay, The Scandal Point and The famous Shopping Plaza of the North The Mall.

O/N Hotel`,
      },

      {
        day: "03",
        title: "Shimla to Manali",
        desc: `After breakfast check out from the hotel a distance of 265 km 8 hrs. on the way visit Sunder Nagar, Vaishno Devi temple, Kullu Valley,

O/N Hotel`,
      },

      {
        day: "04",
        title: "Manali",
        desc: `After breakfast excursion to Solang Valley & Attal Tunnel till north pole and back to Hotel O/N Hotel.

OR

Excursion to Rohatang Pass till snow point (Excursion to Rohtang Pass (Guest Own on direct payment & Subject to Permit). Situated at an altitude of 3979 mtrs above sea level and 51 kms outside Manali is the mighty Rohtang Pass - the gateway to Lahaul-Spiti valley. It affords a wide panoramic view of the mountains. Here one sees the majesty of the mountains at its height and splendour. At the top of the pass the air seems to glitter against the snow as you look down over herringboned ridges into the Lahaul valley. Evening at Leisure. O/N Hotel (Closed on Tuesday)

Note: Rohtang Pass Closed from Nov to May Month due to snow`,
      },

      {
        day: "05",
        title: "Manali to Kasol",
        desc: `After Breakfast check out from hotel drive to Kasol.

O/N hotel`,
      },

      {
        day: "06",
        title: "Kasol",
        desc: `Excursion to Kullu and Kasol.

O/N hotel`,
      },

      {
        day: "07",
        title: "Kasol to Delhi Drop",
        desc: ``,
      },
    ],

    pointsToRemember: [
      "Rohtang Pass Closed from Nov to May Month due to snow.",
      "Rohtang Pass Excursion Closed on Tuesday.",
      "A/c not working in Hilly Area.",
    ],

    hotels: [
      {
        destination: "Shimla",
        options: "Hotel Snow Lotus",
        category: "4 Star",
      },
      {
        destination: "Manali",
        options: "Hotel Ashapuri Residency",
        category: "4 Star",
      },
      {
        destination: "Kasol",
        options: "Kovid Camp",
        category: "4 Star",
      },
    ],

    vehicle: "Sedan car used",

    inclusions: {
      included: [
        "Transportation by Sedan for the Entire Tour. A/c not working in Hilly Area.",
        "All sightseeing and excursions as per the itinerary.",
        "Mentioned or similar hotels on as per the meal Plan.",
        "Child of the age of below 5 Years complimentary without extra bed.",
      ],

      excluded: [
        "GST @ 5%.",
        "Personal expenses of any nature.",
        "Train/Air fare.",
        "Guide.",
        "Entry Charges.",
        "Heater Charges.",
        "Unforeseen Expenses because of the weather conditions.",
        "Excursion to Rohtang Pass (Guest Own on direct payment & Subject to Permit).",
        "Any up gradation in Airline class or hotel room category.",
        "Cost of Insurance.",
        "Any extra expense such as route change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeure circumstances during the tour.",
        "Any services or activity charges other than those included in the tour itinerary/ Holiday Package Offer.",
      ],
    },

    pricing: {
      rows: [
        {
          category: "4 Star (Sedan)",
          price: "₹42,000",
          unit: "per person",
        },
      ],
      note: "RS.42000 PER PERSON",
    },

    images: [
      himachall1,
      himachall2,
      himachall3,
      himachall5,
      himachall6,
      himachall7,
      himachall8,
    ],
  },




  {
    title: "European Wonders – 09 Days",
    slug: "european-wonders-09-days",
    price: "On Request",
    days: "9 Days / 8 Nights",
    rating: "4.8",
    image: europe2,
    location: "France, Switzerland & Italy",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Countries, 6 Cities, 8 Nights",
        places: "Paris, Lucerne, Interlaken, Venice, Florence, Rome",
      },
      pills: [
        "Daily Breakfast",
        "Jungfraujoch Excursion",
        "Eiffel Tower",
        "Gondola Ride",
        "Colosseum Visit"
      ],
      highlights: [
        "Jungfraujoch – Top of Europe",
        "Eiffel Tower",
        "Venice Canals",
        "Florence Duomo",
        "Roman Colosseum"
      ],
      experiences: [
        {
          title: "Swiss Glacier Adventure",
          desc: "Journey to Jungfraujoch, Europe’s highest railway station."
        },
        {
          title: "Historic Rome",
          desc: "Explore Colosseum and Vatican area."
        }
      ],
    },

    itinerary: [
      { day: "01", title: "Arrive Paris", desc: "Arrival and leisure." },
      { day: "02", title: "Paris City Tour", desc: "Eiffel Tower visit and sightseeing." },
      { day: "03", title: "Paris – Lucerne", desc: "Train to Lucerne." },
      { day: "04", title: "Jungfraujoch Excursion", desc: "Full-day Swiss Alps excursion." },
      { day: "05", title: "Lucerne – Venice", desc: "Travel to Venice." },
      { day: "06", title: "Venice", desc: "Explore canals and St. Mark’s Square." },
      { day: "07", title: "Venice – Florence", desc: "Discover Renaissance Florence." },
      { day: "08", title: "Florence – Rome", desc: "Visit Rome landmarks." },
      { day: "09", title: "Depart Rome", desc: "Departure transfer." }
    ],

    pointsToRemember: [
      "Seat-in-coach city tours.",
      "Optional tours extra."
    ],

    inclusions: {
      included: [
        "08 nights accommodation",
        "Daily breakfast",
        "Jungfraujoch excursion",
        "City tours"
      ],
      excluded: [
        "Airfare",
        "Visa",
        "Travel insurance"
      ],
    },

    // pricing: {
    //   rows: [{ category: "Standard", price: "On Request", unit: "per person" }],
    //   note: "Rates vary by travel season."
    // },


    pricing: {
      rows: [{ category: "Standard", price: "On Request", unit: "per person" }],
      note: "Seasonal pricing."
    },


    terms: [
      "Subject to availability."
    ],

    images: [europe1, europe2, europe3, europe4, europe5, europe6, europe7, europe8, europe9, europe10, europe11, europe12, europe13, europe14, europe15, europe16, europe17, europe18, europe19, europe20],
  },


  //--------------------------------------- Chardham -----------------------------------



  {
    title: "Chardham",
    slug: "chardham-package",
    category: "Domestic",
    price: "₹62,000",
    days: "12 Days / 11 Nights",
    rating: "4.9",
    image: chardham1,
    location: "Haridwar, Barkot, Uttarkashi, Guptkashi, Kedarnath, Badrinath, Rudraprayag, Rishikesh",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4 Dhams, 8 Destinations",
        places:
          "Haridwar, Barkot, Uttarkashi, Guptkashi, Kedarnath, Badrinath, Rudraprayag, Rishikesh",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Har Ki Pauri",
        "Yamunotri Temple",
        "Gangotri Temple",
        "Kedarnath Temple",
        "Badrinath Temple",
        "Mana Village",
        "Vishnu Prayag",
        "Triveni Ghat",
      ],

      experiences: [
        {
          title: "Char Dham Pilgrimage",
          desc: "Visit all four sacred dhams of Uttarakhand.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Start from Delhi to Haridwar",
        desc: `Upon arrival at the airport, you will be greeted and assisted with your transfer to Haridwar, a sacred city nestled on the banks of the holy Ganges. The drive offers a blend of serene countryside views and glimpses of small towns rich in culture and tradition.

Upon reaching Haridwar, check into your hotel and take some time to freshen up. In the evening, immerse yourself in the spiritual ambiance as you witness the mesmerizing Ganga Aarti at Har Ki Pauri, where oil lamps and chants illuminate the riverbanks.

Return to your hotel for a delightful dinner, reflecting on the spiritual journey ahead.

Haridwar, one of the seven holiest cities in India, is a gateway to spirituality and nature's tranquility. Known for its sacred ghats, ancient temples, and vibrant markets, the city attracts pilgrims and tourists alike.

Key attractions include Har Ki Pauri, Mansa Devi Temple, and Bharat Mata Mandir. The city is also a hub for yoga and wellness retreats. Additionally, Haridwar's proximity to destinations like Rishikesh and Rajaji National Park provides opportunities for day excursions, blending spirituality, adventure, and nature in one memorable trip.

Distance: 235 Kms : 5-6 Hours`,
      },

      {
        day: "02",
        title: "Haridwar to Barkot",
        desc: `Start your day with a hearty breakfast at your hotel in Haridwar, then check out and begin your journey towards Barkot.

The route will take you to beautiful views of the hills and valleys of Garhwal region. After a relaxing drive, you will arrive in Barkot, passing through small towns and villages, making it an enjoyable journey.

Upon arrival in Barkot, check into your hotel, relax, and enjoy a delightful dinner.

Take some time to unwind at the hotel, preparing for an early start the next day as you'll begin your trek to Yamunotri, one of the Char Dham destinations.

A restful evening will ensure you're well-rested for the adventure ahead.

Important Note: During the heavy traffic season traffic is diverted to Vikasnagar Route which is just little longer compared to Mussoorie route. Mussoorie visit depends on Traffic situation.`,
      },

      {
        day: "03",
        title: "Barkot to Yamunotri Visit & Return",
        desc: `Start your day early with a packed breakfast from your hotel in Barkot as you prepare for the journey to Yamunotri.

Our vehicle will take you to Janki Chatti, the starting point of the trek.

Begin your 6 km trek through picturesque trails surrounded by lush forests and towering mountains.

Upon reaching Yamunotri, visit Suryakund, for bath in a natural hot spring known for its hot water.

After visiting Suryakund, proceed to the sacred Yamunotri Temple, dedicated to Goddess Yamuna.

Offer your prayers and take in the spiritual ambiance of this revered site, one of the Char Dham destinations.

Here, devotees often cook rice tied in muslin cloth as an offering to the goddess. This cooked rice, considered prasad, is taken home by pilgrims as a blessing.

After spending quality time at the temple, begin your return trek to Janki Chatti.

Visit Shani Dev Temple at Kharsali (Winter Seat of Yamunotri).

Drive back to Barkot, where you can unwind, enjoy dinner, and relax at your hotel, concluding a spiritually enriching day.`,
      },

      {
        day: "04",
        title: "Barkot to Uttarkashi",
        desc: `Today you can start your day relaxed to get your body relaxed from trek yesterday.

Have a breakfast at your hotel in Barkot, then check out and begin your journey towards Uttarkashi, approximately 85 km away (4–5 hours drive).

En route, visit the serene Shivgufa, a natural cave temple dedicated to Lord Shiva, known for its tranquil ambiance and spiritual significance.

After offering prayers, continue your scenic drive through the lush valleys and winding roads of Uttarakhand.

Upon reaching Uttarkashi, visit the sacred Vishwanath Temple, dedicated to Lord Shiva, a key spiritual landmark in the town.

Nearby, explore the Shakti Temple, famous for its giant trishul (trident), which is believed to hold mythological significance.

After the visits, check into your hotel in Uttarkashi, relax, and enjoy a delicious dinner.

Rest overnight, preparing for the next day's exploration.`,
      },

      {
        day: "05",
        title: "Uttarkashi to Gangotri visit",
        desc: `Start your day with a wholesome breakfast at your hotel in Uttarkashi before heading towards Gangotri.

En route, stop at Gangnani Hot Springs, a serene spot where pilgrims often take a dip in the natural hot water as a ritual cleansing before proceeding to Gangotri.

Continue your journey along the scenic route that follows the course of the Bhagirathi River, offering stunning views of the Himalayas.

On reaching Gangotri, visit the sacred Gangotri Temple, dedicated to Goddess Ganga, the origin of the holy river.

Offer prayers and soak in the spiritual ambiance of this revered site.

While returning to Uttarkashi, take a break at Harsil, a picturesque hamlet known for its apple orchards and serene surroundings.

Enjoy the tranquility before heading back to your hotel in Uttarkashi.

End the day with a delicious dinner and relax with an overnight stay, preparing for the next leg of your journey.`,
      },

      {
        day: "06",
        title: "Uttarkashi to Guptkashi",
        desc: `Start your day with breakfast at your hotel in Uttarkashi and check out for your journey to Guptkashi, a town known for its religious significance and breathtaking views of the Himalayas.

The drive takes you through winding mountain roads, dense forests, and picturesque valleys, offering stunning views of the surrounding landscape.

En route, you may stop at places like the famous town of Rudraprayag, where the Alaknanda and Mandakini rivers meet, a serene and spiritual spot.

Upon arrival in Guptkashi, check in to your hotel and take some time to relax.

You can visit the ancient Kashi Vishwanath Temple or explore the beautiful surroundings of the town.

Dinner and an overnight stay at the hotel.`,
      },

      {
        day: "07",
        title: "Guptkashi to Kedarnath (Trekking)",
        desc: `Before sunrise, guests should pick up their packed breakfast from the hotel (Inform the hotel previous day regarding packed breakfast), then check out and start the journey from Guptkashi to Kedarnath.

Drive to Sonprayag. Here, guests will transfer to a local jeep (available at an additional cost of INR 50-100 per seat) that will take them to Gaurikund, the starting point for the Kedarnath trek.

The trek from Gaurikund to Kedarnath spans approximately 20 kilometers.

Guests have the option to complete the trek on foot or by hiring a horse (also at an additional cost).

The route offers stunning mountain views, dense forests, and spiritual ambiance as they ascend to Kedarnath, one of the most revered pilgrimage sites in India.

Upon reaching Kedarnath, guests can check in to their accommodation, freshen up, and later proceed to visit the Kedarnath Temple.

Dedicated to Lord Shiva, the temple stands amidst the majestic Himalayas at an altitude of 3,583 meters.

Believed to be one of the twelve Jyotirlingas, the temple’s ancient stone structure and spiritual energy make it a powerful and transformative experience for pilgrims.

In the evening, guests can return to their accommodation for a warm dinner and an overnight stay in Kedarnath, surrounded by the tranquility of the sacred peaks.

Important Note: Carry warm cloths, shawl and towels for Kedarnath as temperature can go down very low at night.

Hotels are very basic at Kedarnath.

Pooja Booking Online: badrinath-kedarnath.gov.in

Official Helicopter Booking Link: heliyatra.irctc.co.in

(All other websites which offer instant heli tickets of Kedarnath are fake).`,
      },

      {
        day: "08",
        title: "Kedarnath to Guptkashi (Trekking)",
        desc: `Begin the day with an early morning visit to the Kedarnath Temple to experience the morning Darshan of this sacred place.

After spending time at the temple, return to the hotel for breakfast, then check out and prepare for the trek back down to Gaurikund.

The descent from Kedarnath to Gaurikund covers a distance of around 20 kilometers, which guests can choose to complete either on foot or by hiring a horse (at their own cost).

Along the way, they can enjoy breathtaking views of the mountains and forests that characterize this holy route.

Upon reaching Gaurikund, guests can take a local jeep (for an additional cost) to travel to Sonprayag, where you will meet your vehicle for the transfer back to Guptkashi.

Once you arrive in Guptkashi, guests can check in to the hotel and relax after the day's journey.

Dinner will be served at the hotel, followed by a comfortable overnight stay in the peaceful surroundings of Guptkashi, offering a chance to rest and reflect on the Kedarnath pilgrimage experience.`,
      },

      {
        day: "09",
        title: "Guptkashi to Badrinath",
        desc: `Begin your day with a hearty breakfast at the hotel and check out.

Embark on a picturesque drive to Badrinath, with a stop at Vishnu Prayag, where the Alaknanda and Dhauliganga rivers meet, creating a serene confluence amidst the majestic Himalayan landscapes.

Upon reaching Badrinath, check in to your hotel and later proceed to visit the Badrinath Temple, one of the Char Dhams and a revered pilgrimage site dedicated to Lord Vishnu.

Nestled between the Nar and Narayan mountain ranges, this temple is known for its striking architecture and spiritual significance, attracting devotees from around the world.

After seeking blessings and soaking in the temple's divine atmosphere, return to your hotel for dinner and an overnight stay in Badrinath.`,
      },

      {
        day: "10",
        title: "Badrinath to Rudraprayag",
        desc: `Begin your day with an early morning visit to the Badrinath Temple, a sacred site dedicated to Lord Vishnu, nestled amidst breathtaking Himalayan peaks.

Experience the serenity of the temple and seek divine blessings before returning to the hotel for breakfast.

After breakfast, check out from the hotel and proceed to explore the charming Mana Village, the last Indian village near the Tibet border.

Visit the Saraswati River, revered for its mythological significance, and the ancient Vyas Gufa, a cave where Sage Vyas is believed to have composed the Mahabharata. (This involves a 2-km trek one way.)

Post sightseeing, drive towards Rudraprayag.

En route, make stops at Karnaprayag, the confluence of the Alaknanda and Pindar rivers, and Nandprayag, where the Alaknanda meets the Nandakini River, both offering stunning views of nature and spiritual ambiance.

Upon arrival in Rudraprayag, check in to your hotel.

Enjoy a hearty dinner and relax with an overnight stay at the hotel.`,
      },

      {
        day: "11",
        title: "Rudraprayag to Rishikesh",
        desc: `Start your day with a delicious breakfast at your hotel in Rudraprayag and check out.

Begin your scenic drive to Rishikesh, a spiritual town nestled along the banks of the Ganges River, known for its ashrams, temples, and adventure activities.

As you travel, enjoy the picturesque route through winding mountain roads, serene riverside views, and lush green landscapes.

Upon arrival in Rishikesh, check in at your hotel and relax.

In the evening, you can visit the iconic Triveni Ghat to witness the mesmerizing Ganga Aarti, or explore the famous Laxman Jhula, a suspension bridge offering stunning views of the river and surrounding mountains.

End your day with a warm dinner at your hotel and enjoy a peaceful overnight stay in Rishikesh, surrounded by the spiritual ambiance and natural beauty of the area.`,
      },

      {
        day: "12",
        title: "Rishikesh to Dehradun Airport Drop",
        desc: `Start your day with a hearty breakfast at your hotel in Rishikesh, then check out and begin your journey towards Dehradun.

Enjoy the scenic drive as you bid farewell to the serene ambiance of Rishikesh and head towards the airport.

Upon arrival at Dehradun Airport, proceed with your onward journey, carrying cherished memories of your trip.`,
      },
    ],

    pointsToRemember: [
      "Mussoorie visit depends on traffic situation.",
      "Carry warm cloths, shawl and towels for Kedarnath as temperature can go down very low at night.",
      "Hotels are very basic at Kedarnath.",
      "Pooja Booking Online: badrinath-kedarnath.gov.in",
      "Official Helicopter Booking Link: heliyatra.irctc.co.in",
      "All other websites which offer instant heli tickets of Kedarnath are fake.",
    ],

    inclusions: {
      included: [
        "Stay as per the above mentioned hotels.",
        "Meals as mentioned above.",
        "Transfer and sightseeing as per itinerary & Vehicle mentioned above (AC in non hill areas only.)",
        "All toll tax, inter state tax, parking, fuel and driver allowances.",
      ],

      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "Standard",
          price: "₹62,000",
          unit: "per person",
        },
      ],
      note: "TOUR COST RS.62000 PER PERSON APPX",
    },

    images: [
      chardham1,
      chardham2,
      chardham3,
      chardham4,
      chardham5,
      chardham6,
      chardham7,
      chardham8,
      chardham9,
      chardham10,
      chardham11,
      chardham12,
    ],
  },

  

  {
    title: "Kedarnath",
    slug: "kedarnath-package",
    category: "Domestic",
    price: "₹26,200",
    days: "5 Days / 4 Nights",
    rating: "4.9",
    image: dodham1,
    location: "Guptkashi, Kedarnath, Rishikesh",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Dham, 3 Destinations",
        places: "Guptkashi, Kedarnath, Rishikesh",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Dhari Devi Temple",
        "Devprayag",
        "Kedarnath Temple",
        "Sonprayag",
        "Gaurikund",
        "Triveni Ghat",
        "Ganga Aarti",
      ],

      experiences: [
        {
          title: "Kedarnath Yatra",
          desc: "Sacred trek to Kedarnath Temple.",
        },
        {
          title: "Devprayag",
          desc: "Witness the confluence of Alaknanda and Bhagirathi Rivers.",
        },
        {
          title: "Triveni Ghat",
          desc: "Experience the evening Ganga Aarti in Rishikesh.",
        },
        {
          title: "Himalayan Journey",
          desc: "Scenic drives through the mountains of Uttarakhand.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Dehradun to Guptkashi",
        desc: `Morning pickup from Dehradun / Haridwar and proceed towards Guptkashi, enjoying the scenic drive through the Himalayas.

En route, visit Dhari Devi Temple, a revered shrine dedicated to Goddess Kali, situated on the banks of the Alaknanda River.

Continue your journey with a stop at Devprayag, the sacred confluence of the Alaknanda and Bhagirathi rivers, where the holy Ganga River officially begins.

Upon arrival in Guptkashi, check in to the hotel and relax.

Enjoy dinner and an overnight stay at the hotel in Guptkashi.`,
      },

      {
        day: "02",
        title: "Guptkashi to Kedarnath",
        desc: `Before sunrise, guests should pick up their packed breakfast from the hotel (Inform the hotel previous day regarding packed breakfast), then check out and start the journey from Guptkashi to Kedarnath.

Drive to Sonprayag. Here, guests will transfer to a local jeep (available at an additional cost of INR 50-100 per seat) that will take them to Gaurikund, the starting point for the Kedarnath trek.

The trek from Gaurikund to Kedarnath spans approximately 20 kilometers.

Guests have the option to complete the trek on foot or by hiring a horse (also at an additional cost).

The route offers stunning mountain views, dense forests, and spiritual ambiance as they ascend to Kedarnath, one of the most revered pilgrimage sites in India.

Upon reaching Kedarnath, guests can check in to their accommodation, freshen up, and later proceed to visit the Kedarnath Temple.

Dedicated to Lord Shiva, the temple stands amidst the majestic Himalayas at an altitude of 3,583 meters.

Believed to be one of the twelve Jyotirlingas, the temple’s ancient stone structure and spiritual energy make it a powerful and transformative experience for pilgrims.

In the evening, guests can return to their accommodation for a warm dinner and an overnight stay in Kedarnath, surrounded by the tranquility of the sacred peaks.

Important Note: Hotels are mostly basic Dharamshala type at Kedarnath. Hot water in bucket at own cost.

Very few hotels take advance bookings and fulfill commitment so limited options we have. Kindly have minimum expectation.

Kedarnath most hotels take bookings on per bed basis instead of rooms. However we provide personal rooms for your group instead sharing with unknown people.

Even if you have booked package on double / triple sharing you will still get quad / six / eight sharing personal room in Kedarnath based on your family size.

Carry warm cloths, shawl and towels for Kedarnath as temperature can go down very low at night.

Pooja Booking Online: badrinath-kedarnath.gov.in

Official Helicopter Booking Link: heliyatra.irctc.co.in

(All other websites which offer instant heli tickets of Kedarnath are fake).`,
      },

      {
        day: "03",
        title: "Kedarnath to Guptkashi",
        desc: `Begin the day with an early morning visit to the Kedarnath Temple to experience the morning Darshan of this sacred place.

After spending time at the temple, return to the hotel for breakfast, then check out and prepare for the trek back down to Gaurikund.

The descent from Kedarnath to Gaurikund covers a distance of around 20 kilometers, which guests can choose to complete either on foot or by hiring a horse (At their own cost).

Along the way, they can enjoy breathtaking views of the mountains and forests that characterize this holy route.

Upon reaching Gaurikund, guests can take a local jeep (for an additional cost) to travel to Sonprayag, where you will meet your vehicle for the transfer back to Guptkashi.

Once you arrive in Guptkashi, guests can check in to the hotel and relax after the day's journey.

Dinner will be served at the hotel, followed by a comfortable overnight stay in the peaceful surroundings of Guptkashi, offering a chance to rest and reflect on the Kedarnath pilgrimage experience.`,
      },

      {
        day: "04",
        title: "Guptkashi to Rishikesh",
        desc: `Start your day with a refreshing breakfast at your hotel in Guptkashi.

After check-out, begin your scenic drive towards Rishikesh, a spiritual town located on the banks of the Ganges River in Uttarakhand.

Known as the "Yoga Capital of the World," Rishikesh is a serene and vibrant destination, offering a blend of spirituality, adventure, and natural beauty.

As you drive towards Rishikesh, the route takes you through beautiful mountain roads, lush forests, and small villages, providing stunning views of the Alaknanda River and surrounding valleys.

You can make a brief stop at Devprayag, where the Alaknanda and Bhagirathi rivers converge to form the Ganges, offering a picturesque view of the confluence.

Upon arrival in Rishikesh, check in at your hotel and relax.

Visit the Triveni Ghat, where you can take part in the Ganga Aarti in the evening.

In the evening, enjoy the lively atmosphere of the town, with locals and tourists gathered at the ghats for the evening Ganga Aarti.

End your day with a delicious dinner at your hotel and a restful overnight stay in this spiritual and tranquil destination.`,
      },

      {
        day: "05",
        title: "Rishikesh to Dehradun Airport Drop",
        desc: `Start your day with a hearty breakfast at your hotel in Rishikesh, then check out and begin your journey towards Dehradun.

Enjoy the scenic drive as you bid farewell to the serene ambiance of Rishikesh and head towards the airport.

Upon arrival at Dehradun Airport, proceed with your onward journey, carrying cherished memories of your trip.`,
      },
    ],

    pointsToRemember: [
      "Hotels are mostly basic Dharamshala type at Kedarnath.",
      "Hot water in bucket at own cost.",
      "Carry warm cloths, shawl and towels for Kedarnath.",
      "Official Helicopter Booking Link: heliyatra.irctc.co.in",
      "Pooja Booking Online: badrinath-kedarnath.gov.in",
    ],

    inclusions: {
      included: [
        "Stay as per the Above Mentioned Hotels",
        "Meals as Mentioned Above",
        "Transfer and Sightseeing as per Itinerary & Vehicle Mentioned Above (AC in Non Hill Areas Only)",
        "All Toll Tax",
        "Inter State Tax",
        "Parking",
        "Fuel",
        "Driver Allowances",
      ],

      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "Standard",
          price: "₹26,200",
          unit: "per person",
        },
      ],
      note: "Per Person INR 26,200",
    },

    terms: [
      "Hotels are mostly basic Dharamshala type at Kedarnath.",
      "Hot water in bucket at own cost.",
      "Very few hotels take advance bookings and fulfill commitment so limited options are available.",
      "Kedarnath most hotels take bookings on per bed basis instead of rooms.",
      "Even if you have booked package on double / triple sharing you will still get quad / six / eight sharing personal room in Kedarnath based on your family size.",
      "Carry warm cloths, shawl and towels for Kedarnath as temperature can go down very low at night.",
      "Pooja Booking Online: badrinath-kedarnath.gov.in",
      "Official Helicopter Booking Link: heliyatra.irctc.co.in",
      "All other websites which offer instant heli tickets of Kedarnath are fake.",
    ],

    images: [
      dodham1,
      dodham2,
      dodham3,
      dodham4,
      dodham5,
    ],
  },

  //--------------------------------------- Kashmir -----------------------------------

  {
    title: "Amazing Kashmir",
    slug: "kashmir-5nights-6days-package",
    category: "Domestic",
    price: "₹44,500",
    days: "05 Nights / 06 Days",
    rating: "4.9",
    image:  "/images/kashmir/day-1.jpg",
    location: "Srinagar, Pahalgam, Gulmarg",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations Covered",
        places: "Srinagar, Pahalgam, Gulmarg",
      },

      pills: [
        "Hotel Stay Included",
        "Shikara Ride Included",
      ],

      highlights: [
        "Dal Lake Shikara Ride",
        "Pahalgam",
        "Gulmarg",
        "Aru Valley",
        "Chandanwari",
        "Betaab Valley",
      ],

      experiences: [
        {
          title: "Amazing Kashmir Getaway",
          desc: "",
        },
      ],
    },

    stayPlan: [
      {
        nights: "2 Nights",
        destination: "Srinagar",
        hotels: "Stay Villa / Shara Grand Hills / The Victory",
      },
      {
        nights: "2 Nights",
        destination: "Pahalgam",
        hotels: "Srichan Resort / Green Heights",
      },
      {
        nights: "1 Night",
        destination: "Gulmarg",
        hotels: "Shanu Lodge / Gulmarg Resort / Khaleel Palace",
      },
    ],

    // NOTE: Source PDF did not include a day-wise itinerary breakdown (only
    // hotel stay plan, total cost, and optional activity costs). Add the
    // day-by-day details here once available — left empty intentionally to
    // avoid fabricating content not present in the source.
    itinerary: [],

    pointsToRemember: [
      "Shikara Ride complementary for 1hr in Famous Dal Lake.",
      "Itinerary is tentative.",
    ],

    optionalActivities: [
      {
        activity: "Aru, Chandanwari & Betaab Valley trip at Pahalgam by NAC Tavera",
        cost: "₹2,700/-",
      },
      {
        activity: "Aru, Chandanwari & Betaab Valley trip at Pahalgam by NAC Innova",
        cost: "₹3,000/-",
      },
      {
        activity: "Gondola tickets till phase Ist",
        cost: "₹900/- Per Head",
      },
      {
        activity: "Gondola tickets for phase Ist & 2nd",
        cost: "₹2,000/- Per ticket per head",
      },
      {
        activity: "Pony Ride in Pahalgam from Pahalgam - Baisaran Valley (Mini Switzerland) - Pahalgam",
        cost: "₹2,500/- per person",
      },
      {
        activity: "Local guide cost in Gulmarg",
        cost: "₹800/- per day",
      },
      {
        activity: "Union Taxi for full day local sightseeing of Gulmarg (Strawberry Valley, Maharani Temple (Shiv Temple), St. Mary Church, Maharaja Palace, Bota Pathri, Children's Park, Fish Point & Golf Course)",
        cost: "₹3,500/-",
      },
      {
        activity: "Pony Ride in Sonmarg for Thajwas Glacier trip",
        cost: "₹2,000/- per person",
      },
      {
        activity: "Union Taxi for Zero Point trip at Sonmarg",
        cost: "₹4,000 to 5,000/-",
      },
      {
        activity: "Mughal Garden entry fees in Srinagar",
        cost: "₹100/- per person",
      },
      {
        activity: "Betaab Valley entry tickets",
        cost: "₹100/- per person",
      },
      {
        activity: "Aru Valley entry ticket",
        cost: "₹120/- per person",
      },
    ],

    inclusions: {
      included: [],
      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "Standard",
          price: "₹44,500",
          unit: "per person",
        },
      ],
      note: "TOTAL COST = 44,500/- PER PERSON",
    },

    images: [
      "/images/kashmir/day-1.jpg",
      "/images/kashmir/day-2.jpg",
      "/images/kashmir/day-3.jpg",
      "/images/kashmir/day-4.jpg",
      "/images/kashmir/day-5.jpg",
      "/images/kashmir/day-6.jpg",
      "/images/kashmir/gulmarg.jpg",
    ],
  },


  //--------------------------------------- Meghalaya, Arunachal Pradesh & Assam -----------------------------------

  {
    title: "Heavens of the East (NHE - 26)",
    slug: "meghalaya-arunachal-assam-8nights-9days-package",
    price: "₹41,400",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image:  "/images/east/day-1.jpg",
    location: "Shillong, Cherrapunjee, Tezpur, Dirang, Tawang, Bomdila, Guwahati",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "Meghalaya, Arunachal Pradesh & Assam - Shillong 2N, Tezpur 1N, Dirang 1N, Tawang 2N, Bomdila 1N, Guwahati 1N",
        places: "Shillong, Cherrapunjee, Tezpur, Dirang, Tawang, Bomdila, Guwahati",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Umium Lake",
        "Nohkalikai Falls",
        "Nohsngithiang Falls (Seven Sisters Falls)",
        "Mawsmai Caves",
        "Sela Pass",
        "Tawang Monastery",
        "Jaswantgarh War Memorial",
        "Kamakhya Temple",
      ],

      experiences: [
        {
          title: "Heavens of the East",
          desc: "",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Guwahati Airport / Rly Station - Shillong (100 kms / 03 hrs.)",
        desc: `On arrival at Guwahati Airport / Railway Station & transfer to Shillong (4,900 ft.), called 'Scotland of the East".

Enroute visit Umium Lake, a majestic placid lake with its surrounding sylvan hills.

On arrival at Shillong, check in at your hotel. Overnight stay at Shillong.`,
      },

      {
        day: "02",
        title: "Excursion to Cherrapunjee (60 kms / 3 hrs.)",
        desc: `After an early breakfast, proceed for a full-day excursion to Cherrapunjee (4,400 ft.), renowned as one of the wettest places on earth.

En route, stop to admire the cascading Elephanta Falls, soak in the breathtaking vistas from Mawdok–Dympep Valley Viewpoint, and explore the unique Garden of Caves.

On arrival, witness some of Cherrapunjee's most spectacular natural wonders including the majestic Nohkalikai Falls (the tallest plunge waterfall in India), the enchanting Nohsngithiang Falls (Seven Sisters Falls), and the fascinating limestone formations inside the Mawsmai Caves.

In the evening, drive back to Shillong for an Overnight stay at Shillong.`,
      },

      {
        day: "03",
        title: "Shillong Sightseeing - Tezpur (320 kms / 7 hrs.)",
        desc: `After breakfast visit Don Bosco Museum (Sunday Closed) & Ward's Lake.

Later drive to Tezpur. On arrival check in to the hotel. Evening is free for leisure. Overnight stay at Tezpur.`,
      },

      {
        day: "04",
        title: "Tezpur - Dirang (138 kms / 5 hrs.)",
        desc: `After early breakfast drive to Dirang. On the way visit Tipi Orchidarium situated on the banks of the river Bharali, a place over 500 orchids, on display there are some rare species of orchid. Arunachal has largest range of orchids in the country then take a break to visit Nag Temple. Continue your drive and do not forget to keep your cameras handy as you cross beautiful waterfalls and get some spectacular views.

On arrival check in to the hotel. Afternoon visit Apple orchard & Kiwi Farm (depending upon season), Dirang Monastery and Kalachakra Monastery. Dirang is also famous for hot water springs where people take bath to cure skin ailments. Overnight stay at Dirang

Note: Every Indian tourist visiting Arunachal Pradesh has to obtain ILP (Inner Line Permit) at Bhalukpong border before entering the state against submission of photo identity card and two copies of passport size photographs.`,
      },

      {
        day: "05",
        title: "Dirang - Tawang (130 kms / 7 hrs.)",
        desc: `After early breakfast proceed to Tawang the Land of Hidden Paradise. On the way enjoy the beauty of Sela Pass (13700 Ft) a border line between two districts i.e Tawang & West Kameng, Tawang, Sela Lake a small lake, which remains frozen for most of the year.

Further drive to 10 kms visit Jaswantgarh War Memorial – a memorial to the brave soldier who single handily tried to hold of approaching Chinese from the pass during the 1962 Indo-Chinese war.

Later visit majesty of Nuranng Falls where scenes from the SRK-Madhuri Dixit starrer "Koyla" were shot.

Arrive & check in to the hotel. Evening is free for leisure. Overnight stay at Tawang.`,
      },

      {
        day: "06",
        title: "Tawang Sightseeing",
        desc: `After breakfast visit Tawang Monstery world famous seventeenth century Tawang Monastery, also known as Galden Namgyal Lhatse which overlooks the wide Tawang Valley at a height of 10,000 ft. The monastery is a vast complex of 65 buildings housing Lamas and antique scriptures written in gold letters and ancient scripture, images and has an eight meters high gilded Buddha statue. It is the largest monastery in the Himalayan region and the second oldest monastery in Asia. Five hundred lamas live in its residential buildings and it is rich in.

Later visit Urgeling Gompa, 6th Dalai Lama's birth place who is the only Indian to have risen to such a high position in Gelupka Sect of Buddhism so far. Inside the monastery there are several Stupas (Vihar) and people from all walks of life visit this place during Buddhist new year to get the blessing for the coming year. Then proceed to the War Memorial which is dedicated to the martyrs of the 1962 Sino-Indian war. The memorial is 40-foot-high and like a stupa in design. It is locally called 'Namgyal Chortan'. The names of 2420 martyrs imprinted in gold on 32 black granite plagues.

You can also visit the craft center in Tawang sells beautiful masks, hand woven carpets, jewellery in silver, coral and amber, 'chubas' the local dress and delightful affordable mementos. Evening at leisure. Overnight stay at Tawang.`,
      },

      {
        day: "07",
        title: "Tawang - Bomdila (170 kms / 6 hrs.)",
        desc: `After breakfast transfer to Bomdila (8,200 ft.) – the head quarter of West Kameng District of Arunachal Pradesh and also known for its Buddhist monasteries. It has a lot of attractions for the visitors for its cool climate.

On arrival check in to the hotel. Later visit Gontse Rabgyaling Monastery (Upper Gonpa), Thub-Chog Gatsel Ling Monastery (Lower Gonpa). Bomdila offers wonderfully panoramic view of Himalayan landscapes and snow-clad ranges.

Evening you can visit the local market. Overnight stay at Bomdila.`,
      },

      {
        day: "08",
        title: "Bomdila - Guwahati (350 kms / 11 hrs.)",
        desc: `After Breakfast transfer to Guwahati. On arrival check in at your hotel. Evening free for individual activities. Overnight stay at Guwahati.`,
      },

      {
        day: "09",
        title: "Hotel - Guwahati Airport / Rly Station",
        desc: `After breakfast visit Kamakhya Temple (Notes -Timing 08:00 A.M till 01:00 P.M & 3:00 P.M till its gets dark).

Transfer to Guwahati Airport / Railway Station for your onward journey.

Note: Temple visit will depend on your departure time. It May be done on previous day.`,
      },
    ],

    pointsToRemember: [
      "Every Indian tourist visiting Arunachal Pradesh has to obtain ILP (Inner Line Permit) at Bhalukpong border before entering the state against submission of photo identity card and two copies of passport size photographs.",
      "Temple visit at Kamakhya (Day 9) will depend on your departure time. It may be done on previous day.",
      "Kamakhya Temple Timing: 08:00 A.M till 01:00 P.M & 3:00 P.M till its gets dark.",
      "Rates are valid for INDIAN NATIONALS only.",
    ],

    hotels: [
      {
        destination: "Shillong",
        options: "Landmark Victoria / Sunshine Guest House / Similar",
        category: "Economy (CP)",
      },
      {
        destination: "Tezpur",
        options: "Aavas Inn (Royal Gold) / Similar",
        category: "Economy (CP)",
      },
      {
        destination: "Dirang",
        options: "Wangdi Residency / Similar",
        category: "Economy (CP)",
      },
      {
        destination: "Tawang",
        options: "Tayatha / Similar",
        category: "Economy (CP)",
      },
      {
        destination: "Bomdila",
        options: "Atisha Guest House / Nambrog / Similar",
        category: "Economy (CP)",
      },
      {
        destination: "Guwahati",
        options: "Aarian Atithya / D'Courtyard / Similar",
        category: "Economy (CP)",
      },
    ],

    hotelCategoryDetails: "Economy Packages: Decent Hotel with Breakfast.",

    vehicle: "Dzire / Similar",

    inclusions: {
      included: [
        "Accommodation on twin Sharing Basis.",
        "Complimentary Breakfast.",
        "Exclusive A/c vehicle for transfers & sightseeing.",
        "All permit fees & hotel taxes (as per itinerary).",
        "Inner Line Permit Fees.",
      ],

      excluded: [
        "Rates are valid for INDIAN NATIONALS only.",
        "GST.",
        "Air Fare / Train fare.",
        "Personal Expenses such as Laundry, telephone calls, tips & gratuity, mineral water, soft & hard drinks, rafting, rock climbing, paragliding and porterage.",
        "Additional sightseeing or extra usage of vehicle, other than mentioned in the itinerary.",
        "VIP Darshan in Kamakhya Temple Entrance Fees & Guide charges.",
        "Any cost arising due to natural calamities like, landslides, road blockage, political disturbances (strikes), etc (to be borne by the client, is directly payable on the spot).",
        "Any increase in taxes or fuel price, leading to increase in cost on surface transportation & land arrangements, which may come into effect prior to departure.",
        "Room Heater Charges.",
        "Insurance.",
        "Anything specifically not mentioned in the 'Cost includes' column.",
      ],
    },

    pricing: {
      rows: [
        {
          category: "02 PAX - Economy (CP)",
          price: "₹41,400",
          unit: "per person",
          vehicleType: "Dzire / Similar",
        },
      ],
      note: "NO OF PAX (COST PER PERSON) ECONOMY (CP) VEHICLE TYPE: 02 PAX - 41400 - DZIRE / SIMILAR",
    },

    images: [
      "/images/east/day-1.jpg",
      "/images/east/day-2.jpg",
      "/images/east/day-3.jpg",
      "/images/east/day-4.jpg",
      "/images/east/day-5.jpg",
      "/images/east/day-6.jpg",
      "/images/east/day-7.jpg",
      "/images/east/day-8.jpg",
    ],
  },

  {
    title: "Rajasthan Jaipur Pushkar Udaipur",
    slug: "rajasthan-jaipur-pushkar-udaipur",
    category: "Domestic",
    price: "₹25,550",
    days: "6 Days / 5 Nights",
    rating: "4.8",
    image: rajasthan,
    location: "Jaipur, Pushkar, Ajmer, Udaipur",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 State, 4 Cities, 12 Attractions",
        places: "Jaipur, Pushkar, Ajmer, Udaipur",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Amer Fort",
        "Hawa Mahal",
        "Pushkar Brahma Temple",
        "Ajmer Dargah",
        "Lake Pichola",
        "City Palace Udaipur",
      ],

      experiences: [
        {
          title: "Pink City Tour",
          desc: "Explore Jaipur's forts, palaces and local markets.",
        },
        {
          title: "Spiritual Experience",
          desc: "Visit Brahma Temple in Pushkar and Ajmer Dargah.",
        },
        {
          title: "Lake Pichola",
          desc: "Enjoy beautiful views of Udaipur's famous lake.",
        },
        {
          title: "Heritage Walk",
          desc: "Discover royal palaces and museums of Rajasthan.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Jaipur Arrival",
        desc: "Visit Birla Mandir, Albert Museum, Hawa Mahal and evening shopping.",
        tags: [{ label: "Dinner", icon: cream }],
      },

      {
        day: "02",
        title: "Jaipur Sightseeing",
        desc: "Visit City Palace, Jantar Mantar, Amer Fort, Jal Mahal and optional Chokhi Dhani.",
        tags: [
          { label: "Breakfast", icon: leaf },
          { label: "Dinner", icon: cream },
        ],
      },

      {
        day: "03",
        title: "Jaipur – Pushkar – Ajmer",
        desc: "Visit Brahma Temple, Pushkar Sarovar and Ajmer Dargah.",
        tags: [
          { label: "Breakfast", icon: leaf },
          { label: "Dinner", icon: cream },
        ],
      },

      {
        day: "04",
        title: "Ajmer – Udaipur",
        desc: "Transfer to Udaipur and visit City Palace and Lake Pichola.",
        tags: [
          { label: "Breakfast", icon: leaf },
          { label: "Dinner", icon: cream },
        ],
      },

      {
        day: "05",
        title: "Udaipur Sightseeing",
        desc: "Visit Fateh Sagar Lake, Maharana Pratap Memorial, Nehru Garden, Saheliyon Ki Bari, Lok Kala Museum, Vintage Car Museum and Gulab Bagh.",
        tags: [
          { label: "Breakfast", icon: leaf },
          { label: "Dinner", icon: cream },
        ],
      },

      {
        day: "06",
        title: "Udaipur Departure",
        desc: "Check-out and transfer to Udaipur Airport.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
    ],

    pointsToRemember: [
      "Carry valid government ID proof.",
      "Rates subject to availability.",
      "Entrance fees are extra.",
      "Hotels may be replaced with similar category hotels.",
    ],

    inclusions: {
      included: [
        "5 Breakfasts",
        "5 Dinners",
        "Hotel Accommodation",
        "Transportation",
        "All Sightseeing",
        "Parking Charges",
        "Toll Tax",
        "Driver Allowance",
        "All Taxes",
      ],

      excluded: [
        "Airfare",
        "Train Fare",
        "Personal Expenses",
        "Guide Charges",
        "Entrance Fees",
        "Activities",
      ],
    },

    pricing: {
      rows: [
        {
          category: "3 Star",
          price: "₹25,550",
          unit: "per person",
        },
      ],
      note: "Based on twin sharing.",
    },

    terms: [
      "Rates subject to change without notice.",
      "Bookings subject to availability.",
      "Personal expenses are extra.",
      "Entrance fees are not included.",
    ],

    images: [
      rajasthan3,
      rajasthan4,
      rajasthan5,
      rajasthan6,
      rajasthan7,
      rajasthan8,
      rajasthan9,
      rajasthan10,
      rajasthan11,
      rajasthan12,
      rajasthan13,
      rajasthan14,
      rajasthan15,
      rajasthan16,
    ],
  },


  // ------------------------------------------- Andaman1 ---------------------------------

  {
    title: "Andaman Island Escape",
    slug: "andaman-island-escape",
    price: "₹26,200",
    days: "5 Days / 4 Nights",
    rating: "4.9",
    image: andaman2,
    location: "Port Blair, Havelock Island",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Union Territory, 2 Islands",
        places: "Port Blair, Havelock",
      },

      pills: [
        "Ferry Included",
        "Beach Stay",
        "Sightseeing Included",
      ],

      highlights: [
        "Cellular Jail",
        "Corbyn's Cove Beach",
        "Radhanagar Beach",
        "Elephant Beach",
        "Private Catamaran Ferry",
      ],

      experiences: [
        {
          title: "Beach Experience",
          desc: "Relax at Radhanagar Beach, one of Asia's best beaches.",
        },
        {
          title: "Snorkelling",
          desc: "Enjoy marine life and coral reefs at Elephant Beach.",
        },
        {
          title: "Cellular Jail",
          desc: "Explore the history of Kalapani.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Port Blair Arrival - Cellular Jail - Corbyn's Cove Beach",
        desc: `Arrival at Port Blair Airport and meet & greet with our representative before transfer to your hotel.

Late afternoon, visit the historic Cellular Jail Museum and learn about the stories of the prisoners of Kalapani. Later, enjoy a 360° view of the city and surrounding areas from the upper level.

After the jail visit, proceed to Corbyn's Cove Beach, Port Blair's only sandy palm-fringed beach. Enroute, stop at Tiranga Park for photographs.

At Corbyn's Cove Beach, enjoy optional Sea Kart rides and water sports activities (not included).

Overnight stay at Port Blair.`,
      },

      {
        day: "02",
        title: "Port Blair to Havelock - Radhanagar Beach",
        desc: `Transfer to Port Blair Jetty for your onward journey to Havelock Island by Private Catamaran Ferry.

If you have a morning ferry, request a packed breakfast from the hotel (subject to hotel policy).

Upon arrival at Havelock, meet our representative and transfer to your resort.

In the afternoon, visit the Blue Flag certified Radhanagar Beach for swimming and relaxation.

Please carry changing clothes and towels. Boarding vehicles with wet clothes is not permitted.

Overnight stay at Havelock Island.`,
      },

      {
        day: "03",
        title: "Havelock - Elephanta Beach",
        desc: `After breakfast, proceed to Elephanta Beach, also known as Coral Beach.

Elephanta Beach is famous for snorkelling and adventure activities such as Jet Ski, Banana Ride and Sea Walk.

Boat operators generally provide a complimentary 5-minute snorkelling experience, however this is subject to availability.

Reach Elephanta Beach via a shared 11-seater boat from the jetty. Boat timings are allotted one day prior.

Carry a water bottle, snacks and changing clothes.

Important: If Elephanta Beach is not operational due to weather conditions, a visit to Kala Pathar Beach will be arranged or the applicable amount will be refunded.

Overnight stay at Havelock Island.`,
      },

      {
        day: "04",
        title: "Havelock to Port Blair - Light & Sound Show",
        desc: `After breakfast, check out and proceed to the jetty for your return journey to Port Blair via Private Catamaran Ferry.

Upon arrival, transfer to your hotel.

In the evening, experience the famous 3D Light & Sound Show at Cellular Jail, showcasing the history of Kalapani.

Guests will be dropped at the parking area near the jail and need to walk approximately 200 metres to the venue.

Light & Sound Show timings are generally between 6:00 PM and 7:00 PM, subject to availability.

Overnight stay at Port Blair.`,
      },

      {
        day: "05",
        title: "Port Blair Departure",
        desc: `After breakfast, transfer to Port Blair Airport for your onward journey.

Port Blair Airport is relatively small and experiences heavy traffic. Guests are advised to reach the airport at least 2 hours before departure.

Tour Ends with Happy Memories.`,
      },
    ],

    pointsToRemember: [
      "Carry swimwear, changing clothes and towels for beach visits.",
      "Water sports activities such as Sea Kart, Jet Ski, Banana Ride, Sea Walk and Snorkelling are chargeable unless specifically mentioned.",
      "Ferry timings are subject to weather and operational conditions.",
      "Guests are not permitted to board vehicles with wet clothes.",
      "Elephanta Beach visit is subject to weather conditions.",
      "If Elephanta Beach is not operational, Kala Pathar Beach will be provided or the applicable amount will be refunded.",
      "Packed breakfast may be provided on ferry days subject to hotel policy.",
      "Guests should carry a water bottle, snacks and changing clothes during Elephanta Beach excursions.",
      "Light & Sound Show timings are subject to availability.",
      "Port Blair Airport experiences heavy traffic; guests should reach at least 2 hours before departure.",
      "Anything not specifically mentioned in the inclusions is excluded.",
    ],

    inclusions: {
      included: [
        "Meet & Greet Services at Airport & Jetty",
        "Hotel Accommodation",
        "Meal Plan as Mentioned in Itinerary",
        "Airport Transfers in Air-Conditioned Vehicle",
        "Ferry Terminal Transfers in Air-Conditioned Vehicle",
        "All Sightseeing as per Itinerary",
        "Entry Fees Included",
        "Air-Conditioned Vehicle for Sightseeing",
        "Inter-Island Ferry Transfers",
        "Private Catamaran Ferry Transfers",
        "Makruzz / Nautika / Green Ocean / ITT Majestic Ferry (Subject to Availability)",
      ],

      excluded: [
        "Vehicle Services Beyond the Mentioned Itinerary",
        "Personal Expenses",
        "Optional Tours",
        "Extra Meals",
        "Vehicle for Dinner Transfers",
        "Water Sports Activities",
        "Anything Not Mentioned in the Inclusions",
      ],
    },

    pricing: {
      rows: [
        {
          category: "Deluxe",
          price: "₹26,200",
          unit: "per person",
        },
      ],
      note: "Based on 2 adults.",
    },

    terms: [
      "Weather may affect ferry operations.",
      "Activities are subject to local conditions.",
    ],

    images: [
      andaman1,
      andaman2,
      andaman3,
      andaman4,
      andaman5,
      andaman6,
      andaman7
    ],
  },

  // --------------------------------------------- Andaman 2 ---------------------------------------------

  {
    title: "Andaman Complete Explorer",
    slug: "andaman-complete-explorer",
    price: "₹32,900",
    days: "7 Days / 6 Nights",
    rating: "4.9",
    image: andaman1,
    location: "Port Blair, Havelock, Neil Island",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Union Territory, 3 Islands",
        places: "Port Blair, Havelock, Neil Island",
      },

      pills: [
        "Private Ferry",
        "Island Hopping",
        "Sightseeing Included",
      ],

      highlights: [
        "Cellular Jail",
        "North Bay Island",
        "Ross Island",
        "Radhanagar Beach",
        "Elephant Beach",
        "Natural Bridge",
        "Neil Island",
      ],

      experiences: [
        {
          title: "Island Hopping",
          desc: "Explore Port Blair, Havelock and Neil Island.",
        },
        {
          title: "Water Activities",
          desc: "Snorkelling, Scuba Diving and Sea Walk experiences.",
        },
        {
          title: "Nature Views",
          desc: "Witness crystal-clear beaches and coral reefs.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Port Blair Arrival - Cellular Jail - Corbyn's Cove Beach",
        desc: `Arrival at Port Blair Airport and meet & greet with our airport representative before transfer to your booked hotel/resort.

Late afternoon, visit the historic Cellular Jail Museum and learn about the stories of the prisoners of Kalapani. Later, go upstairs to enjoy a 360° view of the city and surrounding areas.

After the jail visit, proceed to Corbyn's Cove Beach, Port Blair's only sandy palm-fringed beach. Enroute, stop at Tiranga Park for photographs.

At Corbyn's Cove Beach, enjoy an enthralling Sea Kart boat ride and other soft water sports activities (Water Sports not included).

Overnight stay at Port Blair.`,
      },

      {
        day: "02",
        title: "Port Blair - North Bay Island - Ross Island",
        desc: `After breakfast, transfer to the Water Sports Complex and board a speed boat.

Visit the historic Ross Island and explore the remnants of the British and Japanese eras.

Proceed to North Bay Island (Coral Beach), famous for adventure activities such as Scuba Diving, Snorkelling, Parasailing, Dolphin Glass Bottom Boat Ride and Coral Safari Semi-Submarine.

In case Ross Island and North Bay Island are not operational due to bad weather conditions, alternative sightseeing will be arranged or the applicable refund amount will be processed.

Return to Port Blair in the evening.

Guests may optionally visit Corbyn's Cove Beach and experience the Sea Kart ride (Direct Payment Basis).

Overnight stay at Port Blair.`,
      },

      {
        day: "03",
        title: "Port Blair to Havelock - Radhanagar Beach",
        desc: `Transfer from hotel to Port Blair Jetty for your onward journey to Havelock Island by Private Catamaran Ferry.

If travelling by morning ferry, request a packed breakfast from the hotel (subject to hotel policy).

Upon arrival at Havelock, meet our local representative and transfer to your booked hotel/resort.

In the afternoon, visit the Blue Flag certified Radhanagar Beach for swimming and relaxation.

Please carry changing clothes and towels.

Guests are not permitted to board vehicles with wet clothes.

Overnight stay at Havelock Island.`,
      },

      {
        day: "04",
        title: "Havelock - Elephanta Beach",
        desc: `After breakfast, proceed to Elephanta Beach, also known as Coral Beach.

Elephanta Beach is famous for Snorkelling and adventure activities such as Jet Ski Ride, Banana Ride and Sea Walk.

Boat operators usually provide a complimentary 5-minute snorkelling experience, however the same cannot be guaranteed.

Reach Elephanta Beach via a small 11-seater sharing boat from the jetty.

Boat timings are allotted one day in advance and guests should be ready accordingly.

Please carry a water bottle, snacks and changing clothes.

Overnight stay at Havelock Island.`,
      },
      {
        day: "05",
        title: "Havelock to Neil Island - Laxmanpur Beach, Bharatpur Beach & Natural Bridge",
        desc: `After breakfast, check out from the hotel and proceed to the jetty for your onward journey to Neil Island by Private Catamaran Ferry.

Upon arrival at Neil Island, meet our representative and transfer to your hotel.

Later, visit Bharatpur Beach, known for its crystal-clear waters and beautiful shoreline.

Continue to the famous Natural Bridge, a naturally formed rock arch created by years of sea erosion.

In the evening, visit Laxmanpur Beach and enjoy the scenic sunset views.

Overnight stay at Neil Island.`,
      },

      {
        day: "06",
        title: "Neil Island to Port Blair - Light & Sound Show",
        desc: `After breakfast, check out from the hotel and proceed to the jetty for your return journey to Port Blair by Private Catamaran Ferry.

Upon arrival in Port Blair, transfer to your hotel.

In the evening, enjoy the famous Light & Sound Show at Cellular Jail, which narrates the history and sacrifices of the freedom fighters imprisoned at Kalapani.

Guests will be dropped near the jail parking area and need to walk approximately 200 metres to the venue.

Light & Sound Show timings are subject to availability.

Overnight stay at Port Blair.`,
      },

      {
        day: "07",
        title: "Port Blair Departure",
        desc: `After breakfast, transfer to Port Blair Airport for your onward journey.

Port Blair Airport experiences heavy traffic, therefore guests are advised to reach the airport at least 2 hours prior to flight departure.

Tour Ends with Happy Memories.`,
      },
    ],

    pointsToRemember: [
      "Carry swimwear, changing clothes and towels for beach visits.",
      "Water sports activities are chargeable unless specifically mentioned.",
      "Guests are not permitted to board vehicles with wet clothes.",
      "Ferry timings are subject to weather and operational conditions.",
      "Ross Island and North Bay visits are subject to weather conditions.",
      "Alternative sightseeing or refund will be provided if boat operations are cancelled due to weather.",
      "Packed breakfast on ferry days is subject to hotel policy.",
      "Light & Sound Show timings are subject to availability.",
      "Anything not specifically mentioned in the inclusions is excluded.",
    ],

    inclusions: {
      included: [
        "Meet & Greet Services by our Local Representatives at Airport & Jetty",
        "Meal Plan – As Mentioned Above",
        "Airport Transfers in Air-Conditioned Vehicle",
        "Ferry Terminal Transfers in Air-Conditioned Vehicle",
        "All Sightseeing (Entry Fees Included) as per Itinerary in Air-Conditioned Vehicle",
        "Inter-Island Ferry Transfers by Private Catamaran Ferries Makruzz (Preferred) / Nautika / Green Ocean / ITT Majestic etc. (Subject to Availability)",
      ],

      excluded: [
        "The Services of Vehicles not on Disposal Basis & Finishing the Sightseeing Tour as per the Itinerary",
        "Any Kind of Personal Expenses",
        "Optional Tours",
        "Extra Meals",
        "Vehicle for Dinner etc.",
        "Anything not Mentioned in the Inclusions",
      ],
    },
    pricing: {
      rows: [
        {
          category: "Deluxe",
          price: "₹32,900",
          unit: "per person",
        },
      ],
      note: "Based on 2 adults.",
    },

    terms: [
      "Weather may impact ferry schedules.",
      "Activities are subject to local conditions.",
    ],

    images: [
      andaman1,
      andaman2,
      andaman3,
      andaman4,
      andaman5,
      andaman6,
      andaman7,
      //   andaman-day8,
    ],
  },

  // -----------------------------  Assam -------------------------------

  {
    title: "North East Triangle",
    slug: "north-east-triangle",
    price: "₹33,900",
    days: "6 Days / 5 Nights",
    rating: "4.9",
    image: assam1,
    location: "Kaziranga, Shillong, Guwahati",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 6 Days",
        places: "Kaziranga, Shillong, Cherrapunjee, Guwahati",
      },

      pills: [
        "Breakfast Included",
        "Safari Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Kaziranga National Park",
        "Elephant Safari",
        "Jeep Safari",
        "Kaziranga Orchid Park",
        "Umium Lake",
        "Elephanta Falls",
        "Nohkalikai Falls",
        "Seven Sisters Falls",
        "Mawsmai Caves",
        "Kamakhya Temple",
      ],

      experiences: [
        {
          title: "Wildlife Safari",
          desc: "Experience elephant and jeep safari in Kaziranga National Park.",
        },
        {
          title: "Cherrapunjee Excursion",
          desc: "Visit one of the wettest places on Earth.",
        },
        {
          title: "Shillong",
          desc: "Explore the Scotland of the East.",
        },
        {
          title: "Spiritual Journey",
          desc: "Seek blessings at Kamakhya Temple.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Guwahati – Kaziranga",
        desc: `On arrival at Guwahati Airport / Railway Station & transfer to Kaziranga National Park, the home of One Horned Rhinoceros.

Enroute visit Maha Mrityunjay Temple.

On arrival at Kaziranga check in at your hotel.

Evening is free for leisure.

Overnight stay at Kaziranga.`,
      },

      {
        day: "02",
        title: "Kaziranga National Park",
        desc: `Early morning explores any one zone of Kaziranga National Park on back of Elephant. Apart from the Rhino, other species found are Hog Deer, Swamp Deer, Wild Buffalo, Elephants and if you are lucky then tiger also. It is also home to pelicans, storks and darters as there are a number of water bodies inside the Park.

Return to the resort for breakfast.

In the afternoon enjoy jeep safari through the National Park, later visit Kaziranga Orchid Park.

Return to the hotel. Overnight stay at Kaziranga.`,
      },

      {
        day: "03",
        title: "Kaziranga – Shillong",
        desc: `After breakfast proceed for Shillong (4,900 ft.), which is called "Scotland of the East". Enroute visit Umium Lake, a majestic placid lake with its surrounding sylvan hills.

On arrival at Shillong, check in at your hotel.

Evening is free for leisure.

Overnight stay at Shillong.`,
      },

      {
        day: "04",
        title: "Cherrapunjee Excursion",
        desc: `After an early breakfast, proceed for a full-day excursion to Cherrapunjee (4,400 ft.), renowned as one of the wettest places on earth.

En route, stop to admire the cascading Elephanta Falls, soak in the breathtaking vistas from Mawdok–Dympep Valley Viewpoint, and explore the unique Garden of Caves.

On arrival, witness some of Cherrapunjee’s most spectacular natural wonders including the majestic Nohkalikai Falls (the tallest plunge waterfall in India), the enchanting Nohsngithiang Falls (Seven Sisters Falls), and the fascinating limestone formations inside the Mawsmai Caves.

In the evening, drive back to Shillong for an overnight stay at Shillong.`,
      },

      {
        day: "05",
        title: "Shillong Sightseeing – Guwahati",
        desc: `After breakfast visit Don Bosco Museum (Sunday Closed), Ward’s Lake and Lady Hydari Park.

Thereafter, drive to Guwahati and check in at the hotel.

In the evening, we suggest an optional tour of the Golden Sunset Cruise on the Brahmaputra River (Direct Payment Basis).

Overnight stay at Guwahati.`,
      },

      {
        day: "06",
        title: "Guwahati Departure",
        desc: `After breakfast visit Kamakhya Temple (Timing: 08:00 AM to 01:00 PM and 03:00 PM till evening).

Transfer to Guwahati Airport / Railway Station for your onward journey.

Note: Temple visit will depend on your departure time and may be done on the previous day if required.`,
      },
    ],

    pointsToRemember: [
      "Carry valid ID proof.",
      "Temple visit depends on departure timing.",
      "Weather may affect sightseeing schedules.",
      "Elephant rides are regulated and controlled by the Forest Department, Govt. of Assam.",
      "Elephant rides and Jeep Safari are subject to availability only.",
      "We do not have any control over safari bookings.",
      "Kamakhya Temple visit is subject to departure timing and may be scheduled on the previous day.",
      "Any additional cost due to landslides, road blockages or political disturbances must be paid directly by the guest.",

    ],

    inclusions: {
      included: [
        "Accommodation on Twin Sharing Basis",
        "Complimentary Breakfast",
        "Exclusive AC Vehicle for Transfers & Sightseeing",
        "One Elephant Safari at Kaziranga National Park",
        "One Jeep Safari at Kaziranga National Park",
        "All Permit Fees",
        "Hotel Taxes (as per itinerary)",
        "GST",
      ],
      excluded: [
        "Air Fare",
        "Train Fare",
        "Personal Expenses",
        "Laundry Charges",
        "Telephone Calls",
        "Tips & Gratuity",
        "Mineral Water",
        "Soft Drinks",
        "Hard Drinks",
        "Rafting",
        "Rock Climbing",
        "Paragliding",
        "Porterage",
        "Additional Sightseeing",
        "Extra Usage of Vehicle",
        "VIP Darshan at Kamakhya Temple",
        "Entrance Fees",
        "Guide Charges",
        "Expenses due to Natural Calamities",
        "Expenses due to Landslides",
        "Road Blockages",
        "Political Disturbances / Strikes",
        "Increase in Taxes or Fuel Prices",
        "Room Heater Charges",
        "Insurance",
        "Anything Not Mentioned in Cost Includes",
      ],
    },

    pricing: {
      rows: [
        {
          category: "Economy",
          price: "₹33,900",
          unit: "per person",
        },
      ],
      note: "Approximate rate based on twin sharing.",
    },

    terms: [
      "Rates valid for Indian Nationals only.",
      "Safari is subject to forest department availability.",
      "Natural calamities and road blocks are not included.",
      "Anything not mentioned in inclusions is excluded.",
    ],

    images: [
      assam1,
      assam2,
      assam3,
      assam4,
      assam5,
      assam6,
    ],
  },

  {
    title: "Golden Triangle",
    slug: "golden-triangle-package",
    price: "₹24,800",
    days: "6 Days / 5 Nights",
    rating: "4.9",
    image: golden1,
    location: "Delhi, Agra, Jaipur",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Cities, 6 Days",
        places: "Delhi, Agra, Jaipur",
      },

      pills: [
        "MAP Plan",
        "Breakfast Included",
        "Dinner Included",
      ],

      highlights: [
        "Akshardham Temple",
        "Lotus Temple",
        "Red Fort",
        "Qutub Minar",
        "India Gate",
        "Parliament House",
        "Agra Fort",
        "Taj Mahal",
        "Fatehpur Sikri",
        "Hawa Mahal",
        "Jantar Mantar",
        "City Palace Jaipur",
        "Jal Mahal",
        "Amer Fort",
      ],

      experiences: [
        {
          title: "Delhi Sightseeing",
          desc: "Visit Akshardham Temple, Lotus Temple, Red Fort, Qutub Minar, India Gate and Parliament House.",
        },
        {
          title: "Agra Heritage",
          desc: "Visit Agra Fort and Taj Mahal.",
        },
        {
          title: "Fatehpur Sikri",
          desc: "Visit Fatehpur Sikri while travelling from Agra to Jaipur.",
        },
        {
          title: "Pink City Jaipur",
          desc: "Explore Hawa Mahal, Jantar Mantar, City Palace, Jal Mahal and Amer Fort.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Delhi Arrival – Local Sightseeing",
        desc: `Upon arrival at Delhi Airport / Railway Station, pickup and proceed to hotel and visit Akshardham Temple (Closed on Monday), local market and stay at Delhi.`,
      },

      {
        day: "02",
        title: "Delhi Local",
        desc: `After breakfast, proceed for local sightseeing including Lotus Temple (Closed on Monday), Red Fort (Closed on Monday), Qutub Minar, India Gate and Parliament House and stay at Delhi.`,
      },

      {
        day: "03",
        title: "Delhi – Agra",
        desc: `Today proceed for Agra for around 4 hours drive and visit local Agra including Agra Fort and Taj Mahal (Closed on Friday) and stay at Agra.

Distance: 235 Kms / 4 Hours`,
      },

      {
        day: "04",
        title: "Agra – Jaipur",
        desc: `Today proceed for Jaipur via Fatehpur Sikri sightseeing on the way.

Check in Jaipur hotel, visit Pink City Market and overnight stay at Jaipur.

Distance: 240 Kms / 5 Hours`,
      },

      {
        day: "05",
        title: "Jaipur Local Sightseeing",
        desc: `After breakfast proceed for beautiful Pink City of Jaipur, visit Hawa Mahal, Jantar Mantar, City Palace Jaipur, The Jal Mahal Jaipur and Amer Fort.

The rest of the day is free to explore this vibrant and colourful city.

Overnight stay at Jaipur.`,
      },

      {
        day: "06",
        title: "Jaipur – Delhi Drop",
        desc: `Today after breakfast, check out from hotel and proceed for drop at Delhi Airport / Railway Station for your onward journey.`,
      },
    ],

    inclusions: {
      included: [
        "MAP Plan (5 Breakfast + 5 Dinner)",
        "Rooms: As per Package",
        "Transportation as per Package",
        "Sedan - 2 & 4 Pax",
        "Crysta - 6 Pax",
        "Tempo 12 Seater - 8/10 Pax",
        "All Sightseeing as per Package (Itinerary)",
        "Toll Tax",
        "Parking",
        "State Tax",
        "Driver Allowance",
        "All Taxes",
        "Pick & Drop - Delhi",
      ],

      excluded: [
        "Airfare",
        "Train Fare",
        "Activities",
        "Heater Charges",
        "Expenses of Personal Nature such as Tips, Telephone Calls, Laundry, Liquor etc.",
        "Guide Charges",
        "Any Other Item not Specified in Includes",
        "Entrance Fees During Sightseeing",
      ],
    },

    pointsToRemember: [
      "Akshardham Temple is Closed on Monday.",
      "Lotus Temple is Closed on Monday.",
      "Red Fort is Closed on Monday.",
      "Taj Mahal is Closed on Friday.",
      "All Rates & Bookings Subject to Availability.",
      "Rates are Subject to Change Without Prior Notice.",
    ],

    pricing: {
      rows: [
        {
          category: "3 Star",
          price: "₹24,800",
          unit: "per person",
        },
      ],
      note: "PACKAGE TYPE (SEASON RATE) - MIN. (Per Person Rates)",
    },

    terms: [
      "All Rates & Bookings Subject to Availability.",
      "Rates are Subject to Change Without Prior Notice.",
    ],

    images: [
      golden1,
      golden2,
      golden3,
      golden4,
      golden5,
      golden6,
    ],
  },


  // ------------------------------- Rajkot - Jamnagar - Dwarka - Somnath - Rajkot ---------------------------------


  {
    title: "Pancha Dwarka Tour",
    slug: "pancha-dwarka-tour",
    price: "₹42,300",
    days: "9 Days / 8 Nights",
    rating: "4.9",
    image:  "/images/gujarat/day-1.jpg",
    location:
      "Ahmedabad, Dakor, Rajkot, Dwarka, Somnath, Gondal, Mount Abu, Nathdwara, Udaipur",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 States, 9 Destinations",
        places:
          "Ahmedabad, Dakor, Rajkot, Dwarka, Somnath, Gondal, Mount Abu, Nathdwara, Udaipur",
      },

      pills: [
        "MAP Plan",
        "Breakfast Included",
        "Dinner Included",
      ],

      highlights: [
        "Shree Ranchhodraiji Temple",
        "ISKCON Ahmedabad",
        "Sabarmati Ashram",
        "Science City",
        "BAPS Swaminarayan Temple",
        "Dwarkadhish Temple",
        "Nageshwar Jyotirlinga",
        "Bet Dwarka",
        "Rukmini Temple",
        "Gomti Ghat",
        "Sudama Setu",
        "Gopi Talav",
        "Sudama Temple",
        "Kirti Mandir",
        "Somnath Jyotirlinga",
        "Navlakha Palace",
        "Dilwara Jain Temples",
        "Shrinathji Temple",
        "City Palace Udaipur",
        "Jagdish Temple",
        "Saheliyon-ki-Bari",
        "Fateh Sagar",
        "Lake Pichola",
      ],

      experiences: [
        {
          title: "Pancha Dwarka Yatra",
          desc: "Visit the sacred temples of Gujarat with specially designed spiritual itinerary.",
        },
        {
          title: "Dwarka Darshan",
          desc: "Visit Dwarkadhish Temple, Bet Dwarka and Nageshwar Jyotirlinga.",
        },
        {
          title: "Somnath",
          desc: "Attend the evening Aarti at the famous Somnath Jyotirlinga Temple.",
        },
        {
          title: "Mount Abu & Udaipur",
          desc: "Explore Dilwara Jain Temples, Nathdwara and the beautiful city of Udaipur.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Ahmedabad Arrival – Dakor – Ahmedabad",
        desc: `Arrive Ahmedabad, excursion to Dakor (Shree Ranchhodraiji Temple).

Visit city attractions – ISKCON, Sabarmati Ashram, Swaminarayan Temple and Science City.

Overnight at Ahmedabad.`,
      },

      {
        day: "02",
        title: "Ahmedabad – Rajkot",
        desc: `Drive to Rajkot.

Visit BAPS Swaminarayan Temple, ISKCON Temple and Ramakrishna Ashram.

Overnight at Rajkot.`,
      },

      {
        day: "03",
        title: "Rajkot – Dwarka",
        desc: `Proceed to Dwarka.

Visit Dwarkadhish Temple and Nageshwar Jyotirlinga.

Overnight at Dwarka.`,
      },

      {
        day: "04",
        title: "Dwarka – Bet Dwarka – Dwarka",
        desc: `Excursion to Bet Dwarka.

Visit Rukmini Temple, Gomti Ghat, Sudama Setu and Gopi Talav.

Overnight at Dwarka.`,
      },

      {
        day: "05",
        title: "Dwarka – Porbandar – Somnath",
        desc: `En route visit Sudama Temple & Kirti Mandir at Porbandar.

At Somnath, visit the famous Jyotirlinga Temple and attend evening Aarti.

Overnight at Somnath.`,
      },

      {
        day: "06",
        title: "Somnath – Gondal – Ahmedabad",
        desc: `Visit Gondal's Navlakha Palace & Swaminarayan Temple.

Drive to Ahmedabad.

Overnight stay.`,
      },

      {
        day: "07",
        title: "Ahmedabad – Mount Abu",
        desc: `Drive to Mount Abu.

Visit Dilwara Jain Temples and enjoy the serene hill atmosphere.

Overnight at Mount Abu.`,
      },

      {
        day: "08",
        title: "Mount Abu – Nathdwara – Udaipur",
        desc: `Visit Shrinathji Temple at Nathdwara and explore local art and handicrafts.

Proceed to Udaipur.

Overnight at Udaipur.`,
      },

      {
        day: "09",
        title: "Udaipur Sightseeing – Drop at Udaipur / Ahmedabad",
        desc: `City tour covering City Palace, Jagdish Temple, Saheliyon-ki-Bari, Fateh Sagar and Lake Pichola.

Later drop at Ahmedabad / Udaipur Airport or Railway Station.

------ TOUR END ------`,
      },
    ],

    pointsToRemember: [
      "Meet & Greet on Arrival.",
      "Garland Welcome on Request.",
      "24/7 Assistance.",
    ],

    inclusions: {
      included: [
        "Accommodation at Mentioned Hotel on MAP Basis",
        "Rooms on Double Sharing Basis",
        "08 Breakfast + 08 Dinner",
        "All Transfers & Sightseeing by Pvt AC Sedan / Innova Crysta / Tempo Traveller throughout the Trip",
        "Toll Charges",
        "Parking",
        "Driver Allowance",
        "Fuel Cost",
        "24/7 Assistance",
        "Meet & Greet on Arrival",
        "Garland Welcome on Request",
        "Government Tax (GST 5%)",
      ],

      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "3 Star Deluxe",
          price: "₹42,300",
          unit: "per person",
        },
      ],
      note: "AC Sedan",
    },

    terms: [],

    images: [
    "/images/gujarat/day-1.jpg",
    "/images/gujarat/day-2.jpg",
    "/images/gujarat/day-3.jpg",
    "/images/gujarat/day-4.jpg",
    "/images/gujarat/day-5.jpg",
    ],
  },


  //--------------------------------------- Gujarat -----------------------------------

  {
    title: "Ahmedabad - Statue of Unity - Vadodara - Ahmedabad",
    slug: "gujarat-3nights-4days-package",
    price: "₹19,700",
    days: "03 Nights / 04 Days",
    rating: "4.9",
    image: gujarat2,
    location: "Ahmedabad, Statue of Unity, Vadodara",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Cities Covered",
        places: "Ahmedabad, Statue of Unity, Vadodara",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Sabarmati Ashram",
        "Adalaj Stepwell",
        "Akshardham Temple",
        "Atal Bridge",
        "Sabarmati Riverfront",
        "Statue of Unity",
        "Sardar Sarovar Dam",
        "Laxmi Villas Palace",
      ],

      experiences: [
        {
          title: "Statue of Unity & Vadodara Heritage",
          desc: "Curated for a refined travel experience, this journey highlights the architectural marvel of the Statue of Unity along with the regal legacy of Vadodara—perfect for premium clientele.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrive at Ahmedabad",
        desc: `Arrival at Ahmedabad

Visit Sabarmati Ashram

Visit Adalaj Stepwell

Akshardham Temple

Atal Bridge

Sabarmati Riverfront

Overnight Stay at Ahmedabad`,
      },

      {
        day: "02",
        title: "Ahmedabad - Statue of Unity (04Hrs)",
        desc: `Statue of Unity (Pre Booking Required)

Sardar Sarovar Dam

Ekta Mall & Other Sightseeing

Light and Sound Show

Overnight stay near Statue of Unity`,
      },

      {
        day: "03",
        title: "Statue of Unity - Vadodara (2Hrs)",
        desc: `After Breakfast Check out from Hotel

Visit Butterfly Garden

Cactus Garden

Arogya Van

Gurudeshwar Temple

Poicha Temple

Overnight stay at Vadodara`,
      },

      {
        day: "04",
        title: "Vadodara - Ahmedabad Drop (2Hrs)",
        desc: `After Breakfast Check out from Hotel

Visit Laxmi Villas Palace

Visit Sur Sagar Lake

EME Temple

Baroda Museum

Drive Towards Ahmedabad Airport for Departure

----- TOUR ENDS -----`,
      },
    ],

    pointsToRemember: [
      "Statue of Unity requires Pre Booking.",
    ],

    inclusions: {
      included: [
        "Accommodation at mentioned hotel on MAP basis.",
        "Rooms are on Double Sharing basis.",
        "03 Breakfast + 03 Dinner.",
        "All Transfers & Sightseeing by a Pvt AC Sedan/Innova Crysta/ Tempo Traveller/ Urbania Vehicle throughout the trip.",
        "Toll charges, Parking, Driver Allowance & Fuel Cost.",
      ],

      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "3 Star Deluxe (AC Sedan)",
          price: "₹19,700",
          unit: "per person",
        },
      ],
      note: "PACKAGE COST WITH 3 STAR DELUXE HOTEL - INR 19,700/- Per Person (AC Sedan)",
    },

    images: [
      gujarat1,
      gujarat2,
      gujarat3,
      gujarat4,
    ],
  },


  //--------------------------------------- Gujarat 4N/5D -----------------------------------

  {
    title: "Rajkot - Jamnagar - Dwarka - Bet Dwarka - Porbandar - Somnath - Junagadh - Rajkot",
    slug: "gujarat-4nights-5days-package",
    price: "₹24,900",
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: gujarat3,
    location: "Rajkot, Jamnagar, Dwarka, Bet Dwarka, Porbandar, Somnath, Junagadh",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "7 Destinations Covered",
        places: "Rajkot, Jamnagar, Dwarka, Bet Dwarka, Porbandar, Somnath, Junagadh",
      },

      pills: [
        "Breakfast Included",
        "Dinner Included",
        "Hotel Stay Included",
      ],

      highlights: [
        "Bala Hanuman Temple",
        "Dwarkadish Temple",
        "Rukmani Devi Temple",
        "Bet Dwarka",
        "Nageshwar Jyotirlinga Temple",
        "Somnath Jyotirlinga Temple",
        "Girnar Hill (Temple)",
        "Uparkot Fort",
      ],

      experiences: [
        {
          title: "Somnath, Dwarka & Junagadh Pilgrimage",
          desc: "Experience a divine journey through Somnath, Dwarka, and the historic charm of Junagadh. This summer pilgrimage blends spirituality, heritage, and comfort—perfect for travelers seeking peace and cultural richness.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrive at Rajkot - Jamnagar - Dwarka (4Hrs)",
        desc: `Arrival at Rajkot

Visit Bala Hanuman Temple in Jamnagar

Visit Dwarkadish Temple

Rukmani Devi Temple

Gomti Ghat

Gopi Talab.

Overnight Stay at Dwarka`,
      },

      {
        day: "02",
        title: "Dwarka - Bet Dwarka - Dwarka",
        desc: `After Breakfast

Visit Bet Dwarka

Sudhama Setu

Bhadkeshwar Mahadev Temple

Nageshwar Jyotirlinga Temple

Swaminarayan Temple

Dunny Point

Overnight stay at Dwarka`,
      },

      {
        day: "03",
        title: "Dwarka - Porbandar - Somnath (4Hrs)",
        desc: `After Breakfast

Drive towards Somnath Via Porbandar

Kirti Mandir (Porbandar)

Somnath Jyotirlinga Temple

Bhalkha Tirth

Triveni Sangam

Laxminarayan Temple

Overnight stay at Somnath`,
      },

      {
        day: "04",
        title: "Somnath - Junagadh (2Hrs)",
        desc: `After Breakfast

Checkout from Hotel

Drive towards Junagadh

Visit Girnar Hill (Temple)

Uparkot Fort

Mahabat Maqbara

Overnight stay at Junagadh`,
      },

      {
        day: "05",
        title: "Junagadh - Rajkot Drop (3Hrs)",
        desc: `After Breakfast

Checkout from Hotel

Drive Towards Rajkot for Departure

----- TOUR ENDS -----`,
      },
    ],

    pointsToRemember: [
      "Above rates is inclusive of Government Tax (GST 5%).",
    ],

    inclusions: {
      included: [
        "Accommodation at mentioned hotel on MAP basis.",
        "Rooms are on Double Sharing basis.",
        "04 Breakfast + 04 Dinner.",
        "All Transfers & Sightseeing by a Pvt AC Sedan/Innova Crysta/ Tempo Traveller/ Urbania Vehicle throughout the trip.",
        "Toll charges, Parking, Driver Allowance & Fuel Cost.",
        "24/7 assistance.",
        "Meet & Greet on arrival.",
        "Garland welcome on request.",
        "Above rates is inclusive of Government Tax (GST 5%).",
      ],

      excluded: [],
    },

    pricing: {
      rows: [
        {
          category: "3 Star Deluxe (AC Sedan) - Minimum 2 Person",
          price: "₹24,900",
          unit: "per person",
        },
      ],
      note: "PACKAGE COST WITH 3 STAR DELUXE HOTEL - Minimum 2 Person: INR 24,900/- Per Person (AC Sedan)",
    },

    images: [
      gujarat1,
      gujarat2,
      gujarat3,
      gujarat4,
      gujarat5,
    ],
  },


  //--------------------------------------- Sikkim - Darjeeling -----------------------------------

//   {
//     title: "Sikkim - Darjeeling",
//     slug: "sikkim-darjeeling-7nights-8days-package",
//     price: "₹40,800",
//     days: "7 Nights / 8 Days",
//     rating: "4.9",
//     // image: sikkim1,
//     location: "Gangtok, Pelling, Darjeeling",
//     nextDate: "Available on Request",

//     highlightsData: {
//       locationCard: {
//         meta: "Gangtok 2 Nights / Pelling 2 Nights / Darjeeling 3 Nights",
//         places: "Gangtok, Pelling, Darjeeling",
//       },

//       pills: [
//         "Breakfast Included",
//         "Dinner Included",
//         "Hotel Stay Included",
//       ],

//       highlights: [
//         "Tsomgo Lake",
//         "New Baba Mandir",
//         "Khecheopalri Lake",
//         "Pemayangtse Monastery",
//         "Sang-Ngag Choling (Skywalk)",
//         "Tiger Hill",
//         "Mirik Sumendu Lake",
//         "Himalayan Mountaineering Institute",
//       ],

//       experiences: [
//         {
//           title: "Sikkim - Darjeeling Getaway",
//           desc: "",
//         },
//       ],
//     },

//     pax: "8 Adults",

//     itinerary: [
//       {
//         day: "01",
//         title: "Bagdogra Airport to Gangtok - Pickup",
//         desc: `Approx Distance: 125 Km • Est. Travel Time: 5 hours

// Meet and Greet on arrival at Bagdogra International Airport and transfer to Gangtok (5,500 Ft.). On arrival check-in to the hotel and rest of the day at leisure. Overnight stay at Gangtok`,
//       },

//       {
//         day: "02",
//         title: "Gangtok to Tsomgo Lake & Baba Mandir - Excursion",
//         desc: `Approx Distance: 120 Km • Est. Travel Time: 8 hours

// After breakfast, start for an excursion to Tsomgo Lake (12,400 ft. / 37 Kms. / 02 Hrs. from Gangtok) and further drive to New Baba Mandir (13,200 ft. / 16 Kms. / 01 Hrs. from Tsomgo Lake). Evening back to Gangtok. Overnight stay at Gangtok.

// Note: In case of Land slide or any other reason Tsomgo Lake is closed we will provided alternate sightseeing. Due to winter season (heavy snow) vehicle will be able to drive till Snow point on the way to Tsomgo Lake and New Baba Mandir.`,
//       },

//       {
//         day: "03",
//         title: "Gangtok to Pelling - Transfer Via Namchi",
//         desc: `Approx Distance: 200 Km • Est. Travel Time: 9 hours

// After breakfast, start for Pelling (6,300 Ft. / 120 Kms. / 5 Hrs.) via Namchi to visit Siddheshwar Dham (Chardham) and Sai Temple. On arrival check-in to your hotel. Overnight stay at Pelling.`,
//       },

//       {
//         day: "04",
//         title: "Pelling - Fullday Sightseeing with Sky Walk",
//         desc: `Est. Travel Time: 6 hours

// After breakfast start for a full day sightseeing tour. In first half, Rimbi waterfalls, Khecheopalri Lake (Wishfulling Lake) and Khangchendzongha waterfalls. In the second half cover the Pemayangtse monastery, Rabdantse ruins (2nd capital of Sikkim), Sang-Ngag Choling (Skywalk). Evening free for leisure. Overnight stay at Pelling.`,
//       },

//       {
//         day: "05",
//         title: "Pelling to Darjeeling - Transfer",
//         desc: `Approx Distance: 100 Km • Est. Travel Time: 4 hours

// After breakfast check out from the hotel and transfer to Darjeeling (6,950 Ft.) via Singla Check post. On arrival, check-in to the hotel and rest of the day at leisure. Overnight stay at Darjeeling.`,
//       },

//       {
//         day: "06",
//         title: "Darjeeling - Mirik and Pashupati Market Day Visit",
//         desc: `Approx Distance: 100 Km • Est. Travel Time: 6 hours

// After breakfast start for a full day excursion trip to Mirik (4,902 ft.), which is a small picturesque hill station with a beautiful lake surrounded by forested hills on all sides with the back drop of Mt Kanchenjunga. The road runs through some fascinating tea gardens, and pine forests. Visit Sumendu Lake, which is famous for it being one of the best man-made lakes. Enjoy horse ride and boating at the lake site on direct payment basis.

// On the way back to Darjeeling return via Pasupati Market, which is situated in Indo-Nepal border (Extra vehicle charges will be applicable for Nepal Border to Pasupati Market on direct payment basis). Evening back to hotel. Overnight stay at Darjeeling.`,
//       },

//       {
//         day: "07",
//         title: "Darjeeling - Fullday Sightseeing with Tiger Hill",
//         desc: `Approx Distance: 130 Km • Est. Travel Time: 8 hours

// Early morning (4:00 AM) visit Tiger Hill (Subject to availability of token, if not possible at the time of Sunrise, then it will be covered in day time.) and then back to hotel.

// After breakfast, starting at 8.30 AM, visit Himalayan Mountaineering Institute, P.N. Zoological Park (Thursday closed), Tenzing Rock, Ropeway (Note: Closed on 19th of Every Month), Tibetan Refugee self-help Centre (Sunday closed), Tea Garden (outer view), Japanese Temple (Peace Pagoda). Evening free for leisure. Overnight stay at Darjeeling.

// Note: Darjeeling ropeway will be on direct payment basis. It has limited cabins (Approx. 8 and per cabin 4 persons can be accommodated), resulting in long queues due to high tourist volume. Be patient with potential delays. It could also impact your schedule for other sightseeing activities due to time constraints.`,
//       },

//       {
//         day: "08",
//         title: "Darjeeling to Bagdogra Airport - Drop",
//         desc: `Approx Distance: 70 Km • Est. Travel Time: 3 hours

// After breakfast Checkout from hotel and take, the departure transfers to Bagdogra International Airport for your onward journey.`,
//       },
//     ],

//     pointsToRemember: [
//       "In case of Land slide or any other reason Tsomgo Lake is closed, alternate sightseeing will be provided.",
//       "Due to winter season (heavy snow) vehicle will be able to drive till Snow point on the way to Tsomgo Lake and New Baba Mandir.",
//       "Horse ride and boating at Mirik lake site on direct payment basis.",
//       "Extra vehicle charges will be applicable for Nepal Border to Pasupati Market on direct payment basis.",
//       "Tiger Hill visit subject to availability of token; if not possible at sunrise, will be covered in day time.",
//       "P.N. Zoological Park closed on Thursday.",
//       "Darjeeling Ropeway closed on 19th of every month.",
//       "Tibetan Refugee self-help Centre closed on Sunday.",
//       "Darjeeling ropeway is on direct payment basis, has limited cabins (Approx. 8, 4 persons per cabin), resulting in long queues.",
//     ],

//     hotels: [
//       {
//         nights: "1st (25 Jun) & 2nd (26 Jun)",
//         destination: "Gangtok",
//         hotel: "Shinkham Grand / Similar",
//         mealPlan: "MAP",
//         accommodation: "4 Super Deluxe Double Room",
//         pax: "8 Pax",
//       },
//       {
//         nights: "3rd (27 Jun) & 4th (28 Jun)",
//         destination: "Pelling",
//         hotel: "Amani / Similar",
//         mealPlan: "MAP",
//         accommodation: "4 Super Deluxe Room",
//         pax: "8 Pax",
//       },
//       {
//         nights: "5th (29 Jun), 6th (30 Jun) & 7th (01 Jul)",
//         destination: "Darjeeling",
//         hotel: "Q Saina Mapham (Veg) / Similar",
//         mealPlan: "MAP",
//         accommodation: "4 Cozy Kanchenjunga View Room",
//         pax: "8 Pax",
//       },
//     ],

//     hotelCategoryDetails: "Hotels Used - LUXURY (3* DLX)",

//     inclusions: {
//       included: [],
//       excluded: [],
//     },

//     pricing: {
//       rows: [
//         {
//           category: "Luxury (3* DLX)",
//           price: "₹40,800",
//           unit: "per person",
//         },
//       ],
//       note: "Rs.40,800 per person",
//     },

//     // images: [
//     //   sikkim1,
//     //   sikkim2,
//     //   sikkim3,
//     //   sikkim4,
//     // ],
//   },


  {
    title: "Best of Iceland – 08 Nights/09 Days (8N Reykjavik)",
    slug: "best-of-iceland-8n-reykjavik",
    price: "Euro 1477 per person onwards",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/iceland/day-1.jpg",
    location: "Reykjavik, Iceland",
    nextDate: "Available on Request", // not present in PDF

    highlightsData: {
      locationCard: {
        meta: "1 Country, 1 City, 7 Tours & Experiences",
        places: "Reykjavik",
      },

      pills: [
        "Breakfast Included",
        "Private Airport Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Thingvellir National Park",
        "Gullfoss Waterfall",
        "Blue Lagoon",
        "Jokulsarlon Glacier Lagoon",
        "Kirkjufell Mountain",
        "Hallgrimskirkja Church",
      ],

      experiences: [
        {
          title: "Golden Circle Full-Day Tour",
          desc: "Visit Thingvellir National Park, Geysir geothermal area and Gullfoss Waterfall on the famous 300 km loop.",
        },
        {
          title: "South Iceland Tour",
          desc: "Walk behind Seljalandsfoss, see Skogafoss, Reynisfjara Black Sand Beach and Dyrholaey cliffs.",
        },
        {
          title: "Blue Lagoon Experience",
          desc: "Relax in the mineral-rich geothermal waters with silica mud mask and bathing facilities.",
        },
        {
          title: "Jokulsarlon Glacier Lagoon Tour",
          desc: "See floating icebergs at Jokulsarlon and ice pieces on Diamond Beach.",
        },
        {
          title: "Snaefellsnes Peninsula & Kirkjufell",
          desc: "Explore 'Iceland in Miniature' with black sand beaches, lava fields and Kirkjufell Mountain.",
        },
        {
          title: "Reykjavik Hop-On Hop-Off City Bus Tour",
          desc: "Visit Hallgrimskirkja Church, Harpa Concert Hall and Old Harbour with flexible stops.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Reykjavik – Arrival in Reykjavik",
        desc: "Arrival at Reykjavik International Airport. Private transfer to hotel and check-in. Rest of the day at leisure to explore Reykjavik city centre. Overnight stay in Reykjavik.",
        tags: [],
      },
      {
        day: "02",
        title: "Golden Circle Full-Day Tour (SIC Basis)",
        desc: "Join the Golden Circle route (300 km loop) – visit Thingvellir National Park, Geysir geothermal area (Strokkur erupts every 04-10 minutes) and Gullfoss Waterfall. Optional stops may include Kerid Crater or local farms. Tour duration approx. 7–8 hours. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "South Iceland Tour (SIC Basis)",
        desc: "Drive along Iceland's scenic South Coast. Visit Seljalandsfoss Waterfall (walk behind the falls), Skogafoss Waterfall, Reynisfjara Black Sand Beach and view Dyrholaey cliffs. Return to Reykjavik in the evening. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Blue Lagoon Experience (SIC Transfers)",
        desc: "Transfer to Blue Lagoon geothermal spa. Relax in warm mineral-rich waters surrounded by lava fields, includes silica mud mask and bathing facilities. Spend 2–3 hours at leisure. Return transfer to Reykjavik. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Jokulsarlon Glacier Lagoon Tour (SIC Basis)",
        desc: "Early morning departure for a full-day tour along the South Coast towards Vatnajokull National Park. Visit Jokulsarlon Glacier Lagoon (floating icebergs) and Diamond Beach (ice pieces on black sand). Optional boat ride available (extra cost). Return late evening to Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Snaefellsnes Peninsula & Kirkjufell (Small Group)",
        desc: "Explore Snaefellsnes Peninsula, known as 'Iceland in Miniature'. Visit Kirkjufell Mountain, black sand beaches, lava fields, fishing villages and view Snaefellsjokull glacier volcano. Return to Reykjavik. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Reykjavik Hop-On Hop-Off City Bus Tour (SIC Basis)",
        desc: "Unlimited access to hop-on hop-off sightseeing bus. Visit key attractions: Hallgrimskirkja Church, Harpa Concert Hall, Old Harbour. Flexible stops to explore museums, shopping streets and cafes. Audio guide available in multiple languages. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Leisure Day in Reykjavik",
        desc: "Day at leisure for optional activities or shopping. Optional tours: Northern Lights (seasonal), Sky Lagoon, or food tours – Not included. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Departure",
        desc: "Private transfer from hotel to Reykjavik Airport. Departure with unforgettable Iceland memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Nights' Accommodation with Breakfast",
        "Private transfer from Reykjavik Airport to hotel",
        "Golden Circle Full-Day Tour on SIC Basis",
        "One day South Iceland Tour on SIC basis",
        "Blue Lagoon Admission with Transfers on SIC basis",
        "One day Jokulsarlon Glacier Lagoon Tour on SIC basis",
        "Snaefellsnes Peninsula and Kirkjufell Small-Group Tour on SIC Basis",
        "Reykjavik City Sightseeing Hop-On Hop-Off Bus Tour",
        "Free day",
        "Private transfer from Reykjavik hotel to Airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season) unless otherwise stated. The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel (Reykjavik Lights by Keahotels or similar)",
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 1584 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1514 per person onwards (Twin/Double) / Euro 1451 (Triple)" },
                { pax: "06 Pax", price: "Euro 1488 per person onwards (Twin/Double) / Euro 1397 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 934 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 707 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1477 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1407 per person onwards (Twin/Double) / Euro 1355 (Triple)" },
                { pax: "06 Pax", price: "Euro 1381 per person onwards (Twin/Double) / Euro 1301 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 860 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 600 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1497 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1427 per person onwards (Twin/Double) / Euro 1390 (Triple)" },
                { pax: "06 Pax", price: "Euro 1401 per person onwards (Twin/Double) / Euro 1336 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 925 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 620 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel (Radisson Blu 1919 Hotel, Reykjavik or similar)",
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1916 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1846 per person onwards (Twin/Double) / Euro 1769 (Triple)" },
                { pax: "06 Pax", price: "Euro 1820 per person onwards (Twin/Double) / Euro 1741 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1302 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1039 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1944 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1918 per person onwards (Twin/Double) / Euro 1805 (Triple)" },
                { pax: "06 Pax", price: "Euro 1902 per person onwards (Twin/Double) / Euro 1789 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 966 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1222 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1942 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 1872 per person onwards (Twin/Double) / Euro 1805 (Triple)" },
                { pax: "06 Pax", price: "Euro 1846 per person onwards (Twin/Double) / Euro 1751 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1280 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1065 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/iceland/day-1.jpg",
      "/images/iceland/day-2.jpg",
      "/images/iceland/day-3.jpg",
      "/images/iceland/day-4.jpg",
      "/images/iceland/day-5.jpg",
      "/images/iceland/day-6.jpg",
      "/images/iceland/day-7.jpg",
      "/images/iceland/day-8.jpg",
      "/images/iceland/day-9.jpg",
      "/images/iceland/day-10.jpg",
      "/images/iceland/day-11.jpg",
      "/images/iceland/day-12.jpg",
      "/images/iceland/extra1.jpg",
    ],
  },

  {
    title: "Best of Iceland – 11 Nights/12 Days (03N Akureyri + 04N Reykjavik + 03N Vik + 01N Reykjavik)",
    slug: "best-of-iceland-11n-akureyri-reykjavik-vik",
    price: "Euro 3470 per person onwards", // lowest rate in PDF (3* Hotel, 06 Pax Triple, Jan/Feb/Nov/Dec)
    days: "11 Nights / 12 Days",
    rating: "4.9",
    image: "/images/ice/day-2.jpg",
    location: "Akureyri, Reykjavik, Vik, Iceland",
    nextDate: "Available on Request", // not present in PDF

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 9 Tours & Experiences",
        places: "Akureyri, Reykjavik, Vik",
      },

      pills: [
        "Breakfast Included",
        "Private Airport Transfers Included",
        "11 Nights Accommodation",
      ],

      highlights: [
        "Godafoss Waterfall",
        "Lake Myvatn",
        "Gullfoss Waterfall",
        "Blue Lagoon",
        "Jokulsarlon Glacier Lagoon",
        "Katla Ice Cave",
      ],

      experiences: [
        {
          title: "Lake Myvatn & Godafoss Guided Tour",
          desc: "Visit Godafoss Waterfall and explore Lake Myvatn's volcanic landscapes, pseudo craters, lava fields and Hverir hot spring area.",
        },
        {
          title: "Whale Watching Experience",
          desc: "Board a specialized boat from Akureyri harbor to spot humpback whales, minke whales, dolphins and seabirds.",
        },
        {
          title: "Golden Circle Full-Day Tour",
          desc: "Visit Thingvellir National Park, Geysir geothermal area and Gullfoss Waterfall.",
        },
        {
          title: "Snaefellsnes Peninsula & Kirkjufell",
          desc: "Small-group scenic tour to Kirkjufell Mountain, black sand beaches, lava fields, coastal cliffs and fishing villages like Arnarstapi and Hellnar.",
        },
        {
          title: "Jokulsarlon Glacier Lagoon Tour",
          desc: "Witness floating icebergs at Jokulsarlon and visit Diamond Beach with a scenic drive through Vatnajokull National Park.",
        },
        {
          title: "Katla Ice Cave Small Group Tour",
          desc: "Super jeep tour through rugged volcanic terrain to explore a natural ice cave with guide and safety equipment.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Akureyri – Arrival in Akureyri",
        desc: "Arrival at Akureyri Airport in North Iceland. Meet and greet followed by a private transfer to your hotel. Check-in and relax. Evening free to explore Akureyri town, botanical gardens, or waterfront area. Overnight stay in Akureyri.",
        tags: [],
      },
      {
        day: "02",
        title: "Lake Myvatn & Godafoss Guided Tour (SIC Basis)",
        desc: "Join a shared guided tour to Lake Myvatn region. Visit Godafoss Waterfall ('Waterfall of the Gods'), explore Lake Myvatn's volcanic landscapes, pseudo craters, lava fields and hot spring areas like Hverir. Optional stop at Myvatn Nature Baths (entry not included unless specified). Return to Akureyri in the evening. Overnight stay in Akureyri.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Whale Watching Experience (needs to reach meeting point)",
        desc: "Proceed to Akureyri harbor for a whale watching tour. Board a specialized boat with expert guides to spot humpback whales, minke whales, dolphins and seabirds. Tour duration approx. 2–3 hours. Rest of the day free for leisure or optional activities. Overnight stay in Akureyri.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Akureyri to Reykjavik",
        desc: "Private transfer to Akureyri Airport. Flight to Reykjavik (not included unless specified). Arrival in Reykjavik and private transfer to hotel. Check-in and relax. Evening free to explore Reykjavik city center, cafes, and shopping streets. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Golden Circle Full-Day Tour (SIC Basis)",
        desc: "Join Golden Circle tour covering Thingvellir National Park (UNESCO World Heritage Site, tectonic plate rift), Geysir geothermal area (Strokkur geyser eruptions every few minutes) and Gullfoss Waterfall. Optional stops at Kerid Crater or local farms. Return to Reykjavik in the evening. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Snaefellsnes Peninsula & Kirkjufell (Small Group on SIC)",
        desc: "Small-group scenic tour to Snaefellsnes Peninsula. Visit Kirkjufell Mountain, black sand beaches, lava fields, coastal cliffs, view Snaefellsjokull Glacier volcano and visit fishing villages like Arnarstapi and Hellnar. Return to Reykjavik in the evening. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Blue Lagoon Experience (SIC Transfers)",
        desc: "Transfer to Blue Lagoon geothermal spa. Enjoy a relaxing bath in mineral-rich warm waters, includes silica mud mask and basic amenities. Spend 2–3 hours at leisure. Return transfer to Reykjavik. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Transfer to Vik (Private Transfer)",
        desc: "Private scenic transfer along the South Coast to Vik. Enroute visit Seljalandsfoss Waterfall (walk behind the waterfall). Arrival in Vik and hotel check-in. Overnight stay in Vik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Jokulsarlon Glacier Lagoon Tour (SIC Basis)",
        desc: "Join a full-day tour to Jokulsarlon Glacier Lagoon. Witness floating icebergs, visit Diamond Beach with ice chunks on black sand, optional amphibian boat ride (subject to availability), and a scenic drive through Vatnajokull National Park. Overnight stay in Vik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "10",
        title: "Katla Ice Cave Small Group Tour (SIC Basis)",
        desc: "Join a small-group super jeep tour to Katla Ice Cave. Drive through rugged terrain and volcanic landscapes, explore a natural ice cave with guide and safety equipment, and learn about glaciers and volcanic formations. Return to Vik hotel. Overnight stay in Vik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "11",
        title: "Return to Reykjavik (Private Transfer)",
        desc: "Private transfer from Vik to Reykjavik. Check-in at hotel. Overnight stay in Reykjavik.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "12",
        title: "Departure",
        desc: "Private transfer from hotel to Reykjavik Airport. Departure with unforgettable Iceland memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "11 Nights' Accommodation with Breakfast",
        "Akureyri Airport to hotel",
        "Lake Myvatn and Godafoss Guided Tour on SIC Basis",
        "One day Whale Watching ticket only",
        "Akureyri hotel to Airport",
        "Reykjavik Airport to hotel",
        "Golden Circle Full-Day Tour on SIC Basis",
        "Snaefellsnes Peninsula and Kirkjufell Small-Group Tour on SIC Basis",
        "Blue Lagoon Admission with Transfers on SIC basis",
        "Private transfer from Reykjavik hotel to Vik hotel",
        "One day Jokulsarlon Glacier Lagoon Tour on SIC basis",
        "Katla Ice Cave Small-Group Tour",
        "Vik hotel to Reykjavik hotel",
        "Reykjavik hotel to Airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season) unless otherwise stated. The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Akureyri 3N", hotel: "Hotel Akureyri" },
            { location: "Reykjavik 4N", hotel: "Reykjavik Lights Hotel" },
            { location: "Vik 3N", hotel: "Hotel Kria" },
            { location: "Reykjavik 1N", hotel: "Reykjavik Lights Hotel" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 3470 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3036 per person onwards (Twin/Double) / Euro 2978 (Triple)" },
                { pax: "06 Pax", price: "Euro 2842 per person onwards (Twin/Double) / Euro 2592 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1150 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1400 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 3622 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3188 per person onwards (Twin/Double) / Euro 3142 (Triple)" },
                { pax: "06 Pax", price: "Euro 2994 per person onwards (Twin/Double) / Euro 2756 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1338 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1552 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 3565 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3131 per person onwards (Twin/Double) / Euro 3069 (Triple)" },
                { pax: "06 Pax", price: "Euro 2937 per person onwards (Twin/Double) / Euro 2683 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1233 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1495 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Akureyri 3N", hotel: "Hótel Kea" },
            { location: "Reykjavik 4N", hotel: "Canopy by Hilton Reykjavik City Centre" },
            { location: "Vik 3N", hotel: "Icelandair Hotel Vik (03 star)" },
            { location: "Reykjavik 1N", hotel: "Canopy by Hilton Reykjavik City Centre" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 4031 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3667 per person onwards (Twin/Double) / Euro 3590 (Triple)" },
                { pax: "06 Pax", price: "Euro 3403 per person onwards (Twin/Double) / Euro 3238 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1966 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1961 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 4421 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3987 per person onwards (Twin/Double) / Euro 3855 (Triple)" },
                { pax: "06 Pax", price: "Euro 3793 per person onwards (Twin/Double) / Euro 3469 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1879 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 2351 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 4079 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 3692 per person onwards (Twin/Double) / Euro 3654 (Triple)" },
                { pax: "06 Pax", price: "Euro 3458 per person onwards (Twin/Double) / Euro 3268 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 1946 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 2016 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/ice/day-1.jpg",
      "/images/ice/day-2.jpg",
      "/images/ice/day-3.jpg",
      "/images/ice/day-4.jpg",
      "/images/ice/day-5.jpg",
      "/images/ice/day-6.jpg",
      "/images/ice/day-7.jpg",
      "/images/ice/day-8.jpg",
      "/images/ice/day-9.jpg",
      "/images/ice/day-10.jpg",
      "/images/ice/day-11.jpg",
      "/images/ice/day-12.jpg",
      "/images/ice/extra1.jpg",
    ],
  },

  {
    title: "Athens – 03 Nights/04 Days (3N Athens)",
    slug: "athens-3n",
    price: "Euro 302 per person onwards",
    days: "03 Nights / 04 Days",
    rating: "4.9", // not present in PDF
    image: "/images/Athens/day-1.jpg",
    location: "Athens, Greece",
    nextDate: "Available on Request", // not present in PDF

    highlightsData: {
      locationCard: {
        meta: "1 Country, 1 City, 1 Guided Tour",
        places: "Athens",
      },

      pills: [
        "Breakfast Included",
        "Private Airport Transfers Included",
        "03 Nights Accommodation",
      ],

      highlights: [
        "Acropolis",
        "Parthenon",
        "Erechtheion",
        "Temple of Athena Nike",
        "Plaka",
        "Syntagma Square",
      ],

      experiences: [
        {
          title: "Acropolis Walking Tour",
          desc: "Visit the iconic Acropolis, home to the Parthenon, Erechtheion, and Temple of Athena Nike, with a guided walk through ancient Greek history, mythology and architecture.",
        },
        {
          title: "Day at Leisure in Athens",
          desc: "Explore Athens at your own pace — optional visits to the Acropolis Museum, National Archaeological Museum, or a walk through Monastiraki and Syntagma Square.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Athens: Arrival in Athens",
        desc: "Welcome to Athens, the cradle of Western civilization. Upon arrival at Athens International Airport, enjoy a smooth private transfer to your hotel. The remainder of the day is at leisure to explore nearby streets, local cafés, or relax after your journey. Overnight stay in Athens.",
        tags: [],
      },
      {
        day: "02",
        title: "Athens – Acropolis Walking Tour",
        desc: "Proceed for the Acropolis Walking Tour on a shared basis. Visit the iconic Acropolis, home to world-famous monuments such as the Parthenon, Erechtheion, and Temple of Athena Nike. Learn about ancient Greek history, mythology and architecture while enjoying panoramic views of the city. Rest of the day at leisure for shopping, exploring Plaka, or local cuisine. Overnight stay in Athens.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Athens – Day at Leisure",
        desc: "Today is free at leisure. Explore Athens at your own pace, visit optional attractions such as the Acropolis Museum, National Archaeological Museum, or enjoy a leisurely walk through Monastiraki and Syntagma Square. Overnight stay in Athens.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Athens – India: Departure",
        desc: "After breakfast, enjoy a private transfer from your hotel to Athens International Airport for your return journey to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "03 nights' accommodation with daily breakfast",
        "Private transfer from Athens Airport to Athens hotel",
        "Acropolis Walking Tour on shared basis including entrance ticket",
        "One full day at leisure in Athens",
        "Private transfer from Athens hotel to Athens Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
  note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "Delphi Day Tour from Athens on SIC Basis with Lunch",
          price: "Euro 88 per adult & Euro 80 per Child",
        },
        {
          name: "Hydra, Poros, and Aegina Day Cruise on Shared Basis from Athens with Lunch",
          price: "Euro 133 per adult & Euro 87 per Child",
        },
      ],
    },

    pricing: {
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season) unless otherwise stated. The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel (Parnon or similar)",
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 302 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 272 per person onwards (Twin/Double) / Euro 227 (Triple)" },
                { pax: "06 Pax", price: "Euro 260 per person onwards (Twin/Double) / Euro 215 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 110 per child" },
                { pax: "Single Room Supplement", price: "Euro 284" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 490 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 460 per person onwards (Twin/Double) / Euro 253 (Triple)" },
                { pax: "06 Pax", price: "Euro 448 per person onwards (Twin/Double) / Euro 241 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 157 per child" },
                { pax: "Single Room Supplement", price: "Euro 300" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 505 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 475 per person onwards (Twin/Double) / Euro 424 (Triple)" },
                { pax: "06 Pax", price: "Euro 463 per person onwards (Twin/Double) / Euro 412 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 180 per child" },
                { pax: "Single Room Supplement", price: "Euro 390" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel (Casual Kubic Athens or similar)",
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 284 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 254 per person onwards (Twin/Double) / Euro 236 (Triple)" },
                { pax: "06 Pax", price: "Euro 242 per person onwards (Twin/Double) / Euro 224 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 130 per child" },
                { pax: "Single Room Supplement", price: "Euro 250" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 358 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 328 per person onwards (Twin/Double) / Euro 310 (Triple)" },
                { pax: "06 Pax", price: "Euro 316 per person onwards (Twin/Double) / Euro 298 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 130 per child" },
                { pax: "Single Room Supplement", price: "Euro 290" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 374 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 343 per person onwards (Twin/Double) / Euro 335 (Triple)" },
                { pax: "06 Pax", price: "Euro 331 per person onwards (Twin/Double) / Euro 323 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 155 per child" },
                { pax: "Single Room Supplement", price: "Euro 400" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 3 – 5* Hotel (Adia Aluma Athens, Curio Collection by Hilton or similar)",
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec – 2026-2027",
              rows: [
                { pax: "02 Pax", price: "Euro 550 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 520 per person onwards (Twin/Double) / Euro 480 (Triple)" },
                { pax: "06 Pax", price: "Euro 508 per person onwards (Twin/Double) / Euro 468 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 252 per child" },
                { pax: "Single Room Supplement", price: "Euro 310" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 525 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 495 per person onwards (Twin/Double) / Euro 485 (Triple)" },
                { pax: "06 Pax", price: "Euro 483 per person onwards (Twin/Double) / Euro 473 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 280 per child" },
                { pax: "Single Room Supplement", price: "Euro 390" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug – 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 610 per person onwards (Twin/Double)" },
                { pax: "04 Pax", price: "Euro 580 per person onwards (Twin/Double) / Euro 545 (Triple)" },
                { pax: "06 Pax", price: "Euro 568 per person onwards (Twin/Double) / Euro 533 (Triple)" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 170 per child" },
                { pax: "Single Room Supplement", price: "Euro 410" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Athens/day-1.jpg",
      "/images/Athens/day-2.jpg",
      "/images/Athens/day-3.jpg",
      "/images/Athens/day-4.jpg",
      "/images/Athens/day-5.jpg",
      "/images/Athens/day-6.jpg",
      "/images/Athens/day-7.jpg",
    ],

  },

  {
    title: "Athens Mykonos Santorini Heraklion",
    slug: "athens-mykonos-santorini-heraklion",
    price: "Euro 1024 per person",
    rating: "4.9",
    image: "/images/Mykonos/day-4.jpg",
    days: "09 Days / 08 Nights",
    location: "Athens, Mykonos, Santorini, Heraklion",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 4 Cities, 08 Nights",
        places: "Athens, Mykonos, Santorini, Heraklion",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
        "SIC Sightseeing Tours Included",
        "Private Transfers Included",
      ],

      highlights: [
        "Acropolis & Parthenon",
        "Acropolis Museum",
        "Little Venice, Mykonos",
        "Mykonos Windmills",
        "Oia Sunset, Santorini",
        "Akrotiri Archaeological Site",
        "Spinalonga Island",
        "Agios Nikolaos",
      ],

      experiences: [
        {
          title: "Athens Half-Day Tour",
          desc: "Visit the Acropolis, Parthenon, Erechtheion and Acropolis Museum on an SIC basis.",
        },
        {
          title: "Mykonos Highlights Tour",
          desc: "Explore Mykonos Old Town, Little Venice, the windmills, Paraportiani Church and the village of Ano Mera.",
        },
        {
          title: "Santorini Island Bus Tour with Oia Sunset",
          desc: "Discover Akrotiri, Emporio village, Perissa's black sand beach, Profitis Ilias Mountain, wine tasting and the famous Oia sunset.",
        },
        {
          title: "Spinalonga & Agios Nikolaos Excursion",
          desc: "Full-day excursion with lunch to Agios Nikolaos, Plaka village and a cruise to Spinalonga Island.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Athens",
        desc: "Arrival at Athens International Airport and private transfer to the hotel. Rest of the day free at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Athens",
        desc: "Half-day guided sightseeing tour of Athens on SIC basis including the Acropolis Museum, Panathenaic Stadium, Temple of Olympian Zeus, Hadrian's Arch, the Acropolis, Parthenon and Erechtheion.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "03",
        title: "Athens – Mykonos",
        desc: "Check out and private transfer to Athens Ferry Port. High-speed ferry to Mykonos followed by private transfer to hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "04",
        title: "Mykonos",
        desc: "Guided Mykonos Highlights Tour on SIC basis covering Mykonos Old Town, Little Venice, windmills, Paraportiani Church, beaches (Agios Ioannis, Plati Yalos, San Stefanos, Kalafatis) and Ano Mera village.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "05",
        title: "Mykonos – Santorini",
        desc: "Check out and private transfer to Mykonos Ferry Port. High-speed ferry to Santorini followed by private transfer to hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "06",
        title: "Santorini",
        desc: "Full-day Island Bus Tour with Oia Sunset on SIC basis covering Akrotiri Archaeological Site (entrance payable directly), Emporio village, Perissa's black sand beach, Profitis Ilias Mountain, wine tasting and Oia sunset.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "07",
        title: "Santorini – Heraklion",
        desc: "Check out and private transfer to Santorini Ferry Port. High-speed ferry to Heraklion followed by private transfer to hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "08",
        title: "Heraklion",
        desc: "Full-day excursion to Spinalonga and Agios Nikolaos with lunch, including Agios Nikolaos lake and harbor, Plaka village, and a cruise to Spinalonga Island (entrance payable directly).",
        tags: [
          { label: "Breakfast", icon: leaf },
          { label: "Lunch", icon: cream },
        ],
      },
      {
        day: "09",
        title: "Heraklion – India",
        desc: "Check out and private transfer to Heraklion Airport for return journey home.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment is processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "Private transfer from Airports to hotels",
        "Private transfer from hotel to ferry Ports",
        "Half-Day Sightseeing Tour with Acropolis Museum on SIC Basis",
        "Mykonos Guided Highlights Tour on SIC Basis",
        "Santorini Island Bus Tour with Oia Sunset on SIC Basis (Akrotiri Archaeological Site entrance to be paid directly)",
        "Spinalonga and Agios Nikolaos Cruise with Lunch (Spinalonga entrance to be paid directly)",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (to be paid on the spot at the hotel)",
        "Lunch & Dinner (except Day 8 lunch)",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    hotelOptions: [
      {
        option: "Option 1 – 03* Hotels",
        hotels: [
          { city: "Athens 2N", hotel: "Arion Athens Hotel or similar" },
          { city: "Mykonos 2N", hotel: "Hotel Madalena or similar" },
          { city: "Santorini 2N", hotel: "Dream Island Hotel or similar" },
          { city: "Heraklion 2N", hotel: "Kastro Hotel or similar" },
        ],
        rates: [
          {
            season: "April, May, June, July & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1024 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 935 per person on Twin/Double sharing basis / Euro 887 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 888 per person on Twin/Double sharing basis / Euro 791 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 426 per child" },
              { pax: "Single Room Supplement", price: "Euro 475" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Sep & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1047 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 958 per person on Twin/Double sharing basis / Euro 912 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 911 per person on Twin/Double sharing basis / Euro 816 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 455 per child" },
              { pax: "Single Room Supplement", price: "Euro 498" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 2 – 04* Hotels",
        hotels: [
          { city: "Athens 2N", hotel: "International Atene hotel or similar" },
          { city: "Mykonos 2N", hotel: "Paradision hotel or similar" },
          { city: "Santorini 2N", hotel: "Santorini Palace or similar" },
          { city: "Heraklion 2N", hotel: "Castello City Hotel or similar" },
        ],
        rates: [
          {
            season: "April, May, June, July & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1161 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1072 per person on Twin/Double sharing basis / Euro 995 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1025 per person on Twin/Double sharing basis / Euro 948 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 606 per child" },
              { pax: "Single Room Supplement", price: "Euro 595" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Sep & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1174 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1085 per person on Twin/Double sharing basis / Euro 1032 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1036 per person on Twin/Double sharing basis / Euro 982 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 683 per child" },
              { pax: "Single Room Supplement", price: "Euro 609" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 3 – 05* Hotels",
        hotels: [
          { city: "Athens 2N", hotel: "Divani Caravel Hotel or similar" },
          { city: "Mykonos 2N", hotel: "Mykonos Princess Hotel or similar" },
          { city: "Santorini 2N", hotel: "The Majestic Hotel Santorini or similar" },
          { city: "Heraklion 2N", hotel: "Aquila Atlantis Hotel or similar" },
        ],
        rates: [
          {
            season: "April, May, June, July & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1402 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1313 per person on Twin/Double sharing basis / Euro 1135 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1266 per person on Twin/Double sharing basis / Euro 1088 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 544 per child" },
              { pax: "Single Room Supplement", price: "Euro 836" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Sep & Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1486 per person on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1397 per person on Twin/Double sharing basis / Euro 1243 per person on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1348 per person on Twin/Double sharing basis / Euro 1193 per person on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 692 per child" },
              { pax: "Single Room Supplement", price: "Euro 921" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
    ],

    optionalCostForFerryAndTour: {
  note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        { component: "Economy class ferry ticket", price: "291" },
        { component: "Half-day Delos tour from Mykonos on shared basis", price: "145" },
        { component: "Volcanic Island Sunset Dinner Cruise from Santorini on shared basis", price: "95" },
      ],
    },

    pricing: {
      rows: [
        { category: "3 Star", price: "Euro 1024 per person", unit: "02 Pax, Twin/Double sharing, Apr-Aug 2026" },
        { category: "4 Star", price: "Euro 1161 per person", unit: "02 Pax, Twin/Double sharing, Apr-Aug 2026" },
        { category: "5 Star", price: "Euro 1402 per person", unit: "02 Pax, Twin/Double sharing, Apr-Aug 2026" },
      ],
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season). See hotelOptions for full pax/season breakdown. Rates not applicable during fair/event dates.",
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when payment is processed, ROE is subject to change.",
    ],

    images: [
      "/images/Mykonos/day-1.jpg",
      "/images/Mykonos/day-2.jpg",
      "/images/Mykonos/day-3.jpg",
      "/images/Mykonos/day-4.jpg",
      "/images/Mykonos/day-5.jpg",
      "/images/Mykonos/day-6.jpg",
      "/images/Mykonos/day-7.jpg",
      "/images/Mykonos/day-8.jpg",
      "/images/Mykonos/day-9.jpg",
      "/images/Mykonos/extra1.jpg",
      "/images/Mykonos/extra2.jpg",
      "/images/Mykonos/extra3.jpg",
      "/images/Mykonos/extra4.jpg",
      "/images/Mykonos/extra5.jpg",

    ],

  },

  {
    title: "Glimpses of Greece",
    slug: "glimpses-of-greece-athens-santorini",
    price: "Euro 905 per person",
    rating: "4.9",
    days: "06 Days / 05 Nights",
    image: "/images/Greece/day-1.jpg",
    location: "Athens, Santorini",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 2 Cities, 05 Nights",
        places: "Athens, Santorini",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
        "Half-Day Athens Sightseeing on SIC Basis",
        "Private Transfers Included",
      ],

      highlights: [
        "Acropolis",
        "Acropolis Museum",
        "Santorini Caldera",
        "Volcanic Islands & Hot Springs",
        "Catamaran Caldera Cruise",
      ],

      experiences: [
        {
          title: "Athens Half-Day Sightseeing Tour",
          desc: "Guided visit to the Acropolis, a UNESCO World Heritage site, and the Acropolis Museum showcasing ancient sculptures and artifacts.",
        },
        {
          title: "Santorini Volcanic Islands Cruise with Hot Springs Visit",
          desc: "Shared-basis sail from Athinios Port on a traditional wooden boat through the caldera with live commentary, visiting spots shaped by volcanic activity.",
        },
        {
          title: "Santorini Catamaran Caldera Cruise",
          desc: "Shared-basis catamaran cruise along Santorini's volcanic coastline with views of cliffs and lava formations, often including swimming stops.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Athens",
        desc: "Arrival at Athens International Airport and private transfer to the hotel. Rest of the day free at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Athens – Half-Day Sightseeing Tour with Acropolis Museum on SIC Basis",
        desc: "Shared-basis half-day sightseeing tour of Athens, visiting the Acropolis and the Acropolis Museum.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "03",
        title: "Athens – Santorini",
        desc: "Private transfer from Athens hotel to Athens Ferry Port, economy ferry from Athens to Santorini, then private transfer from Santorini Ferry Port to the hotel.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "04",
        title: "Santorini – Day at Leisure / Volcanic Islands Cruise with Hot Springs Visit on Shared Basis",
        desc: "Day at leisure, or an optional shared-basis cruise from Athinios Port on a traditional wooden boat through Santorini's volcanic caldera with live commentary.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "05",
        title: "Santorini – Day at Leisure / Catamaran Caldera Cruise on Shared Basis",
        desc: "Day at leisure, or an optional shared-basis catamaran cruise around Santorini's caldera with views of cliffs, lava formations and crystal-clear waters.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "06",
        title: "Santorini – India",
        desc: "Private transfer from Santorini hotel to Santorini Airport for the return journey home.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment is processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "05 Night Accommodation with Breakfast",
        "Private Transfer from Athens Airport to Athens Hotel",
        "Athens Half-Day Sightseeing Tour with Acropolis Museum on SIC Basis",
        "Private Transfer from Athens Hotel to Athens Ferry Port",
        "Economy Ferry from Athens to Santorini",
        "Private Transfer from Santorini Ferry Port to Santorini Hotel",
        "Private Transfer from Santorini Hotel to Santorini Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (to be paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    hotelOptions: [
      {
        option: "Option 1 – 03* Hotel",
        hotels: [
          { city: "Athens 2N", hotel: "Apollo Hotel Athens or Similar" },
          { city: "Santorini 3N", hotel: "Kastro Suites or similar" },
        ],
        rates: [
          {
            season: "Apr, May, Jun & Jul - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 905 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 872 per person onwards on Twin/Double sharing basis / Euro 697 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 846 per person onwards on Twin/Double sharing basis / Euro 577 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 122 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 535 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Aug, Sep & Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 951 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 890 per person onwards on Twin/Double sharing basis / Euro 708 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 864 per person onwards on Twin/Double sharing basis / Euro 682 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 119 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 553 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 2 – 04* Hotel",
        hotels: [
          { city: "Athens 2N", hotel: "Casual Kubic Athens or Similar" },
          { city: "Santorini 3N", hotel: "Aria Suites or similar" },
        ],
        rates: [
          {
            season: "Apr, May, Jun & Jul - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1046 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 990 per person onwards on Twin/Double sharing basis / Euro 797 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 964 per person onwards on Twin/Double sharing basis / Euro 771 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 196 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 648 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Aug, Sep & Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1029 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 973 per person onwards on Twin/Double sharing basis / Euro 911 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 943 per person onwards on Twin/Double sharing basis / Euro 890 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 557 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 631 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
    ],

    optionalCosts: [
      {
        title: "Santorini Volcanic Islands Cruise with Hot Springs Visit on Shared Basis",
        price: "EUR 57 Per Adult and EUR 29 Per Child",
      },
      {
        title: "Santorini Catamaran Caldera Cruise on Shared Basis",
        price: "EUR 110 Per Adult and EUR 55 Per Child",
      },
    ],

    pricing: {
      rows: [
        { category: "3 Star", price: "Euro 905 per person", unit: "02 Pax, Twin/Double sharing, Apr-Jul 2026" },
        { category: "4 Star", price: "Euro 1046 per person", unit: "02 Pax, Twin/Double sharing, Apr-Jul 2026" },
      ],
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season). See hotelOptions for full pax/season breakdown. Rates not applicable during fair/event dates.",
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when payment is processed, ROE is subject to change.",
    ],

    images: [
      "/images/Greece/day-1.jpg",
      "/images/Greece/day-2.jpg",
      "/images/Greece/day-3.jpg",
      "/images/Greece/day-4.jpg",
      "/images/Greece/day-5.jpg",
      "/images/Greece/day-6.jpg",
      "/images/Greece/extra1.jpg",
      "/images/Greece/extra2.jpg",
      "/images/Greece/extra3.jpg",
    ],
  },

  {
    title: "Experience the Heart of Greece",
    slug: "experience-the-heart-of-greece-athens-mykonos-santorini",
    price: "EUR 1232 per person",
    days: "08 Days / 07 Nights",
    rating: "4.9",
    image: "/images/heart/day-1.jpg",
    location: "Athens, Mykonos, Santorini",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 07 Nights",
        places: "Athens, Mykonos, Santorini",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
        "Half-Day Athens Sightseeing on SIC Basis",
        "Private Transfers Included",
      ],

      highlights: [
        "Acropolis",
        "Parthenon",
        "Acropolis Museum",
        "Mykonos Cycladic Villages",
        "Santorini Caldera",
        "Volcanic Islands & Hot Springs",
      ],

      experiences: [
        {
          title: "Athens Sightseeing Tour",
          desc: "Half-Day Sightseeing Tour with Acropolis Museum on SIC basis, visiting the Acropolis, Parthenon and other historic sites.",
        },
        {
          title: "Mykonos Highlights Tour",
          desc: "Guided Highlights Tour of Mykonos on shared basis, discovering key attractions, traditional villages, scenic viewpoints and cultural highlights.",
        },
        {
          title: "Santorini Volcanic Islands Cruise",
          desc: "Volcanic Islands Cruise with Hot Springs Visit on shared basis, sailing across the caldera and enjoying a rejuvenating swim in the hot springs.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Greece (Arrival in Athens)",
        desc: "Private transfer from Athens International Airport to the hotel. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Athens Sightseeing Tour",
        desc: "Half-Day Sightseeing Tour with Acropolis Museum on SIC basis, visiting the Acropolis, Parthenon and other historic sites. Rest of the day free at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "03",
        title: "Athens – Mykonos",
        desc: "Check out and private transfer to Athens Ferry Port. Economy class ferry to Mykonos, then private transfer to the hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "04",
        title: "Mykonos Highlights Tour",
        desc: "Guided Highlights Tour of Mykonos on shared basis, discovering key attractions, traditional villages, scenic viewpoints and cultural highlights. Rest of the day free at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "05",
        title: "Mykonos – Santorini",
        desc: "Check out and private transfer to Mykonos Ferry Port. Economy class ferry to Santorini, then private transfer to the hotel. Evening at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "06",
        title: "Santorini Volcanic Islands Cruise",
        desc: "Volcanic Islands Cruise with Hot Springs Visit on shared basis, sailing across the caldera, exploring volcanic landscapes and a swim in the hot springs. Evening at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "07",
        title: "Santorini – Athens",
        desc: "Check out and private transfer to Santorini Airport for the flight to Athens. Upon arrival, private transfer to the hotel. Rest of the day free at leisure.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "08",
        title: "Departure",
        desc: "Check out and private transfer from the Athens hotel to Athens International Airport for the onward flight.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment is processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "Private transfer from Athens Airport to Athens hotel",
        "Half-Day Sightseeing Tour with Acropolis Museum from Athens on SIC basis",
        "Private transfer from Athens hotel to Athens Ferry Port",
        "Economy class ferry ticket from Athens to Mykonos",
        "Private transfer from Mykonos Ferry Port to Mykonos hotel",
        "Guided Highlights Tour of Mykonos on shared basis",
        "Private transfer from Mykonos hotel to Mykonos Ferry Port",
        "Economy class ferry ticket from Mykonos to Santorini",
        "Private transfer from Santorini Ferry Port to Santorini hotel",
        "Volcanic Islands Cruise with Hot Springs Visit from Santorini on shared basis",
        "Private transfer from Santorini hotel to Santorini Airport",
        "Private transfer from Athens Airport to Athens hotel",
        "Private transfer from Athens hotel to Athens Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (to be paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    hotelOptions: [
      {
        option: "Option 1 – 03* Hotel",
        hotels: [
          { city: "02 Night Athens", hotel: "Acropolis Hill or similar" },
          { city: "02 Night Mykonos", hotel: "Elena Hotel or Similar" },
          { city: "02 Night Santorini", hotel: "Pantelia Suites or Similar" },
          { city: "02 Night Athens", hotel: "Acropolis Hill Hotel or similar" },
        ],
        rates: [
          {
            season: "Jan, Feb, Nov & Dec - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1232 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1131 per person onwards on Twin/Double sharing basis / EUR 1113 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 969 per person onwards on Twin/Double sharing basis / EUR 901 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 490 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 520 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "April, May, June, July, Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1527 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1426 per person onwards on Twin/Double sharing basis / EUR 1366 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1264 per person onwards on Twin/Double sharing basis / EUR 1154 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 530 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 795 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Mar, Sep & Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1337 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1236 per person onwards on Twin/Double sharing basis / EUR 1189 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1074 per person onwards on Twin/Double sharing basis / EUR 977 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 520 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 605 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 2 – 04* Hotel",
        hotels: [
          { city: "02 Night Athens", hotel: "Amalia Hotel Athens or Similar" },
          { city: "02 Night Mykonos", hotel: "Harmony Boutique Hotel-Mykonos Town or Similar" },
          { city: "02 Night Santorini", hotel: "Asha Luxury Suites or Similar" },
          { city: "01 Night Athens", hotel: "Novotel Athenes or Similar" },
        ],
        rates: [
          {
            season: "Jan, Feb, Nov & Dec - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1182 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1096 per person onwards on Twin/Double sharing basis / EUR 1086 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 919 per person onwards on Twin/Double sharing basis / EUR 894 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 540 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 460 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "April, May, June, July, Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1516 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1415 per person onwards on Twin/Double sharing basis / EUR 1201 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1253 per person onwards on Twin/Double sharing basis / EUR 986 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 690 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 799 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Mar, Sep, Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1216 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1140 per person onwards on Twin/Double sharing basis / EUR 1126 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 953 per person onwards on Twin/Double sharing basis / EUR 919 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 545 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 510 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 3 – 05* Hotel",
        hotels: [
          { city: "02 Night Athens", hotel: "Adia Aluma Athens, Curio Collection by Hilton or Similar" },
          { city: "02 Night Mykonos", hotel: "Tharroe of Mykonos Hotel or Similar" },
          { city: "02 Night Santorini", hotel: "De sol spa hotel or Similar" },
          { city: "01 Night Athens", hotel: "Divani Palace Acropolis or Similar" },
        ],
        rates: [
          {
            season: "Jan, Feb, Nov & Dec - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1537 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1476 per person onwards on Twin/Double sharing basis / EUR 1384 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1314 per person onwards on Twin/Double sharing basis / EUR 1172 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 570 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 855 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "April, May, June, July, Aug - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1876 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1775 per person onwards on Twin/Double sharing basis / EUR 1576 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1613 per person onwards on Twin/Double sharing basis / EUR 1364 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 670 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 1134 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Mar, Sep, Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "EUR 1621 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "EUR 1520 per person onwards on Twin/Double sharing basis / EUR 1429 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "EUR 1353 per person onwards on Twin/Double sharing basis / EUR 1217 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "EUR 555 per child onwards" },
              { pax: "Single Room Supplement", price: "EUR 889 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
    ],

    pricing: {
      rows: [
        { category: "3 Star", price: "EUR 1232 per person", unit: "02 Pax, Twin/Double sharing, Jan/Feb/Nov/Dec 2026" },
        { category: "4 Star", price: "EUR 1182 per person", unit: "02 Pax, Twin/Double sharing, Jan/Feb/Nov/Dec 2026" },
        { category: "5 Star", price: "EUR 1537 per person", unit: "02 Pax, Twin/Double sharing, Jan/Feb/Nov/Dec 2026" },
      ],
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season). See hotelOptions for full pax/season breakdown across all months and hotel tiers. Rates not applicable during fair/event dates.",
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when payment is processed, ROE is subject to change.",
    ],

    images: [
      "/images/heart/day-1.jpg",
      "/images/heart/day-2.jpg",
      "/images/heart/day-3.jpg",
      "/images/heart/day-4.jpg",
      "/images/heart/day-5.jpg",
      "/images/heart/day-6.jpg",
      "/images/heart/extra1.jpg",
    ],
  },

  {
    title: "Greece Getaway Plus",
    slug: "greece-getaway-plus-athens-mykonos-santorini",
    price: "Euro 909 per person",
    rating: "4.9",
    days: "07 Days / 06 Nights",
    location: "Athens, Mykonos, Santorini",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 06 Nights",
        places: "Athens, Mykonos, Santorini",
      },

      pills: [
        "Breakfast Included",
        "Hotel Stay Included",
        "Half-Day Athens Sightseeing on SIC Basis",
        "Private Transfers Included",
      ],

      highlights: [
        "Acropolis",
        "Acropolis Museum",
        "Mykonos Windmills",
        "Little Venice, Mykonos",
        "Santorini Caldera",
        "Volcanic Islands & Hot Springs",
      ],

      experiences: [
        {
          title: "Athens Half-Day Sightseeing Tour",
          desc: "Shared-basis half-day sightseeing tour of Athens, visiting the Acropolis and the Acropolis Museum.",
        },
        {
          title: "Mykonos City and Island Tour",
          desc: "Shared-basis tour showcasing the iconic windmills, Little Venice and panoramic island viewpoints of Mykonos.",
        },
        {
          title: "Santorini Volcanic Islands Cruise with Hot Springs Visit",
          desc: "Shared-basis sail from Athinios Port on a traditional wooden boat through the caldera with live commentary, visiting spots shaped by volcanic activity.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Athens",
        desc: "Arrival at Athens International Airport and private transfer to the hotel. Rest of the day free at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Athens – Half-Day Sightseeing Tour with Acropolis Museum on SIC Basis",
        desc: "Shared-basis half-day sightseeing tour of Athens, visiting the Acropolis and the Acropolis Museum.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "03",
        title: "Athens – Mykonos",
        desc: "Check out and private transfer to Athens Port. High-speed ferry (economy class) to Mykonos, then private transfer to the hotel.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "04",
        title: "Mykonos – Mykonos City and Island Tour on Shared Basis",
        desc: "Shared-basis Mykonos city and island tour covering the iconic windmills, Little Venice and panoramic island viewpoints.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "05",
        title: "Mykonos – Santorini",
        desc: "Check out and private transfer to Mykonos Port. High-speed ferry (economy class) to Santorini, then private transfer to the hotel.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "06",
        title: "Santorini – Day at Leisure / Volcanic Islands Cruise with Hot Springs Visit on Shared Basis",
        desc: "Day at leisure, or an optional shared-basis cruise from Athinios Port on a traditional wooden boat through Santorini's volcanic caldera with live commentary.",
        tags: [{ label: "Breakfast", icon: leaf }],
      },
      {
        day: "07",
        title: "Santorini – India",
        desc: "Private transfer from Santorini hotel to Santorini Airport for the return journey home.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment is processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private Transfer from Athens Airport to Athens Hotel",
        "Half day city tour of Athens with Acropolis on Seat in coach basis",
        "Private Transfer from Athens Hotel to Athens Port",
        "High-speed ferry (Economy class) from Athens to Mykonos",
        "Private Transfer from Mykonos Port to Mykonos Hotel",
        "Mykonos City and Island tour on Shared basis",
        "Private Transfer from Mykonos Hotel to Mykonos Port",
        "High-speed ferry (Economy class) from Mykonos to Santorini",
        "Private Transfer from Santorini Port to Santorini Hotel",
        "Private Transfer from Santorini Hotel to Santorini Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (to be paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    hotelOptions: [
      {
        option: "Option 1 – 03* Hotel",
        hotels: [
          { city: "Athens 2N", hotel: "Apollo Hotel Athens or Similar" },
          { city: "Mykonos 2N", hotel: "Hotel madalena or similar" },
          { city: "Santorini 2N", hotel: "Melina hotel or Similar" },
        ],
        rates: [
          {
            season: "April, May, June & Jul - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 909 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 838 per person onwards on Twin/Double sharing basis / Euro 807 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 803 per person onwards on Twin/Double sharing basis / Euro 772 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 369 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 305 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Aug, Sep & Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1064 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 993 per person onwards on Twin/Double sharing basis / Euro 863 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 958 per person onwards on Twin/Double sharing basis / Euro 833 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 227 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 460 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
      {
        option: "Option 2 – 04* Hotel",
        hotels: [
          { city: "Athens 2N", hotel: "Casual Kubic Athens or Similar" },
          { city: "Mykonos 2N", hotel: "Porto mykonos hotel or similar" },
          { city: "Santorini 2N", hotel: "Nomikos Villas or Similar" },
        ],
        rates: [
          {
            season: "April, May, June & Jul - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1109 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1038 per person onwards on Twin/Double sharing basis / Euro 923 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1003 per person onwards on Twin/Double sharing basis / Euro 888 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 317 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 505 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
          {
            season: "Aug, Sep & Oct - 2026",
            rows: [
              { pax: "02 Pax", price: "Euro 1209 per person onwards on Twin/Double sharing basis" },
              { pax: "04 Pax", price: "Euro 1138 per person onwards on Twin/Double sharing basis / Euro 963 per person onwards on Triple sharing basis" },
              { pax: "06 Pax", price: "Euro 1103 per person onwards on Twin/Double sharing basis / Euro 933 per person onwards on Triple sharing basis" },
              { pax: "Child Sharing with Extra Bed", price: "Euro 237 per child onwards" },
              { pax: "Single Room Supplement", price: "Euro 605 onwards" },
              { pax: "Below 2-year child", price: "Free of cost" },
            ],
          },
        ],
      },
    ],

    optionalCosts: [
      {
        title: "Santorini Volcanic Islands Cruise with Hot Springs Visit on Shared Basis",
        price: "EUR 57 Per Adult and EUR 29 Per Child",
      },
      {
        title: "From Mykonos Delos Islands Half-Day Trip by Boat on Shared Basis",
        price: "EUR 86 Per Adult/Per Child",
      },
    ],

    pricing: {
      rows: [
        { category: "3 Star", price: "Euro 909 per person", unit: "02 Pax, Twin/Double sharing, Apr-Jul 2026" },
        { category: "4 Star", price: "Euro 1109 per person", unit: "02 Pax, Twin/Double sharing, Apr-Jul 2026" },
      ],
      note: "All prices are PER PERSON, based on 02 Pax twin/double sharing (lowest season). See hotelOptions for full pax/season breakdown across all hotel tiers. Rates not applicable during fair/event dates.",
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost, to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when payment is processed, ROE is subject to change.",
    ],

    images: [],
  },


  {
    title: "Best of Mykonos",
    slug: "best-of-mykonos-3n",
    price: "Euro 458 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Apr-Aug 2026)
    days: "03 Nights / 04 Days",
    rating: "4.9",
    image: "/images/my/day-1.jpg",
    location: "Mykonos, Greece",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 1 City, 03 Nights",
        places: "Mykonos",
      },

      pills: [
        "Breakfast Included",
        "Private Airport Transfers Included",
        "03 Nights Accommodation",
      ],

      highlights: [
        "Delos Ancient Ruins",
        "Rhenia Island",
        "Mykonos Town (Chora)",
        "Little Venice",
        "Windmills of Mykonos",
      ],

      experiences: [
        {
          title: "Delos & Rhenia Cruise",
          desc: "Shared cruise to Delos & Rhenia, exploring the ancient ruins of Delos and enjoying sailing and swimming near Rhenia Island.",
        },
        {
          title: "Day at Leisure in Mykonos",
          desc: "Free day to explore Mykonos Town (Chora), Little Venice, the Windmills of Mykonos, or enjoy an optional beach visit or shopping.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Mykonos: Arrival in Mykonos",
        desc: "Arrival at Mykonos Airport. Private transfer from Mykonos Airport to hotel. Check-in at hotel. Rest of the day at leisure. Overnight stay in Mykonos.",
        tags: [],
      },
      {
        day: "02",
        title: "Delos & Rhenia Cruise",
        desc: "Breakfast at the hotel. Proceed for shared cruise to Delos & Rhenia. Explore the ancient ruins of Delos and enjoy sailing and swimming near Rhenia Island. Return to Mykonos by afternoon. Evening free at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Day at Leisure",
        desc: "Breakfast at the hotel. Day free at leisure (no services provided as per itinerary). Guests may explore on their own: Mykonos Town (Chora), Little Venice, Windmills of Mykonos, optional beach visit or shopping. Overnight stay in Mykonos.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Departure",
        desc: "Breakfast at the hotel. Check-out. Private transfer from hotel to Mykonos Airport for onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "03 Nights' accommodation with breakfast",
        "Mykonos Hotel",
        "Private Airport → Hotel transfer",
        "Shared Delos & Rhenia Cruise",
        "Private Hotel → Airport transfer",
        "Leisure day with no services",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "Day tour to South east in cruise from Mykonos on shared basis",
          price: "EUR 88 per Adult & EUR 55 per Child",
        },
      ],
    },

    pricing: {
      note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel (Mykonos View or similar)",
          hotels: [
            { location: "Mykonos 03 N", hotel: "Mykonos View or similar" },
          ],
          seasons: [
            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 458 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 441 per person onwards on Twin/Double sharing basis / Euro 436 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 429 per person onwards on Twin/Double sharing basis / Euro 424 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 375 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 320 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Aug, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 528 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 496 per person onwards on Twin/Double sharing basis / Euro 484 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 464 per person onwards on Twin/Double sharing basis / Euro 462 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 304 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 454 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel (Porto Mykonos Hotel or similar)",
          hotels: [
            { location: "Mykonos 03 N", hotel: "Porto Mykonos Hotel or similar" },
          ],
          seasons: [
            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 466 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 444 per person onwards on Twin/Double sharing basis / Euro 432 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 432 per person onwards on Twin/Double sharing basis / Euro 420 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 385 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 302 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Aug, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 1456 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 1411 per person onwards on Twin/Double sharing basis / Euro 1262 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 1368 per person onwards on Twin/Double sharing basis / Euro 1219 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 397 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 302 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/my/day-1.jpg",
      "/images/my/day-2.jpg",
      "/images/my/day-3.jpg",
      "/images/my/day-4.jpg",
      "/images/my/extra1.jpg",
      "/images/my/extra2.jpg",
    ],
  },



  {
    title: "Explore Santorini",
    slug: "explore-santorini-3n",
    price: "Euro 447 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Apr-Jul 2026)
    days: "03 Nights / 04 Days",
    rating: "4.9",
    image: "/images/san/day-1.jpg",
    location: "Santorini, Greece",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 1 City, 03 Nights",
        places: "Santorini",
      },

      pills: [
        "Breakfast Included",
        "Private Airport Transfers Included",
        "03 Nights Accommodation",
      ],

      highlights: [
        "Santorini Caldera",
        "Volcano & Hot Springs",
        "Red and White Beaches",
        "Santorini Island Villages",
        "Catamaran Cruise",
      ],

      experiences: [
        {
          title: "Volcano and Hot Springs Sunset Dinner Cruise",
          desc: "Sail across the caldera toward the volcanic islands, explore the volcano's rugged trails, swim in mineral-rich hot springs, and enjoy dinner on board as the sun sets over the caldera.",
        },
        {
          title: "Santorini Island Bus Tour",
          desc: "Guided island bus tour showcasing picturesque villages, scenic viewpoints and cultural landmarks, with free time to explore streets, shops and cafés.",
        },
        {
          title: "5-Hour Catamaran Cruise – Morning or Sunset Tour",
          desc: "Sail along Santorini's coastline with stops at the Red and White Beaches and volcanic hot springs for swimming and snorkeling, with a freshly prepared meal and drinks on board.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Santorini: Arrival in Santorini",
        desc: "Arrival at Santorini Airport (JTR). After passport control and baggage claim, proceed to the arrivals hall where taxis, shuttle services and car rental counters are available. Overnight Stay in Santorini.",
        tags: [],
      },
      {
        day: "02",
        title: "Santorini – Volcano and Hot Springs Sunset Dinner Cruise / Santorini Island Bus Tour",
        desc: "Breakfast at Hotel. Experience the Volcano and Hot Springs Sunset Dinner Cruise, sailing across the caldera, exploring the volcano's trails, swimming in hot springs and enjoying dinner as the sun sets. Also includes the Santorini Island Bus Tour, discovering picturesque villages, scenic viewpoints and cultural landmarks. Overnight Stay in Santorini.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Santorini – 5-Hour Catamaran Cruise – Morning or Sunset Tour",
        desc: "Breakfast at Hotel. Sail along Santorini's coastline on a 5-hour catamaran cruise (morning or sunset option), stopping at the Red and White Beaches and volcanic hot springs for swimming and snorkeling, with a meal and drinks on board. Overnight Stay in Santorini.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Santorini – India: Departure",
        desc: "Breakfast at Hotel. After breakfast, proceed to Santorini Airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "03 Night Accommodation with Breakfast",
        "Transfer from Santorini airport to hotel on private basis",
        "Volcano and Hot Springs Sunset Dinner Cruise",
        "Santorini Island Bus Tour",
        "5-Hour Catamaran Cruise – Morning or Sunset Tour",
        "Private Transfer from Santorini Hotel to Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel (Hotel Kalma or similar)",
          hotels: [
            { location: "Santorini 3N", hotel: "Hotel Kalma or similar" },
          ],
          seasons: [
            {
              months: "Apr, May, Jun & Jul - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 447 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 422 per person onwards on Twin/Double sharing basis / Euro 379 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 416 per person onwards on Twin/Double sharing basis / Euro 372 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 193 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 161 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Aug, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 449 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 425 per person onwards on Twin/Double sharing basis / Euro 384 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 418 per person onwards on Twin/Double sharing basis / Euro 376 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 202 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 164 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel (Pantheon Hotel or similar)",
          hotels: [
            { location: "Santorini 3N", hotel: "Pantheon Hotel or similar" },
          ],
          seasons: [
            {
              months: "Apr, May, Jun & Jul - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 481 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 458 per person onwards on Twin/Double sharing basis / Euro 412 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 452 per person onwards on Twin/Double sharing basis / Euro 405 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 217 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 194 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Aug, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 495 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 472 per person onwards on Twin/Double sharing basis / Euro 420 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 466 per person onwards on Twin/Double sharing basis / Euro 413 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 219 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 208 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 3 – 5* Hotel (Splendour Hotel and Suites or similar)",
          hotels: [
            { location: "Santorini 3N", hotel: "Splendour Hotel and Suites or similar" },
          ],
          seasons: [
            {
              months: "Apr, May, Jun & Jul - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 553 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 530 per person onwards on Twin/Double sharing basis / Euro 522 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 524 per person onwards on Twin/Double sharing basis / Euro 516 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 399 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 264 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Aug, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "Euro 556 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "Euro 532 per person onwards on Twin/Double sharing basis / Euro 524 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "Euro 526 per person onwards on Twin/Double sharing basis / Euro 518 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 388 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 256 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/san/day-1.jpg",
      "/images/san/day-2.jpg",
      "/images/san/day-3.jpg",
      "/images/san/day-4.jpg",
      "/images/san/extra1.jpg",
      "/images/san/extra2.jpg",
      "/images/san/extra3.jpg",
    ],
  },


  // {
  //   title: "Best of Barcelona, Madrid & Ibiza",
  //   slug: "best-of-barcelona-madrid-ibiza",
  //   price: "Euro 1114 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
  //   days: "08 Nights / 09 Days",
  //   rating: "",
  //   image: "",
  //   location: "Barcelona, Madrid, Ibiza, Spain",
  //   nextDate: "Available on Request",

  //   highlightsData: {
  //     locationCard: {
  //       meta: "1 Country, 3 Cities, 08 Nights",
  //       places: "Barcelona, Madrid, Ibiza",
  //     },

  //     pills: [
  //       "Breakfast Included",
  //       "Private Airport Transfers Included",
  //       "08 Nights Accommodation",
  //     ],

  //     highlights: [
  //       "Sagrada Familia",
  //       "Montserrat Monastery",
  //       "Royal Palace, Madrid",
  //       "Prado Museum",
  //       "Segovia & Toledo",
  //       "Formentera Cruise",
  //     ],

  //     experiences: [
  //       {
  //         title: "Barcelona Hop-On Hop-Off City Tour",
  //         desc: "Covers Plaça de Catalunya, Gothic Quarter, La Rambla, Olympic Port and Montjuïc Hill, followed by a visit to Sagrada Familia with entry ticket.",
  //       },
  //       {
  //         title: "Montserrat Day Tour",
  //         desc: "Shared coach to Montserrat, travel up the mountain by cog-wheel train or cable car, guided orientation tour and visit to Santa Maria de Montserrat Abbey including the Black Madonna.",
  //       },
  //       {
  //         title: "Madrid Hop-On Hop-Off City Tour",
  //         desc: "Covers the Royal Palace, Plaza Mayor, Gran Via and Puerta del Sol, followed by a Prado Museum Guided Tour with Skip-the-Line Ticket.",
  //       },
  //       {
  //         title: "Segovia & Toledo Day Tour with Alcázar",
  //         desc: "Shared coach day tour to Segovia (Roman Aqueduct, Alcázar of Segovia) and Toledo (Toledo Cathedral exterior, Jewish Quarter, artisan streets).",
  //       },
  //       {
  //         title: "Ibiza – Formentera Cruise",
  //         desc: "Shared-basis cruise to Formentera including paddle activities, snorkeling and scenic coastal views.",
  //       },
  //     ],
  //   },

  //   itinerary: [
  //     {
  //       day: "01",
  //       title: "India – Barcelona",
  //       desc: "Arrival at Barcelona Airport. Meet & greet and private transfer to the hotel. Check-in and rest of the day at leisure. Overnight Stay in Barcelona.",
  //       tags: [],
  //     },
  //     {
  //       day: "02",
  //       title: "Barcelona – Hop On Hop Off City Tour",
  //       desc: "Breakfast at the hotel. 01 Day Hop-On Hop-Off City Tour covering Plaça de Catalunya, Gothic Quarter, La Rambla, Olympic Port and Montjuïc Hill. Later, visit Sagrada Familia with entry ticket only. Evening free for leisure or shopping. Overnight Stay in Barcelona.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "03",
  //       title: "Barcelona – Montserrat Day Tour",
  //       desc: "Breakfast at hotel. Pickup from a designated meeting point in Barcelona on a shared coach to Montserrat. Travel up the mountain by cog-wheel train or cable car (subject to availability). Guided orientation tour and visit to Santa Maria de Montserrat Abbey, including access to see the Black Madonna (La Moreneta). Free time to explore the basilica, enjoy panoramic views, visit souvenir shops, or taste local products. Return to Barcelona.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "04",
  //       title: "Barcelona → Madrid",
  //       desc: "Breakfast at the hotel. After check-out, private transfer from Barcelona Hotel to Barcelona Station to board the onward journey to Madrid (train ticket not included). Upon arrival at Madrid Station, private transfer to the hotel. Rest of the day at leisure. Overnight Stay in Madrid.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "05",
  //       title: "Madrid Hop-On Hop-Off City Tour",
  //       desc: "Breakfast at the hotel. 01 Day Hop-On Hop-Off City Tour of Madrid covering the Royal Palace, Plaza Mayor, Gran Via and Puerta del Sol. Later, enjoy the Prado Museum Guided Tour with Skip-the-Line Ticket. Evening free at leisure. Overnight Stay in Madrid.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "06",
  //       title: "Day Tour from Madrid to Segovia & Toledo with Alcázar (Shared Basis)",
  //       desc: "Breakfast at the hotel. Departure from a designated meeting point in Madrid by shared coach with a professional guide. Guided walking tour of Segovia including the Roman Aqueduct, the old town and the Alcázar of Segovia. Free time in Segovia, then continue to Toledo, the 'City of Three Cultures.' Panoramic view of the city followed by a guided walking tour covering the exterior of Toledo Cathedral, the Jewish Quarter and artisan streets. Free time before returning to Madrid by shared coach.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "07",
  //       title: "Madrid → Ibiza",
  //       desc: "Breakfast at the hotel. Check-out and private transfer from Madrid Hotel to Madrid Airport for the flight to Ibiza (flight not included). Upon arrival at Ibiza Airport, private transfer to the hotel. Rest of the day free to relax or explore Ibiza town. Overnight Stay in Ibiza.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "08",
  //       title: "Ibiza – Formentera Cruise",
  //       desc: "Breakfast at the hotel. Formentera Cruise on a shared basis including paddle activities, snorkeling experience and scenic coastal views. Return to Ibiza and enjoy the evening at leisure. Overnight Stay in Ibiza.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "09",
  //       title: "Departure from Ibiza",
  //       desc: "Breakfast at the hotel. Check-out and private transfer from Ibiza Hotel to Ibiza Airport for the onward journey. End of Tour with Wonderful Memories.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //   ],

  //   pointsToRemember: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   inclusions: {
  //     included: [
  //       "08 Nights' Accommodation with Breakfast",
  //       "Private transfer from Barcelona Airport to Barcelona Hotel",
  //       "Barcelona: 01 Day Hop-On Hop-Off City Tour",
  //       "Barcelona: Sagrada Familia Entry Ticket (Only)",
  //       "Day tour to Montserrat with Black Madonna on Shared Basis",
  //       "Private transfer from Barcelona Hotel to Barcelona Station",
  //       "Private transfer from Madrid Station to Madrid Hotel",
  //       "Madrid: 01 Day Hop-On Hop-Off City Tour",
  //       "Madrid: Prado Museum Guided Tour with Skip-the-Line Ticket",
  //       "Day tour from Madrid to Segovia and Toledo Tour, Alcazar on Shared Basis",
  //       "Private transfer from Madrid Hotel to Madrid Airport",
  //       "Private transfer from Ibiza Airport to Ibiza Hotel",
  //       "Ibiza: Cruise to Formentera with Paddle & Snorkelling",
  //       "Private transfer from Ibiza Hotel to Ibiza Airport",
  //     ],

  //     excluded: [
  //       "The tours which are on SIC/Shared basis require the client to reach the pickup point",
  //       "Return Flight Tickets",
  //       "Visa & Insurance fees",
  //       "Water Bottles",
  //       "Train ticket",
  //       "Optional tours",
  //       "Hotel City Tax (paid on the spot at the hotel)",
  //       "Lunch & Dinner",
  //       "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
  //       "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
  //     ],
  //   },

  //   supplementaryTours: {
  //     note: "Price is not applicable during fair/Events dates.",
  //     items: [
  //       {
  //         name: "2nd class train ticket from Barcelona to Madrid",
  //         price: "€90 – 120 per person",
  //       },
  //     ],
  //   },

  //   pricing: {
  //     note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
  //     options: [
  //       {
  //         category: "Option 1 – 3* Hotel",
  //         hotels: [
  //           { location: "Barcelona 03N", hotel: "Hotel Acta Azul Barcelona or similar" },
  //           { location: "Madrid 03N", hotel: "Hotel Puerta de Toledo or similar" },
  //           { location: "Ibiza 03N", hotel: "Hotel Royal Plaza or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov & Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1114 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1069 per person onwards on Twin/Double sharing basis / Euro 965 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1026 per person onwards on Twin/Double sharing basis / Euro 922 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 698 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 362 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July & Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1193 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1148 per person onwards on Twin/Double sharing basis / Euro 1124 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1105 per person onwards on Twin/Double sharing basis / Euro 1181 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 1031 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 681 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "Mar, Sept & Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1268 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1223 per person onwards on Twin/Double sharing basis / Euro 1119 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1180 per person onwards on Twin/Double sharing basis / Euro 1076 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 852 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 516 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         category: "Option 2 – 4* Hotel",
  //         hotels: [
  //           { location: "Barcelona 3N", hotel: "Catalonia Barcelona Plaza or similar" },
  //           { location: "Madrid 3N", hotel: "Nh Collection Madrid Gran Via or similar" },
  //           { location: "Ibiza 2N", hotel: "Hotel Royal Plaza or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov & Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1347 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1302 per person onwards on Twin/Double sharing basis / Euro 1214 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1263 per person onwards on Twin/Double sharing basis / Euro 1167 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 979 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 643 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July & Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1403 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1358 per person onwards on Twin/Double sharing basis / Euro 1243 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1340 per person onwards on Twin/Double sharing basis / Euro 1175 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 968 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 618 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "Mar, Sept & Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "Euro 1456 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "Euro 1411 per person onwards on Twin/Double sharing basis / Euro 1262 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "Euro 1368 per person onwards on Twin/Double sharing basis / Euro 1219 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "Euro 905 per child onwards" },
  //               { pax: "Single Room Supplement", price: "Euro 569 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //     ],
  //   },

  //   terms: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   images: [],
  // },


  {
    title: "Central Europe Escape: Budapest, Zagreb & Ljubljana",
    slug: "central-europe-escape-budapest-zagreb-ljubljana",
    price: "EUR 1076 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/central/day-1.jpg",
    location: "Budapest, Zagreb, Ljubljana",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Countries, 3 Cities, 07 Nights",
        places: "Budapest, Zagreb, Ljubljana",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "Hungarian Parliament Building",
        "Buda Castle",
        "Széchenyi Thermal Bath",
        "Plitvice Lakes National Park",
        "Lake Bled & Bled Island",
        "Bled Castle",
      ],

      experiences: [
        {
          title: "Budapest City Tour + Széchenyi Spa",
          desc: "Hop-On Hop-Off Bus Tour (24 hours) covering the Hungarian Parliament Building, Buda Castle and Heroes' Square, plus entry to the Széchenyi Thermal Bath Experience.",
        },
        {
          title: "Plitvice Lakes & Rastoke Tour",
          desc: "Guided tour on SIC basis to Plitvice Lakes National Park, famous for cascading lakes and waterfalls, and Rastoke, a picturesque watermill village.",
        },
        {
          title: "Lake Bled Day Tour",
          desc: "SIC day tour exploring Lake Bled, Bled Island and Bled Castle.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Budapest",
        desc: "Meet your private driver at the airport and transfer comfortably to your hotel: Star City Hotel (or similar). Check in and relax. Overnight Stay in Budapest.",
        tags: [],
      },
      {
        day: "02",
        title: "Budapest City Tour + Széchenyi Spa",
        desc: "Breakfast at the hotel. Hop-On Hop-Off Bus Tour (24 hours) exploring the Hungarian Parliament Building, Buda Castle and Heroes' Square. Enjoy the Széchenyi Thermal Bath Experience, with entry to one of Europe's largest thermal bath complexes and relaxation in natural hot spring pools and spa facilities. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Budapest at Leisure",
        desc: "Breakfast at the hotel. Day free to explore at your own pace. Suggested experiences: walk across the Chain Bridge, visit Fisherman's Bastion for panoramic views, and enjoy local Hungarian cuisine. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Budapest → Zagreb",
        desc: "Breakfast at the hotel. Private transfer to Zagreb with a comfortable intercity transfer directly to your hotel. Check in at Best Western Hotel Stella (or similar). Overnight Stay in Zagreb.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Plitvice Lakes & Rastoke Tour",
        desc: "Breakfast at the hotel. Plitvice Lakes Guided Tour with Ticket & Rastoke (SIC), visiting Plitvice Lakes National Park and the watermill village of Rastoke. Overnight Stay in Zagreb.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Zagreb → Ljubljana",
        desc: "Breakfast at the hotel. Private transfer to Ljubljana, directly to your hotel: Ibis Styles Ljubljana Centre (or similar). Check in and relax. Overnight Stay in Ljubljana.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Lake Bled Day Tour",
        desc: "Breakfast at the hotel. Lake Bled Day Tour (SIC), exploring Lake Bled, Bled Island and Bled Castle. Overnight Stay in Ljubljana.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Ljubljana → Departure",
        desc: "Breakfast at the hotel. Private transfer to the airport. Depart with unforgettable Central European memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "03 Nights in Budapest – Star City Hotel or similar",
        "02 Nights in Zagreb – Best Western Hotel Stella or similar",
        "02 Nights in Ljubljana – Ibis Styles Ljubljana Centre or similar",
        "Private transfer in Budapest (Airport → Hotel)",
        "Private transfer Budapest → Zagreb (Hotel → Hotel)",
        "Private transfer Zagreb → Ljubljana (Hotel → Hotel)",
        "Private transfer in Ljubljana (Hotel → Airport)",
        "Budapest Hop-On Hop-Off Bus (24 hrs)",
        "Széchenyi Spa Day Ticket (entry only)",
        "Plitvice Lakes Guided Tour with Ticket & Rastoke from Zagreb (SIC)",
        "Lake Bled Day Tour from Ljubljana (SIC)",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Budapest 3N", hotel: "Star city hotel or similar" },
            { location: "Zagreb 2N", hotel: "Best Western Hotel Stella or similar" },
            { location: "Ljubljana 2N", hotel: "Ibis Styles Ljubljana Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1076 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 813 per person onwards on Twin/Double sharing basis / EUR 795 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 716 per person onwards on Twin/Double sharing basis / EUR 698 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 428 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 264 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1181 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 918 per person onwards on Twin/Double sharing basis / EUR 844 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 821 per person onwards on Twin/Double sharing basis / EUR 747 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 365 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 369 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1149 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 886 per person onwards on Twin/Double sharing basis / EUR 827 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 789 per person onwards on Twin/Double sharing basis / EUR 730 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 378 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 337 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Budapest 3N", hotel: "Hotel Bristol Budapest or similar" },
            { location: "Zagreb 2N", hotel: "Canopy By Hilton Zagreb City Centre or similar" },
            { location: "Ljubljana 2N", hotel: "Doubletree By Hilton Ljubljana or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1203 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 940 per person onwards on Twin/Double sharing basis / EUR 935 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 843 per person onwards on Twin/Double sharing basis / EUR 838 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 594 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 391 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1243 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 980 per person onwards on Twin/Double sharing basis / EUR 955 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 883 per person onwards on Twin/Double sharing basis / EUR 858 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 574 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 431 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1231 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 968 per person onwards on Twin/Double sharing basis / EUR 944 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 871 per person onwards on Twin/Double sharing basis / EUR 847 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 565 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 419 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/central/day-1.jpg",
      "/images/central/day-2.jpg",
      "/images/central/day-3.jpg",
      "/images/central/day-4.jpg",
      "/images/central/day-5.jpg",
      "/images/central/day-6.jpg",
      "/images/central/day-7.jpg",
      "/images/central/day-8.jpg",
      "/images/central/extra1.jpg",
      "/images/central/extra2.jpg",
      "/images/central/extra3.jpg",
      "/images/central/extra4.jpg",
    ],
  },


  {
    title: "Scenic Europe Escape: Ljubljana, Salzburg & Munich",
    slug: "scenic-europe-escape-ljubljana-salzburg-munich",
    price: "EUR 918 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Ljuba/day-1.jpg",
    location: "Ljubljana, Salzburg, Munich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Countries, 3 Cities, 06 Nights",
        places: "Ljubljana, Salzburg, Munich",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Lake Bled & Bled Island",
        "Bled Castle",
        "Julian Alps",
        "Hallstatt Village",
        "Marienplatz",
        "Nymphenburg Palace",
      ],

      experiences: [
        {
          title: "Lake Bled Day Tour",
          desc: "SIC day tour to the alpine resort of Lake Bled, visiting Bled Island with its picturesque church, Bled Castle, and scenic views of the Julian Alps.",
        },
        {
          title: "Hallstatt Half-Day Tour",
          desc: "SIC half-day tour to the postcard-perfect village of Hallstatt, with stunning lake and mountain scenery, traditional alpine houses and free time to explore.",
        },
        {
          title: "Munich Hop-On Hop-Off Bus Tour",
          desc: "24-hour hop-on hop-off bus tour covering top attractions such as Marienplatz, Nymphenburg Palace and the English Garden.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Ljubljana",
        desc: "Meet your private driver at the airport and enjoy a comfortable transfer to your hotel: Ibis Styles Ljubljana Centre (or similar). Check in and relax. Overnight Stay in Ljubljana.",
        tags: [],
      },
      {
        day: "02",
        title: "Lake Bled Day Tour",
        desc: "Breakfast at the hotel. Lake Bled Day Tour (SIC) visiting the alpine resort of Lake Bled, including Bled Island with its picturesque church, Bled Castle, and scenic views of the Julian Alps. Overnight Stay in Ljubljana.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Ljubljana → Salzburg",
        desc: "Breakfast at the hotel. Private transfer to the station, board the train to Salzburg, then private transfer to your hotel: Leonardo Hotel Salzburg City Center (or similar). Rest of the day at leisure. Overnight Stay in Salzburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Hallstatt Half-Day Tour",
        desc: "Breakfast at the hotel. Hallstatt Half-Day Tour (SIC) visiting the postcard-perfect village of Hallstatt, with stunning lake and mountain scenery, traditional alpine houses and free time to explore this fairytale destination. Overnight Stay in Salzburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Salzburg → Munich",
        desc: "Breakfast at the hotel. Private transfer to the station, train journey to Munich, then private transfer to your hotel: Cocoon Stachus (or similar). Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Munich City Tour",
        desc: "Breakfast at the hotel. Munich Hop-On Hop-Off Bus Tour (24 hours) exploring top attractions such as Marienplatz, Nymphenburg Palace and the English Garden. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Munich → Departure",
        desc: "Breakfast at the hotel. Private transfer to the airport. Depart with unforgettable European memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "02 Nights in Ljubljana – Ibis Styles Ljubljana Centre or similar",
        "02 Nights in Salzburg – Leonardo Hotel Salzburg City Center or similar",
        "02 Nights in Munich – Cocoon Stachus or similar",
        "Private transfer in Ljubljana (Airport → Hotel)",
        "Private transfer in Ljubljana (Hotel → Station)",
        "Private transfer in Salzburg (Station → Hotel)",
        "Private transfer in Salzburg (Hotel → Station)",
        "Private transfer in Munich (Station → Hotel)",
        "Private transfer in Munich (Hotel → Airport)",
        "Lake Bled Day Tour from Ljubljana (SIC)",
        "Hallstatt Half-Day Tour from Salzburg (SIC)",
        "Munich Hop-On Hop-Off Bus Tour (24 hrs)",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from Ljubljana to Salzburg (with one interchange)",
          price: "EUR 80 – 125 Per Adult",
        },
        {
          name: "2nd class Train ticket from Salzburg to Munich",
          price: "EUR 80 – 125 Per Adult",
        },
      ],
    },

    pricing: {
      note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Ljubljana 2N", hotel: "Ibis Styles Ljubljana Centre or similar" },
            { location: "Salzburg 2N", hotel: "Leonardo Hotel Salzburg City Center or similar" },
            { location: "Munich 2N", hotel: "Cocoon Stachus or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 918 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 823 per person onwards on Twin/Double sharing basis / EUR 817 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 773 per person onwards on Twin/Double sharing basis / EUR 767 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 682 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 448 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1186 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1071 per person onwards on Twin/Double sharing basis / EUR 958 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1021 per person onwards on Twin/Double sharing basis / EUR 908 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 539 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 716 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1041 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 899 per person onwards on Twin/Double sharing basis / EUR 894 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 849 per person onwards on Twin/Double sharing basis / EUR 844 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 691 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 544 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Ljubljana 2N", hotel: "Doubletree By Hilton Ljubljana or similar" },
            { location: "Salzburg 2N", hotel: "Nh Collection Salzburg City or similar" },
            { location: "Munich 2N", hotel: "Nh Munchen Messe or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 970 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 855 per person onwards on Twin/Double sharing basis / EUR 844 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 805 per person onwards on Twin/Double sharing basis / EUR 794 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 629 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 500 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1233 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1148 per person onwards on Twin/Double sharing basis / EUR 1085 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1088 per person onwards on Twin/Double sharing basis / EUR 1035 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 856 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 763 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1125 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1025 per person onwards on Twin/Double sharing basis / EUR 1016 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 970 per person onwards on Twin/Double sharing basis / EUR 966 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 850 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 655 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Ljuba/day-1.jpg",
      "/images/Ljuba/day-2.jpg",
      "/images/Ljuba/day-3.jpg",
      "/images/Ljuba/day-4.jpg",
      "/images/Ljuba/day-5.jpg",
      "/images/Ljuba/day-6.jpg",
      "/images/Ljuba/day-7.jpg",
      "/images/Ljuba/extra1.jpg",
      "/images/Ljuba/extra2.jpg",
      "/images/Ljuba/extra3.jpg",
    ],
  },


  {
    title: "Classic UK Escape: London, Cardiff & Liverpool Highlights",
    slug: "classic-uk-escape-london-cardiff-liverpool",
    price: "GBP 1190 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/liverpool/day-1.jpg",
    location: "London, Cardiff, Liverpool, United Kingdom",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 06 Nights",
        places: "London, Cardiff, Liverpool",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Big Ben",
        "Buckingham Palace",
        "Tower Bridge",
        "London Eye",
        "Cardiff Castle",
        "The Beatles Story",
      ],

      experiences: [
        {
          title: "London City Tour + London Eye + River Cruise",
          desc: "Hop-On Hop-Off City Tour (24 hours) covering Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge, a 30-minute London Eye ride with panoramic views, and a River Thames Cruise passing The Shard and the Tower of London.",
        },
        {
          title: "Cardiff City Highlights Walking Tour",
          desc: "Guided walking tour discovering the charm of Wales' capital, including Cardiff Castle, Bute Park and Cardiff Bay, with insights into Welsh history and culture.",
        },
        {
          title: "Liverpool City Tour + River Cruise",
          desc: "Hop-On Hop-Off Bus Tour exploring Royal Albert Dock, Liverpool Cathedral and The Beatles Story, plus a scenic River Mersey cruise taking in the city's waterfront skyline.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → London",
        desc: "Meet your private driver in the arrivals hall and enjoy a comfortable transfer to your hotel: The California Hotel (or similar). Check in and relax after your journey. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "02",
        title: "London City Tour + London Eye + River Cruise",
        desc: "Breakfast at the hotel. Hop-On Hop-Off City Tour (24 hours) exploring Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge. Enjoy the London Eye Experience, a 30-minute ride with panoramic city views. River Thames Cruise passing iconic landmarks such as The Shard and the Tower of London. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London → Cardiff",
        desc: "Breakfast at the hotel. Private transfer to the station, board the train to Cardiff, then private transfer to your hotel: Holiday Inn Cardiff City Centre (or similar). Rest of the day at leisure. Overnight Stay in Cardiff.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Cardiff – City Highlights Walking Tour",
        desc: "Breakfast at the hotel. City Highlights Guided Walking Tour of Cardiff discovering Cardiff Castle, Bute Park and Cardiff Bay, with insights into Welsh history, culture and local life. Overnight Stay in Cardiff.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Cardiff → Liverpool",
        desc: "Breakfast at the hotel. Private transfer to the station, board the train to Liverpool, then private transfer to your hotel: Holiday Inn Express Liverpool Central (or similar). Overnight Stay in Liverpool.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Liverpool City Tour + River Cruise",
        desc: "Breakfast at the hotel. Hop-On Hop-Off Bus Tour exploring Liverpool's top attractions: Royal Albert Dock, Liverpool Cathedral and The Beatles Story. River Cruise Experience along the River Mersey, taking in the city's famous waterfront skyline. Overnight Stay in Liverpool.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Liverpool → India",
        desc: "Breakfast at the hotel. Private transfer to the airport for departure. Depart with unforgettable UK memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "02 Nights in London – The California Hotel or similar",
        "02 Nights in Cardiff – Holiday Inn Cardiff City Centre or similar",
        "02 Nights in Liverpool – Holiday Inn Express Liverpool Central or similar",
        "Private transfer in London (Airport → Hotel)",
        "Private transfer to London (Hotel → Station)",
        "Private transfer in Cardiff (Station → Hotel)",
        "Private transfer in Cardiff (Hotel → Station)",
        "Private transfer in Liverpool (Station → Hotel)",
        "Private transfer in Liverpool (Hotel → Airport)",
        "London Hop-On Hop-Off Bus (24 hrs) with River Cruise",
        "London Eye Ticket (entry only)",
        "City Highlights Guided Walking Tour of Cardiff",
        "Liverpool River Cruise",
        "Liverpool Hop-On Hop-Off Bus Tour",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from London to Cardiff",
          price: "GBP 115 – 125 Per Adult",
        },
        {
          name: "2nd class Train ticket from Cardiff to Liverpool (with one interchange)",
          price: "GBP 115 – 125 Per Adult",
        },
      ],
    },

    pricing: {
      note: "The tours which are on SIC/Shared basis require the client to reach the pickup point. Price is not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "London 2N", hotel: "The California or similar" },
            { location: "Cardiff 2N", hotel: "Holiday Inn Cardiff City Centre or similar" },
            { location: "Liverpool 2N", hotel: "Holiday Inn Express Liverpool Central or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1190 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 774 per person onwards on Twin/Double sharing basis / GBP 727 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 722 per person onwards on Twin/Double sharing basis / GBP 678 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 521 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 777 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1351 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 794 per person onwards on Twin/Double sharing basis / GBP 718 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 677 per person onwards on Twin/Double sharing basis / GBP 664 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 524 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 414 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1257 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 823 per person onwards on Twin/Double sharing basis / GBP 744 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 855 per person onwards on Twin/Double sharing basis / GBP 695 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 238 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 596 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "London 2N", hotel: "Crowne Plaza London - Kings Cross or similar" },
            { location: "Cardiff 2N", hotel: "Hilton Cardiff or similar" },
            { location: "Liverpool 2N", hotel: "Maldron Hotel Liverpool or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1059 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 954 per person onwards on Twin/Double sharing basis / GBP 873 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 909 per person onwards on Twin/Double sharing basis / GBP 819 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 525 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 646 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1298 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1191 per person onwards on Twin/Double sharing basis / GBP 931 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1144 per person onwards on Twin/Double sharing basis / GBP 882 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 221 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 885 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1093 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 998 per person onwards on Twin/Double sharing basis / GBP 947 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 958 per person onwards on Twin/Double sharing basis / GBP 898 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 709 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 680 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/liverpool/day-1.jpg",
      "/images/liverpool/day-2.jpg",
      "/images/liverpool/day-3.jpg",
      "/images/liverpool/day-4.jpg",
      "/images/liverpool/day-5.jpg",
      "/images/liverpool/day-6.jpg",
      "/images/liverpool/day-7.jpg",
      "/images/liverpool/extra1.jpg",
      "/images/liverpool/extra2.jpg",
      "/images/liverpool/extra3.jpg",
      "/images/liverpool/extra4.jpg",
    ],
  },


  {
    title: "Classic UK Escape: London, Cardiff & Manchester Highlights",
    slug: "classic-uk-escape-london-cardiff-manchester",
    price: "GBP 937 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/cardiff/day-1.jpg",
    location: "London, Cardiff, Manchester, United Kingdom",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 06 Nights",
        places: "London, Cardiff, Manchester",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Big Ben",
        "Buckingham Palace",
        "Tower Bridge",
        "London Eye",
        "Cardiff Castle",
        "Manchester Canal & River Cruise",
      ],

      experiences: [
        {
          title: "London City Tour + London Eye + River Cruise",
          desc: "Hop-On Hop-Off City Tour (24 hours) covering Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge, a 30-minute London Eye ride in a glass capsule with panoramic skyline views, and a River Thames Cruise passing The Shard and the Tower of London with live or audio commentary.",
        },
        {
          title: "Cardiff Guided Walking Tour",
          desc: "Guided walking tour exploring Cardiff Castle, Principality Stadium and Cardiff Bay waterfront, with insights into Welsh history, culture and architecture.",
        },
        {
          title: "Manchester Canal & River Cruise",
          desc: "A relaxing cruise discovering the city's industrial heritage, passing through historic waterways with landmarks like Old Trafford (area views depending on route), followed by free time for shopping, the Northern Quarter, or football attractions.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → London",
        desc: "Welcome to London — World's most vibrant and historic capital. Meet your private driver in the arrivals hall for a smooth transfer to your hotel. Check in and relax after your journey. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "02",
        title: "London – City Tour with London Eye and London River Cruise",
        desc: "Breakfast at the hotel. Hop-On Hop-Off City Tour (24 hours) exploring Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge. London Eye Experience: 30-minute ride in a glass capsule with panoramic views of the London skyline and great photo opportunities. River Thames Cruise passing landmarks like The Shard and Tower of London, with live or audio commentary. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London → Cardiff",
        desc: "Breakfast at the hotel. Private transfer to the train station and board your train to Cardiff. Overnight Stay in Cardiff.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Cardiff Guided Walking Tour",
        desc: "Explore highlights of the city including Cardiff Castle, Principality Stadium and Cardiff Bay waterfront. Learn about Welsh history, culture, and architecture. Overnight Stay in Cardiff.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Cardiff → Manchester",
        desc: "Breakfast at the hotel. Private transfer to the station for your train to Manchester. Upon arrival, private transfer to your hotel. Rest of the day at leisure. Overnight Stay in Manchester.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Manchester Canal & River Cruise",
        desc: "Breakfast at the hotel. Enjoy a relaxing Manchester Canal & River Cruise: discover the city's industrial heritage, cruise through historic waterways, and pass landmarks like Old Trafford (area views depending on route). Rest of the day free for shopping, exploring the Northern Quarter, or football attractions. Overnight Stay in Manchester.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Manchester → India",
        desc: "Breakfast at the hotel. Private transfer to the airport for your return journey. Depart with wonderful memories of your UK experience.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights' Accommodation with Breakfast",
        "Private transfer in London (Airport to Hotel)",
        "London Hop-On Hop-Off 24 hours with River Cruise",
        "Ticket to London Eye (ticket only)",
        "Private transfer to London (Hotel to Station)",
        "Private transfer in Cardiff (Station to Hotel)",
        "City Highlights Guided Walking Tour of Cardiff",
        "Private transfer in Cardiff (Hotel to Station)",
        "Private transfer to Manchester (Station to Hotel)",
        "Manchester Canal & River Cruise",
        "Private transfer in Manchester (Hotel to Airport)",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from London to Cardiff",
          price: "GBP 115 – 135 Per Adult",
        },
        {
          name: "2nd class Train ticket from Cardiff to Manchester",
          price: "GBP 115 – 135 Per Adult",
        },
      ],
    },

    pricing: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "London 2N", hotel: "The California Hotel or similar" },
            { location: "Cardiff 2N", hotel: "Holiday Inn Cardiff City Centre or similar" },
            { location: "Manchester 2N", hotel: "Holiday Inn Express Manchester City Centre – Arena or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 937 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 831 per person onwards on Twin/Double sharing basis / GBP 723 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 781 per person onwards on Twin/Double sharing basis / GBP 673 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 317 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 531 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1454 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 799 per person onwards on Twin/Double sharing basis / GBP 711 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 677 per person onwards on Twin/Double sharing basis / GBP 661 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 753 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1048 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1336 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 790 per person onwards on Twin/Double sharing basis / GBP 742 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 728 per person onwards on Twin/Double sharing basis / GBP 692 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 456 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 531 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "London 2N", hotel: "Crowne Plaza London - Kings Cross or similar" },
            { location: "Cardiff 2N", hotel: "Hilton Cardiff or similar" },
            { location: "Manchester 2N", hotel: "Crowne Plaza Manchester City Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1108 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1002 per person onwards on Twin/Double sharing basis / GBP 906 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 952 per person onwards on Twin/Double sharing basis / GBP 856 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 524 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 702 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1140 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1034 per person onwards on Twin/Double sharing basis / GBP 1018 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 984 per person onwards on Twin/Double sharing basis / GBP 968 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 796 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 734 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1109 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1003 per person onwards on Twin/Double sharing basis / GBP 928 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 953 per person onwards on Twin/Double sharing basis / GBP 878 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 588 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 703 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/cardiff/day-1.jpg",
      "/images/cardiff/day-2.jpg",
      "/images/cardiff/day-3.jpg",
      "/images/cardiff/day-4.jpg",
      "/images/cardiff/day-5.jpg",
      "/images/cardiff/day-6.jpg",
      "/images/cardiff/day-7.jpg",
      "/images/cardiff/extra1.jpg",
      "/images/cardiff/extra2.jpg",
    ],
  },

  {
    title: "Classic UK Escape: London, Newport & Edinburgh Highlights",
    slug: "classic-uk-escape-london-newport-edinburgh",
    price: "GBP 1111 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/newport/day-1.jpg",
    location: "London, Newport, Edinburgh, United Kingdom",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 06 Nights",
        places: "London, Newport, Edinburgh",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Big Ben",
        "Buckingham Palace",
        "Tower Bridge",
        "London Eye",
        "Newport Transporter Bridge",
        "Edinburgh Castle",
      ],

      experiences: [
        {
          title: "London City Tour + London Eye + River Cruise",
          desc: "Hop-On Hop-Off City Tour (24 hours) covering Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge, a 30-minute London Eye ride with panoramic city views, and a River Thames Cruise passing The Shard and the Tower of London.",
        },
        {
          title: "Newport Yacht Sightseeing Cruise",
          desc: "A relaxing standard sightseeing yacht cruise with scenic waterfront views and coastal charm, with the option to explore nearby attractions such as the Newport Transporter Bridge and Tredegar House.",
        },
        {
          title: "Edinburgh City Tour + Edinburgh Castle",
          desc: "Hop-On Hop-Off Tour (24 hours) discovering top attractions including the Royal Mile, Holyrood Palace and Arthur's Seat, plus entry to Edinburgh Castle to learn about Scottish history and enjoy stunning city views.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → London",
        desc: "Welcome to one of the world's most iconic capitals! Meet your private driver in the arrivals hall and enjoy a comfortable transfer to your hotel: The California Hotel (or similar). Check in and relax after your journey. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "02",
        title: "London City Tour + London Eye + River Cruise",
        desc: "Breakfast at the hotel. Hop-On Hop-Off City Tour (24 hours) exploring famous landmarks such as Big Ben, Buckingham Palace, St. Paul's Cathedral and Tower Bridge. London Eye Experience: entry to the London Eye for a 30-minute ride with panoramic city views. River Thames Cruise: relax on a scenic cruise passing landmarks like The Shard and Tower of London. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London → Newport",
        desc: "Breakfast at the hotel. Private transfer to the train station, board your train to Newport, then private transfer to your hotel: Holiday Inn Express Newport (or similar). Rest of the day at leisure. Overnight Stay in Newport.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Newport – Yacht Sightseeing Cruise",
        desc: "Breakfast at the hotel. Enjoy a relaxing standard sightseeing Yacht Sightseeing Cruise, experiencing scenic waterfront views and coastal charm. You can also explore nearby attractions such as the Newport Transporter Bridge and Tredegar House. Overnight Stay in Newport.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Newport → Edinburgh",
        desc: "Breakfast at the hotel. Private transfer to the station and board your train to Edinburgh. Upon arrival, private transfer to your hotel: Holiday Inn Express Edinburgh City Centre (or similar). Overnight Stay in Edinburgh.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Edinburgh City Tour + Edinburgh Castle",
        desc: "Breakfast at the hotel. Hop-On Hop-Off Tour (24 hours) discovering top attractions including the Royal Mile, Holyrood Palace and Arthur's Seat. Edinburgh Castle Visit: entry to Edinburgh Castle to learn about Scottish history and enjoy stunning city views. Overnight Stay in Edinburgh.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Edinburgh → India",
        desc: "Breakfast at the hotel. Private transfer to the airport for your return journey. Depart with unforgettable UK memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "02 Nights in London – The California Hotel or similar",
        "02 Nights in Newport – Holiday Inn Express Newport or similar",
        "02 Nights in Edinburgh – Holiday Inn Express Edinburgh City Centre or similar",
        "Private Airport Transfer in London (Airport → Hotel)",
        "Private Transfer in London (Hotel → Station)",
        "Private Transfer in Newport (Station → Hotel → Station)",
        "Private Transfer in Edinburgh (Station → Hotel → Airport)",
        "London Hop-On Hop-Off Bus (24 hrs) + River Cruise",
        "London Eye Ticket",
        "Yacht Sightseeing Cruise in Newport",
        "Edinburgh Hop-On Hop-Off Bus (24 hrs)",
        "Edinburgh Castle Ticket",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from London to Newport",
          price: "GBP 135 – 145 Per Adult",
        },
        {
          name: "2nd class Train ticket from Newport to Edinburgh",
          price: "GBP 135 – 145 Per Adult",
        },
      ],
    },

    pricing: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "London 2N", hotel: "The California or similar" },
            { location: "Newport 2N", hotel: "Holiday Inn Express Newport or similar" },
            { location: "Edinburgh 2N", hotel: "Holiday Inn Express Edinburgh City Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1111 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 926 per person onwards on Twin/Double sharing basis / GBP 914 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 892 per person onwards on Twin/Double sharing basis / GBP 869 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 1299 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 584 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1531 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 936 per person onwards on Twin/Double sharing basis / GBP 927 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 890 per person onwards on Twin/Double sharing basis / GBP 882 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 759 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1098 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1180 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 926 per person onwards on Twin/Double sharing basis / GBP 913 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 874 per person onwards on Twin/Double sharing basis / GBP 868 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 1351 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 747 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "London 2N", hotel: "Crowne Plaza London - Kings Cross or similar" },
            { location: "Newport 2N", hotel: "Holiday Inn Milton Keynes East or similar" },
            { location: "Edinburgh 2N", hotel: "Holiday Inn Edinburgh or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 975 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 899 per person onwards on Twin/Double sharing basis / GBP 832 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 857 per person onwards on Twin/Double sharing basis / GBP 787 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 583 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 542 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1051 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 965 per person onwards on Twin/Double sharing basis / GBP 851 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 920 per person onwards on Twin/Double sharing basis / GBP 806 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 473 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 618 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1049 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 958 per person onwards on Twin/Double sharing basis / GBP 841 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 913 per person onwards on Twin/Double sharing basis / GBP 796 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 432 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 616 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/newport/day-1.jpg",
      "/images/newport/day-2.jpg",
      "/images/newport/day-3.jpg",
      "/images/newport/day-4.jpg",
      "/images/newport/day-5.jpg",
      "/images/newport/day-6.jpg",
      "/images/newport/day-7.jpg",
      "/images/newport/extra1.jpg",
      "/images/newport/extra2.jpg",
    ],
  },


  {
    title: "Classic Poland Escape: Warsaw & Kraków Highlights",
    slug: "classic-poland-escape-warsaw-krakow",
    price: "EUR 799 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/poland/Day 1.jpg",
    location: "Warsaw, Kraków, Poland",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 2 Cities, 06 Nights",
        places: "Warsaw, Kraków",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Old Town Warsaw",
        "Royal Castle Warsaw",
        "Palace of Culture and Science",
        "Zakopane & Tatra Mountains",
        "Wieliczka Salt Mine",
        "Wawel Castle",
      ],

      experiences: [
        {
          title: "Warsaw City Tour",
          desc: "Hop-On Hop-Off Bus Tour (24 hours) exploring key attractions such as Old Town Warsaw, Royal Castle Warsaw and the Palace of Culture and Science.",
        },
        {
          title: "Zakopane & Thermal Pools Tour",
          desc: "A visit to the scenic mountain resort town of Zakopane, taking in stunning views of the Tatra Mountains, local markets and wooden architecture, with time to relax in natural thermal pools.",
        },
        {
          title: "Wieliczka Salt Mine Tour",
          desc: "Discover the underground wonder of the Wieliczka Salt Mine, a UNESCO World Heritage Site, featuring intricate salt carvings, chapels and fascinating underground tunnels.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Warsaw",
        desc: "Welcome to Warsaw — a city where history meets modern charm! Meet your private driver at the airport and enjoy a comfortable transfer to your hotel: Metropol Hotel Warsaw (or similar). Check in and relax. Overnight Stay in Warsaw.",
        tags: [],
      },
      {
        day: "02",
        title: "Warsaw City Tour",
        desc: "Breakfast at the hotel. Warsaw Hop-On Hop-Off Bus Tour (24 hours) exploring key attractions such as Old Town Warsaw, Royal Castle Warsaw and the Palace of Culture and Science. Overnight Stay in Warsaw.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Warsaw → Kraków",
        desc: "Breakfast at the hotel. Private transfer to the train station and travel to Kraków. Private transfer to your hotel: Hotel Pollera (or similar). Check in and relax. Overnight Stay in Kraków.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Zakopane & Thermal Pools Tour",
        desc: "Breakfast at the hotel. Zakopane Tour with Thermal Pools (SIC): visit the scenic mountain resort town of Zakopane, with stunning views of the Tatra Mountains, local markets and wooden architecture, and time to relax in natural thermal pools. Overnight Stay in Kraków.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Wieliczka Salt Mine Tour",
        desc: "Breakfast at the hotel. Wieliczka Salt Mine Tour (SIC): discover the underground wonder of the Wieliczka Salt Mine, with intricate salt carvings and chapels, fascinating underground tunnels, and UNESCO World Heritage status. Overnight Stay in Kraków.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Free Day in Kraków",
        desc: "Breakfast at the hotel. Day at leisure for self-exploration/shopping. Suggested experiences: explore Main Market Square Kraków, visit Wawel Castle, and enjoy cafés, shopping, and local food. Overnight Stay in Kraków.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Kraków → Departure",
        desc: "Breakfast at the hotel. Private transfer to the airport. Depart with unforgettable Poland memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "02 Nights in Warsaw – Metropol Hotel Warsaw or similar",
        "04 Nights in Kraków – Hotel Pollera or similar",
        "Private transfer in Warsaw (Airport → Hotel)",
        "Private transfer in Warsaw (Hotel → Station)",
        "Private transfer in Kraków (Station → Hotel)",
        "Private transfer in Kraków (Hotel → Airport)",
        "Warsaw Hop-On Hop-Off Bus Tour (24 hrs)",
        "Zakopane Tour with Thermal Pools from Kraków (SIC)",
        "Wieliczka Salt Mine Tour from Kraków (SIC)",
        "Free day for self-exploration/shopping",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      items: [
        {
          name: "2nd class Train ticket from Warsaw to Krakow",
          price: "EUR 25 – 35 Per Adult",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Warsaw 2N", hotel: "Metropol Hotel Warsaw or similar" },
            { location: "Krakow 4N", hotel: "Hotel Pollera or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 799 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 756 per person onwards on Twin/Double sharing basis / EUR 748 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 732 per person onwards on Twin/Double sharing basis / EUR 724 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 659 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 427 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 862 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 834 per person onwards on Twin/Double sharing basis / EUR 829 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 820 per person onwards on Twin/Double sharing basis / EUR 805 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 776 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 490 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 839 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 801 per person onwards on Twin/Double sharing basis / EUR 794 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 777 per person onwards on Twin/Double sharing basis / EUR 770 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 717 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 467 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Warsaw 2N", hotel: "Holiday Inn Warsaw City Centre or similar" },
            { location: "Krakow 4N", hotel: "Hotel Unique or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 681 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 653 per person onwards on Twin/Double sharing basis / EUR 542 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 639 per person onwards on Twin/Double sharing basis / EUR 518 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 277 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 309 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 789 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 746 per person onwards on Twin/Double sharing basis / EUR 660 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 722 per person onwards on Twin/Double sharing basis / EUR 636 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 420 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 417 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 716 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 678 per person onwards on Twin/Double sharing basis / EUR 631 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 654 per person onwards on Twin/Double sharing basis / EUR 607 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 474 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 344 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/poland/Day 1.jpg",
      "/images/poland/Day 2.jpg",
      "/images/poland/Day 3.jpg",
      "/images/poland/Day 4.jpg",
      "/images/poland/Day 5.jpg",
      "/images/poland/Day 6.jpg",
      "/images/poland/Day 7.jpg",
    ],
  },


  {
    title: "Classic Europe Escape: Warsaw & Prague Highlights",
    slug: "classic-europe-escape-warsaw-prague",
    price: "EUR 610 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "05 Nights / 06 Days",
    rating: "4.9",
    image: "/images/warsaw/Day 1.jpg",
    location: "Warsaw, Prague",

    highlightsData: {
      locationCard: {
        meta: "2 Countries, 2 Cities, 05 Nights",
        places: "Warsaw, Prague",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "05 Nights Accommodation",
      ],

      highlights: [
        "Old Town Warsaw",
        "Royal Castle Warsaw",
        "Palace of Culture and Science",
        "Prague Castle",
        "Charles Bridge",
        "Český Krumlov",
      ],

      experiences: [
        {
          title: "Warsaw City Tour",
          desc: "Hop-On Hop-Off Bus Tour (24 hours) exploring key attractions such as Old Town Warsaw, Royal Castle Warsaw and the Palace of Culture and Science.",
        },
        {
          title: "Prague City Tour + River Cruise",
          desc: "Hop-On Hop-Off Bus Tour (24 hours) exploring top attractions including Prague Castle, Charles Bridge and Old Town Square Prague, followed by a relaxing River Cruise Experience along the Vltava River, admiring Prague's skyline from the water.",
        },
        {
          title: "Český Krumlov Day Trip",
          desc: "Full-day trip to the UNESCO-listed old town of Český Krumlov, exploring the stunning Český Krumlov Castle and walking through medieval streets and scenic river bends.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Warsaw",
        desc: "Welcome to Warsaw — a city where history meets modern charm! Meet your private driver at the airport and enjoy a comfortable transfer to your hotel: Metropol Hotel Warsaw (or similar). Check in and relax. Overnight Stay in Warsaw.",
        tags: [],
      },
      {
        day: "02",
        title: "Warsaw City Tour",
        desc: "Breakfast at the hotel. Warsaw Hop-On Hop-Off Bus Tour (24 hours) exploring key attractions such as Old Town Warsaw, Royal Castle Warsaw and the Palace of Culture and Science. Overnight Stay in Warsaw.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Warsaw → Prague",
        desc: "Breakfast at the hotel. Private transfer to the airport and travel onward to Prague. Meet your private driver and transfer to your hotel: Exe City Park Prague (or similar). Check in and relax. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Prague City Tour + River Cruise",
        desc: "Breakfast at the hotel. Prague Hop-On Hop-Off Bus Tour (24 hours) exploring top attractions: Prague Castle, Charles Bridge and Old Town Square Prague. River Cruise Experience: enjoy a relaxing cruise along the Vltava River and admire Prague's skyline from the water. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Český Krumlov Day Trip",
        desc: "Breakfast at the hotel. Full-Day Trip to Český Krumlov (SIC): visit the UNESCO-listed old town, explore the stunning Český Krumlov Castle, and walk through medieval streets and scenic river bends. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Prague → Departure",
        desc: "Breakfast at the hotel. Private transfer to the airport. Depart with unforgettable European memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "02 Nights in Warsaw – Metropol Hotel Warsaw or similar",
        "03 Nights in Prague – Exe City Park Prague or similar",
        "Private transfer in Warsaw (Airport → Hotel)",
        "Private transfer in Warsaw (Hotel → Airport)",
        "Private transfer in Prague (Airport → Hotel)",
        "Private transfer in Prague (Hotel → Airport)",
        "Warsaw Hop-On Hop-Off Bus Tour (24 hrs)",
        "Prague Hop-On Hop-Off Bus Tour (24 hrs) with River Cruise",
        "Full-Day Trip to Český Krumlov from Prague (SIC)",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      items: [
        {
          name: "2nd class Train ticket from Ljubljana to Salzburg (with one interchange)",
          price: "EUR 80 – 125 Per Adult",
        },
        {
          name: "2nd class Train ticket from Salzburg to Munich",
          price: "EUR 80 – 125 Per Adult",
        },
      ],
    },

    pricing: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Warsaw 2N", hotel: "Metropol Hotel Warsaw or similar" },
            { location: "Prague 3N", hotel: "Exe City Park Prague or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 610 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 577 per person onwards on Twin/Double sharing basis / EUR 567 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 557 per person onwards on Twin/Double sharing basis / EUR 547 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 484 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 296 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 644 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 611 per person onwards on Twin/Double sharing basis / EUR 596 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 591 per person onwards on Twin/Double sharing basis / EUR 576 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 158 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 330 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 641 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 593 per person onwards on Twin/Double sharing basis / EUR 583 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 573 per person onwards on Twin/Double sharing basis / EUR 563 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 455 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 327 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Warsaw 2N", hotel: "Holiday Inn Warsaw City Centre or similar" },
            { location: "Prague 3N", hotel: "Hotel Unique or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 696 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 663 per person onwards on Twin/Double sharing basis / EUR 615 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 643 per person onwards on Twin/Double sharing basis / EUR 595 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 456 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 382 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 785 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 737 per person onwards on Twin/Double sharing basis / EUR 702 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 717 per person onwards on Twin/Double sharing basis / EUR 682 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 524 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 471 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 784 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 751 per person onwards on Twin/Double sharing basis / EUR 717 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 731 per person onwards on Twin/Double sharing basis / EUR 697 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 586 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 470 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/warsaw/Day 1.jpg",
      "/images/warsaw/Day 2.jpg",
      "/images/warsaw/Day 3.jpg",
      "/images/warsaw/Day 4.jpg",
      "/images/warsaw/Day 5.jpg",
      "/images/warsaw/Day 6.jpg",
    ],
  },

  {
    title: "From Windmills to the Eiffel",
    slug: "from-windmills-to-the-eiffel-amsterdam-paris",
    price: "EUR 838 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/wind/day-1.jpg",
    location: "Amsterdam, Paris",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Countries, 2 Cities, 06 Nights",
        places: "Amsterdam, Paris",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Van Gogh Museum & Rijksmuseum",
        "Zaanse Schans Windmills",
        "Eiffel Tower Summit",
        "Seine River Cruise",
        "Louvre Museum",
        "Montmartre & Sacré-Cœur",
      ],

      experiences: [
        {
          title: "Amsterdam One Day Hop-On Hop-Off",
          desc: "Discover Amsterdam's artistic heritage, elaborate canal system and narrow gabled houses dating back to the 17th-century Golden Age, taking in the Museum District with the Van Gogh Museum, the Rijksmuseum, and the Stedelijk Museum for modern art.",
        },
        {
          title: "Zaanse Schans, Edam, Volendam & Marken Bus Tour",
          desc: "A day trip from Amsterdam into the Dutch countryside covering traditional villages, iconic windmills and classic Dutch culture — historic windmills and clog-making at Zaanse Schans, the cheese town of Edam, the fishing village of Volendam, and the wooden houses of Marken.",
        },
        {
          title: "Paris Hop-On Hop-Off + Eiffel Tower Summit + Seine River Cruise",
          desc: "A one-day hop-on hop-off tour covering the Louvre Museum, Notre Dame, Champs-Élysées and Arc de Triomphe, followed by Summit Level entrance to the Eiffel Tower and a Seine River Cruise past Paris's iconic monuments.",
        },
        {
          title: "Montmartre Walking Tour with a Local Guide",
          desc: "A guided walk through the historic, bohemian Montmartre neighbourhood, visiting the Sacré-Cœur Basilica and Place du Tertre, with stories of the area's role in shaping Parisian art and culture.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Amsterdam",
        desc: "Arrival in Amsterdam: I Amsterdam. Welcome to Amsterdam, the Netherlands' capital, known for its artistic heritage, elaborate canal system and narrow houses with gabled facades, legacies of the city's 17th-century Golden Age. Its Museum District houses the Van Gogh Museum, works by Rembrandt and Vermeer at the Rijksmuseum, and modern art at the Stedelijk. Cycling is key to the city's character, with numerous bike paths. Overnight Stay in Amsterdam.",
        tags: [],
      },
      {
        day: "02",
        title: "Amsterdam One Day Hop-On Hop-Off",
        desc: "Breakfast at Hotel. Explore Amsterdam's artistic heritage, elaborate canal system, and narrow gabled houses dating to the 17th-century Golden Age. The Museum District houses the Van Gogh Museum, the Rijksmuseum with works by Rembrandt and Vermeer, and the Stedelijk Museum for modern art. Cycling is essential to Amsterdam's culture, with numerous scenic bike paths. Overnight Stay in Amsterdam.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Amsterdam – Zaanse Schans, Edam, Volendam & Marken Bus Tour",
        desc: "Breakfast at Hotel. A popular day tour from Amsterdam into the Dutch countryside, experiencing traditional villages, iconic windmills and classic Dutch culture. Zaanse Schans: historic windmills, wooden houses and artisan workshops, with clog-making and cheese production demonstrations. Edam: the charming town famous for its world-renowned Edam cheese. Volendam: a lively fishing village on the Ijsselmeer known for its colorful harbor and seafood. Marken: a former island with distinctive wooden houses, narrow lanes and strong local traditions. Overnight Stay in Amsterdam.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Amsterdam – Paris",
        desc: "Breakfast at hotel. Private transfer from your Amsterdam hotel to the train station, board the train to Paris, then a private transfer from the station to your hotel. Paris, the City of Lights, is world-famous for its iconic landmarks, rich artistic and cultural heritage, romantic charm, haute fashion, exquisite cuisine, and historic architecture. Overnight stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Paris Hop-On Hop-Off + Eiffel Tower Summit Entrance Ticket + Seine River Cruise Ticket",
        desc: "Breakfast at Hotel. The Paris One Day Hop-On Hop-Off Tour covers the main attractions of Paris including the Louvre Museum, Notre Dame, Champs-Élysées and Arc de Triomphe. Continue to the Eiffel Tower with Summit Level Entrance Ticket for breathtaking views over Paris. Later, enjoy the Seine River Cruise Entrance Ticket for a peaceful journey along the river with views of Paris's most iconic monuments. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Montmartre Walking Tour with a Local Guide",
        desc: "Breakfast at Hotel. A guided walking tour of Montmartre with a local expert, exploring one of Paris's most charming and historic neighborhoods, known for its artistic heritage, cobbled streets and bohemian atmosphere. Visit the Sacré-Cœur Basilica, Place du Tertre with its lively artists' square, and hidden corners once frequented by famous painters and writers, with panoramic views of the city. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Paris – India",
        desc: "Breakfast at Hotel. Proceed to Paris Airport with a private transfer for your onwards flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from Amsterdam Airport to Amsterdam Hotel",
        "Amsterdam One Day Hop on Hop off",
        "Amsterdam Canal Cruise Ticket on Shared Basis",
        "Zaanse Schans, Edam, Volendam & Marken Bus Tour from Amsterdam on SIC Basis",
        "Private transfer from Amsterdam Hotel to Amsterdam Station",
        "Private transfer from Paris Station to Paris Hotel",
        "Paris One day Hop on Hop off",
        "Eiffel Tower Summit level Entrance ticket",
        "Seine River Cruise Entrance Ticket Only",
        "Montmartre Walking Tour with a Local Guide from Paris on Shared Basis",
        "Private transfer from Paris Hotel to Paris Airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa and Insurance fees",
        "Hotel pick up for shared/SIC tours",
        "Optional tours",
        "Hotel City Tax to be paid directly at the hotel",
        "Lunch and Dinner",
        "Water bottles",
        "Train tickets not included unless mentioned in inclusions",
        "Expenses of personal nature such as laundry, drinks, telephone, etc.",
        "Anything not mentioned in the Inclusions",
      ],
    },

    supplementaryTours: {
        note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      items: [
        {
          name: "Amsterdam–Paris 2nd class train ticket – on actual basis",
          price: "EUR 85 – 105",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Amsterdam 3N", hotel: "Hampton By Hilton Amsterdam Centre East or similar" },
            { location: "Paris 3N", hotel: "Ibis Styles Paris Gare De L'est Chateau Landon or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 838 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 835 per person onwards on Twin/Double sharing basis / EUR 823 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 803 per person onwards on Twin/Double sharing basis / EUR 791 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 240 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 399 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1346 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1323 per person onwards on Twin/Double sharing basis / EUR 1095 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1291 per person onwards on Twin/Double sharing basis / EUR 1063 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 435 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 534 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1009 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 981 per person onwards on Twin/Double sharing basis / EUR 901 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 949 per person onwards on Twin/Double sharing basis / EUR 869 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 459 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 675 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Amsterdam 3N", hotel: "Conscious Hotel Westerpark or similar" },
            { location: "Paris 3N", hotel: "Hotel The Originals Paris Maison Montmartre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 960 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 942 per person onwards on Twin/Double sharing basis / EUR 895 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 910 per person onwards on Twin/Double sharing basis / EUR 863 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 256 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 536 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1052 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 994 per person onwards on Twin/Double sharing basis / EUR 973 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 962 per person onwards on Twin/Double sharing basis / EUR 941 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 296 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 658 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1151 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1124 per person onwards on Twin/Double sharing basis / EUR 1101 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1092 per person onwards on Twin/Double sharing basis / EUR 1069 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 330 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 633 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/wind/day-1.jpg",
      "/images/wind/day-2.jpg",
      "/images/wind/day-3.jpg",
      "/images/wind/day-4.jpg",
      "/images/wind/day-5.jpg",
      "/images/wind/day-6.jpg",
      "/images/wind/day-7.jpg",
    ],
  },


  {
    title: "Best of Barcelona, Madrid & Ibiza",
    slug: "best-of-barcelona-madrid-ibiza",
    price: "EUR 1114 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "08 Nights / 09 Days", // itinerary in PDF runs Day 1–Day 8 (08 Nights); the header's own "06 Nights/07 Days" and "02N Barcelona + 02N Madrid + 02 Ibiza" undercount this — see note below
    rating: "4.9",
    image: "/images/barcelona/day-1.jpg",
    location: "Barcelona, Madrid, Ibiza, Spain",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 3 Cities, 08 Nights",
        places: "Barcelona, Madrid, Ibiza",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Sagrada Familia",
        "Montserrat Monastery",
        "Royal Palace Madrid",
        "Prado Museum",
        "Ibiza Town",
        "Formentera Cruise",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off City Tour",
          desc: "A one-day hop-on hop-off city tour covering major attractions such as Plaça de Catalunya, the Gothic Quarter, La Rambla, Olympic Port and Montjuïc Hill, followed by a visit to Sagrada Familia with entry ticket only.",
        },
        {
          title: "Montserrat Monastery Day Trip",
          desc: "A shared-coach excursion to the breathtaking Montserrat mountain range, traveling up by cog-wheel train or cable car to visit the Santa Maria de Montserrat Abbey, with access to see the revered Black Madonna (La Moreneta) and free time to explore the basilica and enjoy panoramic views.",
        },
        {
          title: "Madrid Hop-On Hop-Off City Tour + Prado Museum",
          desc: "A one-day hop-on hop-off tour of Madrid covering the Royal Palace, Plaza Mayor, Gran Via and Puerta del Sol, followed by a guided Prado Museum tour with skip-the-line entry.",
        },
        {
          title: "Ibiza – Formentera Cruise",
          desc: "A shared-basis cruise to Formentera featuring paddle activities, a snorkeling experience and scenic coastal views.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Barcelona",
        desc: "Arrival at Barcelona Airport. Meet & greet and enjoy a private transfer to your hotel. Check-in and rest of the day at leisure — explore nearby areas or relax after your journey. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Hop On Hop Off City Tour",
        desc: "Breakfast at the hotel. Proceed for a 01 Day Hop-On Hop-Off City Tour, covering major attractions such as Plaça de Catalunya, Gothic Quarter, La Rambla, Olympic Port and Montjuïc Hill. Later, visit Sagrada Familia with entry ticket only. Evening free for leisure or shopping. Overnight Stay in Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Montserrat Monastery Day Trip",
        desc: "Guests are picked up from a designated meeting point in Barcelona on a shared coach and proceed towards Montserrat, a breathtaking mountain range and spiritual site. Upon arrival, travel up the mountain by cog-wheel train or cable car (subject to availability) and meet the local guide for an orientation tour. Visit the famous Santa Maria de Montserrat Abbey, with access to see the revered Black Madonna (La Moreneta), and learn about the history, culture and religious significance of Montserrat. Free time to explore the basilica, enjoy panoramic views, visit local souvenir shops, or taste local products. Return to Barcelona by shared coach with drop-off at the original meeting point.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Barcelona → Madrid",
        desc: "Breakfast at the hotel. After check-out, enjoy a private transfer from Barcelona Hotel to Barcelona Station to board your onwards journey to Madrid (train ticket not included). Upon arrival at Madrid Station, enjoy a private transfer to your hotel. Rest of the day at leisure. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Madrid City Tour + Prado Museum",
        desc: "Breakfast at the hotel. Proceed for a 01 Day Hop-On Hop-Off City Tour of Madrid, covering the Royal Palace, Plaza Mayor, Gran Via and Puerta del Sol. Later, enjoy the Prado Museum Guided Tour with Skip-the-Line Ticket. Evening free at leisure. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Madrid → Ibiza",
        desc: "Breakfast at the hotel. Check-out and enjoy a private transfer from Madrid Hotel to Madrid Airport for your flight to Ibiza (flight not included). Upon arrival at Ibiza Airport, enjoy a private transfer to your hotel. Rest of the day free to relax or explore Ibiza town. Overnight Stay in Ibiza.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Ibiza – Formentera Cruise",
        desc: "Breakfast at the hotel. Proceed for a Formentera Cruise on a shared basis, including paddle activities, snorkeling experience and scenic coastal views. Return to Ibiza and enjoy the evening at leisure. Overnight Stay in Ibiza.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Departure from Ibiza",
        desc: "Breakfast at the hotel. Check-out and enjoy a private transfer from Ibiza Hotel to Ibiza Airport for your onwards journey. End of Tour with Wonderful Memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Nights' Accommodation with Breakfast",
        "Private transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona: 01 Day Hop-On Hop-Off City Tour",
        "Barcelona: Sagrada Familia Entry Ticket (Only)",
        "Day tour to Montserrat with Black Madonna on Shared Basis",
        "Private transfer from Barcelona Hotel to Barcelona Station",
        "Private transfer from Madrid Station to Madrid Hotel",
        "Madrid: 01 Day Hop-On Hop-Off City Tour",
        "Madrid: Prado Museum Guided Tour with Skip-the-Line Ticket",
        "Day tour from Madrid to Segovia and Toledo Tour, Alcazar on shared Basis",
        "Private transfer from Madrid Hotel to Madrid Airport",
        "Private transfer from Ibiza Airport to Ibiza Hotel",
        "Ibiza: Cruise to Formentera with Paddle & Snorkeling (Shared Basis)",
        "Private transfer from Ibiza Hotel to Ibiza Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      items: [
        {
          name: "2nd class Train ticket from Barcelona to Madrid",
          price: "EUR 90 – 120 Per Adult",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 03N", hotel: "Hotel Acta Azul Barcelona or similar" },
            { location: "Madrid 03N", hotel: "Hotel Puerta de Toledo or similar" },
            { location: "Ibiza 02N", hotel: "Hotel Royal Plaza or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1114 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1069 per person onwards on Twin/Double sharing basis / EUR 965 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1026 per person onwards on Twin/Double sharing basis / EUR 922 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 698 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 362 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1193 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1148 per person onwards on Twin/Double sharing basis / EUR 1124 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1105 per person onwards on Twin/Double sharing basis / EUR 1081 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1031 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 681 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1268 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1223 per person onwards on Twin/Double sharing basis / EUR 1119 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1180 per person onwards on Twin/Double sharing basis / EUR 1076 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 852 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 516 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 3N", hotel: "Catalonia Barcelona Plaza or similar" },
            { location: "Madrid 3N", hotel: "NH Collection Madrid Gran Via or similar" },
            { location: "Ibiza 2N", hotel: "Hotel Royal Plaza or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1347 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1302 per person onwards on Twin/Double sharing basis / EUR 1214 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1263 per person onwards on Twin/Double sharing basis / EUR 1167 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 979 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 643 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1403 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1358 per person onwards on Twin/Double sharing basis / EUR 1243 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1340 per person onwards on Twin/Double sharing basis / EUR 1175 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 968 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 618 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1456 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1411 per person onwards on Twin/Double sharing basis / EUR 1262 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1368 per person onwards on Twin/Double sharing basis / EUR 1219 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 905 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 569 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/barcelona/day-1.jpg",
      "/images/barcelona/day-2.jpg",
      "/images/barcelona/day-3.jpg",
      "/images/barcelona/day-4.jpg",
      "/images/barcelona/day-5.jpg",
      "/images/barcelona/day-6.jpg",
      "/images/barcelona/day-7.jpg",
      "/images/barcelona/day-8.jpg",
    ],
  },

  {
    title: "Best of Barcelona + Valencia + Seville + Madrid",
    slug: "best-of-barcelona-valencia-seville-madrid",
    price: "EUR 863 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/Madrid7/day-4.jpg",
    location: "Barcelona, Valencia, Seville, Madrid, Spain",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "1 Country, 4 Cities, 08 Nights",
        places: "Barcelona, Valencia, Seville, Madrid",
      },

      pills: [
        "Breakfast Included",
        "Airport Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Sagrada Familia & Park Güell",
        "City of Arts and Sciences",
        "Seville Cathedral & Flamenco Culture",
        "Royal Palace Madrid",
        "Prado Museum",
        "El Retiro Park",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off Tour",
          desc: "A double-decker bus tour running on two routes with 24- or 48-hour passes, offering unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with audio commentary and free Wi-Fi.",
        },
        {
          title: "Valencia Hop-On Hop-Off Bus Tour",
          desc: "An open-top sightseeing bus with 17 stops across the city, taking in historic monuments, lively plazas and contemporary landmarks such as the City of Arts and Sciences and the Oceanogràfic, with multilingual audio guide.",
        },
        {
          title: "Seville Hop-On Hop-Off Bus Tour",
          desc: "A bright red open-top bus tour with 14 stops around the city, covering prestigious Islamic monuments, gardens and flamenco culture, plus the option to join free walking tours of Plaza de España, Maria Luisa Park and the Santa Cruz Jewish quarter.",
        },
        {
          title: "Madrid City Tour (SIC Basis)",
          desc: "A guided sightseeing tour covering key highlights of Madrid including historical monuments, iconic squares and architectural landmarks such as the Royal Palace, Prado Museum, Puerta de Alcalá, Cibeles Palace and Almudena Cathedral.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Barcelona – Arrival",
        desc: "Welcome to Barcelona – The City of Gaudí! A smooth transfer from the airport to your hotel gets you ready to immerse yourself in the magic of Barcelona, whether it's the art, culture, fashion, or food. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Barcelona Hop-On Hop-Off Tour",
        desc: "Breakfast at Hotel. Proceed to the Barcelona hop-on hop-off tour, a convenient way to see the city's main attractions using a double-decker bus running on two routes, with 24- or 48-hour passes allowing unlimited stops at landmarks like Sagrada Familia and Park Güell. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona – Valencia",
        desc: "After breakfast, check out from Barcelona Hotel and travel by train to Valencia (AVE high-speed train around 3–3.5 hours, or Euromed around 3–4 hours). Welcome to Valencia, the City of Arts and Sciences — a vibrant destination on Spain's eastern coast known for its beaches, futuristic architecture and rich cultural heritage. Enjoy the city's cuisine, including paella, and explore the historic center. Overnight stay at Valencia.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Valencia – Valencia 01 Day Hop-On Hop-Off Bus Tour",
        desc: "Breakfast at Hotel. Proceed to the Valencia Hop-On Hop-Off Bus Tour, exploring the city's highlights at your own pace with 17 convenient stops, taking in historic monuments, lively plazas and contemporary landmarks such as the City of Arts and Sciences and the Oceanogràfic, with a multilingual audio guide. Overnight stay at Valencia.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Valencia – Seville",
        desc: "After breakfast, check out from Valencia Hotel and travel by train to Seville (AVE high-speed train with a change in Madrid, around 6 hours, or Renfe Intercity, around 8 hours). Welcome to Seville, the Pearl of Andalusia — known for its stunning architecture, rich culture and vibrant flamenco music. Overnight stay at Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Seville – Seville 01 Day Hop-On Hop-Off Bus Tour",
        desc: "Breakfast at Hotel. Proceed to the Seville Hop-On Hop-Off Bus Tour aboard a bright red open-top bus with 14 stops, covering Islamic monuments, gardens and Flamenco culture, plus the option to join free walking tours of Plaza de España, Maria Luisa Park and the Santa Cruz Jewish quarter. Overnight Stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Seville – Madrid",
        desc: "After breakfast, check out from Seville Hotel and travel by AVE high-speed train to Madrid (around 2.5–4 hours depending on train and class). Welcome to Madrid, the vibrant capital of Spain, known for its stunning architecture, world-class museums and lively nightlife. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Madrid – Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
        desc: "Breakfast at Hotel. Enjoy the Madrid City Tour on SIC Basis, covering key highlights including historical monuments, iconic squares and architectural landmarks such as the Royal Palace, Prado Museum and Puerta de Alcalá, cruising through El Retiro and the Royal Botanic Gardens, and taking in Cibeles Palace and Almudena Cathedral. Afternoon and evening at leisure. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Madrid – Departure",
        desc: "After breakfast, check out from Madrid Hotel and proceed to the airport with a private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Nights' Accommodation with Breakfast",
        "Private Transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01 Day Hop on Hop off bus tour",
        "Valencia 01 Day Hop on Hop off bus tour",
        "Seville 01 Day Hop on Hop off bus tour",
        "Madrid City Tour on SIC Basis (1.5 hrs approx.)",
        "Private Transfer from Madrid Hotel to Madrid Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Tours operating on SIC/Shared basis may require travellers to reach the designated pickup point. Prices are not applicable during fair/event dates.",

      items: [
        {
          name: "Barcelona – Valencia (standard class train ticket, on actual basis)",
          price: "EUR 180 – 200 Per Adult",
        },
        {
          name: "Valencia – Seville (standard class train ticket, on actual basis)",
          price: "EUR 180 – 200 Per Adult",
        },
        {
          name: "Seville – Madrid (standard class train ticket, on actual basis)",
          price: "EUR 180 – 200 Per Adult",
        },
        {
          name: "Entrance to Park Güell",
          price: "EUR 22 Per Person",
        },
        {
          name: "Entrance to Sagrada Familia",
          price: "EUR 30 Per Person",
        },
        {
          name: "Entrance to Royal Alcázar",
          price: "EUR 32 Per Person",
        },
        {
          name: "Tour Bernabéu Entry Ticket",
          price: "EUR 37 Per Person",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "NH Barcelona Eixample or Similar" },
            { location: "Valencia 2N", hotel: "Hotel Ilunion Valencia 3 or similar" },
            { location: "Seville 2N", hotel: "ibis Styles Sevilla Santa Justa or similar" },
            { location: "Madrid 2N", hotel: "Leonardo Boutique Hotel Madrid or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 863 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 841 per person onwards on Twin/Double sharing basis / EUR 796 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 828 per person onwards on Twin/Double sharing basis / EUR 770 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 571 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 486 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 936 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 914 per person onwards on Twin/Double sharing basis / EUR 839 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 901 per person onwards on Twin/Double sharing basis / EUR 803 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 818 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 439 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 878 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 856 per person onwards on Twin/Double sharing basis / EUR 834 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 843 per person onwards on Twin/Double sharing basis / EUR 808 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 500 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 600 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Valencia 2N", hotel: "Hotel Ilunion Valencia 4 or similar" },
            { location: "Seville 2N", hotel: "Hotel Sevilla Center or similar" },
            { location: "Madrid 2N", hotel: "Hotel Agora Juan De Austria or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 870 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 858 per person onwards on Twin/Double sharing basis / EUR 819 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 835 per person onwards on Twin/Double sharing basis / EUR 783 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 616 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 306 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1013 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 991 per person onwards on Twin/Double sharing basis / EUR 950 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 978 per person onwards on Twin/Double sharing basis / EUR 924 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 743 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 648 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 952 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 930 per person onwards on Twin/Double sharing basis / EUR 854 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 917 per person onwards on Twin/Double sharing basis / EUR 828 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 537 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 422 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Madrid7/day-1.jpg",
      "/images/Madrid7/day-2.jpg",
      "/images/Madrid7/day-3.jpg",
      "/images/Madrid7/day-4.jpg",
      "/images/Madrid7/day-5.jpg",
      "/images/Madrid7/day-6.jpg",
      "/images/Madrid7/day-7.jpg",
    ],
  },

  {
    title: "Best of Ireland",
    slug: "best-of-ireland-belfast-dublin",
    price: "GBP 928 per person onwards", // lowest 02 Pax rate in PDF (4* Hotel, Twin/Double, Nov–Feb 2026/2027); 3* lowest was GBP 983
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/land/day-1.jpg",
    location: "Belfast, Dublin, Ireland",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Countries, 2 Cities, 07 Nights",
        places: "Belfast, Dublin",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "Titanic Belfast Experience",
        "Giant's Causeway",
        "Game of Thrones Filming Locations",
        "Trinity College Dublin",
        "Guinness Storehouse",
        "Temple Bar",
      ],

      experiences: [
        {
          title: "Belfast Hop-On Hop-Off Bus Tour + Titanic Belfast Experience",
          desc: "A flexible 1-day bus tour discovering Belfast's top attractions at your own pace, including City Hall, the Cathedral Quarter, the Peace Walls and Crumlin Road Gaol, followed by the world-famous Titanic Belfast Experience with immersive galleries on the legendary ship designed and built in Belfast.",
        },
        {
          title: "Giant's Causeway & Game of Thrones Day Tour",
          desc: "A full-day tour to marvel at the volcanic rock formations of the Giant's Causeway, a UNESCO World Heritage Site, followed by dramatic coastal scenery and famous Game of Thrones filming locations, including medieval ruins and rugged cliffs.",
        },
        {
          title: "Dublin Hop-On Hop-Off Bus Tour",
          desc: "A 1-day bus tour visiting must-see landmarks such as Trinity College, Temple Bar, Phoenix Park, St. Patrick's Cathedral and the Guinness Storehouse, exploring the city at your own pace.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Ireland (Arrival in Belfast)",
        desc: "Welcome to Ireland, a country known for its breathtaking landscapes, ancient Celtic heritage and warm hospitality — the Emerald Isle, where history, myths, music and modern charm come together. Upon landing at Belfast Airport, meet your driver and enjoy a smooth private transfer to your hotel. Belfast, the spirited capital of Northern Ireland, is famed for its maritime history, vibrant culture and elegant Victorian architecture. After checking in, relax or explore the city at your leisure. Overnight stay in Belfast.",
        tags: [],
      },
      {
        day: "02",
        title: "Belfast Hop-On Hop-Off Bus Tour + Titanic Belfast Experience",
        desc: "Breakfast at Hotel. Enjoy a 1-day Belfast Hop-On Hop-Off Bus Tour, discovering the city's top attractions at your own pace, including City Hall, Cathedral Quarter, the Peace Walls and Crumlin Road Gaol. Then head to the world-famous Titanic Belfast Experience, walking through immersive galleries on the legendary ship designed and built in Belfast. Free evening at leisure. Overnight stay in Belfast.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Giant's Causeway & Game of Thrones Day Tour",
        desc: "After breakfast, set off for a full-day Giant's Causeway & Game of Thrones Tour (SIC Basis). Marvel at the stunning volcanic rock formations of the Giant's Causeway, a UNESCO World Heritage Site, then explore dramatic coastal scenery and famous Game of Thrones filming locations, including medieval ruins and rugged cliffs. Return to Belfast in the evening. Overnight stay in Belfast.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Day at Leisure",
        desc: "A free day to explore Belfast at your own pace. Overnight stay in Belfast.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Belfast → Dublin",
        desc: "Breakfast at Hotel. After breakfast, check out and enjoy a smooth private transfer from your Belfast hotel to your hotel in Dublin. Spend the rest of the day exploring Dublin's lively pubs, historic squares and cultural attractions. Overnight stay in Dublin.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dublin Hop-On Hop-Off Bus Tour",
        desc: "Start your day with breakfast before enjoying a 1-day Dublin Hop-On Hop-Off Bus Tour, visiting must-see landmarks such as Trinity College, Temple Bar, Phoenix Park, St. Patrick's Cathedral and the Guinness Storehouse — exploring the city at your own pace. Overnight stay in Dublin.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Day at Leisure",
        desc: "A free day to explore Dublin at your own pace. Overnight stay in Dublin.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Departure from Dublin",
        desc: "Private transfer from Dublin hotel to Dublin Airport for your onward flight, marking the end of your memorable Ireland adventure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "Private transfer from Belfast Airport to hotel",
        "01-day Belfast Hop on Hop off bus tour - SIC",
        "Belfast The Titanic Experience entry ticket",
        "Giant's Causeway and Game of Thrones Day Tour from Belfast on SIC Basis",
        "Private transfer from Belfast hotel to Dublin",
        "Dublin 01 Hop on Hop off bus tour - SIC",
        "Day at Leisure",
        "Private transfer from Dublin Hotel to Dublin Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Belfast 4N", hotel: "Hampton by Hilton Belfast City Centre or Similar" },
            { location: "Dublin 3N", hotel: "Hilton Garden Inn Dublin City Centre or Similar" },
          ],
          seasons: [
            {
              months: "Nov – Feb 2026/2027",
              rows: [
                { pax: "02 Pax", price: "GBP 983 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 857 per person onwards on Twin/Double sharing basis / GBP 790 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 801 per person onwards on Twin/Double sharing basis / GBP 732 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 417 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 562 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1225 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1101 per person onwards on Twin/Double sharing basis / GBP 881 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1042 per person onwards on Twin/Double sharing basis / GBP 824 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 213 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 793 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1383 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1259 per person onwards on Twin/Double sharing basis / GBP 1111 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1201 per person onwards on Twin/Double sharing basis / GBP 1053 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 568 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 944 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Belfast 4N", hotel: "Clayton Hotel Belfast or Similar" },
            { location: "Dublin 3N", hotel: "Hotel Riu Plaza The Gresham Dublin or Similar" },
          ],
          seasons: [
            {
              months: "Nov – Feb 2026/2027",
              rows: [
                { pax: "02 Pax", price: "GBP 928 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 830 per person onwards on Twin/Double sharing basis / GBP 807 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 775 per person onwards on Twin/Double sharing basis / GBP 750 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 569 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 510 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1121 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 996 per person onwards on Twin/Double sharing basis / GBP 833 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 938 per person onwards on Twin/Double sharing basis / GBP 776 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 276 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 694 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1887 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1762 per person onwards on Twin/Double sharing basis / GBP 1368 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1705 per person onwards on Twin/Double sharing basis / GBP 1310 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 343 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1424 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/land/day-1.jpg",
      "/images/land/day-2.jpg",
      "/images/land/day-3.jpg",
      "/images/land/day-4.jpg",
      "/images/land/day-5.jpg",
      "/images/land/day-6.jpg",
      "/images/land/day-7.jpg",
      "/images/land/day-8.jpg",
    ],
  },


  {
    title: "Budapest + Vienna + Prague",
    slug: "budapest-vienna-prague",
    price: "EUR 546 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026-2027)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/buda6/day-1.jpg",
    location: "Budapest, Vienna, Prague",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Countries, 3 Cities, 06 Nights",
        places: "Budapest, Vienna, Prague",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Danube Sightseeing Cruise",
        "Buda Castle & Chain Bridge",
        "Schönbrunn Palace",
        "St. Stephen's Cathedral",
        "Prague Castle",
        "Charles Bridge",
      ],

      experiences: [
        {
          title: "Budapest City Highlights Sightseeing Cruise",
          desc: "A Danube river cruise with entrance ticket and tour included, taking in stunning views of the Parliament Building, Buda Castle, Chain Bridge, Gellért Hill and Budapest's picturesque riverbanks, with informative commentary throughout.",
        },
        {
          title: "Schönbrunn Palace & Gardens Skip-the-Line Tour",
          desc: "A shared-basis tour of the magnificent imperial residence, strolling through the ornate halls to learn about the Habsburg dynasty, plus the exquisite Baroque gardens, fountains and viewpoints surrounding the palace grounds.",
        },
        {
          title: "Prague Castle Skip-the-Line Ticket with Audioguide",
          desc: "Skip-the-line entry to explore St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica and the charming Golden Lane, with an audioguide covering the history of the world's largest ancient castle complex.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Budapest",
        desc: "Welcome to Hungary! Welcome to Budapest. Upon arrival at Budapest Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening walking along the Danube Promenade or exploring the lively streets around Váci Utca at your own pace. Overnight Stay in Budapest.",
        tags: [],
      },
      {
        day: "02",
        title: "Budapest City Highlights Sightseeing Cruise",
        desc: "Breakfast at Hotel. Proceed for your Budapest City Highlights Sightseeing Cruise (ticket included). Sail along the Danube and enjoy stunning views of the Parliament Building, Buda Castle, Chain Bridge, Gellért Hill and the picturesque riverbanks of Budapest, with informative commentary during the cruise. Rest of the day is free for leisure — explore Fisherman's Bastion, Heroes' Square, or Budapest's famous thermal baths. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Budapest – Vienna",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Budapest Hotel to the Train Station, board your train to Vienna. Upon arrival at Vienna Station, enjoy a private transfer to your hotel. Check in and spend the evening strolling around the Ringstrasse, St. Stephen's Cathedral area, or visiting a traditional Viennese café. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Vienna – Schönbrunn Palace & Gardens Tour",
        desc: "Breakfast at Hotel. Proceed for the Schönbrunn Palace & Gardens Skip-the-Line Tour (shared basis, included). Visit the magnificent imperial residence, stroll through the ornate halls, and learn about the Habsburg dynasty, and enjoy the exquisite Baroque gardens, fountains and viewpoints surrounding the palace grounds. Return to the city center and enjoy your afternoon at leisure — explore the Hofburg Palace, Rathausplatz or Vienna's classical music and coffee culture. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Vienna – Prague",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Vienna Hotel to Station, board your train to Prague. Upon arrival at Prague Station, enjoy a private transfer to your hotel. Check in and relax, or take an evening walk across Charles Bridge and explore Old Town Square. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Prague – Prague Castle Skip-the-Line Ticket with Audioguide",
        desc: "Breakfast at Hotel. Proceed to visit Prague Castle using your Skip-the-Line Ticket with Audioguide (included). Explore St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica, and the charming Golden Lane, while learning about the history of the world's largest ancient castle complex. Afternoon and evening at leisure — explore the Astronomical Clock, Vltava riverside, or enjoy cafés and local markets in the Old Town area. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Prague – India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Prague Hotel to Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private transfer from Budapest Airport to Hotel",
        "City Highlights Sightseeing Cruise",
        "Private Transfer from Budapest Hotel to Train Station",
        "Private Transfer from Vienna Station to Hotel",
        "Schönbrunn Palace & Gardens Skip-the-Line Tour on Shared Basis",
        "Private Transfer from Vienna Hotel to Station",
        "Private Transfer from Prague Station to Hotel",
        "Prague Castle Skip-the-Line Ticket with Audioguide",
        "Private Transfer from Prague Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from Budapest to Vienna & Vienna to Prague – on actual basis",
          price: "EUR 55 – 60 Per Adult",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Budapest 2N", hotel: "Star City Hotel or Similar" },
            { location: "Vienna 2N", hotel: "Garner Hotel Vienna or Similar" },
            { location: "Prague 2N", hotel: "Exe City Park or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026/2027",
              rows: [
                { pax: "02 Pax", price: "EUR 546 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 488 per person onwards on Twin/Double sharing basis / EUR 478 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 462 per person onwards on Twin/Double sharing basis / EUR 452 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 321 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 213 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 652 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 594 per person onwards on Twin/Double sharing basis / EUR 571 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 571 per person onwards on Twin/Double sharing basis / EUR 544 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 383 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 275 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 631 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 570 per person onwards on Twin/Double sharing basis / EUR 506 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 552 per person onwards on Twin/Double sharing basis / EUR 479 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 370 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 255 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Budapest 2N", hotel: "Exe Budapest Center or Similar" },
            { location: "Vienna 2N", hotel: "Leonardo Hotel Vienna or Similar" },
            { location: "Prague 2N", hotel: "Century Old Town Prague - Mgallery or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026/2027",
              rows: [
                { pax: "02 Pax", price: "EUR 585 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 527 per person onwards on Twin/Double sharing basis / EUR 568 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 501 per person onwards on Twin/Double sharing basis / EUR 542 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 513 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 405 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 718 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 660 per person onwards on Twin/Double sharing basis / EUR 690 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 637 per person onwards on Twin/Double sharing basis / EUR 663 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 608 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 500 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 635 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 574 per person onwards on Twin/Double sharing basis / EUR 622 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 556 per person onwards on Twin/Double sharing basis / EUR 595 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 553 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 445 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/buda6/day-1.jpg",
      "/images/buda6/day-2.jpg",
      "/images/buda6/day-3.jpg",
      "/images/buda6/day-4.jpg",
      "/images/buda6/day-5.jpg",
      "/images/buda6/day-6.jpg",
      "/images/buda6/day-7.jpg",

    ],
  },

  {
    title: "Budapest + Vienna + Prague",
    slug: "budapest-vienna-prague-08n",
    price: "EUR 646 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/buda/day-1.jpg",
    location: "Budapest, Vienna, Prague",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Countries, 3 Cities, 08 Nights",
        places: "Budapest, Vienna, Prague",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Danube Sightseeing Cruise",
        "Buda Castle & Chain Bridge",
        "Schönbrunn Palace",
        "St. Stephen's Cathedral",
        "Prague Castle",
        "Charles Bridge",
      ],

      experiences: [
        {
          title: "Budapest City Highlights Sightseeing Cruise",
          desc: "A Danube river cruise with entrance ticket and tour included, taking in stunning views of the Parliament Building, Buda Castle, Chain Bridge, Gellért Hill and Budapest's picturesque riverbanks, with informative commentary throughout.",
        },
        {
          title: "Schönbrunn Palace & Gardens Skip-the-Line Tour",
          desc: "A shared-basis tour of the magnificent imperial residence, strolling through the ornate halls to learn about the Habsburg dynasty, plus the exquisite Baroque gardens, fountains and viewpoints surrounding the palace grounds.",
        },
        {
          title: "Prague Castle Skip-the-Line Ticket with Audioguide",
          desc: "Skip-the-line entry to explore St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica and the charming Golden Lane, with an audioguide covering the history of the world's largest ancient castle complex.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Budapest",
        desc: "Welcome to Hungary! Welcome to Budapest. Upon arrival at Budapest Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening walking along the Danube Promenade or exploring the lively streets around Váci Utca at your own pace. Overnight Stay in Budapest.",
        tags: [],
      },
      {
        day: "02",
        title: "Budapest City Highlights Sightseeing Cruise",
        desc: "Breakfast at Hotel. Proceed for your Budapest City Highlights Sightseeing Cruise (ticket included). Sail along the Danube and enjoy stunning views of the Parliament Building, Buda Castle, Chain Bridge, Gellért Hill and the picturesque riverbanks of Budapest, with informative commentary during the cruise. Rest of the day is free for leisure — explore Fisherman's Bastion, Heroes' Square, or Budapest's famous thermal baths. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Budapest – Vienna",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Budapest Hotel to the Train Station, board your train to Vienna. Upon arrival at Vienna Station, enjoy a private transfer to your hotel. Check in and spend the evening strolling around the Ringstrasse, St. Stephen's Cathedral area, or visiting a traditional Viennese café. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Vienna – Day at Leisure",
        desc: "Breakfast at Hotel. A free day to explore Vienna at your own pace. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Vienna – Schönbrunn Palace & Gardens Tour",
        desc: "Breakfast at Hotel. Proceed for the Schönbrunn Palace & Gardens Skip-the-Line Tour (shared basis, included). Visit the magnificent imperial residence, stroll through the ornate halls, and learn about the Habsburg dynasty, and enjoy the exquisite Baroque gardens, fountains and viewpoints surrounding the palace grounds. Return to the city center and enjoy your afternoon at leisure — explore the Hofburg Palace, Rathausplatz or Vienna's classical music and coffee culture. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Vienna – Prague",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Vienna Hotel to Station, board your train to Prague. Upon arrival at Prague Station, enjoy a private transfer to your hotel. Check in and relax, or take an evening walk across Charles Bridge and explore Old Town Square. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Prague – Prague Castle Skip-the-Line Ticket with Audioguide",
        desc: "Breakfast at Hotel. Proceed to visit Prague Castle using your Skip-the-Line Ticket with Audioguide (included). Explore St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica, and the charming Golden Lane, while learning about the history of the world's largest ancient castle complex. Afternoon and evening at leisure — explore the Astronomical Clock, Vltava riverside, or enjoy cafés and local markets in the Old Town area. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Prague – Day at Leisure",
        desc: "Breakfast at hotel. A free day to explore Prague at your own pace. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Prague – India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Prague Hotel to Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Night Accommodation with Breakfast",
        "Private transfer from Budapest Airport to Hotel",
        "City Highlights Sightseeing Cruise",
        "Private Transfer from Budapest Hotel to Train Station",
        "Private Transfer from Vienna Station to Hotel",
        "Schönbrunn Palace & Gardens Skip-the-Line Tour on Shared Basis",
        "Private Transfer from Vienna Hotel to Station",
        "Private Transfer from Prague Station to Hotel",
        "Prague Castle Skip-the-Line Ticket with Audioguide",
        "Private Transfer from Prague Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class Train ticket from Budapest to Vienna & Vienna to Prague – on actual basis",
          price: "EUR 55 – 60 Per Adult",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Budapest 2N", hotel: "Star City Hotel or Similar" },
            { location: "Vienna 3N", hotel: "Garner Hotel Vienna or Similar" },
            { location: "Prague 3N", hotel: "Exe City Park or Similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb & Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 646 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 588 per person onwards on Twin/Double sharing basis / EUR 553 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 562 per person onwards on Twin/Double sharing basis / EUR 527 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 432 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 324 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 738 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 677 per person onwards on Twin/Double sharing basis / EUR 590 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 660 per person onwards on Twin/Double sharing basis / EUR 540 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 493 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 385 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 762 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 704 per person onwards on Twin/Double sharing basis / EUR 700 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 693 per person onwards on Twin/Double sharing basis / EUR 682 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 598 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 567 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Budapest 2N", hotel: "Exe Budapest Center or Similar" },
            { location: "Vienna 3N", hotel: "Leonardo Hotel Vienna or Similar" },
            { location: "Prague 3N", hotel: "Century Old Town Prague - Mgallery or Similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb & Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 683 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 681 per person onwards on Twin/Double sharing basis / EUR 625 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 620 per person onwards on Twin/Double sharing basis / EUR 599 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 587 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 506 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 735 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 710 per person onwards on Twin/Double sharing basis / EUR 670 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 660 per person onwards on Twin/Double sharing basis / EUR 643 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 680 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 587 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 907 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 895 per person onwards on Twin/Double sharing basis / EUR 849 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 828 per person onwards on Twin/Double sharing basis / EUR 868 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 634 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 654 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/buda/day-1.jpg",
      "/images/buda/day-2.jpg",
      "/images/buda/day-3.jpg",
      "/images/buda/day-4.jpg",
      "/images/buda/day-5.jpg",
      "/images/buda/day-6.jpg",
      "/images/buda/day-7.jpg",
      "/images/buda/day-8.jpg",
      "/images/buda/day-9.jpg",
    ],
  },

  {
    title: "Best of Copenhagen and Gothenburg",
    slug: "copenhagen-gothenburg-04n",
    price: "EUR 656 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Mar/Sep/Oct 2026)
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/cop/day-1.jpg",
    location: "Copenhagen, Gothenburg",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Countries, 2 Cities, 04 Nights",
        places: "Copenhagen, Gothenburg",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "04 Nights Accommodation",
      ],

      highlights: [
        "Rosenborg Castle",
        "Amalienborg Palace",
        "Tivoli Gardens",
        "The Little Mermaid Statue",
        "Gothenburg Cathedral",
        "Haga District",
      ],

      experiences: [
        {
          title: "Copenhagen Hop-on Hop-off City Tour + Boat Ride + Illusion Museum",
          desc: "A Hop-on Hop-off City Tour of Copenhagen taking in iconic attractions like Rosenborg Castle, Amalienborg Palace, Tivoli Gardens and The Little Mermaid Statue, followed by a One-Way Boat Tour offering stunning views of canals and colorful townhouses, and a visit to the Copenhagen Illusion Museum (entry ticket included) — a fun and interactive experience perfect for all ages.",
        },
        {
          title: "Guided Walking Tour of Gothenburg",
          desc: "A Guided Walking Tour of Gothenburg (Shared Basis) covering Gustav Adolfs Square, Gothenburg Cathedral, Feskekôrka Fish Market and the Haga District, famous for giant cinnamon buns, showcasing the charming blend of Scandinavian architecture, beautiful parks and lively markets.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Copenhagen",
        desc: "Welcome to Copenhagen – The capital city of Denmark! Upon arrival at Copenhagen Airport, you will be greeted and transferred privately to your hotel. The rest of the day is free to relax or explore the city on your own. Stroll through Nyhavn harbour, taste local bakeries, or simply enjoy the fresh Nordic air. Overnight stay in Copenhagen.",
        tags: [],
      },
      {
        day: "02",
        title: "Copenhagen – Hop on hop off City Tour + Boat Ride + Illusion Museum",
        desc: "Breakfast at the hotel. After breakfast, proceed for your Hop-on Hop-off City Tour of Copenhagen. Explore iconic attractions like: Rosenborg Castle, Amalienborg Palace, Tivoli Gardens, The Little Mermaid Statue. Later, enjoy a One-Way Boat Tour offering stunning views of canals and colorful townhouses. Continue to the Copenhagen Illusion Museum (Entry Ticket Included) – a fun and interactive experience perfect for all ages. Overnight stay in Copenhagen.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Paris – Copenhagen ➜ Gothenburg (By Train)",
        desc: "Breakfast at the hotel. Today, you will be transferred privately from your hotel to Copenhagen Train Station. Board your train to Sweden's harbour city, Gothenburg. Upon arrival, you will get a private transfer from Gothenburg Station to your hotel. Time free at leisure to relax or explore the shopping streets like Avenyn or enjoy waterfront cafes. Overnight stay in Gothenburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Guided Walking Tour – Gothenburg",
        desc: "Breakfast at the hotel. After breakfast, join a Guided Walking Tour of Gothenburg (Shared Basis). Highlights include: Gustav Adolfs Square, Gothenburg Cathedral, Feskekôrka Fish Market, Haga District (famous for giant cinnamon buns). Enjoy the charming blend of Scandinavian architecture, beautiful parks, and lively markets. Rest of the day is free to explore at your own pace. Overnight stay in Gothenburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Gothenburg ➜ Copenhagen Airport (Departure)",
        desc: "Breakfast at the hotel. After breakfast, proceed with a private transfer from Gothenburg Hotel to Gothenburg Station. On arrival in Copenhagen, you will again get your private transfer from Copenhagen Station to Copenhagen Airport for your flight back home. End of your Scandinavian Journey with lifetime memories!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "04 Nights' Accommodation with Breakfast",
        "Private transfer from Copenhagen Airport (CDG) to Copenhagen Hotel",
        "Copenhagen: 01-Day Hop on hop off Tour + One-Way Boat Tour",
        "Copenhagen Illusion Museum (Entry Ticket Only)",
        "Private transfer from Copenhagen Hotel to Copenhagen Train Station",
        "Guided Walking Tour of Gothenburg (Shared Basis)",
        "02nd Class 04 Days Consecutive Swiss Pass",
        "Private transfer from Gothenburg Hotel to Gothenburg Station",
        "Private transfer from Copenhagen Station to Copenhagen Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      items: [
        {
          name: "2nd class train ticket from Copenhagen to Gothenburg – on actual basis",
          price: "EUR 70 – 120 Per Person",
        },
      ],
    },

    pricing: {
       note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Copenhagen 2N", hotel: "Best Western Hotel Hebron or similar" },
            { location: "Gothenburg 2N", hotel: "Spar Garda or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb, Nov, Dec - 2025-2026",
              rows: [
                { pax: "02 Pax", price: "EUR 720 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 601 per person onwards on Twin/Double sharing basis / EUR 591 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 544 per person onwards on Twin/Double sharing basis / EUR 514 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 547 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 246 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct",
              rows: [
                { pax: "02 Pax", price: "EUR 656 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 642 per person onwards on Twin/Double sharing basis / EUR 656 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 557 per person onwards on Twin/Double sharing basis / EUR 595 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 590 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 349 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 837 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 789 per person onwards on Twin/Double sharing basis / EUR 644 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 649 per person onwards on Twin/Double sharing basis / EUR 597 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 439 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 171 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "July, Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 849 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 708 per person onwards on Twin/Double sharing basis / EUR 674 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 661 per person onwards on Twin/Double sharing basis / EUR 627 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 495 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 171 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Paris 3N", hotel: "Scandic Palace Hotel or Similar" },
            { location: "Zurich 1N", hotel: "Scandic Crown or similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb, Nov, Dec - 2025-2026",
              rows: [
                { pax: "02 Pax", price: "EUR 764 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 703 per person onwards on Twin/Double sharing basis / EUR 734 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 598 per person onwards on Twin/Double sharing basis / EUR 594 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 959 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 657 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct",
              rows: [
                { pax: "02 Pax", price: "EUR 866 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 756 per person onwards on Twin/Double sharing basis / EUR 711 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 708 per person onwards on Twin/Double sharing basis / EUR 663 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 703 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 401 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 939 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 850 per person onwards on Twin/Double sharing basis / EUR 831 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 841 per person onwards on Twin/Double sharing basis / EUR 784 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 766 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 498 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "July, Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1009 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 909 per person onwards on Twin/Double sharing basis / EUR 830 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 821 per person onwards on Twin/Double sharing basis / EUR 782 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 650 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 382 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/cop/day-1.jpg",
      "/images/cop/day-2.jpg",
      "/images/cop/day-3.jpg",
      "/images/cop/day-4.jpg",
      "/images/cop/day-5.jpg",
    ],
  },

  {
    title: "Best of Sweden",
    slug: "stockholm-gothenburg-04n",
    price: "EUR 833 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/swe/day-1.jpg",
    location: "Stockholm, Gothenburg",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2N Stockholm + 2N Gothenburg, 04 Nights",
        places: "Stockholm, Gothenburg",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "04 Nights Accommodation",
      ],

      highlights: [
        "Royal Palace",
        "Gamla Stan (Old Town)",
        "City Hall",
        "ABBA Museum",
        "Djurgården Island",
        "Vasa Museum",
      ],

      experiences: [
        {
          title: "Stockholm Hop-On Hop-Off + Vasa Museum Guided Tour",
          desc: "A Stockholm Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis) exploring top highlights like the Royal Palace, Gamla Stan (Old Town), City Hall, ABBA Museum and Djurgården Island, followed by a Vasa Museum Guided Tour (entry ticket included) to discover the world's only preserved 17th-century warship and learn about Sweden's maritime history.",
        },
        {
          title: "Amphibious Bus Tour + Guided Walking Tour of Gothenburg",
          desc: "A Land & Water Amphibious Bus Sightseeing Tour (SIC Basis – 1 Hour) aboard the amphibious 'Ocean Bus' that travels both on land and water with fun commentary and scenic views of the city's major landmarks, followed by a Private Walking Tour (Shared Basis) exploring Gothenburg's history, architecture and cultural highlights through charming squares, lively markets and beautiful boulevards.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Stockholm",
        desc: "Welcome to Stockholm – The Nordic Pearl! Stockholm is the cultural, media, political, and economic centre of Sweden. The Stockholm region alone accounts for over a third of the country's GDP, and is among the top 10 regions in Europe by GDP per capita. Considered a global city, it is the largest in Scandinavia and the main centre for corporate headquarters in the Nordic region. Overnight Stay in Stockholm.",
        tags: [],
      },
      {
        day: "02",
        title: "Stockholm Hop-On Hop-Off + Vasa Museum Guided Tour",
        desc: "Breakfast at Hotel. Start your day with the Stockholm Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis). Explore top highlights like: Royal Palace, Gamla Stan (Old Town), City Hall, ABBA Museum, Djurgården Island. Later, proceed for your Vasa Museum Guided Tour (Entry Ticket Included). Discover the world's only preserved 17th-century warship and learn about Sweden's maritime history. Evening is free for leisure, shopping, or enjoying Swedish cuisine. Overnight Stay in Stockholm.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Stockholm → Gothenburg",
        desc: "Breakfast at Hotel. This morning, proceed for your private transfer from Stockholm Hotel to Stockholm Station to board your train to Gothenburg. Arrive in Gothenburg, Sweden's charming west-coast city, and enjoy a private transfer from Gothenburg Station to your hotel. Rest of the day is free to explore the harbour area, canals, and café culture. Overnight Stay in Gothenburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Amphibious Bus Tour + Guided Walking Tour",
        desc: "Breakfast at Hotel. Land & Water Amphibious Bus Sightseeing Tour (SIC Basis – 1 Hour). Experience Gothenburg like never before as you aboard the amphibious \"Ocean Bus\" that travels both on land and water! Enjoy fun commentary and scenic views of the city's major landmarks. Private Walking Tour (Shared Basis). Later, join a guided Walking Tour to explore Gothenburg's history, architecture, and cultural highlights. Walk through charming squares, lively markets, and beautiful boulevards with your expert guide. Overnight Stay in Gothenburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Gothenburg → India",
        desc: "Breakfast at Hotel. Check out and enjoy a comfortable private transfer from Gothenburg hotel to Gothenburg Airport for your flight back to India. Your memorable Sweden trip ends with wonderful experiences and beautiful memories!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "04 Night's Accommodation with Breakfast",
        "Private transfer from Stockholm Airport to Stockholm hotel",
        "Stockholm Hop-on Hop-off Bus tour 01 day pass on sic basis",
        "Vasa Museum Guided Tour Entry ticket",
        "Private transfer from Stockholm Hotel to Stockholm hotel",
        "Private transfer from Gothenburg station to Gothenburg hotel",
        "Land & Water Amphibious Bus Sightseeing Tour on sic basis 01 hr duration",
        "Private Walking Tour with a Guide on shared basis",
        "Private transfer from Gothenburg Hotel to Gothenburg Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "Stockholm - Gothenburg 2nd class train ticket – on actual basis",
          price: "EUR 65 – 80 onwards Per Person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Stockholm 2N", hotel: "Ibis Styles Stockholm Oden plan or similar" },
            { location: "Gothenburg 2N", hotel: "Avalon Hotel or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 833 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 718 per person onwards on Twin/Double sharing basis / EUR 705 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 654 per person onwards on Twin/Double sharing basis / EUR 639 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 682 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 263 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 923 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 813 per person onwards on Twin/Double sharing basis / EUR 758 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 739 per person onwards on Twin/Double sharing basis / EUR 674 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 338 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 353 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 833 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 728 per person onwards on Twin/Double sharing basis / EUR 717 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 649 per person onwards on Twin/Double sharing basis / EUR 658 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 525 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 243 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Stockholm 2N", hotel: "Scandic Grand Central or similar" },
            { location: "Gothenburg 2N", hotel: "Jacy'z Hotel & Resort or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 924 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 804 per person onwards on Twin/Double sharing basis / EUR 788 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 740 per person onwards on Twin/Double sharing basis / EUR 724 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 471 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 339 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1008 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 888 per person onwards on Twin/Double sharing basis / EUR 819 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 824 per person onwards on Twin/Double sharing basis / EUR 760 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 411 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 423 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 904 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 784 per person onwards on Twin/Double sharing basis / EUR 768 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 800 per person onwards on Twin/Double sharing basis / EUR 706 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 297 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 399 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/swe/day-1.jpg",
      "/images/swe/day-2.jpg",
      "/images/swe/day-3.jpg",
      "/images/swe/day-4.jpg",
      "/images/swe/day-5.jpg",
    ],
  },


  // {
  //   title: "Best of Edinburgh & Glasgow",
  //   slug: "edinburgh-glasgow-06n",
  //   price: "GBP 805 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Mar/Sep/Oct 2026)
  //   days: "06 Nights / 07 Days",
  //   rating: "",
  //   image: "",
  //   location: "Edinburgh, Glasgow",
  //   nextDate: "Available on Request",

  //   highlightsData: {
  //     locationCard: {
  //       meta: "03 Night Edinburgh + 03 Night Glasgow, 06 Nights",
  //       places: "Edinburgh, Glasgow",
  //     },

  //     pills: [
  //       "Breakfast Included",
  //       "Private Transfers Included",
  //       "06 Nights Accommodation",
  //     ],

  //     highlights: [
  //       "Edinburgh Castle",
  //       "Royal Mile",
  //       "Loch Ness & Glencoe",
  //       "Scottish Highlands",
  //       "Glasgow Cathedral",
  //       "Glenfinnan Viaduct",
  //     ],

  //     experiences: [
  //       {
  //         title: "Edinburgh 01 Day Hop on Hop off Bus (SIC Basis)",
  //         desc: "An award-winning hop-on hop-off open-top bus tour of Edinburgh with onboard commentary describing the city's history, stopping at locations like St Andrew Square, Johnstone Terrace and the Royal Mile, and taking in sights like Edinburgh Castle and Grassmarket, comparing the cramped Old Town to the elegant Georgian New Town.",
  //       },
  //       {
  //         title: "Loch Ness, Glencoe & the Scottish Highlands Tour from Edinburgh (SIC Basis)",
  //         desc: "A scenic full-day trip into the Scottish Highlands by air-conditioned luxury coach, stopping in the Callander area for a chance to see Highland cows, continuing to Glencoe for dramatic views and clan massacre history, then on to Fort William before reaching Loch Ness, with optional visits to Urquhart Castle or a Loch Ness boat cruise, before returning via Inverness and Pitlochry.",
  //       },
  //       {
  //         title: "Glasgow 01 Day Hop on Hop off City Tour (SIC Basis)",
  //         desc: "A 1-day ticket to Glasgow's hop-on hop-off bus, exploring museums, art galleries, parks, theatres and Glasgow Cathedral, with stops convenient for the Riverside Museum of Transport and Travel, Kelvingrove Art Galleries, Glasgow University, Glasgow Green and Clydeside Distillery.",
  //       },
  //       {
  //         title: "Glenfinnan, Fort William & Glencoe Day Trip from Glasgow (SIC Basis)",
  //         desc: "A day trip north to the Highlands via Tyndrum to the dramatic landscapes of Glencoe (featured in Skyfall), continuing to Fort William with views of Ben Nevis, then to the Glenfinnan Viaduct made famous by the Harry Potter films and the Glenfinnan Monument on Loch Shiel, returning via Neptune's Staircase and the scenic banks of Loch Lomond.",
  //       },
  //     ],
  //   },

  //   itinerary: [
  //     {
  //       day: "01",
  //       title: "India – Edinburgh",
  //       desc: "Welcome to Edinburgh – The City of Lights! Your adventure begins with a smooth transfer from the airport to your hotel, where you'll be ready to immerse yourself in the magic of Edinburgh. Whether you're here for the art, the culture, the fashion, or the food, Edinburgh offers an abundance of experiences waiting to be explored. Overnight Stay in Edinburgh.",
  //       tags: [],
  //     },
  //     {
  //       day: "02",
  //       title: "Edinburgh – Edinburgh 01 Day Hop on Hop off Bus",
  //       desc: "Breakfast at Hotel. After breakfast proceed to Edinburgh 01 Day Hop on Hop off Bus city tour on SIC basis. Customers can join the tour at any of the stops along the route. Explore Edinburgh at your own pace with an award-winning hop-on hop-off open-top bus tour. Enjoy the onboard commentary that describes the history behind the city. Stop at locations like St Andrew Square, Johnstone Terrace, the Royal Mile. See sights like Edinburgh Castle and Grassmarket. Board the bus and begin your city adventure. Compare Edinburgh's Old Town, where families lived in cramped conditions and rubbish was thrown out of the windows, to the elegant Georgian New Town, with its 3 main streets and square at either end. Overnight Stay in Edinburgh.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "03",
  //       title: "Edinburgh – Loch Ness, Glencoe & the Scottish Highlands Tour from Edinburgh on SIC Basis",
  //       desc: "Breakfast at Hotel. Loch Ness, Glencoe & the Scottish Highlands Tour from Edinburgh on SIC Basis. Our Edinburgh tours depart from Castle Terrace, Edinburgh EH1 2EW, outside the NCP Car Park. Head into the Scottish Highlands on a scenic full-day trip from Edinburgh. Travel by air-conditioned luxury coach while your guide shares stories, music, and commentary along the way. Stop first in the Callander area, where you may get a chance to see the famous Highland cows (seasonal). Continue onward to Glencoe for dramatic views, historic tales of the clan massacres, and a brief photo stop. Arrive at the Fort William area before heading to the iconic Loch Ness. Here, you can choose optional activities such as visiting Urquhart Castle, taking a Loch Ness boat cruise, enjoying the \"Donald Fraser – Illicit Whisky Experience,\" or exploring the surrounding walking routes. Travel the full length of Loch Ness, pass through Inverness, and continue south with a short break in Pitlochry before returning to Edinburgh around 20:30hrs. Overnight Stay in Edinburgh.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "04",
  //       title: "Edinburgh – Glasgow",
  //       desc: "Breakfast at Hotel. After breakfast transfer from hotel to station on private basis. Train from Edinburgh to Glasgow. Travelling by train from Edinburgh to Glasgow is a fantastic way to experience UK. Private transfer from Edinburgh Hotel to Edinburgh Train station. Private transfer from Glasgow Train station to Glasgow Hotel. Overnight Stay in Glasgow.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "05",
  //       title: "Glasgow – Glasgow 01 Day Hop on Hop off City tour on SIC Basis",
  //       desc: "Breakfast at Hotel. Glasgow 01 Day Hop on Hop off City bus. Meeting Point: Meeting point may vary depending on the option booked. Explore one of the most vibrant Scottish cities with a 1 or 2-day ticket to Glasgow's hop-on and hop-off bus. Explore museums, art galleries, parks, theatres and even Glasgow Cathedral. In addition, the city's pubs, cafés, bars and nightclubs help make Glasgow one of the new preferred destinations for short breaks. The visitor attractions and places of interest are spread throughout the city and the best way to visit the attractions and to see the city, is to step on one of the open-top tour buses for a fully guided tour round all the main sights. Jump off at any of the stops, conveniently located for the Gothic Cathedral, the Riverside Museum of Transport and Travel, the recently restored Kelvingrove Art Galleries, Glasgow University, Glasgow Green and Clydeside Distillery, among many other sights. Overnight Stay in Glasgow.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "06",
  //       title: "Glasgow – Glenfinnan, Fort William, and Glencoe Day Trip from Glasgow on SIC Basis",
  //       desc: "Breakfast at Hotel. Meeting point: Meet outside the Royal Scottish National Orchestra which is opposite the Buchanan bus station. Depart Glasgow in the morning and travel north to the Highlands, stopping in Tyndrum before continuing to the dramatic landscapes of Glencoe. Enjoy its iconic scenery, featured in Skyfall, and learn about the history of the Massacre of Glencoe. Continue through stunning Highland scenery to Fort William with views of Ben Nevis, Britain's tallest mountain. Then travel east to the highlight of the day: the Glenfinnan Viaduct, famous from the Harry Potter films. In summer, you may even see the Jacobite Steam Train crossing the bridge. Spend time at the Glenfinnan Monument on the shores of Loch Shiel, an important site of the 1745 Jacobite Uprising, and enjoy views of the viaduct, the loch, and Harry Potter filming locations. Begin the return journey via Neptune's Staircase on the Caledonian Canal, then continue south along the scenic banks of Loch Lomond with a brief stop in Tarbet before arriving back in Glasgow. Overnight Stay in Glasgow.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "07",
  //       title: "Glasgow – India",
  //       desc: "Breakfast at Hotel. Private Transfer from Glasgow Hotel to Glasgow Airport for your flight back to India.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //   ],

  //   pointsToRemember: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   inclusions: {
  //     included: [
  //       "06 nights' accommodation with breakfast",
  //       "Private transfer from Edinburgh Airport to Edinburgh Hotel",
  //       "Loch Ness, Glencoe & the Scottish Highlands Tour from Edinburgh on SIC Basis",
  //       "Private transfer from Edinburgh Hotel to Edinburgh Train station",
  //       "Private transfer from Glasgow Train station to Glasgow Hotel",
  //       "Glasgow 01 Day Hop on Hop off City tour on SIC Basis",
  //       "Glenfinnan, Fort William, and Glencoe Day Trip from Glasgow on SIC Basis",
  //       "Private Transfer from Glasgow Hotel to Glasgow Airport",
  //     ],

  //     excluded: [
  //       "The tours which are on SIC/Shared basis require the client to reach the pickup point",
  //       "Return Flight Tickets",
  //       "Visa & Insurance fees",
  //       "Water Bottles",
  //       "Train ticket",
  //       "Optional tours",
  //       "Hotel City Tax (paid on the spot at the hotel)",
  //       "Lunch & Dinner",
  //       "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
  //       "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
  //     ],
  //   },

  //   supplementaryTours: {
  //     note: "Price is not applicable during fair/Events dates.",
  //     items: [
  //       {
  //         name: "2nd class train ticket from Edinburgh to Glasgow – on actual basis",
  //         price: "GBP 30 – 40 Per Person",
  //       },
  //     ],
  //   },

  //   pricing: {
  //     note: "Price is not applicable during fair/Events dates.",
  //     options: [
  //       {
  //         category: "Option 1 – 3* Hotel",
  //         hotels: [
  //           { location: "Edinburgh 3N", hotel: "Hampton by Hilton Edinburgh West End or Similar" },
  //           { location: "Glasgow 3N", hotel: "Sandyford Lodge Hotel or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov & Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 830 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 802 per person onwards on Twin/Double sharing basis / GBP 920 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 806 per person onwards on Twin/Double sharing basis / GBP 910 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 571 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 795 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July, Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 890 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 777 per person onwards on Twin/Double sharing basis / GBP 840 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 830 per person onwards on Twin/Double sharing basis / GBP 847 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 569 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 1241 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "March, Sep & Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 805 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 777 per person onwards on Twin/Double sharing basis / GBP 847 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 761 per person onwards on Twin/Double sharing basis / GBP 840 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 554 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 760 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         category: "Option 2 – 4* Hotel",
  //         hotels: [
  //           { location: "Edinburgh 3N", hotel: "The Caledonian Edinburgh, Curio Collection by Hilton or Similar" },
  //           { location: "Glasgow 3N", hotel: "Clayton Hotel Glasgow or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov & Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 1025 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 997 per person onwards on Twin/Double sharing basis / GBP 937 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 985 per person onwards on Twin/Double sharing basis / GBP 937 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 348 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 1701 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July, Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 1220 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 1200 per person onwards on Twin/Double sharing basis / GBP 1110 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 1190 per person onwards on Twin/Double sharing basis / GBP 1123 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 450 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 1671 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "March, Sep & Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "GBP 1015 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "GBP 1002 per person onwards on Twin/Double sharing basis / GBP 927 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "GBP 981 per person onwards on Twin/Double sharing basis / GBP 927 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "GBP 354 per child onwards" },
  //               { pax: "Single Room Supplement", price: "GBP 1671 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //     ],
  //   },

  //   terms: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   images: [],
  // },

  {
    title: "Explore Florence + Pisa + Rome",
    slug: "florence-pisa-rome-07n",
    price: "EUR 1015 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/rom/day-1.jpg",
    location: "Florence, Pisa, Rome",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "Florence 2N + Pisa 2N + Rome 3N, 07 Nights",
        places: "Florence, Pisa, Rome",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "Duomo, Florence",
        "Leaning Tower of Pisa",
        "Colosseum",
        "Piazza dei Miracoli",
        "Amalfi Coast",
        "Positano & Sorrento",
      ],

      experiences: [
        {
          title: "Florence Walking Tour with Expert Guide - 1.5 Hour on Shared Basis",
          desc: "An engaging and efficient walking tour of Renaissance Florence with a knowledgeable guide, lasting approximately 1.5 hours on a shared basis, covering iconic landmarks like the magnificent Duomo and Baptistery, the elegant streets of the historic center, and the charming piazzas.",
        },
        {
          title: "Leaning Tower of Pisa Entry Ticket",
          desc: "Access to the world-famous Leaning Tower of Pisa, allowing you to climb its spiral staircase to the top and enjoy panoramic views of the surrounding Piazza dei Miracoli, admiring the tower's unique tilt and rich history dating back to the 12th century.",
        },
        {
          title: "Rome Hop-On Hop-Off Bus Tour - 24 Hours",
          desc: "A convenient and flexible 24-hour hop-on hop-off bus ticket covering Rome's most famous landmarks, giving you the freedom to discover the Eternal City's treasures — from the Colosseum and Roman Forum to Piazza Navona and the Pantheon — without the hassle of navigating public transport.",
        },
        {
          title: "Colosseum Entry Ticket",
          desc: "Entry access to the world-famous Colosseum, allowing you to explore its ancient corridors, arches, and underground passages while imagining the gladiatorial spectacles that once captivated thousands, and learning about the emperors, gladiators, and citizens who shaped Rome's past.",
        },
        {
          title: "Day Trip: Positano, Amalfi Coast and Sorrento Tour on SIC Basis",
          desc: "A full-day journey along the world-famous Amalfi Coast, driving through dramatic coastal landscapes to Positano, the jewel of the coast known for its pastel-colored houses and stunning sea views, before continuing to Sorrento to stroll historic streets, sample local limoncello, and soak in the relaxed Mediterranean atmosphere.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Florence",
        desc: "Arrival in Florence: A Magical Start to Your Italian Adventure. Arriving at Florence Airport marks the beginning of an unforgettable journey through the heart of Tuscany. After landing, you'll enjoy a seamless private transfer to your hotel, ensuring a smooth and relaxing start to your stay. Your first evening in Florence will set the tone for the incredible experiences ahead. From the breathtaking piazzas to the charming cobblestone streets, Florence's Renaissance beauty and vibrant atmosphere will captivate you from the very moment you arrive. Whether you're marveling at the magnificent Duomo, strolling along the Arno River, or savoring authentic Italian cuisine, you're in for a memorable adventure in one of the world's most iconic and culturally rich cities. Overnight Stay in Florence.",
        tags: [],
      },
      {
        day: "02",
        title: "Florence - Florence Walking Tour with Expert Guide - 1.5 Hour on Shared Basis",
        desc: "Breakfast at Hotel. The Florence walking tour with an expert guide is one of the most engaging and efficient ways to explore the highlights of this Renaissance city. Lasting approximately 1.5 hours, the tour is conducted on a shared basis, allowing you to discover Florence's iconic landmarks while enjoying detailed insights from a knowledgeable guide. Florence (Italian: Firenze) is a city steeped in art, history, and culture. From the magnificent Duomo and Baptistery to the elegant streets of the historic center and the charming piazzas, Florence offers a rich tapestry of architectural marvels and cultural treasures. Overnight Stay in Florence.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Florence - Pisa",
        desc: "Breakfast at Hotel. The train journey from Florence to Pisa is one of the most convenient and efficient ways to travel between two iconic cities in Tuscany. The distance is approximately 85 km (53 miles), and trains typically take between 50 minutes to 1 hour 10 minutes to cover this route, making it a quick and comfortable connection. Pisa is a city renowned worldwide for its architectural marvels and rich history. From the iconic Leaning Tower and the beautiful Piazza dei Miracoli to its charming streets and historic churches, Pisa offers a delightful mix of culture, art, and history. Whether you're admiring medieval architecture, exploring local landmarks, or enjoying the vibrant atmosphere of the city, Pisa provides an unforgettable experience just a short train ride from Florence. Overnight Stay in Pisa.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Pisa – Leaning Tower of Pisa Entry Ticket",
        desc: "Breakfast at Hotel. Visiting the Leaning Tower of Pisa is one of the most iconic and memorable experiences in Tuscany. The ticket grants you access to this world-famous architectural wonder, allowing you to climb to the top and enjoy panoramic views of the surrounding Piazza dei Miracoli. The Leaning Tower (Italian: Torre Pendente di Pisa) is renowned not only for its unique tilt but also for its rich history, dating back to the 12th century. As you ascend its spiral staircase, you'll witness centuries of architectural ingenuity and admire the beauty of Pisa's historic cathedral, baptistery, and surrounding monuments. Whether you're fascinated by history, architecture, or simply looking for an unforgettable photo opportunity, visiting the Leaning Tower of Pisa offers a truly remarkable experience in one of Italy's most celebrated cities. Overnight Stay in Pisa.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Pisa – Rome",
        desc: "Breakfast at Hotel. The train journey from Pisa to Rome is one of the most convenient and efficient ways to travel between these two iconic cities in Italy. The distance is approximately 350 km (217 miles), and trains typically take between 2 hours 45 minutes to 3 hours on high-speed services, making it a comfortable and scenic connection through the heart of Tuscany and Lazio. Rome (Italian: Roma) is Italy's historic and cultural capital, renowned worldwide for its ancient monuments, vibrant piazzas, and artistic treasures. From the Colosseum and Roman Forum to the Pantheon and Vatican City, Rome offers a captivating blend of history, art, and modern Italian life. Overnight Stay in Rome.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Rome - Rome Hop On Hop Off Bus Tour - 24 Hours",
        desc: "Breakfast at Hotel. The Rome Hop-On Hop-Off Bus Tour is one of the most convenient and flexible ways to explore the Eternal City at your own pace. Covering the city's most famous landmarks, the 24-hour ticket allows you to hop on and off at multiple stops, giving you the freedom to discover Rome's treasures without the hassle of navigating public transport. Rome (Italian: Roma) is a city rich in history, culture, and art. From the grandeur of the Colosseum and the Roman Forum to the elegance of Piazza Navona and the Pantheon, every corner of the city tells a story spanning millennia. Rome - Colosseum Entry Ticket: Visiting the Colosseum is one of the most iconic and memorable experiences in Rome. The entry ticket grants access to this world-famous amphitheater, allowing you to explore its ancient corridors, arches, and underground passages while imagining the gladiatorial spectacles that once captivated thousands. The Colosseum (Italian: Colosseo) is a symbol of Rome's grandeur and rich history, dating back to the 1st century AD. Standing in its vast arena, you can appreciate the engineering brilliance of ancient Rome and learn about the fascinating stories of emperors, gladiators, and citizens who shaped the city's past. Overnight Stay in Rome.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Rome - Day Trip Positano, Amalfi Coast and Sorrento Tour on SIC Basis",
        desc: "Experience the breathtaking beauty of southern Italy on a full-day journey along the world-famous Amalfi Coast. This unforgettable tour takes you through dramatic coastal landscapes, charming seaside towns, and iconic Italian scenery. Begin your adventure with a scenic drive along the Amalfi Coast, where steep cliffs plunge into crystal-clear waters and colorful villages cling to the hillsides. Stop in Positano, the jewel of the coast, renowned for its pastel-colored houses, stylish boutiques, and stunning sea views. Enjoy free time to explore its narrow streets, relax at a café, or take photos from panoramic viewpoints. Continue along the coast to admire the timeless charm of the region before heading to Sorrento, a lively town overlooking the Bay of Naples. Here, stroll through historic streets, sample local limoncello, browse artisan shops, or simply soak in the relaxed Mediterranean atmosphere. Perfect for travelers short on time, this day trip combines natural beauty, culture, and authentic Italian charm into one memorable experience. Overnight Stay in Rome.",
        tags: [],
      },
      {
        day: "08",
        title: "Rome - India",
        desc: "Breakfast at Hotel. After breakfast proceed to Rome airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "07 Night Accommodation with Breakfast",
        "Transfer from Florence airport to hotel on private basis",
        "Florence Walking Tour with Expert Guide - 1.5 Hour on Shared Basis",
        "Transfer from Florence hotel to train station on private basis",
        "Train from Florence to Pisa",
        "Transfer from Pisa train station to hotel on private basis",
        "Leaning Tower of Pisa Entry Ticket",
        "Transfer from Pisa hotel to train station on private basis",
        "Train from Pisa to Rome",
        "Transfer from Rome train station to hotel on private basis",
        "Rome hop on hop off bus tour - 24 hours",
        "Colosseum Entry Ticket",
        "Day Trip Positano, Amalfi Coast and Sorrento Tour on SIC Basis",
        "Private Transfer from Rome Hotel to Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "Florence - Pisa – Rome 2nd Class train ticket – on actual basis",
          price: "EUR 65 - 75 Per Person",
        },
        {
          name: "Florence - Pisa – Rome – Venice – Milan 2nd class train ticket – on actual basis",
          price: "EUR 65 - 75 Per Person",
        },
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Florence 2N", hotel: "Hotel Luxor Florence or similar" },
            { location: "Pisa 2N", hotel: "Hotel Alessandro Della Spina or similar" },
            { location: "Rome 3N", hotel: "Comfort Hotel Bergen or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1015 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 928 per person onwards on Twin/Double sharing basis / EUR 809 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 881 per person onwards on Twin/Double sharing basis / EUR 761 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 315 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 566 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1121 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1024 per person onwards on Twin/Double sharing basis / EUR 920 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 974 per person onwards on Twin/Double sharing basis / EUR 877 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 419 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 644 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1026 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 938 per person onwards on Twin/Double sharing basis / EUR 848 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 886 per person onwards on Twin/Double sharing basis / EUR 803 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 412 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 561 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Florence 2N", hotel: "Cellai Boutique Hotel or similar" },
            { location: "Pisa 2N", hotel: "Bologna Hotel or similar" },
            { location: "Rome 3N", hotel: "Hotel San Giovanni Roma or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 986 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 901 per person onwards on Twin/Double sharing basis / EUR 832 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 820 per person onwards on Twin/Double sharing basis / EUR 765 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 432 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 444 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1123 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1029 per person onwards on Twin/Double sharing basis / EUR 934 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 981 per person onwards on Twin/Double sharing basis / EUR 889 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 475 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 649 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1045 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 952 per person onwards on Twin/Double sharing basis / EUR 895 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 904 per person onwards on Twin/Double sharing basis / EUR 844 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 464 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 575 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/rom/day-1.jpg",
      "/images/rom/day-2.jpg",
      "/images/rom/day-3.jpg",
      "/images/rom/day-4.jpg",
      "/images/rom/day-5.jpg",
      "/images/rom/day-6.jpg",
      "/images/rom/day-7.jpg",
      "/images/rom/day-8.jpg",
    ],
  },

  {
    title: "Experience the Essence of Italy",
    slug: "milan-venice-florence-rome-09n",
    price: "EUR 930 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "09 Nights / 10 Days",
    rating: "4.9",
    image: "/images/italy/day-1.jpg",
    location: "Milan, Venice, Florence, Rome",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3N Milan + 2N Venice + 2N Florence + 2N Rome, 09 Nights",
        places: "Milan, Venice, Florence, Rome",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "09 Nights Accommodation",
      ],

      highlights: [
        "Milan Cathedral & Duomo Terraces",
        "Lake Como, Bellagio & Lugano",
        "Venice Gondola Ride",
        "St. Mark's Square & Rialto Bridge",
        "Florence Cathedral & Ponte Vecchio",
        "Colosseum & Roman Forum",
      ],

      experiences: [
        {
          title: "Milan Hop on Hop Off Tour and Cathedral & Duomo Terraces Entrance Ticket",
          desc: "A one-day Hop on Hop Off bus tour of Milan exploring major highlights at your own pace, including Sforza Castle, Teatro alla Scala, and the fashionable districts that define the city's global reputation, plus a visit to the majestic Milan Cathedral with entry to the Duomo Terraces for breathtaking views of the skyline.",
        },
        {
          title: "Milan Discover Como, Bellagio, and Lugano",
          desc: "A full-day excursion to the scenic lake region, exploring the charming town of Como, the beauty of Lake Como, and the picturesque village of Bellagio known for its romantic landscapes, along with a visit to Lugano offering a blend of Swiss charm and Mediterranean flair.",
        },
        {
          title: "Venice Gondola Ride on Shared Basis",
          desc: "A classic Venetian Gondola Ride gliding along the city's picturesque canals, passing under ancient bridges and by elegant palaces that showcase Venice's rich heritage, offering an authentic and memorable Venetian experience.",
        },
        {
          title: "Florence 01 Day Hop on Hop Off Bus Tour",
          desc: "A one-day Hop on Hop Off bus tour discovering Florence's renowned landmarks, including the Florence Cathedral, Piazza della Signoria, Ponte Vecchio, and viewpoints offering stunning panoramas of the city, exploring the city's artistic and cultural heritage at your own pace.",
        },
        {
          title: "Rome Hop on Hop Off Tour and Colosseum Entry Ticket",
          desc: "A one-day Hop on Hop Off Bus Tour offering the perfect way to explore key Roman attractions at leisure, including the Roman Forum, Trevi Fountain, Spanish Steps, and Vatican City, plus a visit to the iconic Colosseum with entry ticket to learn about the gladiators, emperors, and historic events that shaped Roman history.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Milan",
        desc: "Arrival in Milan: Begin Your Northern Italy Journey. Welcome to Milan, Italy's fashion capital and a city where history blends seamlessly with modern elegance. Upon your arrival at Milan Airport, a private transfer will take you directly to your hotel for a smooth and comfortable start to your holiday. Milan welcomes you with its stylish neighbourhoods, grand architecture, and vibrant cultural energy. Spend your evening strolling through the beautiful streets, enjoying Italian cuisine, or simply relaxing after your journey. Overnight Stay in Milan.",
        tags: [],
      },
      {
        day: "02",
        title: "Milan – Milan Hop on Hop Off Tour and Duomo Visit",
        desc: "Breakfast at Hotel. Milan Hop on Hop Off Tour and Cathedral & Duomo Terraces Entrance Ticket. After breakfast, proceed for your one-day Hop on Hop Off bus tour of Milan, allowing you to explore major highlights at your own pace. Witness iconic landmarks such as Sforza Castle, Teatro alla Scala, and the fashionable districts that define Milan's global reputation. A major highlight of your day is your visit to the majestic Milan Cathedral. With your Cathedral and Duomo Terraces Entrance Ticket, explore one of the world's most stunning Gothic masterpieces and climb to the terraces for breathtaking views of the city's skyline. Overnight Stay in Milan.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Milan – Como, Bellagio and Lugano Excursion",
        desc: "Breakfast at Hotel. Milan Discover Como, Bellagio, and Lugano. After breakfast, proceed for a full-day excursion to the scenic lake region. Explore the charming town of Como, enjoy the beauty of Lake Como, and continue to the picturesque village of Bellagio, known for its romantic landscapes. The tour also includes a visit to Lugano, offering a blend of Swiss charm and Mediterranean flair. Return to Milan in the evening with wonderful memories of Northern Italy's most beautiful destinations. Overnight Stay in Milan.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Milan – Venice",
        desc: "Breakfast at Hotel. After breakfast, a private transfer will take you from your Milan hotel to Milan Train Station for your onward journey to Venice. Upon arrival, make your way to your hotel in the charming city of canals, bridges, and timeless romance. Venice welcomes you with its serene waterways, historic architecture, and captivating ambience. Enjoy your evening walking through its narrow alleys or relaxing near the Grand Canal. Overnight Stay in Venice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Venice – Gondola Ride",
        desc: "Breakfast at Hotel. Gondola Ride on Shared Basis. After breakfast, proceed for your classic Venetian Gondola Ride on shared basis. Glide along the city's picturesque canals, passing under ancient bridges and by elegant palaces that showcase Venice's rich heritage. This peaceful ride offers an authentic and memorable Venetian experience. Enjoy the rest of your day exploring St. Mark's Square, Rialto Bridge, and other iconic locations of this magical floating city. Overnight Stay in Venice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Venice – Florence",
        desc: "Breakfast at Hotel. After breakfast, proceed on your own to Venice Train Station to board your train to Florence, the cradle of the Renaissance. Upon arrival, make your way to your hotel. Florence greets you with world-famous art, historic squares, and architectural masterpieces. Spend your evening strolling through the old town or enjoying authentic Tuscan cuisine. Overnight Stay in Florence.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Florence – Florence Hop on Hop Off Tour",
        desc: "Breakfast at Hotel. Florence 01 Day Hop on Hop Off Bus Tour. After breakfast, enjoy your one-day Hop on Hop Off bus tour of Florence. Discover the city's renowned landmarks, including the Florence Cathedral, Piazza della Signoria, Ponte Vecchio, and viewpoints offering stunning panoramas of the city. The tour allows you to explore Florence's artistic and cultural heritage at your own pace. Overnight Stay in Florence.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Florence – Rome",
        desc: "Breakfast at Hotel. After breakfast, proceed on your own to Florence Train Station to board your train to Rome, the Eternal City. Upon arrival in Rome, make your way to your hotel. Rome's rich history, lively streets, and iconic monuments create an unforgettable atmosphere. Enjoy your evening at leisure exploring nearby piazzas or cafés. Overnight Stay in Rome.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Rome – Rome Hop on Hop Off Tour and Colosseum Visit",
        desc: "Breakfast at Hotel. Rome Hop on Hop Off Tour and Colosseum Entry Ticket. After breakfast, enjoy your Rome one-day Hop on Hop Off Bus Tour, offering the perfect way to explore key Roman attractions at your leisure. Visit sites such as the Roman Forum, Trevi Fountain, Spanish Steps, and Vatican City. A signature highlight of the day is your visit to the iconic Colosseum. With your entry ticket, explore this ancient amphitheatre, learning about the gladiators, emperors, and historic events that shaped Roman history. Overnight Stay in Rome.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "10",
        title: "Rome – India",
        desc: "Breakfast at Hotel. After breakfast, proceed to Rome Airport with a comfortable private transfer, marking the end of your beautiful Italian holiday.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "03 Nights' accommodation in Milan with breakfast",
        "02 Nights' accommodation in Venice with breakfast",
        "02 Nights Florence – Wyndham Garden Florence or Similar",
        "02 Nights' accommodation in Rome with breakfast",
        "Private transfer from Milan Airport to Milan Hotel",
        "Milan 01-day Hop on Hop Off Bus Tour",
        "Cathedral and Duomo's Terraces Entrance Ticket",
        "Milan Discover Como, Bellagio, and Lugano",
        "Gondola Ride on Shared Basis",
        "Florence 01 Day Hop on Hop off Bus Tour",
        "Rome 01-day Hop on Hop Off Bus Tour",
        "Colosseum Entry Ticket",
        "Private transfer from Rome Hotel to Rome Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "Rome - Venice - Florence - Venice 2nd class train ticket – on actual basis",
          price: "EUR 125-130 Per Person",
        },
        {
          name: "Milan – Venice – Florence – Rome 2nd class train ticket – on actual basis",
          price: "EUR 125 - 130 Per Person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Milan 3N", hotel: "Hotel Stradivari or Similar" },
            { location: "Venice 2N", hotel: "Hotel Carlton Capri or Similar" },
            { location: "Florence 2N", hotel: "Wyndham Garden Florence or Similar" },
            { location: "Rome 2N", hotel: "Antica Dimora Contessa Arrivabene or Similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 930 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 885 per person onwards on Twin/Double sharing basis / EUR 835 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 843 per person onwards on Twin/Double sharing basis / EUR 793 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 617 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 367 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1402 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1357 per person onwards on Twin/Double sharing basis / EUR 1188 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1319 per person onwards on Twin/Double sharing basis / EUR 1145 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 637 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 387 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1336 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1288 per person onwards on Twin/Double sharing basis / EUR 1175 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1254 per person onwards on Twin/Double sharing basis / EUR 1132 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 620 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 370 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Milan 3N", hotel: "Leonardo Hotel Milan City Center or Similar" },
            { location: "Venice 2N", hotel: "Hotel Principe or Similar" },
            { location: "Florence 2N", hotel: "Wyndham Garden Florence or Similar" },
            { location: "Rome 2N", hotel: "Best Western Hotel Piccadilly or Similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1213 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1168 per person onwards on Twin/Double sharing basis / EUR 935 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1126 per person onwards on Twin/Double sharing basis / EUR 893 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 640 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 370 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1542 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1497 per person onwards on Twin/Double sharing basis / EUR 1143 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1459 per person onwards on Twin/Double sharing basis / EUR 1100 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 660 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 390 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1485 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1437 per person onwards on Twin/Double sharing basis / EUR 1167 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1403 per person onwards on Twin/Double sharing basis / EUR 1124 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 590 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 330 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/italy/day-1.jpg",
      "/images/italy/day-2.jpg",
      "/images/italy/day-3.jpg",
      "/images/italy/day-4.jpg",
      "/images/italy/day-5.jpg",
      "/images/italy/day-6.jpg",
      "/images/italy/day-7.jpg",
      "/images/italy/day-8.jpg",
      "/images/italy/day-9.jpg",
      "/images/italy/day-10.jpg",
      "/images/italy/extra1.jpg",
      "/images/italy/extra2.jpg",
      "/images/italy/extra3.jpg",
      "/images/italy/extra4.jpg",
      "/images/italy/extra5.jpg",
      "/images/italy/extra6.jpg",
      "/images/italy/extra7.jpg",
    ],
  },

  {
    title: "Best of Finland & Sweden",
    slug: "helsinki-stockholm-04n",
    price: "EUR 640 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Mar/Sep/Oct 2026)
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/finland/day-1.jpg",
    location: "Helsinki, Stockholm",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2N Helsinki + 2N Stockholm, 04 Nights",
        places: "Helsinki, Stockholm",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "04 Nights Accommodation",
      ],

      highlights: [
        "Senate Square",
        "Rock Church",
        "Sibelius Monument",
        "Helsinki Archipelago",
        "Gamla Stan (Old Town)",
        "Vasa Museum",
      ],

      experiences: [
        {
          title: "Helsinki Hop on Hop Off Tour",
          desc: "Explore Helsinki using a 1-Day Hop on Hop Off Bus Pass, visiting top attractions such as Senate Square, Rock Church, Sibelius Monument, Market Square, and the picturesque harbor area at your own pace, plus a Helsinki Archipelago Sightseeing Boat Tour on a shared basis.",
        },
        {
          title: "Stockholm Old Town Walking Tour",
          desc: "A shared Old Town (Gamla Stan) Walking Tour exploring the city's medieval cobblestone lanes, colorful buildings, royal squares, narrow alleys, and historic landmarks, learning about Sweden's history, Viking heritage, and royal stories, plus a Vasa Museum Guided Tour with entry ticket included.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Helsinki",
        desc: "Welcome to Helsinki – The Nordic Pearl! Arrive at Helsinki Airport and enjoy a smooth private transfer to your hotel. After check-in, spend the rest of the day relaxing or strolling around the charming Nordic capital known for its architecture, seaside beauty, and vibrant culture. Overnight Stay in Helsinki.",
        tags: [],
      },
      {
        day: "02",
        title: "Helsinki Hop on Hop Off Tour",
        desc: "Breakfast at Hotel. Today, explore Helsinki using your 1-Day Hop on Hop Off Bus Pass. Visit top attractions such as Senate Square, Rock Church, Sibelius Monument, Market Square, and the picturesque harbor area at your own pace. The evening is free to enjoy shopping, a local café, or a leisurely walk by the waterfront. Overnight Stay in Helsinki.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Helsinki → Stockholm",
        desc: "Breakfast at Hotel. After breakfast, proceed for a private transfer from your Helsinki hotel to the airport for your flight to Stockholm. Arrive in Stockholm and enjoy a comfortable private airport-to-hotel transfer. Later, explore Stockholm's stunning waterfronts, royal buildings, and cozy streets at your leisure. Overnight Stay in Stockholm.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Stockholm Old Town Walking Tour",
        desc: "Breakfast at Hotel. Today, join a shared Old Town (Gamla Stan) Walking Tour, exploring the city's medieval cobblestone lanes, colorful buildings, royal squares, narrow alleys, and historic landmarks. Learn about Sweden's history, Viking heritage, and royal stories. Rest of the day is free to explore Stockholm on your own—visit museums, waterfront cafés, or take a relaxing stroll. Overnight Stay in Stockholm.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Stockholm → India",
        desc: "Breakfast at Hotel. After breakfast, proceed for a private transfer to Stockholm Airport for your flight to India. Reach India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "04 Nights Accommodation with Breakfast",
        "Private transfer from Helsinki Airport to Hotel",
        "Helsinki Hop-on Hop-off Bus tour 01 day pass on sic basis",
        "Helsinki Archipelago Sightseeing Boat Tour on shared basis",
        "Private transfer from Helsinki Hotel to Airport",
        "Private transfer from Stockholm Airport to Stockholm hotel",
        "Stockholm Hop-on Hop-off Bus tour 01 day pass on sic basis",
        "Vasa Museum Guided Tour Entry ticket",
        "Private transfer from Stockholm Hotel to Stockholm Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Helsinki 2N", hotel: "Scandic Kaisaniemi or similar" },
            { location: "Stockholm 2N", hotel: "Ibis Styles Stockholm Odenplan or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 649 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 557 per person onwards on Twin/Double sharing basis / EUR 529 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 509 per person onwards on Twin/Double sharing basis / EUR 481 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 274 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 228 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 643 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 551 per person onwards on Twin/Double sharing basis / EUR 540 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 503 per person onwards on Twin/Double sharing basis / EUR 492 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 319 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 222 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 640 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 548 per person onwards on Twin/Double sharing basis / EUR 519 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 500 per person onwards on Twin/Double sharing basis / EUR 417 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 262 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 219 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Helsinki 2N", hotel: "Radisson Blu Plaza or similar" },
            { location: "Stockholm 2N", hotel: "Scandic Grand Central or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 742 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 650 per person onwards on Twin/Double sharing basis / EUR 614 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 602 per person onwards on Twin/Double sharing basis / EUR 566 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 328 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 306 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 760 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 668 per person onwards on Twin/Double sharing basis / EUR 625 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 620 per person onwards on Twin/Double sharing basis / EUR 577 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 325 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 324 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 732 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 640 per person onwards on Twin/Double sharing basis / EUR 606 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 592 per person onwards on Twin/Double sharing basis / EUR 558 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 154 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 376 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/finland/day-1.jpg",
      "/images/finland/day-2.jpg",
      "/images/finland/day-3.jpg",
      "/images/finland/day-4.jpg",
      "/images/finland/day-5.jpg",
      "/images/finland/extra1.jpg",
      "/images/finland/extra2.jpg",
      "/images/finland/extra3.jpg",
      "/images/finland/extra4.jpg",
    ],
  },

  {
    title: "Grand Britain Experience: England & Scotland Highlights",
    slug: "london-edinburgh-07n",
    price: "GBP 1259 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/Grand/day-1.jpg",
    location: "London, Edinburgh",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "04N London + 03N Edinburgh, 07 Nights",
        places: "London, Edinburgh",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "London Eye",
        "London River Cruise",
        "Madame Tussauds",
        "Tower Bridge",
        "Cotswolds & Oxford",
        "Edinburgh Castle",
      ],

      experiences: [
        {
          title: "London City Tour with London Eye and London River Cruise",
          desc: "A panoramic London City Tour on SIC basis covering the city's most iconic landmarks, including a ticket for the London Eye with a 30-minute ride in a fully enclosed glass capsule offering breathtaking views of the River Thames, Big Ben and St. Paul's Cathedral, plus a River Thames cruise sailing past Tower Bridge, Shakespeare's Globe, The Shard and the London Eye with commentary on the city's history.",
        },
        {
          title: "London City Tour with Madame Tussauds and Tower Bridge",
          desc: "A panoramic London City Tour including entry to Madame Tussauds Wax Museum, featuring lifelike wax figures of celebrities, historical figures and political leaders along with interactive zones like Marvel Superheroes 4D and Star Wars, plus a walk along the iconic Tower Bridge with its high-level glass walkways and views of the River Thames.",
        },
        {
          title: "Cotswolds and Oxford Guided Day Trip from London on SIC Basis",
          desc: "A full-day guided tour of the English countryside from London, admiring the fairytale houses and stone villages of the Cotswolds with stops at Burford and Bourton-On-The-Water, followed by a visit to Oxford, the world's most famous university city, with free time for lunch in the heart of the city.",
        },
        {
          title: "Edinburgh Hop on Hop off City Tour & Edinburgh Castle Entry Ticket",
          desc: "A Hop on Hop off City Tour of Edinburgh offering stunning views of Edinburgh Castle, the Royal Mile, Holyrood Palace and the city's gothic architecture, with an Edinburgh Castle Entry Ticket to discover Scotland's most iconic fortress, home to centuries of history, the Crown Jewels, and panoramic views of the city.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Welcome to London – World's most vibrant and historic capitals. Welcome to London! After you land, your private driver will be waiting for you at the arrivals hall. He will take you directly to your hotel for a smooth and comfortable start to your trip. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "02",
        title: "London – City Tour with London Eye and London River Cruise",
        desc: "Breakfast at the hotel. After breakfast, proceed for your London City Tour on SIC basis. Your panoramic city tour covers some of London's most iconic landmarks, giving you a perfect introduction to the city's rich history, culture, and modern attractions. The London Eye Experience: Your tour includes a ticket for the London Eye, one of the world's tallest observation wheels. Enjoy a 30-minute ride in a fully enclosed glass capsule. Get breathtaking panoramic views of the River Thames, Big Ben, St. Paul's Cathedral, and the entire London skyline. A perfect opportunity for unforgettable photos of London from above. London River Cruise: Experience London from a unique perspective as you cruise along the River Thames. Sail past major landmarks including Tower Bridge, Shakespeare's Globe, The Shard, St. Paul's Cathedral, and the London Eye. Enjoy commentary that highlights the history and stories behind London's most famous sites. A relaxing and scenic journey through the heart of the city. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – City Tour with Madame Tussauds and Tower Bridge",
        desc: "Breakfast at the hotel. After breakfast, proceed for your London City Tour on SIC basis. Your panoramic city tour covers some of London's most iconic landmarks, giving you a perfect introduction to the city's rich history, culture, and modern attractions. Madame Tussauds London: Your tour includes entry to Madame Tussauds Wax Museum, a must-visit London attraction. Meet lifelike wax figures of your favorite celebrities, historical figures, sports stars, and political leaders. Enjoy interactive zones like Marvel Superheroes 4D, Star Wars experience, and music icons. Take memorable photos with your favorite personalities in themed settings. Tower Bridge: Walk along the iconic Tower Bridge, explore its high-level glass walkways, and enjoy views of the River Thames and the city skyline. Learn about the bridge's fascinating engineering and history. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Cotswolds and Oxford Guided Day Trip from London on SIC Basis",
        desc: "Breakfast at the hotel. Today, Cotswolds and Oxford Guided Day Trip from London on SIC Basis. Embark on a full-day guided tour of the English countryside from London. Admire the fairytale houses of the Cotswolds, the historic Oxford University, and the beauty of the English Countryside. Depart London on a full-day tour that takes you west to experience the beauty of the Cotswolds countryside, and the university city of Oxford. Drive through the Cotswolds, as you enjoy views of the lovely landscape and stone villages. A designated area of outstanding natural beauty, this is the English countryside at its finest. We will stop at Burford and Bourton-On-The-Water, the two most loved villages of the Cotswolds. Continue to Oxford to explore the most famous university city in the world. Free-time for lunch in the heart of the city. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "London – Edinburgh",
        desc: "Breakfast at the hotel. After breakfast, transfer from your London hotel to London Train Station by private vehicle. Board your train from London to Edinburgh and enjoy a scenic journey through British countryside landscapes. Upon arrival at Edinburgh Train Station, meet your private driver who will transfer you to your hotel. Edinburgh, the Scottish capital, is known for its historic charm, medieval architecture, and vibrant culture. Overnight Stay in Edinburgh.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Edinburgh - 01 Day Edinburgh Hop on Hop off City Tour & Edinburgh Castle Entry Ticket",
        desc: "Breakfast at the hotel. Today, explore Edinburgh with your Hop on Hop off City Tour. Enjoy stunning views of Edinburgh Castle, the Royal Mile, Holyrood Palace, and the city's gothic architecture. Edinburgh Castle: Your tour includes an Edinburgh Castle Entry Ticket. Discover Scotland's most iconic fortress, home to centuries of history, the Crown Jewels, and panoramic views of the city. Overnight Stay in Edinburgh.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Edinburgh",
        desc: "Breakfast at the hotel. Day at Leisure. Overnight Stay in Edinburgh.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Edinburgh – India",
        desc: "Breakfast at the hotel. After breakfast, private transfer from Edinburgh Hotel to Edinburgh Airport for your onward flight. Depart with wonderful memories of your UK trip.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "07 Nights Accommodation with Breakfast",
        "Private transfer from London Airport (LHR) to London Hotel",
        "02 Days London Hop on Hop off City Tour",
        "London Eye Standard Entry Ticket",
        "London River Cruise Ticket",
        "Madame Tussauds Standard Entry Ticket",
        "London Tower Bridge Entry Ticket",
        "Cotswolds and Oxford Guided Day Trip from London on SIC Basis",
        "Private transfer from London Hotel to London Train Station",
        "Private transfer from Edinburgh Train Station to Edinburgh Hotel",
        "01 Day Edinburgh Hop on Hop off City Tour",
        "Edinburgh Castle Entry Ticket",
        "Day at Leisure",
        "Private transfer from Edinburgh Hotel to Edinburgh Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "London – Edinburgh 2nd class train ticket – on actual basis",
          price: "GBP 85 – 95 Per Adult",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "London 4N", hotel: "Hampton by Hilton London Waterloo or Similar" },
            { location: "Edinburgh 3N", hotel: "Holiday Inn Express Edinburgh City Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1259 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1199 per person onwards on Twin/Double sharing basis / GBP 1129 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1168 per person onwards on Twin/Double sharing basis / GBP 1096 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 775 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 792 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1260 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1199 per person onwards on Twin/Double sharing basis / GBP 1025 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1168 per person onwards on Twin/Double sharing basis / GBP 993 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 473 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 787 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1323 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1262 per person onwards on Twin/Double sharing basis / GBP 1067 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1231 per person onwards on Twin/Double sharing basis / GBP 1035 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 473 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 850 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "London 4N", hotel: "The Clermont Charing Cross or Similar" },
            { location: "Edinburgh 3N", hotel: "Hilton Edinburgh Carlton or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1260 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1199 per person onwards on Twin/Double sharing basis / GBP 1025 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1168 per person onwards on Twin/Double sharing basis / GBP 993 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 473 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 787 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1840 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1781 per person onwards on Twin/Double sharing basis / GBP 1457 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1750 per person onwards on Twin/Double sharing basis / GBP 1425 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 608 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1351 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1887 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1828 per person onwards on Twin/Double sharing basis / GBP 1581 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1797 per person onwards on Twin/Double sharing basis / GBP 1549 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 888 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1398 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Grand/day-1.jpg",
      "/images/Grand/day-2.jpg",
      "/images/Grand/day-3.jpg",
      "/images/Grand/day-4.jpg",
      "/images/Grand/day-5.jpg",
      "/images/Grand/day-6.jpg",
      "/images/Grand/day-7.jpg",
      "/images/Grand/extra1.jpg",
      "/images/Grand/extra2.jpg",
      "/images/Grand/extra3.jpg",
      "/images/Grand/extra4.jpg",
      "/images/Grand/extra5.jpg",
      "/images/Grand/extra6.jpg",
      "/images/Grand/extra7.jpg",
      "/images/Grand/extra8.jpg",
    ],
  },

  {
    title: "Classic UK Explorer",
    slug: "london-manchester-06n",
    price: "GBP 954 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Mar/Sep/Oct 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/classic/day-1.jpg",
    location: "London, Manchester",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4N London + 2N Manchester, 06 Nights",
        places: "London, Manchester",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "London Eye",
        "Madame Tussauds",
        "Tower of London",
        "Tower Bridge",
        "Cotswolds & Oxford",
        "Manchester City Stadium",
      ],

      experiences: [
        {
          title: "London Hop On Hop Off Tour (Day 1) with London Eye & Madame Tussauds",
          desc: "Day 1 of the London Hop On Hop Off Tour, allowing you to explore key attractions at your own pace, with entrance to the London Eye for breathtaking panoramic views over the River Thames and London's skyline, and Madame Tussauds for immersive encounters with lifelike figures of celebrities, world leaders, and historical icons.",
        },
        {
          title: "London Hop On Hop Off Tour (Day 2) with Tower of London & Tower Bridge",
          desc: "Day 2 of the London Hop On Hop Off Tour covering more historic and modern highlights of the city, with entrance to the Tower of London, a UNESCO World Heritage Site with over 1,000 years of history and the dazzling Crown Jewels, and Tower Bridge with its high-level glass walkways and Victorian Engine Rooms.",
        },
        {
          title: "Cotswolds and Oxford Guided Day Trip from London on SIC Basis",
          desc: "A full-day guided tour of the English countryside, admiring the fairytale houses and stone villages of the Cotswolds with stops at Burford and Bourton-On-The-Water, then continuing to Oxford to explore the world's most famous university city, with free time for lunch and a look at Oxford's connections to Alice in Wonderland and Harry Potter.",
        },
        {
          title: "Manchester City Stadium Tour on Shared Basis",
          desc: "An exclusive behind-the-scenes experience at the Manchester City Stadium, walking out of the glass players' tunnel, sitting in the dugout seats, posing for a photo with a virtual Pep Guardiola in the press conference room, and getting an exclusive look at the home team dressing room before walking down the tunnel to the sound of the Etihad Stadium crowd.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrival in London: Begin Your Classic UK Journey. Welcome to London, one of the world's most historic and vibrant capitals. Upon arrival at London Heathrow Airport, you will be met for a smooth private transfer to your hotel. As you settle in, the charm of London unfolds around you—from its iconic monuments to its charming streets and modern atmosphere. Whether you're exploring the local area or simply relaxing after your journey, your first evening sets the stage for an exciting adventure. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "02",
        title: "London – Hop On Hop Off (Day 1), London Eye & Madame Tussauds",
        desc: "Breakfast at Hotel. After breakfast, proceed for Day 1 of your London Hop On Hop Off Tour, allowing you to explore key attractions at your own pace. Today includes entrance to two of London's most popular experiences: London Eye - This iconic giant observation wheel offers breathtaking panoramic views over the River Thames and London's skyline. From the top, you can admire famous sights such as Big Ben, the Houses of Parliament, and St. Paul's Cathedral, making it one of the must-do attractions in the city. Madame Tussauds - At this world-famous wax museum, encounter incredibly lifelike figures of celebrities, world leaders, superheroes, and historical icons. Madame Tussauds offers immersive zones and interactive displays—perfect for fun photos and unforgettable memories. Spend the rest of the day exploring London through various Hop On Hop Off routes. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – Hop On Hop Off (Day 2), Tower of London & Tower Bridge",
        desc: "Breakfast at Hotel. Continue your sightseeing journey with Day 2 of your London Hop On Hop Off Tour, covering more historic and modern highlights of the city. Today includes entrance to two legendary attractions: Tower of London - A UNESCO World Heritage Site, the Tower of London is one of Britain's most important historic landmarks. Discover over 1,000 years of history as you explore the ancient fortress, hear stories of kings, queens, prisoners, and executions, and witness the dazzling Crown Jewels—the nation's greatest treasures. Tower Bridge - An iconic symbol of London, Tower Bridge combines architectural beauty with fascinating engineering. Walk through the high-level glass walkways for spectacular views of the River Thames and explore the Victorian Engine Rooms to learn about the mechanisms that once powered the bridge. Enjoy the remainder of your day exploring London at leisure. Overnight Stay in London.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Cotswolds and Oxford Guided Day-Trip from London on SIC Basis",
        desc: "Embark on a full-day guided tour of the English countryside from London. Admire the fairytale houses of the Cotswolds, the historic Oxford University, and the beauty of the English Countryside. Depart London on a full-day tour that takes you west to experience the beauty of the Cotswolds countryside, and the university city of Oxford. Drive through the Cotswolds, as you enjoy views of the lovely landscape and stone villages. A designated area of outstanding natural beauty, this is the English countryside at its finest. We will stop at Burford and Bourton-On-The-Water, the two most loved villages of the Cotswolds. Continue to Oxford to explore the most famous university city in the world. Free-time for lunch in the heart of the city. Learn about Oxford's connection with Alice in Wonderland and Harry Potter. Overnight Stay in London.",
        tags: [],
      },
      {
        day: "05",
        title: "London – Manchester",
        desc: "Breakfast at Hotel. After breakfast, proceed for your private transfer from your London hotel to the train station. Upon arrival in Manchester, enjoy another private transfer to your hotel. Manchester is known for its rich industrial heritage, iconic music culture, and world-famous football legacy. Overnight Stay in Manchester.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Manchester – Manchester City Stadium Tour",
        desc: "Breakfast at Hotel. Immerse yourself in the city story on the Manchester City Stadium Tour. Gain exclusive access to the stadium for a behind-the-scenes experience and strike a pose with a virtual Pep Guardiola. Delve into the City Story as you walk out of the glass players' tunnel, sit in the seats in the dugouts, and soak up the views of the stadium from pitch side. Pose for a photo and field questions with a virtual Pep Guardiola in the press conference room. Get an exclusive look at the home team dressing room, where you can take a selfie with your favourite player's shirt and walk down the tunnel to the sound of the Etihad Stadium crowd. Overnight Stay in Manchester.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Manchester – India",
        desc: "Breakfast at Hotel. After breakfast, enjoy a private transfer from your hotel to the Manchester Airport for your return journey to India, carrying memorable experiences from your United Kingdom adventure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "6 Nights' Accommodation with Breakfast",
        "Private transfer from London Heathrow Airport to London hotel",
        "London Hop on Hop Off Bus Tour – 2 Days",
        "London Eye Entrance Ticket",
        "Madame Tussauds Entrance Ticket",
        "Tower of London Entrance Ticket",
        "Tower Bridge Entrance Ticket",
        "Cotswolds and Oxford Guided Day-Trip from London on SIC basis",
        "Private transfer from London hotel to London train station",
        "Private transfer from Manchester train station to Manchester hotel",
        "Manchester City Stadium Tour on Shared Basis",
        "Private transfer from Manchester hotel to Manchester Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "London – Manchester 2nd class train ticket – on actual basis",
          price: "GBP 49 - 100 Per Person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "London 4N", hotel: "City London Hotel or similar" },
            { location: "Manchester 2N", hotel: "Holiday Inn Express Manchester City Centre – Arena or similar" },
          ],
          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1029 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 941 per person onwards on Twin/Double sharing basis / GBP 796 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 906 per person onwards on Twin/Double sharing basis / GBP 761 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 353 per child" },
                { pax: "Single Room Supplement", price: "GBP 519" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 954 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 871 per person onwards on Twin/Double sharing basis / GBP 756 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 836 per person onwards on Twin/Double sharing basis / GBP 721 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 374 per child" },
                { pax: "Single Room Supplement", price: "GBP 449" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026/2027",
              rows: [
                { pax: "02 Pax", price: "GBP 1004 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 921 per person onwards on Twin/Double sharing basis / GBP 877 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 886 per person onwards on Twin/Double sharing basis / GBP 837 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 507 per child" },
                { pax: "Single Room Supplement", price: "GBP 659" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "London 4N", hotel: "DoubleTree by Hilton London - West End or similar" },
            { location: "Manchester 2N", hotel: "Holiday Inn Express Manchester City Centre – Arena or similar" },
          ],
          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1201 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1108 per person onwards on Twin/Double sharing basis / GBP 1031 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1075 per person onwards on Twin/Double sharing basis / GBP 996 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 719 per child" },
                { pax: "Single Room Supplement", price: "GBP 681" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "GBP 1163 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1074 per person onwards on Twin/Double sharing basis / GBP 1002 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 1039 per person onwards on Twin/Double sharing basis / GBP 964 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 706 per child" },
                { pax: "Single Room Supplement", price: "GBP 647" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026/2027",
              rows: [
                { pax: "02 Pax", price: "GBP 1069 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "GBP 1016 per person onwards on Twin/Double sharing basis / GBP 959 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "GBP 991 per person onwards on Twin/Double sharing basis / GBP 921 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 782 per child" },
                { pax: "Single Room Supplement", price: "GBP 565" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/classic/day-1.jpg",
      "/images/classic/day-2.jpg",
      "/images/classic/day-3.jpg",
      "/images/classic/day-4.jpg",
      "/images/classic/day-5.jpg",
      "/images/classic/day-6.jpg",
      "/images/classic/day-7.jpg",
      "/images/classic/extra1.jpg",
      "/images/classic/extra2.jpg",
      "/images/classic/extra3.jpg",
      "/images/classic/extra4.jpg",
    ],
  },

  {
    title: "Munich + Innsbruck + Salzburg + Vienna",
    slug: "munich-innsbruck-salzburg-vienna-08n",
    price: "EUR 1078 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026-2027)
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/Inns/day-1.jpg",
    location: "Munich, Innsbruck, Salzburg, Vienna",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4 Cities, 08 Nights",
        places: "Munich, Innsbruck, Salzburg, Vienna",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Neuschwanstein & Linderhof Castle",
        "Swarovski Crystal Worlds",
        "Sound of Music Filming Locations",
        "Schönbrunn Palace & Gardens",
        "Golden Roof, Innsbruck",
        "Mirabell Gardens",
      ],

      experiences: [
        {
          title: "Neuschwanstein & Linderhof Castle Full-Day Trip",
          desc: "A full-day trip to visit two of King Ludwig II's most iconic castles — the fairy-tale Neuschwanstein and the beautiful Linderhof Palace — with guided insights into Bavarian royal history, stunning Alpine scenery, and picturesque villages along the way.",
        },
        {
          title: "Swarovski Crystal Worlds Entrance Ticket",
          desc: "A visit to Swarovski Crystal Worlds to discover the Chambers of Wonder, immersive crystal art installations, and the magical outdoor garden, experiencing the Crystal Cloud, Mirror Pool, and unique exhibits that make it one of Austria's most iconic attractions.",
        },
        {
          title: "Half Day Original Sound of Music Tour on Shared Basis",
          desc: "A half-day tour visiting famous filming locations from the movie, including Mirabell Gardens, Leopoldskron Palace, Lake District views, and the iconic gazebo, with behind-the-scenes stories of the Von Trapp family and the musical legacy of Salzburg.",
        },
        {
          title: "Schönbrunn Palace & Gardens Skip-the-Line Tour on Shared Basis",
          desc: "A skip-the-line tour of the magnificent imperial palace, walking through opulent rooms once used by the Habsburgs and enjoying the beautifully landscaped Baroque gardens.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Munich",
        desc: "Welcome to Germany – Welcome to Munich! Upon arrival at Munich Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening exploring the vibrant streets around Marienplatz, Viktualienmarkt, or Munich's traditional Bavarian cafés. Overnight Stay in Munich.",
        tags: [],
      },
      {
        day: "02",
        title: "Munich",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Neuschwanstein & Linderhof Castle Full-Day Trip (included). Visit two of King Ludwig II's most iconic castles — the fairy-tale Neuschwanstein and the beautiful Linderhof Palace. Enjoy guided insights into Bavarian royal history, stunning Alpine scenery, and picturesque villages along the way. Return to Munich and spend the evening at leisure — explore Munich Old Town, the English Garden, or enjoy Bavarian cuisine. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Munich – Innsbruck",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Munich Hotel to Train Station. Board your train from Munich to Innsbruck. Upon arrival at Innsbruck Station, enjoy a private transfer to your hotel. Check in and explore the medieval Old Town, the Golden Roof, or the scenic river promenade. Overnight Stay in Innsbruck.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Innsbruck – Swarovski Crystal Worlds Entrance Ticket",
        desc: "Breakfast at Hotel. After breakfast, visit Swarovski Crystal Worlds (entrance ticket included). Discover the Chambers of Wonder, immersive crystal art installations, and the magical outdoor garden designed to delight visitors of all ages. Experience the Crystal Cloud, Mirror Pool, and unique exhibits that make this one of Austria's most iconic attractions. Return to Innsbruck and enjoy the rest of the day at leisure — explore Nordkette viewpoints, local cafés, or Maria-Theresien-Strasse. Overnight Stay in Innsbruck.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Innsbruck - Salzburg",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Innsbruck Hotel to Station. Board your train from Innsbruck to Salzburg. Upon arrival at Salzburg Station, enjoy a private transfer to your hotel. Check in and relax, or spend the evening exploring Salzburg's Old Town, Mirabell Gardens, or the vibrant riverfront. Overnight Stay in Salzburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Salzburg – Half Day Original Sound of Music Tour on Shared Basis",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Half Day Original Sound of Music Tour (shared basis, included). Visit famous filming locations from the movie, including Mirabell Gardens, Leopoldskron Palace, Lake District views, and the iconic gazebo. Learn behind-the-scenes stories of the Von Trapp family and the musical legacy of Salzburg. Afternoon and evening at leisure — explore the Hohensalzburg Fortress, Getreidegasse lanes, or enjoy riverside cafés. Overnight Stay in Salzburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Salzburg - Vienna",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Salzburg Hotel to Station. Board your train from Salzburg to Vienna. Upon arrival at Vienna Station, enjoy a private transfer to your hotel. Check in and explore Vienna's historic streets, elegant squares, and famous coffee houses. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Vienna",
        desc: "Breakfast at Hotel. After breakfast, proceed for the Schönbrunn Palace & Gardens Skip-the-Line Tour (shared basis, included). Explore the magnificent imperial palace, walk through opulent rooms once used by the Habsburgs, and enjoy the beautifully landscaped Baroque gardens. Spend the rest of your day at leisure — visit the Hofburg Palace area, Belvedere Palace, or explore Vienna's shopping districts. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Vienna - India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Vienna Hotel to Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Nights Accommodation with Breakfast",
        "Private transfer from Munich Airport to Munich Hotel",
        "Neuschwanstein & Linderhof Castle Full-Day Trip",
        "Private Transfer from Munich Hotel to Train Station",
        "Private Transfer from Innsbruck Station to Hotel",
        "Swarovski Crystal Worlds Entrance Ticket",
        "Private Transfer from Innsbruck Hotel to Station",
        "Private Transfer from Salzburg Station to Hotel",
        "Half Day Original Sound of Music Tour on Shared Basis",
        "Private Transfer from Salzburg Hotel to Station",
        "Private Transfer from Vienna Station to Hotel",
        "Schönbrunn Palace & Gardens Skip-the-Line Tour on Shared Basis",
        "Private Transfer from Vienna Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "2nd class train ticket from Munich to Innsbruck & Innsbruck to Salzburg & Salzburg to Vienna – on actual basis",
          price: "EUR 125 – 130 Per Person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Munich 2N", hotel: "Munich Inn or similar" },
            { location: "Innsbruck 2N", hotel: "Hilton Garden Inn Innsbruck Tivoli Hotel or similar" },
            { location: "Salzburg 2N", hotel: "Leonardo Hotel Salzburg City Center -Nord or similar" },
            { location: "Vienna 2N", hotel: "Garner Hotel Vienna or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 1078 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 972 per person onwards on Twin/Double sharing basis / EUR 953 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 923 per person onwards on Twin/Double sharing basis / EUR 904 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 701 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 437 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1284 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1178 per person onwards on Twin/Double sharing basis / EUR 1253 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1132 per person onwards on Twin/Double sharing basis / EUR 1203 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1064 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 920 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1166 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1053 per person onwards on Twin/Double sharing basis / EUR 1031 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1016 per person onwards on Twin/Double sharing basis / EUR 981 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 737 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 473 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Munich 2N", hotel: "Mercure Hotel Muenchen City Center or similar" },
            { location: "Innsbruck 2N", hotel: "ADLERS Lifestyle Hotel or similar" },
            { location: "Salzburg 2N", hotel: "Holiday Inn Salzburg City or similar" },
            { location: "Vienna 2N", hotel: "Leonardo Hotel Vienna or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 1215 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1109 per person onwards on Twin/Double sharing basis / EUR 1126 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1060 per person onwards on Twin/Double sharing basis / EUR 1077 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 946 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 682 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1319 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1213 per person onwards on Twin/Double sharing basis / EUR 1151 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1167 per person onwards on Twin/Double sharing basis / EUR 1101 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 808 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 544 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1201 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1092 per person onwards on Twin/Double sharing basis / EUR 1160 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1051 per person onwards on Twin/Double sharing basis / EUR 1110 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1050 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 790 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Inns/day-1.jpg",
      "/images/Inns/day-2.jpg",
      "/images/Inns/day-3.jpg",
      "/images/Inns/day-4.jpg",
      "/images/Inns/day-5.jpg",
      "/images/Inns/day-6.jpg",
      "/images/Inns/day-7.jpg",
      "/images/Inns/day-8.jpg",
      "/images/Inns/day-9.jpg",
      "/images/Inns/extra1.jpg",
      "/images/Inns/extra2.jpg",
      "/images/Inns/extra3.jpg",
      "/images/Inns/extra4.jpg",
      "/images/Inns/extra5.jpg",
      "/images/Inns/extra6.jpg",
    ],
  },

  {
    title: "Munich + Stuttgart + Frankfurt",
    slug: "munich-stuttgart-frankfurt-06n",
    price: "EUR 812 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026-2027)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Satu/day-1.jpg",
    location: "Munich, Stuttgart, Frankfurt",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Cities, 06 Nights",
        places: "Munich, Stuttgart, Frankfurt",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Neuschwanstein Castle",
        "Linderhof Palace",
        "Mercedes-Benz Museum",
        "Schlossplatz, Stuttgart",
        "River Main Cruise",
        "Römerberg Square, Frankfurt",
      ],

      experiences: [
        {
          title: "Neuschwanstein & Linderhof Castle Full-Day Trip",
          desc: "A full-day trip to visit two of Bavaria's most iconic royal castles, surrounded by dramatic Alpine landscapes, exploring the fairy-tale Neuschwanstein Castle and the elegant Linderhof Palace while learning about King Ludwig II's fascinating history.",
        },
        {
          title: "Stuttgart 24-Hour Hop-On Hop-Off Sightseeing Bus Tour",
          desc: "A 24-hour hop-on hop-off bus ticket exploring major attractions such as the Mercedes-Benz Museum, Television Tower, Schlossplatz, vineyards, and art museums at your own pace, with informative commentary on the cultural and architectural highlights of Stuttgart.",
        },
        {
          title: "River Main Sightseeing Cruise with Commentary",
          desc: "A sightseeing cruise sailing past Frankfurt's striking skyline, historic bridges, museums, and riverside landmarks while learning about the city's history and culture.",
        },
        {
          title: "Frankfurt Hop-On, Hop-Off Grand or Express Bus Ticket",
          desc: "A hop-on hop-off bus ticket to explore Frankfurt's key attractions such as Römer, Palm Garden, the old opera house, museums along the River Main, and modern business districts.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Munich",
        desc: "Welcome to Germany – Welcome to Munich! Upon arrival at Munich Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening exploring Marienplatz, the Old Town streets, or Munich's lively beer gardens at your leisure. Overnight Stay in Munich.",
        tags: [],
      },
      {
        day: "02",
        title: "Munich",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Neuschwanstein & Linderhof Castle Full-Day Trip (included). Visit two of Bavaria's most iconic royal castles, surrounded by dramatic Alpine landscapes. Explore the fairy-tale Neuschwanstein Castle and the elegant Linderhof Palace, while learning about King Ludwig II's fascinating history. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Munich - Stuttgart",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Munich Hotel to Train Station. Board your train from Munich to Stuttgart. Upon arrival at Stuttgart Station, enjoy a private transfer to your hotel. Check in and explore Stuttgart's modern city center, Königstrasse shopping street, or the Palace Square area. Overnight Stay in Stuttgart.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Stuttgart",
        desc: "Breakfast at Hotel. After breakfast, begin your Stuttgart 24-Hour Hop-On Hop-Off Sightseeing Bus Tour (ticket included). Explore major attractions such as the Mercedes-Benz Museum, Television Tower, Schlossplatz, vineyards, and art museums at your own pace. Enjoy informative commentary as you discover the cultural and architectural highlights of Stuttgart. Overnight Stay in Stuttgart.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Stuttgart - Frankfurt",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Stuttgart Hotel to Station. Board your train from Stuttgart to Frankfurt. Upon arrival at Frankfurt Station, enjoy a private transfer to your hotel. Check in and explore the modern skyline, Römerberg Square, or the riverside promenade. Overnight Stay in Frankfurt.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Frankfurt",
        desc: "Breakfast at Hotel. After breakfast, enjoy your River Main Sightseeing Cruise with Commentary (included). Sail past Frankfurt's striking skyline, historic bridges, museums, and riverside landmarks while learning about the city's history and culture. Later, explore Frankfurt using your Hop-On, Hop-Off Grand or Express Bus Ticket (included). Visit key attractions such as Römer, Palm Garden, old opera house, museums along the River Main, and modern business districts. Overnight Stay in Frankfurt.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Frankfurt - India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Frankfurt Hotel to Frankfurt Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from Munich Airport to Munich Hotel",
        "Neuschwanstein & Linderhof Castle Full-Day Trip",
        "Private Transfer from Munich Hotel to Train Station",
        "Private Transfer from Stuttgart Station to Hotel",
        "Stuttgart 24-Hour Hop-On Hop-Off Sightseeing Bus Tour",
        "Private Transfer from Stuttgart Hotel to Station",
        "Private Transfer from Frankfurt Station to Hotel",
        "River Main Sightseeing Cruise with Commentary",
        "Hop-On, Hop-Off Grand or Express Bus Ticket",
        "Private Transfer from Frankfurt Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis require the client to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax (paid on the spot at the hotel)",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    supplementaryTours: {
      note: "Price is not applicable during fair/Events dates.",
      items: [
        {
          name: "2nd class train ticket from Munich to Stuttgart & Stuttgart to Frankfurt – on actual basis",
          price: "EUR 45 – 50 Per Person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Munich 2N", hotel: "Munich Inn or similar" },
            { location: "Stuttgart 2N", hotel: "Hampton by Hilton Stuttgart City Centre or Similar" },
            { location: "Frankfurt 2N", hotel: "B&B HOTEL Frankfurt-West or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 812 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 706 per person onwards on Twin/Double sharing basis / EUR 645 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 658 per person onwards on Twin/Double sharing basis / EUR 597 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 317 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 136 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 913 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 807 per person onwards on Twin/Double sharing basis / EUR 787 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 762 per person onwards on Twin/Double sharing basis / EUR 738 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 536 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 355 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 890 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 781 per person onwards on Twin/Double sharing basis / EUR 736 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 741 per person onwards on Twin/Double sharing basis / EUR 687 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 442 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 261 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Munich 2N", hotel: "Mercure Hotel Muenchen City Center or similar" },
            { location: "Stuttgart 2N", hotel: "Holiday Inn Stuttgart or Similar" },
            { location: "Frankfurt 2N", hotel: "Grand Hotel Empire Frankfurt or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec & Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 1014 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 896 per person onwards on Twin/Double sharing basis / EUR 927 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 842 per person onwards on Twin/Double sharing basis / EUR 873 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 711 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 530 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1089 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 971 per person onwards on Twin/Double sharing basis / EUR 964 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 920 per person onwards on Twin/Double sharing basis / EUR 909 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 667 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 486 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1004 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 883 per person onwards on Twin/Double sharing basis / EUR 911 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 837 per person onwards on Twin/Double sharing basis / EUR 856 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 661 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 480 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Satu/day-1.jpg",
      "/images/Satu/day-2.jpg",
      "/images/Satu/day-3.jpg",
      "/images/Satu/day-4.jpg",
      "/images/Satu/day-5.jpg",
      "/images/Satu/day-6.jpg",
      "/images/Satu/day-7.jpg",
      "/images/Satu/extra1.jpg",
      "/images/Satu/extra2.jpg",
    ],
  },

  {
    title: "Best of Oslo, Flam & Bergen",
    slug: "oslo-flam-bergen-06n",
    price: "EUR 1192 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/oslo/day-1.jpg",
    location: "Oslo, Flam, Bergen",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Oslo, Flam, Bergen",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Vigeland Sculpture Park",
        "Royal Palace",
        "Oslo Opera House",
        "Akershus Fortress",
        "Viking Ship Museum",
        "Norway in a Nutshell Journey",
        "Bryggen Wharf",
        "Mount Floyen",
        "Mostraumen Fjord Cruise",
      ],

      experiences: [
        {
          title: "Oslo Hop On Hop Off City Tour + Scenic Fjord Cruise",
          desc: "A Hop On Hop Off City Tour covering iconic attractions like Vigeland Sculpture Park, Royal Palace, Oslo Opera House, Akershus Fortress, and Viking Ship Museum, followed by a Scenic Fjord Cruise (Shared Basis) offering breathtaking views of Oslo's bays, islands, fjord landscapes, and serene waters.",
        },
        {
          title: "Norway in a Nutshell Journey (Oslo – Flam – Bergen)",
          desc: "The famous Norway in a Nutshell journey: Oslo ➜ Train ➜ Myrdal ➜ Train ➜ Flam (Overnight Stay), continuing Flam ➜ Boat to Gudvangen ➜ Bus to Voss ➜ Train to Bergen, passing through dramatic mountains, fjord villages, and serene landscapes.",
        },
        {
          title: "Bergen Hop On Hop Off City Tour",
          desc: "A 01 Day HOHO City Tour of Bergen covering Bryggen, Mount Floyen (Optional Funicular), Fish Market, Bergen Fortress, and St. Mary's Church — a perfect introduction to Norway's cultural capital surrounded by mountains and fjords.",
        },
        {
          title: "Mostraumen Fjord Cruise with Guide",
          desc: "The famous Mostraumen Fjord Cruise with Guide (Shared Basis), a scenic journey through narrow fjords, towering cliffs, cascading waterfalls, and stunning natural landscapes.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Oslo",
        desc: "Welcome to Oslo – The Capital of Norway! Upon arrival at Oslo Airport, enjoy a private transfer to your hotel. Rest of the day is free to relax or explore nearby attractions such as Karl Johans Gate, Oslo Harbour, or Aker Brygge. Overnight Stay in Oslo.",
        tags: [],
      },
      {
        day: "02",
        title: "Oslo – Hop On Hop Off City Tour + Scenic Fjord Cruise",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Hop On Hop Off City Tour covering iconic attractions like Vigeland Sculpture Park, Royal Palace, Oslo Opera House, Akershus Fortress, and Viking Ship Museum. Later, enjoy a Scenic Fjord Cruise (Shared Basis) offering breathtaking views of Oslo's bays, islands, fjord landscapes, and serene waters. Overnight Stay in Oslo.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Oslo ➜ Flam (Norway in a Nutshell)",
        desc: "Breakfast at Hotel. After breakfast, proceed for private transfer from Oslo Hotel to Oslo Station. Begin your famous Norway in a Nutshell journey: Oslo ➜ Train ➜ Myrdal ➜ Train ➜ Flam (Overnight Stay). Arrive in Flam, one of Norway's most beautiful fjord villages known for its dramatic mountains and serene landscapes. Overnight Stay in Flam.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Flam ➜ Gudvangen ➜ Voss ➜ Bergen",
        desc: "Breakfast at Hotel. Continue the Norway in a Nutshell route: Flam ➜ Boat to Gudvangen ➜ Bus to Voss ➜ Train to Bergen. Upon arrival at Bergen Station, enjoy a private transfer to your hotel. Spend the evening relaxing or exploring the historic Bryggen Wharf area. Overnight Stay in Bergen.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Bergen – Hop On Hop Off City Tour",
        desc: "Breakfast at Hotel. Proceed for your 01 Day HOHO City Tour of Bergen covering Bryggen, Mount Floyen (Optional Funicular), Fish Market, Bergen Fortress, and St. Mary's Church. A perfect introduction to Norway's cultural capital surrounded by mountains and fjords. Overnight Stay in Bergen.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Bergen – Mostraumen Fjord Cruise",
        desc: "Breakfast at Hotel. Today, enjoy the famous Mostraumen Fjord Cruise with Guide (Shared Basis). This scenic journey takes you through narrow fjords, towering cliffs, cascading waterfalls, and stunning natural landscapes. Return to Bergen and enjoy the rest of the day at leisure. Overnight Stay in Bergen.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Departure – Bergen ➜ Airport",
        desc: "Breakfast at Hotel. After breakfast, proceed for your private transfer from Bergen Hotel to Bergen Airport for your onward flight. End of your Norway Journey with unforgettable memories!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private Transfer from Oslo Airport to Oslo Hotel",
        "Oslo: 01 Day Hop On Hop Off City Tour",
        "Scenic Fjord Cruise on Shared Basis",
        "Private Transfer from Oslo Hotel to Oslo Station",
        "Norway in a Nutshell Oslo ➜ Train ➜ Myrdal ➜ Train ➜ 01 Night Flam ➜ Boat ➜ Gudvangen ➜ Bus ➜ Voss ➜ Train ➜ Ends Bergen",
        "Private Transfer from Bergen Station to Bergen Hotel",
        "Bergen: 01 Day Hop On Hop Off City Tour",
        "Mostraumen Fjord Cruise with Guide on Shared Basis",
        "Private Transfer from Bergen Hotel to Bergen Airport",
      ],

      excluded: [],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Oslo 2N", hotel: "Thon Hotel Slottsparken or similar" },
            { location: "Flam 1N", hotel: "Fretheim Hotel or similar" },
            { location: "Bergen 3N", hotel: "Scandic Torget Bergen or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1192 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1109 per person onwards on Twin/Double sharing basis / EUR 1094 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1126 per person onwards on Twin/Double sharing basis / EUR 1078 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 893 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1109 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1199 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1179 per person onwards on Twin/Double sharing basis / EUR 1164 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1184 per person onwards on Twin/Double sharing basis / EUR 1151 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1031 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1184 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1323 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1303 per person onwards on Twin/Double sharing basis / EUR 1258 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1278 per person onwards on Twin/Double sharing basis / EUR 1275 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1176 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1088 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "July – Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1443 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1441 per person onwards on Twin/Double sharing basis / EUR 1326 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1428 per person onwards on Twin/Double sharing basis / EUR 1313 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1088 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1443 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Oslo 2N", hotel: "Radisson Blu Plaza Hotel, Oslo or similar" },
            { location: "Flam 1N", hotel: "Fretheim Hotel or similar" },
            { location: "Bergen 3N", hotel: "Radisson Blu Royal Hotel, Bergen" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1301 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1248 per person onwards on Twin/Double sharing basis / EUR 1212 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1235 per person onwards on Twin/Double sharing basis / EUR 1226 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1119 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1301 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1293 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1273 per person onwards on Twin/Double sharing basis / EUR 1292 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1278 per person onwards on Twin/Double sharing basis / EUR 1279 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1241 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1293 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1459 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1439 per person onwards on Twin/Double sharing basis / EUR 1298 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1414 per person onwards on Twin/Double sharing basis / EUR 1315 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1024 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1459 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "July – Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1421 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1419 per person onwards on Twin/Double sharing basis / EUR 1391 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1406 per person onwards on Twin/Double sharing basis / EUR 1378 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1321 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1421 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/oslo/day-1.jpg",
      "/images/oslo/day-2.jpg",
      "/images/oslo/day-3.jpg",
      "/images/oslo/day-4.jpg",
      "/images/oslo/day-5.jpg",
      "/images/oslo/day-6.jpg",
      "/images/oslo/day-7.jpg",
    ],
  },

  {
    title: "Best of Swiss & France",
    slug: "paris-geneva-zurich-07n",
    price: "EUR 1192 per person onwards", // Note: lowest 02 Pax rate found is EUR 1274 (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/swis/day-1.jpg",
    location: "Paris, Geneva, Zurich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Paris, Geneva, Zurich",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "Champs-Élysées",
        "Arc de Triomphe",
        "Louvre Museum",
        "Notre-Dame",
        "Musée d'Orsay",
        "Seine River Embankments",
        "Eiffel Tower (2nd Level)",
        "Mt. Glacier 3000 & Peak Walk by Tissot",
        "Lindt Home of Chocolate",
        "Mt. Titlis with Ice Flyer",
      ],

      experiences: [
        {
          title: "Paris Hop-on Hop-off Tour + Eiffel Tower (2nd Level)",
          desc: "A 1-Day Hop-On Hop-Off Bus Tour (SIC Basis) covering Champs-Élysées, Arc de Triomphe, Louvre Museum, Notre-Dame, Musée d'Orsay, and Seine River Embankments, followed by a visit to the world-famous Eiffel Tower (2nd Level Entry Ticket Included) for breathtaking views of the Paris skyline.",
        },
        {
          title: "Excursion to Glacier 3000",
          desc: "An unforgettable excursion to Mt. Glacier 3000 using the Swiss Travel Pass (ticket included), featuring spectacular Alpine views, The Peak Walk by Tissot – the world's only suspension bridge connecting two mountain peaks, snow activities, and scenic viewpoints.",
        },
        {
          title: "Lindt Chocolate Factory Visit",
          desc: "A visit to the famous Lindt Home of Chocolate using the Swiss Travel Pass, with interactive exhibits, the history of Swiss chocolate, and tastings at the world's largest chocolate fountain.",
        },
        {
          title: "Excursion to Mt. Titlis with Ice Flyer",
          desc: "A full-day excursion to Mt. Titlis using the Swiss Travel Pass, featuring a rotating cable car ride to the summit, stunning snow-covered landscapes, the Ice Flyer Chairlift (Ticket Included), and Glacier Cave & Cliff Walk.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Paris",
        desc: "Welcome to Paris – The City of Lights! Arrive at Paris Airport and meet your driver for a smooth private transfer to your hotel. After check-in, relax or explore the charming streets, cafés, and landmarks nearby. Overnight Stay in Paris.",
        tags: [],
      },
      {
        day: "02",
        title: "Paris Hop-on Hop-off Tour + Eiffel Tower (2nd Level)",
        desc: "Breakfast at Hotel. Today explore Paris using your 1-Day Hop-On Hop-Off Bus Tour (SIC Basis). Visit top attractions such as: Champs-Élysées, Arc de Triomphe, Louvre Museum, Notre-Dame, Musée d'Orsay, Seine River Embankments. Later, visit the world-famous Eiffel Tower (2nd Level Entry Ticket Included) for breathtaking views of the Paris skyline. Evening free for shopping or an optional Seine River cruise. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Paris → Geneva",
        desc: "Breakfast at Hotel. After breakfast, proceed for your private transfer from Paris Hotel to the Train Station for your onward journey to Switzerland. Arrive in Geneva and use your Swiss Travel Pass (Second Class – 6 Days Continuous) for seamless travel from Geneva Station to your hotel. Relax for the rest of the day or walk along Lake Geneva's beautiful promenade. Overnight Stay in Geneva.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Excursion to Glacier 3000",
        desc: "Breakfast at Hotel. Today, enjoy an unforgettable excursion to Mt. Glacier 3000 using your Swiss Travel Pass (ticket included). Spectacular Alpine views, The Peak Walk by Tissot – the world's only suspension bridge connecting two mountain peaks. Snow activities and scenic viewpoints. Return to Geneva in the evening. Overnight Stay in Geneva.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Geneva → Zurich",
        desc: "Breakfast at Hotel. Today, travel from Geneva to Zurich using your Swiss Travel Pass. Enjoy one of Europe's most scenic train journeys through lakes, vineyards, and mountains. Arrive in Zurich and check in to your hotel. Rest of the day is free to explore the Old Town, Bahnhofstrasse, or take a walk near Lake Zurich. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Lindt Chocolate Factory Visit",
        desc: "Breakfast at Hotel. This morning, use your Swiss Travel Pass to visit the famous Lindt Home of Chocolate. Enjoy interactive exhibits, learn about the history of Swiss chocolate, and taste freshly made delights at the world's largest chocolate fountain. Return to Zurich and spend the rest of the day at leisure. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Excursion to Mt. Titlis with Ice Flyer",
        desc: "Breakfast at Hotel. Today, enjoy a full-day excursion to Mt. Titlis using your Swiss Travel Pass. Experience: Rotating cable car ride to the summit, Stunning snow-covered landscapes, Ice Flyer Chairlift (Ticket Included), Glacier Cave & Cliff Walk. Return to Zurich in the evening. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Zurich → India",
        desc: "Breakfast at Hotel. Check out and proceed to Zurich Airport using your Swiss Travel Pass for your flight back to India. Your memorable France & Switzerland journey comes to an end with beautiful Alpine memories!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "07 Nights Accommodation with Breakfast",
        "Private transfer from Paris Airport to hotel & hotel to station",
        "Paris Hop-on Hop-off Bus tour 01 day pass on SIC basis",
        "Eiffel Tower 2nd level Entry ticket",
        "06 Days continuous Swiss Travel Pass second class",
        "Geneva station to hotel using Swiss pass",
        "Excursion to Mt. Glacier 3000 ticket using Swiss pass",
        "Geneva Hotel to Zurich Hotel using Swiss pass",
        "Visit Lindt chocolate factory ticket with Swiss pass",
        "Excursion to Mt. Titlis with ice flyer ticket using Swiss pass",
        "Zurich Hotel to Airport using Swiss pass",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Paris - Geneva 2nd class train ticket – on actual basis",
          price: "EUR 71 – 105 onwards per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Paris 2N", hotel: "Hotel Champerret Elysées or similar" },
            { location: "Geneva 2N", hotel: "Hotel Bernina Geneva or similar" },
            { location: "Zurich 3N", hotel: "Sorell Hotel Rex or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1274 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1248 per person onwards on Twin/Double sharing basis / EUR 1222 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1232 per person onwards on Twin/Double sharing basis / EUR 1206 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 557 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 552 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1362 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1336 per person onwards on Twin/Double sharing basis / EUR 1277 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1320 per person onwards on Twin/Double sharing basis / EUR 1261 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 546 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 640 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1390 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1364 per person onwards on Twin/Double sharing basis / EUR 1312 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1348 per person onwards on Twin/Double sharing basis / EUR 1296 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 595 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 668 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Paris 2N", hotel: "Auteuil Tour Eiffel or similar" },
            { location: "Geneva 2N", hotel: "Eastwest Hotel or similar" },
            { location: "Zurich 3N", hotel: "Krone Unterstrass or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1509 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1483 per person onwards on Twin/Double sharing basis / EUR 1459 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1467 per person onwards on Twin/Double sharing basis / EUR 1445 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 804 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 787 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1944 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1918 per person onwards on Twin/Double sharing basis / EUR 1805 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1902 per person onwards on Twin/Double sharing basis / EUR 1789 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 966 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1222 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1920 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1894 per person onwards on Twin/Double sharing basis / EUR 1821 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1880 per person onwards on Twin/Double sharing basis / EUR 1789 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1010 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1200 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/swis/day-1.jpg",
      "/images/swis/day-2.jpg",
      "/images/swis/day-3.jpg",
      "/images/swis/day-4.jpg",
      "/images/swis/day-5.jpg",
      "/images/swis/day-6.jpg",
      "/images/swis/day-7.jpg",
    ],
  },

  {
    title: "Best of Vienna/Munich/Zurich",
    slug: "vienna-munich-zurich-06n",
    price: "EUR 1008 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/best1/day-1.jpg",
    location: "Vienna, Munich, Zurich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Vienna, Munich, Zurich",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "St. Stephen's Cathedral",
        "Vienna State Opera",
        "Belvedere Palace",
        "Danube Tower",
        "Schönbrunn Palace",
        "Nymphenburg Palace",
        "BMW World",
        "Historic Old Town Munich",
        "Lindt Home of Chocolate",
      ],

      experiences: [
        {
          title: "Vienna Hop-on Hop-off + Schönbrunn Palace",
          desc: "A 1-Day Hop-on Hop-off Bus Pass (SIC Basis) covering St. Stephen's Cathedral, Vienna State Opera, Belvedere Palace, Danube Tower, and Parliament & City Hall, followed by a visit to the majestic Schönbrunn Palace (Ticket Included), the former summer residence of the Habsburg Royal Family, with its lavish rooms and beautiful palace gardens.",
        },
        {
          title: "Munich Hop-on Hop-off City Tour",
          desc: "A Munich Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis) exploring top attractions including Nymphenburg Palace, Olympic Park, BMW World, Karlplatz, Historic Old Town, and Viktualienmarkt.",
        },
        {
          title: "Lindt Chocolate Factory Visit",
          desc: "A visit to the world-famous Lindt Home of Chocolate using the Swiss Travel Pass, with interactive exhibits, Swiss chocolate craftsmanship, and a chocolate tasting experience.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Vienna",
        desc: "Welcome to Vienna – The Imperial Capital of Austria! Arrive at Vienna Airport and enjoy a smooth private transfer to your hotel. After check-in, relax or explore the elegant boulevards, gardens, traditional cafés, and classical architecture at your leisure. Overnight Stay in Vienna.",
        tags: [],
      },
      {
        day: "02",
        title: "Vienna Hop-on Hop-off + Schönbrunn Palace",
        desc: "Breakfast at Hotel. Today explore Vienna using your 1-Day Hop-on Hop-off Bus Pass (SIC Basis). Visit major landmarks including: St. Stephen's Cathedral, Vienna State Opera, Belvedere Palace, Danube Tower, Parliament & City Hall. Later, visit the majestic Schönbrunn Palace (Ticket Included), the former summer residence of the Habsburg Royal Family. Walk through its lavish rooms and beautiful palace gardens. Evening is free for leisure, shopping, or enjoying classical music concerts (optional). Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Vienna → Munich",
        desc: "Breakfast at Hotel. After breakfast, proceed for a private transfer from Vienna Hotel to the Train Station for your journey to Munich. Arrive in Munich and meet your driver for a private transfer from Munich Station to your hotel. Spend the remaining day exploring the vibrant Marienplatz Square or enjoying Bavarian food. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Munich Hop-on Hop-off City Tour",
        desc: "Breakfast at Hotel. Today enjoy your Munich Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis). Explore top attractions such as: Nymphenburg Palace, Olympic Park, BMW World, Karlplatz, Historic Old Town, Viktualienmarkt. Evening free to explore Munich's beer gardens or walk around the old town. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Munich → Zurich",
        desc: "Breakfast at Hotel. Proceed for your private transfer from Munich Hotel to the Train Station. Board your train to Switzerland. Upon arrival at Zurich Station, use your Swiss Travel Pass (3 Days Continuous – Second Class) to travel comfortably to your Zurich Hotel. Rest of the day at leisure to explore the Old Town, Bahnhofstrasse, or lakeside promenades. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Lindt Chocolate Factory Visit",
        desc: "Breakfast at Hotel. Today, use your Swiss Travel Pass to visit the world-famous Lindt Home of Chocolate. Discover interactive exhibits, learn about Swiss chocolate craftsmanship, and taste delicious varieties at the chocolate tasting experience. Return to Zurich and enjoy the evening freely. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Zurich → India",
        desc: "Breakfast at Hotel. Check out and proceed to Zurich Airport using your Swiss Travel Pass for your flight back to India. Your delightful Vienna–Munich–Zurich journey concludes with sweet memories, scenic experiences, and royal European charm!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night's Accommodation with Breakfast",
        "Private transfer from Vienna Airport to hotel & Hotel to Station",
        "Vienna Hop-on Hop-off Bus tour 01day pass on SIC basis",
        "Schönbrunn Palace ticket only",
        "Munich Hop-on Hop-off Bus tour 01day pass on SIC basis",
        "03 Days continuous Swiss Travel Pass second class",
        "Zurich station to Zurich Hotel using Swiss pass",
        "Visit Lindt chocolate factory ticket with Swiss pass",
        "Zurich Hotel to Airport using Swiss pass",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Vienna – Munich – Zurich 2nd class train ticket – on actual basis",
          price: "EUR 125 – 155 onwards per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Vienna 2N", hotel: "ibis Wien Mariahilf or similar" },
            { location: "Munich 2N", hotel: "Hotel New Orly München or similar" },
            { location: "Zurich 2N", hotel: "Sorell Hotel Rex or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1008 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 966 per person onwards on Twin/Double sharing basis / EUR 939 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 935 per person onwards on Twin/Double sharing basis / EUR 910 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 450 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 450 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1307 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1265 per person onwards on Twin/Double sharing basis / EUR 1209 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1235 per person onwards on Twin/Double sharing basis / EUR 1177 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 651 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 750 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1257 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1215 per person onwards on Twin/Double sharing basis / EUR 1171 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1183 per person onwards on Twin/Double sharing basis / EUR 1140 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 644 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 698 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Vienna 2N", hotel: "Mercure Grand Hotel Biedermeier Wien or similar" },
            { location: "Munich 2N", hotel: "Eurostars Grand Central Hotel or similar" },
            { location: "Zurich 2N", hotel: "Krone Unterstrass or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1189 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1147 per person onwards on Twin/Double sharing basis / EUR 1113 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1115 per person onwards on Twin/Double sharing basis / EUR 1081 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 603 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 630 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1457 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1415 per person onwards on Twin/Double sharing basis / EUR 1358 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1383 per person onwards on Twin/Double sharing basis / EUR 1326 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 792 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 888 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1408 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1366 per person onwards on Twin/Double sharing basis / EUR 1304 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1334 per person onwards on Twin/Double sharing basis / EUR 1272 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 738 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 849 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/best1/day-1.jpg",
      "/images/best1/day-2.jpg",
      "/images/best1/day-3.jpg",
      "/images/best1/day-4.jpg",
      "/images/best1/day-5.jpg",
      "/images/best1/day-6.jpg",
      "/images/best1/day-7 .jpg",
    ],
  },

  {
    title: "Best of Vienna/Munich/Zurich",
    slug: "vienna-munich-zurich-07n",
    price: "EUR 1130 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/best/day-1.jpg",
    location: "Vienna, Munich, Zurich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Vienna, Munich, Zurich",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "St. Stephen's Cathedral",
        "Vienna State Opera",
        "Belvedere Palace",
        "Danube Tower",
        "Schönbrunn Palace",
        "Bratislava & Western Slovakia",
        "Nymphenburg Palace",
        "BMW World",
        "Lindt Home of Chocolate",
      ],

      experiences: [
        {
          title: "Vienna Hop-on Hop-off + Schönbrunn Palace",
          desc: "A 1-Day Hop-on Hop-off Bus Pass (SIC Basis) covering St. Stephen's Cathedral, Vienna State Opera, Belvedere Palace, Danube Tower, and Parliament & City Hall, followed by a visit to the majestic Schönbrunn Palace (Ticket Included), the former summer residence of the Habsburg Royal Family, with its lavish rooms and beautiful palace gardens.",
        },
        {
          title: "Bratislava & Countryside Guided Half Day Tour",
          desc: "The best of Bratislava and western Slovakia in a single, unforgettable day (SIC Basis) — a full cultural journey blending capital highlights, castles, caves, nature, and authentic local food, all within easy reach of Vienna.",
        },
        {
          title: "Munich Hop-on Hop-off City Tour",
          desc: "A Munich Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis) exploring top attractions including Nymphenburg Palace, Olympic Park, BMW World, Karlplatz, Historic Old Town, and Viktualienmarkt.",
        },
        {
          title: "Lindt Chocolate Factory Visit",
          desc: "A visit to the world-famous Lindt Home of Chocolate using the Swiss Travel Pass, with interactive exhibits, Swiss chocolate craftsmanship, and a chocolate tasting experience.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India → Vienna",
        desc: "Welcome to Vienna – The Imperial Capital of Austria! Arrive at Vienna Airport and enjoy a smooth private transfer to your hotel. After check-in, relax or explore the elegant boulevards, gardens, traditional cafés, and classical architecture at your leisure. Overnight Stay in Vienna.",
        tags: [],
      },
      {
        day: "02",
        title: "Vienna Hop-on Hop-off + Schönbrunn Palace",
        desc: "Breakfast at Hotel. Today explore Vienna using your 1-Day Hop-on Hop-off Bus Pass (SIC Basis). Visit major landmarks including: St. Stephen's Cathedral, Vienna State Opera, Belvedere Palace, Danube Tower, Parliament & City Hall. Later, visit the majestic Schönbrunn Palace (Ticket Included), the former summer residence of the Habsburg Royal Family. Walk through its lavish rooms and beautiful palace gardens. Evening is free for leisure, shopping, or enjoying classical music concerts (optional). Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Bratislava & Countryside Guided Half Day Tour on SIC basis",
        desc: "The best of Bratislava and western Slovakia in a single, unforgettable day. This tour is designed for travellers who want more than a quick city visit — it's a full cultural journey blending capital highlights, castles, caves, nature, and authentic local food, all within easy reach of Vienna. Instead of spending hours in transit, you'll spend your day exploring. Overnight Stay in Vienna.",
        tags: [],
      },
      {
        day: "04",
        title: "Vienna → Munich",
        desc: "Breakfast at Hotel. After breakfast, proceed for a private transfer from Vienna Hotel to the Train Station for your journey to Munich. Arrive in Munich and meet your driver for a private transfer from Munich Station to your hotel. Spend the remaining day exploring the vibrant Marienplatz Square or enjoying Bavarian food. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Munich Hop-on Hop-off City Tour",
        desc: "Breakfast at Hotel. Today enjoy your Munich Hop-on Hop-off Bus Tour (1 Day Pass – SIC Basis). Explore top attractions such as: Nymphenburg Palace, Olympic Park, BMW World, Karlplatz, Historic Old Town, Viktualienmarkt. Evening free to explore Munich's beer gardens or walk around the old town. Overnight Stay in Munich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Munich → Zurich",
        desc: "Breakfast at Hotel. Proceed for your private transfer from Munich Hotel to the Train Station. Board your train to Switzerland. Upon arrival at Zurich Station, use your Swiss Travel Pass (3 Days Continuous – Second Class) to travel comfortably to your Zurich Hotel. Rest of the day at leisure to explore the Old Town, Bahnhofstrasse, or lakeside promenades. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Lindt Chocolate Factory Visit",
        desc: "Breakfast at Hotel. Today, use your Swiss Travel Pass to visit the world-famous Lindt Home of Chocolate. Discover interactive exhibits, learn about Swiss chocolate craftsmanship, and taste delicious varieties at the chocolate tasting experience. Return to Zurich and enjoy the evening freely. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Zurich → India",
        desc: "Breakfast at Hotel. Check out and proceed to Zurich Airport using your Swiss Travel Pass for your flight back to India. Your delightful Vienna–Munich–Zurich journey concludes with sweet memories, scenic experiences, and royal European charm!",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night's Accommodation with Breakfast", // Note: as printed in PDF, though itinerary covers 07 nights
        "Private transfer from Vienna Airport to hotel & Hotel to Station",
        "Vienna Hop-on Hop-off Bus tour 01day pass on SIC basis",
        "Schönbrunn Palace ticket only",
        "Bratislava & Countryside Guided Half Day Tour on SIC basis",
        "Munich Hop-on Hop-off Bus tour 01day pass on SIC basis",
        "03 Days continuous Swiss Travel Pass second class",
        "Zurich station to Zurich Hotel using Swiss pass",
        "Visit Lindt chocolate factory ticket with Swiss pass",
        "Zurich Hotel to Airport using Swiss pass",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Vienna – Munich – Zurich 2nd class train ticket – on actual basis",
          price: "EUR 125 – 155 onwards per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Vienna 3N", hotel: "ibis Wien Mariahilf or similar" },
            { location: "Munich 2N", hotel: "Hotel New Orly München or similar" },
            { location: "Zurich 2N", hotel: "Sorell Hotel Rex or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1130 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1088 per person onwards on Twin/Double sharing basis / EUR 1056 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1057 per person onwards on Twin/Double sharing basis / EUR 1028 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 505 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 511 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1438 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1396 per person onwards on Twin/Double sharing basis / EUR 1339 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1367 per person onwards on Twin/Double sharing basis / EUR 1307 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 697 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 813 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1384 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1342 per person onwards on Twin/Double sharing basis / EUR 1297 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1310 per person onwards on Twin/Double sharing basis / EUR 1266 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 688 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 759 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Vienna 3N", hotel: "Mercure Grand Hotel Biedermeier Wien or similar" },
            { location: "Munich 2N", hotel: "Eurostars Grand Central Hotel or similar" },
            { location: "Zurich 2N", hotel: "Krone Unterstrass or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1338 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1296 per person onwards on Twin/Double sharing basis / EUR 1256 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1264 per person onwards on Twin/Double sharing basis / EUR 1224 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 654 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 713 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1635 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1593 per person onwards on Twin/Double sharing basis / EUR 1530 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1561 per person onwards on Twin/Double sharing basis / EUR 1498 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 874 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 1000 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1569 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1527 per person onwards on Twin/Double sharing basis / EUR 1457 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1495 per person onwards on Twin/Double sharing basis / EUR 1425 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 795 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 944 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/best/day-1.jpg",
      "/images/best/day-2.jpg",
      "/images/best/day-3.jpg",
      "/images/best/day-4.jpg",
      "/images/best/day-5.jpg",
      "/images/best/day-6.jpg",
      "/images/best/day-7.jpg",
    ],
  },

  {
    title: "Zurich + Innsbruck + Salzburg",
    slug: "zurich-innsbruck-salzburg-06n",
    price: "EUR 1053 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026-27)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: zurich1,
    location: "Zurich, Innsbruck, Salzburg",
    nextDate: "Available on Request",



    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Zurich, Innsbruck, Salzburg",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Mount Titlis",
        "Glacier Cave & Cliff Walk",
        "Golden Roof, Innsbruck",
        "Swarovski Crystal Worlds",
        "Mirabell Gardens",
        "Mozart's Birthplace",
        "Original Sound of Music Tour",
        "Leopoldskron Palace",
      ],

      experiences: [
        {
          title: "Mount Titlis Excursion",
          desc: "Using the Swiss Pass, travel to Engelberg and proceed to Mount Titlis (ticket included). Experience the stunning journey by revolving Rotair cable car to the summit, where panoramic snow-clad Alpine scenery awaits, with activities such as the Glacier Cave, Cliff Walk bridge, and snowy viewpoints.",
        },
        {
          title: "Swarovski Crystal Worlds",
          desc: "A visit to Swarovski Crystal Worlds (entrance ticket included), exploring the Chambers of Wonder, unique art installations, crystal-themed exhibits, the magical outdoor garden, the crystal cloud, mirror installations, and family-friendly attractions.",
        },
        {
          title: "Half Day Original Sound of Music Tour",
          desc: "A Half Day Original Sound of Music Tour (shared basis, included), visiting iconic filming locations such as the Mirabell Gardens, Leopoldskron Palace, the lakes district, and the famous gazebo, with stories about the Von Trapp family, the film's production, and Salzburg's beautiful landscapes.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zurich",
        desc: "Welcome to Switzerland! Upon arrival at Zurich Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening exploring the charming lanes of Zurich's Old Town or walking along Lake Zurich at your leisure. Overnight Stay in Zurich.",
        tags: [],
      },
      {
        day: "02",
        title: "Zurich",
        desc: "Breakfast at Hotel. After breakfast, use your Swiss Pass for travel to Engelberg, scan your voucher at the ticket counter from where you will proceed to Mount Titlis (ticket included). Experience the stunning journey by revolving Rotair cable car to the summit, where panoramic snow-clad Alpine scenery awaits. Enjoy activities such as the Glacier Cave, Cliff Walk bridge and snowy viewpoints. Return to Zurich using your Swiss Pass. Evening at leisure to explore Zurich's cafes, riverside area or Bahnhofstrasse. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zurich – Innsbruck",
        desc: "Breakfast at Hotel. Check out from the Hotel. Use your Swiss Pass for your onward train journey from Zurich to the Austrian border region and continue toward Innsbruck. Upon arrival at Innsbruck Station, enjoy a private transfer to your hotel. Check in and spend your first evening strolling around the medieval Old Town and the Golden Roof area. Overnight Stay in Innsbruck.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Innsbruck – Swarovski Crystal Worlds Entrance Ticket",
        desc: "Breakfast at Hotel. After breakfast, make your way to Swarovski Crystal Worlds (entrance ticket included). Explore the Chambers of Wonder, unique art installations, crystal-themed exhibits, and the magical outdoor garden. Enjoy the crystal cloud, mirror installations, and family-friendly attractions at this world-famous venue. Return to Innsbruck and enjoy the rest of the day at leisure — explore Nordkette views, Maria-Theresien-Strasse, or local Tyrolean cafés. Overnight Stay in Innsbruck.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Innsbruck - Salzburg",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Innsbruck Hotel to Station. Board your train from Innsbruck to Salzburg. Upon arrival in Salzburg, enjoy a private transfer from Salzburg Station to your hotel. Check in and relax, or explore the Old Town — Mirabell Gardens, pedestrian streets, and Mozart's birthplace area. Overnight Stay in Salzburg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Salzburg – Half Day Original Sound of Music Tour on Shared Basis",
        desc: "Breakfast at Hotel. After breakfast, proceed for the Half Day Original Sound of Music Tour (shared basis, included). Visit iconic filming locations such as the Mirabell Gardens, Leopoldskron Palace, the lakes district, and the famous gazebo. Hear stories about the Von Trapp family, the film's production, and the history of Salzburg's beautiful landscapes. Afternoon and evening at leisure — explore the Fortress, riverfront, cafés, or the charming lanes around Getreidegasse. Overnight Stay in Berlin.", // Note: "Overnight Stay in Berlin" as printed in source PDF, though itinerary is Zurich/Innsbruck/Salzburg
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Salzburg - India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Salzburg Hotel to Salzburg Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private transfer from Zurich Airport to Hotel",
        "3 Days Swiss Pass – 2nd Class",
        "Mount Titlis Ticket using Swiss Pass",
        "Private Transfer from Innsbruck Station to Hotel",
        "Swarovski Crystal Worlds Entrance Ticket",
        "Private Transfer from Innsbruck Hotel to Station",
        "Private Transfer from Salzburg Station to Hotel",
        "Half Day Original Sound of Music Tour on Shared Basis",
        "Private Transfer from Salzburg Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "2nd class train ticket from Zurich to Innsbruck & Innsbruck to Salzburg – On actual basis",
          price: "EUR 125 – 130 per person",
        },
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Zurich 2N", hotel: "ibis Styles Zurich City Center or similar" },
            { location: "Innsbruck 2N", hotel: "Hilton Garden Inn Innsbruck Tivoli Hotel or similar" },
            { location: "Salzburg 2N", hotel: "Leonardo Hotel Salzburg City Center -Nord or similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 1053 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 985 per person on Twin/Double sharing basis / EUR 992 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 955 per person on Twin/Double sharing basis / EUR 962 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 553 per child" },
                { pax: "Single Room Supplement", price: "EUR 463" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1361 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1293 per person on Twin/Double sharing basis / EUR 1223 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1266 per person on Twin/Double sharing basis / EUR 1198 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 625 per child" },
                { pax: "Single Room Supplement", price: "EUR 535" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1108 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1037 per person on Twin/Double sharing basis / EUR 1020 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1015 per person on Twin/Double sharing basis / EUR 989 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 475 per child" },
                { pax: "Single Room Supplement", price: "EUR 385" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Zurich 2N", hotel: "Central Plaza or similar" },
            { location: "Innsbruck 2N", hotel: "ADLERS Lifestyle Hotel or similar" },
            { location: "Salzburg 2N", hotel: "Holiday Inn Salzburg City or similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 1282 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1214 per person on Twin/Double sharing basis / EUR 1236 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1184 per person on Twin/Double sharing basis / EUR 1206 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 827 per child" },
                { pax: "Single Room Supplement", price: "EUR 737" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1391 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1323 per person on Twin/Double sharing basis / EUR 1241 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1296 per person on Twin/Double sharing basis / EUR 1210 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 619 per child" },
                { pax: "Single Room Supplement", price: "EUR 529" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1283 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1212 per person on Twin/Double sharing basis / EUR 1270 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1190 per person on Twin/Double sharing basis / EUR 1239 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 905 per child" },
                { pax: "Single Room Supplement", price: "EUR 815" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      zurich1,
      zurich2,
      zurich3,
      zurich4,
      zurich5,
      zurich6,
      zurich7],
  },


  {
    title: "Zurich + Bern + Geneva",
    slug: "zurich-bern-geneva-07n",
    price: "EUR 1428 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/Bern/day-1.jpg",
    location: "Zurich, Bern, Geneva",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Zurich, Bern, Geneva",
      },

      pills: [
        "Breakfast Included",
        "Swiss Travel Pass Included",
        "07 Nights Accommodation",
      ],

      highlights: [
        "Rhine Falls",
        "Lindt Home of Chocolate",
        "Mt. Titlis & Titlis Cliff Walk",
        "Bern Old Town & Zytglogge",
        "Mt. Jungfrau – Top of Europe",
        "Jet d'Eau & Lake Geneva",
        "Mont Blanc & Aiguille du Midi",
      ],

      experiences: [
        {
          title: "Rhine Falls & Lindt Home of Chocolate",
          desc: "Visit the Rhine Falls with your Swiss Pass via train from Zurich to Schaffhausen and Neuhausen Rheinfall, followed by the Lindt Home of Chocolate in Kilchberg, with entry providing access to the chocolate fountain and interactive exhibits.",
        },
        {
          title: "Full-Day Excursion to Mt. Titlis",
          desc: "Travel by train from Zurich to Lucerne, then to Engelberg, and board the Titlis Rotair, the world's first revolving cable car, to the summit of Mt. Titlis. Enjoy breathtaking views of snow-covered peaks, the Titlis Cliff Walk, the Glacier Cave, and eternal snow and ice at over 3,000 meters above sea level.",
        },
        {
          title: "Excursion to Mt. Jungfrau – the \"Top of Europe\"",
          desc: "Travel by train from Bern to Interlaken Ost, then to Grindelwald Terminal, board the Eiger Express cable car to Eiger Gletscher, and transfer to the Jungfrau Bahn to reach Jungfrau, Europe's highest railway station, with panoramic vistas of the Aletsch Glacier and the Ice Palace.",
        },
        {
          title: "Day Trip to Mont Blanc from Geneva",
          desc: "A day trip on an SIC basis across the French border to Chamonix through the scenic Arve Valley, with the famous Aiguille du Midi cable car (ticket included) for panoramic views of France, Switzerland, and Italy.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zurich",
        desc: "Welcome to Zurich! Arriving in Zurich is an excellent start to your Swiss adventure! Getting from Zurich to Lucerne with your Swiss Pass is straightforward, scenic, and incredibly convenient. Lucerne is one of Switzerland's most picturesque and enchanting cities, perfectly blending historical charm with stunning natural beauty. Whether you're a history buff, nature lover, or simply in search of a relaxing European getaway, Lucerne offers something for everyone. Overnight Stay in Zurich.",
        tags: [],
      },
      {
        day: "02",
        title: "Zurich",
        desc: "Breakfast at Hotel. Visiting the Rhine Falls with your Swiss Pass is quick and convenient. Take the train from Zurich to Schaffhausen and continue to Neuhausen Rheinfall, where the falls are just a short walk away. Boat rides are not included. After the falls, make your way to the Lindt Home of Chocolate in Kilchberg. It's easily reached by a short train ride from Zurich, followed by a brief walk to the museum. Your entry ticket provides access to the chocolate fountain and the interactive exhibits. Overnight Stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zurich",
        desc: "Breakfast at the hotel. Take a full-day excursion to Mt. Titlis, one of Switzerland's most spectacular alpine destinations, using your Swiss Pass. Travel by train from Zurich to Lucerne, then continue to Engelberg, a charming mountain village. From Engelberg, board the Titlis Rotair, the world's first revolving cable car, which takes you to the summit of Mt. Titlis. At Mt. Titlis, enjoy breathtaking views of snow-covered peaks, walk across the thrilling Titlis Cliff Walk, explore the Glacier Cave, and experience the eternal snow and ice at over 3,000 meters above sea level. After the excursion, return to Zurich in the evening. Overnight stay in Zurich.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Zurich – Bern",
        desc: "Breakfast at Hotel. The train journey from Zurich to Bern is a comfortable and scenic way to travel across Switzerland, offering views of picturesque towns, rolling hills, and the Swiss countryside. Once in Bern, you can explore the city at your own pace. Bern, the capital of Switzerland, perfectly combines historic charm with modern vibrancy. Stroll through its UNESCO-listed Old Town, admire the iconic Zytglogge clock tower, or enjoy the serene banks of the Aare River. Overnight Stay in Bern.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Bern",
        desc: "Breakfast at the hotel. Take a full-day excursion to Mt. Jungfrau – the \"Top of Europe\" using your Swiss Pass. Travel by train from Bern to Interlaken Ost, then continue to Grindelwald Terminal. From there, board the Eiger Express high-speed cable car to Eiger Gletscher, and transfer to the Jungfrau Bahn to reach Jungfrau, Europe's highest railway station. The journey offers breathtaking views of alpine valleys, glaciers, and the iconic Eiger North Face. At Jungfrau, enjoy panoramic vistas of the Aletsch Glacier, explore the Ice Palace, and take in the stunning alpine scenery. Return to Bern in the evening for your overnight stay. Overnight Stay in Bern.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Bern – Geneva",
        desc: "Breakfast at the hotel. Travel by train from Bern to Geneva with your Swiss Pass. The journey is comfortable and scenic, passing through the Swiss countryside and picturesque towns. In Geneva, explore the city at your own pace. Visit landmarks like the Jet d'Eau, Flower Clock, and the Old Town, or enjoy a stroll along Lake Geneva. Geneva is a cosmopolitan city known for its international institutions, rich history, and vibrant cultural scene. Overnight stay in Geneva.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Geneva",
        desc: "Breakfast at the hotel. Embark on a day trip to Mont Blanc from Geneva on an SIC basis. Travel across the French border to Chamonix, passing through the scenic Arve Valley surrounded by stunning alpine landscapes. In Chamonix, take the famous Aiguille du Midi cable car (ticket included) for breathtaking panoramic views of France, Switzerland, and Italy. Enjoy some free time to explore the charming alpine town and soak in its unique atmosphere. Overnight stay in Geneva.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Zurich – India",
        desc: "Breakfast at Hotel. After breakfast proceed to airport with Swiss Pass.", // Note: as printed in PDF, "Zurich – India" heading despite trip ending in Geneva
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "07 Nights Accommodation with Breakfast",
        "Swiss Travel Pass 2nd class 6 consecutive days",
        "Rhine Falls with Swiss Pass",
        "Lindt home of chocolate entry ticket",
        "Zurich to Bern by Train using Swiss Pass",
        "Excursion to Mt. Jungfrau with Swiss pass",
        "Bern to Geneva by Train using Swiss Pass",
        "Day trip to Mont Blanc from Geneva on SIC basis (Aiguille du Midi cable car ticket included)",
        "Tram/Bus ticket from Zurich & Geneva hotel to airport",
        "Private transfer from Geneva Hotel to (GVA) Airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Tour (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Rhine Fall 15 minutes boat ride",
          price: "EUR 10 per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Zurich 3N", hotel: "ibis Styles Zurich City Center or similar" },
            { location: "Bern 2N", hotel: "ibis Styles Bern City or similar" },
            { location: "Geneva 2N", hotel: "ibis Genève Centre Nations or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1428 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1407 per person on Twin/Double sharing basis / EUR 1389 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1397 per person on Twin/Double sharing basis / EUR 1380 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 552 per child" },
                { pax: "Single Room Supplement", price: "EUR 462" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1801 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1777 per person on Twin/Double sharing basis / EUR 1714 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1771 per person on Twin/Double sharing basis / EUR 1700 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 679 per child" },
                { pax: "Single Room Supplement", price: "EUR 820" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1687 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1663 per person on Twin/Double sharing basis / EUR 1607 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1656 per person on Twin/Double sharing basis / EUR 1593 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 593 per child" },
                { pax: "Single Room Supplement", price: "EUR 710" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Zurich 3N", hotel: "Sheraton Zurich Hotel or similar" },
            { location: "Bern 2N", hotel: "ibis Bern Expo or similar" },
            { location: "Geneva 2N", hotel: "Novotel Genève Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1879 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1860 per person on Twin/Double sharing basis / EUR 1735 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1848 per person on Twin/Double sharing basis / EUR 1720 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 589 per child" },
                { pax: "Single Room Supplement", price: "EUR 895" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 2254 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 2232 per person on Twin/Double sharing basis / EUR 2027 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 2236 per person on Twin/Double sharing basis / EUR 2012 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 689 per child" },
                { pax: "Single Room Supplement", price: "EUR 1268" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 2033 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 2009 per person on Twin/Double sharing basis / EUR 1846 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 2002 per person on Twin/Double sharing basis / EUR 1832 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 615 per child" },
                { pax: "Single Room Supplement", price: "EUR 1044" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Bern/day-1.jpg",
      "/images/Bern/day-2.jpg",
      "/images/Bern/day-3.jpg",
      "/images/Bern/day-4.jpg",
      "/images/Bern/day-5.jpg",
      "/images/Bern/day-6.jpg",
      "/images/Bern/day-7.jpg",
    ],
  },

  {
    title: "Vienna + Budapest + Prague",
    slug: "vienna-budapest-prague-06n",
    price: "EUR 546 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026-27)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Pergue/day-1.jpg",
    location: "Vienna, Budapest, Prague",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Vienna, Budapest, Prague",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Ringstrasse",
        "St. Stephen's Cathedral",
        "Schönbrunn Palace & Gardens",
        "Hungarian Parliament Building",
        "Buda Castle & Chain Bridge",
        "Fisherman's Bastion",
        "Old Town Square, Prague",
        "Charles Bridge",
        "Prague Castle",
      ],

      experiences: [
        {
          title: "Schönbrunn Palace & Gardens Skip-the-Line Tour",
          desc: "A Skip-the-Line Tour (shared basis, included) exploring the magnificent imperial residence, the lavishly decorated state rooms, and the lives of the Habsburg rulers, followed by a stroll through the beautifully manicured Baroque gardens with spectacular viewpoints across the palace grounds.",
        },
        {
          title: "City Highlights Sightseeing Cruise, Budapest",
          desc: "A sightseeing cruise (included) along the Danube River, admiring iconic landmarks such as the Hungarian Parliament Building, Buda Castle, Chain Bridge, Gellért Hill, and the historic riverbanks of Budapest, with informative audio commentary.",
        },
        {
          title: "Prague Castle Skip-the-Line Ticket with Audio Guide",
          desc: "A visit to Prague Castle using a Skip-the-Line Ticket with Audio guide (included), exploring St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica, and the charming Golden Lane, learning about the history of one of the world's largest ancient castle complexes.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Vienna",
        desc: "Welcome to Vienna! Upon arrival at Vienna Airport, enjoy a private transfer to your hotel. Check in, relax, and spend the evening exploring the elegant streets around the Ringstrasse, St. Stephen's Cathedral, or Vienna's classic cafés at your leisure. Overnight Stay in Vienna.",
        tags: [],
      },
      {
        day: "02",
        title: "Vienna",
        desc: "Breakfast at Hotel. After breakfast, proceed for the Schönbrunn Palace & Gardens Skip-the-Line Tour (shared basis, included). Explore the magnificent imperial residence, wander through the lavishly decorated state rooms, and learn about the lives of the Habsburg rulers. Stroll through the beautifully manicured Baroque gardens and enjoy spectacular viewpoints across the palace grounds. Return to the city center and enjoy the rest of the day at leisure — explore Hofburg Palace, Belvedere, or Vienna's vibrant shopping streets. Overnight Stay in Vienna.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Vienna - Budapest",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Vienna Hotel to Station. Board your train from Vienna to Budapest. Upon arrival at Budapest Station, enjoy a private transfer to your hotel. Check in and spend the evening relaxing or exploring the beautiful Danube riverside illuminated by night. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Budapest",
        desc: "Breakfast at Hotel. After breakfast, enjoy your City Highlights Sightseeing Cruise (included). Sail along the Danube River and admire iconic landmarks such as the Hungarian Parliament Building, Buda Castle, Chain Bridge, Gellért Hill, and the historic riverbanks of Budapest. Listen to informative audio commentary as you experience the city from a unique perspective. Afternoon and evening at leisure — explore Fisherman's Bastion, stroll around Váci Utca, or unwind in one of Budapest's famous thermal baths. Overnight Stay in Budapest.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Budapest – Prague",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Budapest Hotel to Train Station. Board your train from Budapest to Prague. Upon arrival at Prague Station, enjoy a private transfer to your hotel. Check in and spend the evening walking through Old Town Square, Charles Bridge, or the lively café districts. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Prague - Prague Castle Skip-the-Line Ticket with Audio guide",
        desc: "Breakfast at Hotel. After breakfast, visit Prague Castle using your Skip-the-Line Ticket with Audio guide (included). Explore St. Vitus Cathedral, the Old Royal Palace, St. George's Basilica, and the charming Golden Lane while learning about the history of one of the world's largest ancient castle complexes. Rest of the day is free — discover the Astronomical Clock, stroll along the Vltava River, or enjoy local markets and cafés. Overnight Stay in Prague.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Prague - India",
        desc: "Breakfast at Hotel. Check out from the Hotel. Private transfer from Prague Hotel to Prague Airport for your onward flight. Back to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private Transfer from Vienna Airport to Hotel",
        "Schönbrunn Palace & Gardens Skip-the-Line Tour on Shared Basis",
        "Private Transfer from Vienna Hotel to Station",
        "Private Transfer from Budapest Station to Budapest Hotel",
        "City Highlights Sightseeing Cruise",
        "Private Transfer from Budapest Hotel to Train Station",
        "Private Transfer from Prague Station to Hotel",
        "Prague Castle Skip-the-Line Ticket with Audio guide",
        "Private Transfer from Prague Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "2nd class train ticket from Vienna to Budapest & Budapest to Prague – On actual basis",
          price: "EUR 55 – 65 per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Vienna 2N", hotel: "Garner Hotel Vienna or Similar" },
            { location: "Budapest 2N", hotel: "Star City Hotel or Similar" },
            { location: "Prague 2N", hotel: "Exe City Park or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 546 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 488 per person on Twin/Double sharing basis / EUR 478 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 462 per person on Twin/Double sharing basis / EUR 458 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 321 per child" },
                { pax: "Single Room Supplement", price: "EUR 213" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 652 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 594 per person on Twin/Double sharing basis / EUR 571 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 571 per person on Twin/Double sharing basis / EUR 544 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 383 per child" },
                { pax: "Single Room Supplement", price: "EUR 275" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 631 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 570 per person on Twin/Double sharing basis / EUR 576 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 552 per person on Twin/Double sharing basis / EUR 545 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 411 per child" },
                { pax: "Single Room Supplement", price: "EUR 303" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Vienna 2N", hotel: "Leonardo Hotel Vienna or Similar" },
            { location: "Budapest 2N", hotel: "Exe Budapest Center or Similar" },
            { location: "Prague 2N", hotel: "Century Old Town Prague - Mgallery or Similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026-2027",
              rows: [
                { pax: "02 Pax", price: "EUR 585 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 527 per person on Twin/Double sharing basis / EUR 568 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 501 per person on Twin/Double sharing basis / EUR 542 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 513 per child" },
                { pax: "Single Room Supplement", price: "EUR 405" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 718 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 660 per person on Twin/Double sharing basis / EUR 690 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 637 per person on Twin/Double sharing basis / EUR 663 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 608 per child" },
                { pax: "Single Room Supplement", price: "EUR 500" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 635 per person on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 574 per person on Twin/Double sharing basis / EUR 622 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 556 per person on Twin/Double sharing basis / EUR 595 per person on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 553 per child" },
                { pax: "Single Room Supplement", price: "EUR 445" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Pergue/day-1.jpg",
      "/images/Pergue/day-2.jpg",
      "/images/Pergue/day-3.jpg",
      "/images/Pergue/day-4.jpg",
      "/images/Pergue/day-5.jpg",
      "/images/Pergue/day-6.jpg",
      "/images/Pergue/day-7.jpg",
    ],
  },

  // {
  //   title: "From Windmills to the Eiffel",
  //   slug: "amsterdam-brussels-paris-06n",
  //   price: "EUR 898 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
  //   days: "06 Nights / 07 Days",
  //   rating: "",
  //   image: "",
  //   location: "Amsterdam, Brussels, Paris",
  //   nextDate: "Available on Request",

  //   highlightsData: {
  //     locationCard: {
  //       meta: "3 Destinations, 06 Nights",
  //       places: "Amsterdam, Brussels, Paris",
  //     },

  //     pills: [
  //       "Breakfast Included",
  //       "Private Transfers Included",
  //       "06 Nights Accommodation",
  //     ],

  //     highlights: [
  //       "Van Gogh Museum",
  //       "Rijksmuseum",
  //       "Amsterdam Canal Cruise",
  //       "Grand Place, Brussels",
  //       "Manneken Pis",
  //       "Atomium",
  //       "Louvre Museum",
  //       "Notre Dame",
  //       "Eiffel Tower Summit",
  //       "Seine River Cruise",
  //     ],

  //     experiences: [
  //       {
  //         title: "Amsterdam One Day Hop on Hop off + Canal Cruise",
  //         desc: "Amsterdam is the Netherlands' capital, known for its artistic heritage, elaborate canal system, and narrow houses with gabled facades dating back to the 17th-century Golden Age. The Museum District houses the Van Gogh Museum, the Rijksmuseum with works by Rembrandt and Vermeer, and the Stedelijk Museum for modern art, complemented by a shared-basis Canal Cruise Ticket.",
  //       },
  //       {
  //         title: "Brussels Hop on Hop off + Atomium Entrance Ticket",
  //         desc: "A Brussels One Day Hop on Hop off Tour providing an introduction to the city's major attractions including the Grand Place, Manneken Pis, Royal Palace, and European Quarter, along with the Atomium Entrance Ticket for panoramic views of Brussels from its iconic futuristic spheres.",
  //       },
  //       {
  //         title: "Paris Hop on Hop off + Eiffel Tower Summit + Seine River Cruise",
  //         desc: "A Paris One Day Hop on Hop off Tour covering the main attractions of Paris including the Louvre Museum, Notre Dame, Champs-Élysées, and Arc de Triomphe, followed by the Eiffel Tower with Summit Level Entrance Ticket for breathtaking views, and a Seine River Cruise for a peaceful journey past Paris's most iconic monuments.",
  //       },
  //     ],
  //   },

  //   itinerary: [
  //     {
  //       day: "01",
  //       title: "India – Amsterdam",
  //       desc: "Arrival in Amsterdam: I Amsterdam. Welcome to Amsterdam, Amsterdam is the Netherlands' capital, known for its artistic heritage, elaborate canal system and narrow houses with gabled facades, legacies of the city's 17th-century Golden Age. Its Museum District houses the Van Gogh Museum, works by Rembrandt and Vermeer at the Rijksmuseum, and modern art at the Stedelijk. Cycling is key to the city's character, and there are numerous bike paths. Overnight Stay in Amsterdam.",
  //       tags: [],
  //     },
  //     {
  //       day: "02",
  //       title: "Amsterdam - Amsterdam One Day Hop on Hop off",
  //       desc: "Breakfast at Hotel. Welcome to Amsterdam. Amsterdam is the capital city of the Netherlands, known for its artistic heritage, elaborate canal system, and narrow houses with gabled facades that date back to the 17th-century Golden Age. The Museum District houses the Van Gogh Museum, the Rijksmuseum with works by Rembrandt and Vermeer, and the Stedelijk Museum for modern art. Cycling is an essential part of Amsterdam's culture, and the city offers numerous scenic bike paths. Overnight Stay in Amsterdam.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "03",
  //       title: "Amsterdam – Brussels",
  //       desc: "Breakfast at Hotel. After breakfast, check out and proceed with a private transfer from Amsterdam Hotel to Amsterdam Station. Travel to Brussels by train. Upon arrival, meet your driver for a private transfer from Brussels Station to your hotel. Brussels, the capital of Belgium, is known for its rich history, Gothic architecture, Belgian chocolates, waffles, and European Union headquarters. Its charming streets blend medieval structures with modern European influence. Overnight Stay in Brussels.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "04",
  //       title: "Brussels – Atomium Entrance Ticket + Brussels Hop on Hop off",
  //       desc: "Breakfast at Hotel. Today proceed for the Brussels One Day Hop on Hop off Tour. This tour provides an ideal introduction to the city's major attractions including the Grand Place, Manneken Pis, Royal Palace, and European Quarter. Your experience also includes the Atomium Entrance Ticket, offering panoramic views of Brussels from its iconic futuristic spheres. After sightseeing, return to your hotel or explore the city at leisure. Overnight Stay in Brussels.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "05",
  //       title: "Brussels – Paris",
  //       desc: "Breakfast at Hotel. After breakfast, proceed with a private transfer from Brussels Hotel to Brussels Station. Travel to Paris by train. Upon arrival, meet your chauffeur for a private transfer from Paris Station to your hotel. Paris, the City of Lights, is globally renowned for its iconic landmarks, artistic heritage, romantic ambiance, fashion houses, gourmet cuisine, and historic architecture. From its charming cafés to world-class museums, Paris is a city that inspires travellers from around the world. Overnight Stay in Paris.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "06",
  //       title: "Paris – Paris Hop on Hop off + Eiffel Tower Summit Entrance Ticket + Seine River Cruise Ticket",
  //       desc: "Breakfast at Hotel. After breakfast, proceed for the Paris One Day Hop on Hop off Tour, which covers the main attractions of Paris including the Louvre Museum, Notre Dame, Champs-Élysées, Arc de Triomphe, and more. Continue to the Eiffel Tower with Summit Level Entrance Ticket, offering breathtaking views over Paris from the highest accessible point. Later, enjoy the Seine River Cruise Entrance Ticket, offering a peaceful journey along the river with views of Paris's most iconic monuments. Overnight Stay in Paris.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //     {
  //       day: "07",
  //       title: "Paris – India",
  //       desc: "Breakfast at Hotel. After breakfast, proceed to Paris Airport with a private transfer for your onwards flight.",
  //       tags: [{ label: "Breakfast" }],
  //     },
  //   ],

  //   pointsToRemember: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The Offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   inclusions: {
  //     included: [
  //       "06 Nights Accommodation with Breakfast",
  //       "Private transfer from Amsterdam Airport to Amsterdam Hotel",
  //       "Amsterdam One Day Hop on Hop off",
  //       "Amsterdam Canal Cruise Ticket on Shared Basis",
  //       "Private transfer from Amsterdam Hotel to Amsterdam Station",
  //       "Private transfer from Brussels Station to Brussels Hotel",
  //       "Brussels One Day Hop on Hop off",
  //       "Atomium Entrance Ticket",
  //       "Private transfer from Brussels Hotel to Brussels Station",
  //       "Private transfer from Paris Station to Paris Hotel",
  //       "Paris One Day Hop on Hop off",
  //       "Eiffel Tower Summit Level Entrance Ticket",
  //       "Seine River Cruise Entrance Ticket Only",
  //       "Private transfer from Paris Hotel to Paris Airport",
  //     ],

  //     excluded: [
  //       "Return Flight Tickets",
  //       "Visa and Insurance fees",
  //       "Hotel pick up for shared/SIC tours",
  //       "Optional tours",
  //       "Hotel City Tax to be paid directly at the hotel",
  //       "Lunch and Dinner",
  //       "Water bottles",
  //       "Train tickets not included unless mentioned in inclusions",
  //       "Expenses of personal nature such as laundry, drinks, telephone, etc.",
  //       "Anything not mentioned in the Inclusions",
  //     ],
  //   },

  //   supplementaryTours: {
  //     note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
  //     items: [
  //       {
  //         name: "Amsterdam – Brussels – Paris 2nd class train ticket – on actual basis",
  //         price: "EUR 180 - 250 per person",
  //       },
  //     ],
  //   },

  //   pricing: {
  //     note: "Price is not applicable during fair/Events dates.",
  //     options: [
  //       {
  //         category: "Option 1 – 3* Hotel",
  //         hotels: [
  //           { location: "Amsterdam 2N", hotel: "Hampton By Hilton Amsterdam Centre East or similar" },
  //           { location: "Brussels 2N", hotel: "Floris Arlequin Grand Place or similar" },
  //           { location: "Paris 2N", hotel: "Ibis Styles Paris Gare De L'est Chateau Landon or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov, Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 898 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 864 per person onwards on Twin/Double sharing basis / EUR 852 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 826 per person onwards on Twin/Double sharing basis / EUR 814 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 212 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 426 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "March, Sept, Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 1291 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 1254 per person onwards on Twin/Double sharing basis / EUR 1244 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 1216 per person onwards on Twin/Double sharing basis / EUR 1206 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 435 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 816 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July & Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 1208 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 1166 per person onwards on Twin/Double sharing basis / EUR 1157 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 1128 per person onwards on Twin/Double sharing basis / EUR 1119 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 412 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 728 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         category: "Option 2 – 4* Hotel",
  //         hotels: [
  //           { location: "Amsterdam 2N", hotel: "Conscious Hotel Westerpark or similar" },
  //           { location: "Brussels 2N", hotel: "Nhow Brussels Bloom or similar" },
  //           { location: "Paris 2N", hotel: "Hotel The Originals Paris Maison Montmartre or similar" },
  //         ],
  //         seasons: [
  //           {
  //             months: "Jan, Feb, Nov, Dec - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 1039 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 1007 per person onwards on Twin/Double sharing basis / EUR 993 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 969 per person onwards on Twin/Double sharing basis / EUR 955 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 221 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 569 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "March, Sept, Oct - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 1146 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 1074 per person onwards on Twin/Double sharing basis / EUR 1043 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 1036 per person onwards on Twin/Double sharing basis / EUR 1005 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 222 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 660 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //           {
  //             months: "April, May, June, July & Aug - 2026",
  //             rows: [
  //               { pax: "02 Pax", price: "EUR 1135 per person onwards on Twin/Double sharing basis" },
  //               { pax: "04 Pax", price: "EUR 1135 per person onwards on Twin/Double sharing basis / EUR 1087 per person onwards on Triple sharing basis" },
  //               { pax: "06 Pax", price: "EUR 1135 per person onwards on Twin/Double sharing basis / EUR 1087 per person onwards on Triple sharing basis" },
  //               { pax: "Child Sharing with Extra Bed", price: "EUR 230 per child onwards" },
  //               { pax: "Single Room Supplement", price: "EUR 670 onwards" },
  //               { pax: "Below 2-year child", price: "Free of cost" },
  //             ],
  //           },
  //         ],
  //       },
  //     ],
  //   },

  //   terms: [
  //     "Booking should be received 45 days prior to arrival.",
  //     "A 10% deposit of the total booking amount is required at the time of confirmation.",
  //     "The Offered rates are net and non-commissionable.",
  //     "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
  //     "Rates and availability of the services are subject to change before any confirmation.",
  //     "No bookings are made at the time of quotation.",
  //     "Any extra services to be paid directly.",
  //     "Driver tips to be paid directly.",
  //     "Anything that is not mentioned in the inclusions list is always not included.",
  //     "Cancellation Policy: As per our trading contract.",
  //     "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
  //   ],

  //   images: [],
  // },

  {
    title: "Amsterdam to Paris Escape",
    slug: "amsterdam-brussels-paris-08n",
    price: "EUR 1296 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Nov/Dec/Jan/Feb 2026)
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/ams/day-1.jpg",
    location: "Amsterdam, Brussels, Paris",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 08 Nights",
        places: "Amsterdam, Brussels, Paris",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "08 Nights Accommodation",
      ],

      highlights: [
        "Amsterdam Canal Cruise",
        "Zaanse Schans Windmills",
        "Edam, Volendam & Marken",
        "Brussels Guided Walking Tour",
        "Grand Place",
        "Manneken Pis",
        "Eiffel Tower",
        "Seine River Cruise",
        "Disneyland Paris",
      ],

      experiences: [
        {
          title: "Amsterdam Hop-on Hop-off Tour & Canal Cruise",
          desc: "The Amsterdam 01-Day Hop on Hop off bus tour offers a convenient way to explore the city's iconic landmarks, museums, and scenic canals at your own pace, complemented by the Amsterdam Canal Cruise ticket for a relaxing journey through the city's picturesque waterways and classic Dutch architecture.",
        },
        {
          title: "Zaanse Schans, Edam, Volendam & Marken Bus Tour",
          desc: "Admire the famous windmills of Zaanse Schans, attend a clog-making demonstration, and sample Edam and Gouda cheese, on an SIC basis tour that continues to Volendam and Marken, passing authentic polders, colourful houses, and harbors full of fishing boats.",
        },
        {
          title: "Brussels Guided Walking Tour",
          desc: "A walking tour through the medieval and Baroque city, the industrial city, the bourgeois city, and modern Brussels, split into the Lower City (Grand Palace, Manneken Pis, Saint-Géry Island and more) and the Upper City (Grand Place, Galeries Royales St Hubert, and the Mort Subite).",
        },
        {
          title: "Paris Hop-on Hop-off, Eiffel Tower & Seine Cruise",
          desc: "The Paris 01-Day Hop on Hop off bus tour gives flexibility to explore landmarks such as the Louvre, Champs-Élysées, and Notre-Dame, with the Eiffel Tower 2nd Level entry ticket for breathtaking views, and the Seine River Cruise entry ticket for a stunning evening view of Paris's illuminated bridges and monuments.",
        },
        {
          title: "Disneyland Paris (1 Park)",
          desc: "A magical full-day experience at Disneyland Paris, including a Disneyland 01-Day 01 Park ticket with shuttle transfer, with thrilling rides, live shows, themed attractions, and the enchanting world of Disney characters.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Amsterdam",
        desc: "Arrival in Amsterdam: A Charming Beginning to Your European Holiday. Welcome to Amsterdam, a city known for its artistic heritage, scenic canals, and vibrant culture. Upon arrival at Amsterdam AMS Airport, you will enjoy a smooth private transfer to your hotel. Your first evening in Amsterdam offers the perfect introduction to the city's relaxed atmosphere. From historic streets to enchanting waterways and lively squares, Amsterdam welcomes you with its signature charm. Overnight Stay in Amsterdam.",
        tags: [],
      },
      {
        day: "02",
        title: "Highlight of the Day: Amsterdam Hop-on Hop-off Tour & Canal Cruise Ticket",
        desc: "Breakfast at Hotel. After breakfast, enjoy the Amsterdam 01-Day Hop on Hop off bus tour, offering a convenient way to explore the city's iconic landmarks, museums, and scenic canals at your own pace. Your experience includes the Amsterdam Canal Cruise ticket, providing a relaxing journey through the city's picturesque waterways while admiring classic Dutch architecture and vibrant neighborhoods. Overnight Stay in Amsterdam.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zaanse Schans, Edam, Volendam & Marken Bus Tour from Amsterdam on SIC basis",
        desc: "Admire the famous windmills of Zaanse Schans, attend a clog-making demonstration, and sample Edam and Gouda cheese. Head north of the city to see the historic windmills of Zaanse Schans on the banks of the river Zaan. Explore the traditional 17th-century houses and a collection of beautifully preserved windmills from the nation's industrial heritage. Continue on to visit Edam, a beautiful town known worldwide for its cheese. Enjoy a cheese tasting and an exciting clog demonstration. Before the end of the day, go to Volendam and Marken, passing many authentic polders, the name given to land reclaimed from the sea. Wander down narrow streets, past colourful houses and visit the harbors full of fishing boats. Overnight Stay in Amsterdam.",
        tags: [],
      },
      {
        day: "04",
        title: "Amsterdam – Brussels",
        desc: "Breakfast at Hotel. After breakfast, enjoy a private transfer from your Amsterdam hotel to Amsterdam train station. Travel to Brussels by train. On arrival, enjoy a private transfer from Brussels train station to your hotel. Brussels, the capital of Belgium and the heart of Europe, welcomes you with its rich blend of history, modernity, and world-famous culinary delights. Overnight Stay in Brussels.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Brussels – Guided Walking Tour",
        desc: "Breakfast at Hotel. Get an overview of the fascinating city of Brussels, with a tour through the medieval and Baroque city, the industrial city, the bourgeois city, and on to modern Brussels. During your walking tour of the city, the tour will be split into two different areas and times: the Upper City and Lower City. The Lower City include the Grand Palace, the Everard t'Serclaes monument on Charles Buls street, the Manneken Pis and Grands Carmes street, Marché au Charbon street, the Covering of the Senne, Riches Claires Street, and Grande Île street, Saint-Géry Island and more. Whilst perusing through the Upper city, you'll notice a very different style. During this portion of the tour, you will see landmarks such as the Grand Place, the power of merchants, the Galeries Royales St Hubert, and the Mort Subite. Overnight Stay in Brussels.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Brussels – Paris",
        desc: "Breakfast at Hotel. After breakfast, proceed by private transfer from your Brussels hotel to Brussels train station for your onward train to Paris. Upon arrival in Paris, a private transfer will take you to your hotel. Paris, the City of Lights, captivates every visitor with its classic beauty, romantic ambience, world-class monuments, and timeless charm. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Paris – Hop on Hop off, Eiffel Tower & Seine Cruise",
        desc: "Breakfast at Hotel. After breakfast, enjoy your Paris 01-Day Hop on Hop off bus tour, giving you the flexibility to explore landmarks such as the Louvre, Champs-Élysées, Notre-Dame, and more. Your day includes the Eiffel Tower 02nd Level entry ticket, allowing you to experience breathtaking views of Paris from one of the world's most iconic monuments. Complete your evening with the Seine River Cruise entry ticket, offering a stunning view of Paris from the water as the city lights illuminate its famous bridges and monuments. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Paris – Disneyland (01 Park)",
        desc: "Highlight of the Day: Disneyland 01-Day 01 Park Ticket with Shuttle Transfer. Breakfast at Hotel. Today, enjoy a magical full-day experience at Disneyland Paris. With your included Disneyland 01-Day 01 Park ticket with shuttle transfer, immerse yourself in thrilling rides, live shows, themed attractions, and the enchanting world of Disney characters. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Paris – India",
        desc: "Breakfast at Hotel. After breakfast, proceed for your private transfer from Paris hotel to Paris CDG Airport for your return journey to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "Accommodation with breakfast",
        "Private transfer from Amsterdam AMS Airport to Amsterdam hotel",
        "Amsterdam 01-Day Hop on Hop off bus tour",
        "Amsterdam canal cruise ticket",
        "Zaanse Schans, Edam, Volendam & Marken Bus Tour from Amsterdam on SIC basis",
        "Private transfer from Amsterdam hotel to Amsterdam train station",
        "Private transfer from Brussels train station to Brussels hotel",
        "Guided Walking Tour on shared basis",
        "Private transfer from Brussels hotel to Brussels train station",
        "Private transfer from Paris train station to Paris hotel",
        "Paris 01-Day Hop on Hop off bus tour",
        "Eiffel Tower 02nd level entry ticket",
        "Seine river cruise entry ticket",
        "Disneyland 01-Day 01 Park ticket with shuttle transfer",
        "Private transfer from Paris hotel to Paris CDG Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Amsterdam - Brussels – Paris 2nd class train ticket – on actual basis",
          price: "EUR 212 - 252 per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Amsterdam 3N", hotel: "ibis Amsterdam Centre or similar" },
            { location: "Brussels 2N", hotel: "Bedford Hotel & Congress Centre" },
            { location: "Paris 3N", hotel: "Hôtel Kabanel by HappyCulture or similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1296 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1245 per person onwards on Twin/Double sharing basis / EUR 1235 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1214 per person onwards on Twin/Double sharing basis / EUR 1199 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 931 per child" },
                { pax: "Single Room Supplement", price: "EUR 721" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1493 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1427 per person onwards on Twin/Double sharing basis / EUR 1269 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1391 per person onwards on Twin/Double sharing basis / EUR 1233 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 785 per child" },
                { pax: "Single Room Supplement", price: "EUR 918" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1611 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1545 per person onwards on Twin/Double sharing basis / EUR 1365 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1509 per person onwards on Twin/Double sharing basis / EUR 1329 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 847 per child" },
                { pax: "Single Room Supplement", price: "EUR 1046" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Amsterdam 3N", hotel: "Movenpick Hotel Amsterdam City Centre or similar" },
            { location: "Brussels 2N", hotel: "Thon Hotel EU or similar" },
            { location: "Paris 3N", hotel: "Hotel Joséphine by Happy Culture or similar" },
          ],
          seasons: [
            {
              months: "Nov, Dec, Jan, Feb - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1805 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1724 per person onwards on Twin/Double sharing basis / EUR 1414 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1685 per person onwards on Twin/Double sharing basis / EUR 1375 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 465 per child" },
                { pax: "Single Room Supplement", price: "EUR 1200" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1559 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1508 per person onwards on Twin/Double sharing basis / EUR 1499 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1469 per person onwards on Twin/Double sharing basis / EUR 1460 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1403 per child" },
                { pax: "Single Room Supplement", price: "EUR 954" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1879 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1798 per person onwards on Twin/Double sharing basis / EUR 1720 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1759 per person onwards on Twin/Double sharing basis / EUR 1681 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1391 per child" },
                { pax: "Single Room Supplement", price: "EUR 1284" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/ams/day-1.jpg",
      "/images/ams/day-2.jpg",
      "/images/ams/day-3.jpg",
      "/images/ams/day-4.jpg",
      "/images/ams/day-5.jpg",
      "/images/ams/day-6.jpg",
      "/images/ams/day-7.jpg",
      "/images/ams/day-8.jpg",
      "/images/ams/extra1.jpg",
      "/images/ams/extra2.jpg",
      "/images/ams/extra3.jpg",
      "/images/ams/extra4.jpg",
      "/images/ams/extra5.jpg",
      "/images/ams/extra6.jpg",
      "/images/ams/extra7.jpg",
      // "/images/ams/extra1.jpg",
    ],
  },

  {
    title: "Amsterdam + Cologne + Frankfurt",
    slug: "amsterdam-cologne-frankfurt-06n",
    price: "EUR 753 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "",
    image: "",
    location: "Amsterdam, Cologne, Frankfurt",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Amsterdam, Cologne, Frankfurt",
      },

      pills: [
        "Breakfast Included",
        "Private Transfers Included",
        "06 Nights Accommodation",
      ],

      highlights: [
        "Royal Palace, Amsterdam",
        "Rijksmuseum",
        "Anne Frank House",
        "Amsterdam Canal Cruise",
        "Cologne Cathedral",
        "Rhine River Promenade",
        "Römerberg Square, Frankfurt",
        "Frankfurt Cathedral",
        "Main Tower",
      ],

      experiences: [
        {
          title: "Amsterdam Hop-On Hop-Off Bus Tour + Canal Cruise",
          desc: "A 24-hour flexible Hop-On Hop-Off Bus Tour (shared basis) through the city's most iconic landmarks, charming neighborhoods, and cultural hotspots — including the Royal Palace, Rijksmuseum, Anne Frank House, and picturesque canal districts — complemented by a classic canal cruise past historic bridges, Golden Age merchant houses, and charming houseboats.",
        },
        {
          title: "Cologne Hop-On Hop-Off Bus Tour",
          desc: "A flexible 24-hour sightseeing tour (shared basis) past major attractions such as Cologne Cathedral, the Rhine River promenade, the Old Town, Museum Ludwig, and the historic Roman-Germanic Museum, with engaging commentary on the city's rich heritage.",
        },
        {
          title: "Frankfurt Hop-On Hop-Off Bus Tour",
          desc: "A flexible 24-hour sightseeing tour (shared basis) discovering the city's modern skyline, historic quarters, and cultural landmarks, past iconic attractions such as Römerberg Square, the Frankfurt Cathedral, St. Paul's Church, the Main Tower, and the scenic riverbank of the Main.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Amsterdam",
        desc: "Arrival in Amsterdam: A Magical Start to Your Netherland. Welcome to Amsterdam! Upon arriving at Amsterdam Airport (Amsterdam Airport Schiphol), one of Europe's most modern and efficient airports, marks the beginning of an unforgettable journey. After landing, you'll enjoy a smooth and seamless private transfer to your hotel, allowing you to relax and settle in without any stress. Your first evening in Amsterdam will set the tone for the incredible experiences ahead. From the glittering canals to the charming cobblestone streets, the city's timeless beauty and warm atmosphere will captivate you from the moment you step outside. Whether you're strolling along the illuminated waterfront, admiring the elegant bridges, or savoring a delightful Dutch meal, your Amsterdam adventure begins in one of Europe's most enchanting and iconic destinations. Overnight Stay in Amsterdam.",
        tags: [],
      },
      {
        day: "02",
        title: "Amsterdam - Amsterdam hop on hop off bus tour - 24 Hours",
        desc: "After breakfast, embark on your Amsterdam Hop-On Hop-Off Bus Tour on a shared basis. If you want to explore Amsterdam's top highlights at your own pace, this 24-hour flexible sightseeing experience is the perfect choice. The tour takes you through the city's most iconic landmarks, charming neighborhoods, and cultural hotspots—including the Royal Palace, Rijksmuseum, Anne Frank House, and picturesque canal districts. Amsterdam - Amsterdam Canal Cruise Ticket: Amsterdam Canal Cruise on a shared basis. If you're short on time but want to experience the most picturesque highlights of Amsterdam, this classic canal cruise is the perfect way to explore the city from a unique perspective. During this relaxing journey, you'll glide through Amsterdam's iconic canals, passing historic bridges, Golden Age merchant houses, charming houseboats, and famous landmarks. Overnight Stay in Amsterdam.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Amsterdam - Cologne",
        desc: "After breakfast, catch a direct train from Amsterdam to Cologne. If you're looking for a quick, comfortable way to travel between two of Western Europe's vibrant cities, this train journey is ideal. On a high-speed train (such as ICE), the trip usually takes about 2 hours 37 minutes to 2 hours 40 minutes. You'll depart from Amsterdam's central station and arrive right at Cologne's main station. Overnight Stay in Cologne.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Cologne – Cologne hop on hop off bus tour - 24 Hours",
        desc: "After breakfast, proceed for your Cologne Hop-On Hop-Off Bus Tour on a shared basis. If you're short on time but want to experience the highlights of Cologne, this flexible 24-hour sightseeing tour is the perfect way to explore the city's most iconic landmarks. The tour takes you past major attractions such as Cologne Cathedral, the Rhine River promenade, the Old Town, Museum Ludwig, and the historic Roman-Germanic Museum, all while providing engaging commentary that brings the city's rich heritage to life. With the freedom to hop on and off at multiple stops, you can discover Cologne's culture, architecture, and vibrant neighborhoods at your own pace. Overnight Stay in Cologne.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Cologne – Frankfurt",
        desc: "After breakfast, board your train from Cologne heading to Frankfurt am Main. If you're looking for a fast and efficient way to travel between these two major German cities, this train journey is an excellent choice. The trip covers approximately 152 km (about 94 miles). On a high-speed train (such as those operated by Deutsche Bahn — ICE or IC/InterCity), the journey typically takes around 1 hour 16 minutes on average, and on the fastest services, as little as 1 hour 3 minutes. You'll depart from Cologne's main station (Köln Hbf) and arrive in Frankfurt's central station (Frankfurt (Main) Hbf) — making for a smooth, direct connection with no need to change trains. Overnight Stay in Frankfurt.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Frankfurt - Frankfurt hop on hop off bus tour - 24 hours",
        desc: "After breakfast, proceed for your Frankfurt Hop-On Hop-Off Bus Tour on a shared basis. If you're short on time but want to experience the highlights of Frankfurt, this flexible 24-hour sightseeing tour is an excellent way to discover the city's modern skyline, historic quarters, and cultural landmarks. The tour takes you past iconic attractions such as Römerberg Square, the Frankfurt Cathedral, St. Paul's Church, the Main Tower, and the scenic riverbank of the Main. Along the route, you'll enjoy insightful audio commentary that sheds light on Frankfurt's unique blend of tradition and innovation. With the freedom to hop on and off at designated stops, you can explore the city's museums, shopping districts, and historical sites at your own pace. Overnight Stay in Frankfurt.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Frankfurt - India",
        desc: "Breakfast at Hotel. After breakfast and proceed to Frankfurt airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Transfer from Amsterdam airport to hotel on private basis",
        "Amsterdam hop on hop off bus tour - 24 Hours",
        "Amsterdam Canal Cruise ticket",
        "Transfer from Amsterdam hotel to train station on private basis",
        "Train from Amsterdam to Cologne",
        "Transfer from Cologne train station to hotel on private basis",
        "Cologne hop on hop off bus tour - 24 Hours",
        "Transfer from Cologne hotel to train station on private basis",
        "Train from Cologne to Frankfurt",
        "Transfer from Frankfurt train station to hotel on private basis",
        "Frankfurt hop on hop off bus tour - 24 hours",
        "Transfer from Frankfurt hotel to airport on private basis",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Amsterdam - Cologne – Frankfurt 2nd Class train ticket – on actual basis",
          price: "EUR 115 – 125 per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Amsterdam 2N", hotel: "Hotel Alexander or similar" },
            { location: "Cologne 2N", hotel: "Hotel Ludwig Superior or similar" },
            { location: "Frankfurt 2N", hotel: "ibis Frankfurt Centrum or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 753 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 661 per person onwards on Twin/Double sharing basis / EUR 630 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 619 per person onwards on Twin/Double sharing basis / EUR 586 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 394 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 425 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 912 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 819 per person onwards on Twin/Double sharing basis / EUR 771 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 778 per person onwards on Twin/Double sharing basis / EUR 726 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 495 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 577 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 779 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 686 per person onwards on Twin/Double sharing basis / EUR 651 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 644 per person onwards on Twin/Double sharing basis / EUR 607 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 404 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 450 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Amsterdam 2N", hotel: "NH City Centre Amsterdam or similar" },
            { location: "Cologne 2N", hotel: "NH Collection Koln Mediapark or similar" },
            { location: "Frankfurt 2N", hotel: "Leonardo Royal Hotel Frankfurt or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 764 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 682 per person onwards on Twin/Double sharing basis / EUR 673 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 638 per person onwards on Twin/Double sharing basis / EUR 627 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 565 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 413 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 943 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 847 per person onwards on Twin/Double sharing basis / EUR 792 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 808 per person onwards on Twin/Double sharing basis / EUR 747 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 498 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 607 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 783 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 759 per person onwards on Twin/Double sharing basis / EUR 754 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 722 per person onwards on Twin/Double sharing basis / EUR 715 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 730 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 452 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [],
  },

  // ============================================================
  // 1) Best of Barcelona + Valencia + Seville + Madrid || 07N/08D
  // (Source: Barcelona_2N_Valencia_1N_Neville_2N_Madrid_2N.pdf)
  // ============================================================
  {
    title: "Best of Barcelona + Valencia + Seville + Madrid",
    slug: "barcelona-valencia-seville-madrid-07n",
    price: "EUR 737 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/val7/day-2.jpg",
    location: "Barcelona, Valencia, Seville, Madrid",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4 Destinations, 07 Nights",
        places: "Barcelona, Valencia, Seville, Madrid",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "Private Airport Transfers",
      ],

      highlights: [
        "Sagrada Familia",
        "Park Güell",
        "City of Arts and Sciences, Valencia",
        "Royal Alcázar, Seville",
        "Plaza de España, Seville",
        "Maria Luisa Park, Seville",
        "Santa Cruz Jewish Quarter, Seville",
        "Royal Palace, Madrid",
        "Prado Museum, Madrid",
        "Puerta de Alcalá, Madrid",
        "El Retiro Park, Madrid",
        "Royal Botanic Gardens, Madrid",
        "Cibeles Palace, Madrid",
        "Almudena Cathedral, Madrid",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off Tours",
          desc: "Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi.",
        },
        {
          title: "Seville 01 Day Hop on Hop off Bus Tour",
          desc: "Hop on board one of bright red buses to see the best of Seville - the artistic, cultural, and financial capital of southern Spain. With 14 bus stops around this historical masterpiece of a city, you will see so much from prestigious Islamic monuments, to gardens and Flamenco festivals. Sit back and enjoy the panoramic view from the open top bus and hop on and off at your convenience! Join the free walking tours to find out even more about Seville: discover Plaza de España and Maria Luisa Park, the Jewish quarter, Santa Cruz, with the buses providing audio commentary and free Wi-Fi.",
        },
        {
          title: "Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
          desc: "Covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Barcelona – Arrival",
        desc: "Welcome to Barcelona – The City of Gaudí! Your adventure begins with a smooth transfer from the airport to your hotel, where you'll be ready to immerse yourself in the magic of Barcelona. Whether you're here for the art, the culture, the fashion, or the food, Barcelona offers an abundance of experiences waiting to be explored. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Barcelona hop-on hop-off tours",
        desc: "Breakfast at Hotel. After breakfast proceed to Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona - Valencia",
        desc: "After Breakfast Check-out from Barcelona Hotel. Train from Barcelona to Valencia. Travelling by train from Barcelona to Valencia you can take the AVE high-speed train, which takes around 3-3.5 hours, or the Euromed train, which takes around 3-4 hours. Both trains offer comfortable seating, Wi-Fi, and scenic views of the Mediterranean coast. Some popular trains include: AVE: High-speed train (around 3 hours); Euromed: High-speed train (around 3-4 hours); Iryo: Modern, high-speed train (around 3 hours). Welcome to Valencia! Valencia, the City of Arts and Sciences, is a vibrant and stunning destination on Spain's eastern coast. Known for its beautiful beaches, futuristic architecture, and rich cultural heritage, Valencia is a must-visit! Enjoy the city's delicious cuisine, including paella, and explore the historic center, filled with charming streets and tapas bars! Overnight stay at Valencia.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Valencia – Seville",
        desc: "After Breakfast Check-out from Valencia Hotel. Train from Valencia to Seville. Travelling by train from Valencia to Seville is a great way to see Spain's diverse landscapes! The journey takes around 6-8 hours, depending on the train and route. You can take the AVE high-speed train with a change in Madrid, or opt for a more scenic route with Renfe's Intercity trains. Some popular trains include: AVE: High-speed train with a change in Madrid (around 6 hours); Renfe Intercity: Scenic route with multiple changes (around 8 hours). Welcome to Seville! Seville, the Pearl of Andalusia, is a city of passion, history, and beauty! Known for its stunning architecture, rich culture, and vibrant flamenco music, Seville is a must-visit destination. Overnight stay at Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Seville - Seville 01 Day Hop on Hop off bus tour",
        desc: "Breakfast at Hotel. After breakfast proceed to Seville Hop on Hop off Bus Tour - Hop on board one of bright red buses to see the best of Seville - the artistic, cultural, and financial capital of southern Spain. With 14 bus stops around this historical masterpiece of a city, you will see so much from prestigious Islamic monuments, to gardens and Flamenco festivals. Sit back and enjoy the panoramic view from the open top bus and hop on and off at your convenience! Join the free walking tours to find out even more about Seville: discover Plaza de España and Maria Luisa Park, the Jewish quarter, Santa Cruz, with the buses providing audio commentary and free Wi-Fi. Overnight Stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Seville – Madrid",
        desc: "After Breakfast Check-out from Seville Hotel. Travelling by train from Seville to Madrid is an amazing experience! The AVE high-speed trains are super comfortable, and you can enjoy the beautiful Spanish countryside rolling by. The journey takes around 2.5-4 hours, depending on the train and class. Welcome Madrid! The vibrant capital of Spain, Madrid is a city of art, culture, and passion! Known for its stunning architecture, world-class museums, and lively nightlife, Madrid is a must-visit destination. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Madrid – Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
        desc: "After breakfast, enjoy the Madrid City Tour on SIC Basis, covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Afternoon and evening at leisure. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Madrid – Departure",
        desc: "After Breakfast Check-out from Madrid Hotel. After breakfast proceed to airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "07 Nights’ Accommodation with Breakfast",
        "Private Transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01 Day Hop on Hop off bus tour",
        "Madrid City Tour on SIC Basis (1.5hrs approx.)",
        "Seville 01 Day Hop on Hop off bus tour",
        "Private Transfer from Madrid Hotel to Madrid Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Barcelona – Valencia / Valencia – Seville / Seville – Madrid standard class train ticket – on actual basis",
          price: "EUR 180 – 200 per person",
        },
        { name: "Entrance to Park Guell", price: "EUR 22 per person" },
        { name: "Entrance to Sagrada Familia", price: "EUR 30 per person" },
        { name: "Entrance to Royal Alcázar", price: "EUR 32 per person" },
        { name: "Tour Bernabéu Entry Ticket", price: "EUR 37 per person" },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "NH Barcelona Eixample or Similar" },
            { location: "Valencia 1N", hotel: "Hotel Ilunion Valencia 3 or similar" },
            { location: "Seville 2N", hotel: "ibis Styles Sevilla Santa Justa or similar" },
            { location: "Madrid 2N", hotel: "Leonardo Boutique Hotel Madrid or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 737 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 715 per person onwards on Twin/Double sharing basis / EUR 674 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 702 per person onwards on Twin/Double sharing basis / EUR 648 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 469 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 398 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 840 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 818 per person onwards on Twin/Double sharing basis / EUR 713 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 805 per person onwards on Twin/Double sharing basis / EUR 687 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 674 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 309 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 782 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 760 per person onwards on Twin/Double sharing basis / EUR 738 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 747 per person onwards on Twin/Double sharing basis / EUR 712 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 461 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 403 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Valencia 1N", hotel: "Hotel Ilunion Valencia 4 or similar" },
            { location: "Seville 2N", hotel: "Hotel Sevilla Center or similar" },
            { location: "Madrid 2N", hotel: "Hotel Agora Juan De Austria or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 748 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 726 per person onwards on Twin/Double sharing basis / EUR 683 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 713 per person onwards on Twin/Double sharing basis / EUR 657 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 494 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 410 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 912 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 890 per person onwards on Twin/Double sharing basis / EUR 854 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 877 per person onwards on Twin/Double sharing basis / EUR 828 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 669 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 588 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 831 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 809 per person onwards on Twin/Double sharing basis / EUR 743 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 796 per person onwards on Twin/Double sharing basis / EUR 717 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 458 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 455 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/val7/day-1.jpg",
      "/images/val7/day-2.jpg",
      "/images/val7/day-3.jpg",
      "/images/val7/day-4.jpg",
      "/images/val7/day-5.jpg",
      "/images/val7/day-6.jpg",
      "/images/val7/day-7.jpg",
      "/images/val7/extra1.jpg",
    ],
  },


  // ============================================================
  // 2) Best of Barcelona + Valencia + Malaga + Seville || 06N/07D
  // (Source: Barcelona_2N_Valencia_1N_Malaga_1N_Seville_2N.pdf)
  // ============================================================
  {
    title: "Best of Barcelona + Valencia + Malaga + Seville",
    slug: "barcelona-valencia-malaga-seville-06n",
    price: "EUR 618 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Malaga/day-1.jpg",
    location: "Barcelona, Valencia, Malaga, Seville",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4 Destinations, 06 Nights",
        places: "Barcelona, Valencia, Malaga, Seville",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Airport Transfers",
      ],

      highlights: [
        "Sagrada Familia",
        "Park Güell",
        "City of Arts and Sciences, Valencia",
        "Málaga – birthplace of Picasso",
        "Royal Alcázar, Seville",
        "Plaza de España, Seville",
        "Maria Luisa Park, Seville",
        "Santa Cruz Jewish Quarter, Seville",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off Tours",
          desc: "Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi.",
        },
        {
          title: "Seville 01 Day Hop on Hop off Bus Tour",
          desc: "Hop on board one of bright red buses to see the best of Seville - the artistic, cultural, and financial capital of southern Spain. With 14 bus stops around this historical masterpiece of a city, you will see so much from prestigious Islamic monuments, to gardens and Flamenco festivals. Sit back and enjoy the panoramic view from the open top bus and hop on and off at your convenience! Join the free walking tours to find out even more about Seville: discover Plaza de España and Maria Luisa Park, the Jewish quarter, Santa Cruz, with the buses providing audio commentary and free Wi-Fi.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Barcelona – Arrival",
        desc: "Welcome to Barcelona – The City of Gaudí! Your adventure begins with a smooth transfer from the airport to your hotel, where you'll be ready to immerse yourself in the magic of Barcelona. Whether you're here for the art, the culture, the fashion, or the food, Barcelona offers an abundance of experiences waiting to be explored. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Barcelona hop-on hop-off tours",
        desc: "Breakfast at Hotel. After breakfast proceed to Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona - Valencia",
        desc: "After Breakfast Check-out from Barcelona Hotel. Train from Barcelona to Valencia. Travelling by train from Barcelona to Valencia you can take the AVE high-speed train, which takes around 3-3.5 hours, or the Euromed train, which takes around 3-4 hours. Both trains offer comfortable seating, Wi-Fi, and scenic views of the Mediterranean coast. Some popular trains include: AVE: High-speed train (around 3 hours); Euromed: High-speed train (around 3-4 hours); Iryo: Modern, high-speed train (around 3 hours). Welcome to Valencia! Valencia, the City of Arts and Sciences, is a vibrant and stunning destination on Spain's eastern coast. Known for its beautiful beaches, futuristic architecture, and rich cultural heritage, Valencia is a must-visit! Enjoy the city's delicious cuisine, including paella, and explore the historic center, filled with charming streets and tapas bars! Overnight stay at Valencia.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Valencia - Malaga",
        desc: "After Breakfast Check-out from Valencia Hotel. Train from Valencia to Malaga. The train journey from Valencia to Malaga is a great way to see Spain's southern landscapes! You can take the AVE high-speed train, which takes around 4-5 hours with a change in Madrid or direct. Some popular trains include: AVE: High-speed train (around 4-5 hours); Renfe Intercity: Scenic route with multiple changes (around 6-8 hours). Welcome to Malaga! Málaga, the birthplace of Picasso, is a vibrant coastal city with a rich history, stunning architecture, and beautiful beaches! Known for its warm climate, tapas, and cultural heritage, Málaga is a fantastic destination. Overnight stay at Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Malaga – Seville",
        desc: "After Breakfast Check-out from Valencia Hotel. Train from Valencia to Seville. Travelling by train from Valencia to Seville is a great way to see Spain's diverse landscapes! The journey takes around 6-8 hours, depending on the train and route. You can take the AVE high-speed train with a change in Madrid, or opt for a more scenic route with Renfe's Intercity trains. Some popular trains include: AVE: High-speed train with a change in Madrid (around 6 hours); Renfe Intercity: Scenic route with multiple changes (around 8 hours). Welcome to Seville! Seville, the Pearl of Andalusia, is a city of passion, history, and beauty! Known for its stunning architecture, rich culture, and vibrant flamenco music, Seville is a must-visit destination. Overnight stay at Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Seville - Seville 01 Day Hop on Hop off bus tour",
        desc: "Breakfast at Hotel. After breakfast proceed to Seville Hop on Hop off Bus Tour - Hop on board one of bright red buses to see the best of Seville - the artistic, cultural, and financial capital of southern Spain. With 14 bus stops around this historical masterpiece of a city, you will see so much from prestigious Islamic monuments, to gardens and Flamenco festivals. Sit back and enjoy the panoramic view from the open top bus and hop on and off at your convenience! Join the free walking tours to find out even more about Seville: discover Plaza de España and Maria Luisa Park, the Jewish quarter, Santa Cruz, with the buses providing audio commentary and free Wi-Fi. Overnight Stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Seville – Departure",
        desc: "After Breakfast Check-out from Madrid Hotel. After breakfast proceed to airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights’ Accommodation with Breakfast",
        "Private Transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01 Day Hop on Hop off bus tour",
        "Seville 01 Day Hop on Hop off bus tour",
        "Private Transfer from Seville Hotel to Seville Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Barcelona – Valencia / Valencia – Malaga / Malaga – Seville standard class train ticket – on actual basis",
          price: "EUR 185 – 195 per person",
        },
        { name: "Entrance to Park Guell", price: "EUR 22 per person" },
        { name: "Entrance to Sagrada Familia", price: "EUR 30 per person" },
        { name: "Entrance to Royal Alcázar", price: "EUR 32 per person" },
        { name: "Tour Bernabéu Entry Ticket", price: "EUR 37 per person" },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "NH Barcelona Eixample or Similar" },
            { location: "Valencia 1N", hotel: "Hotel Ilunion Valencia 3 or similar" },
            { location: "Malaga 1N", hotel: "Líbere Málaga Trinidad or Similar" },
            { location: "Seville 2N", hotel: "ibis Styles Sevilla Santa Justa or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 618 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 616 per person onwards on Twin/Double sharing basis / EUR 596 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 604 per person onwards on Twin/Double sharing basis / EUR 584 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 531 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 430 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 690 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 668 per person onwards on Twin/Double sharing basis / EUR 636 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 656 per person onwards on Twin/Double sharing basis / EUR 624 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 497 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 530 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 678 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 656 per person onwards on Twin/Double sharing basis / EUR 556 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 644 per person onwards on Twin/Double sharing basis / EUR 544 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 471 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 230 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Valencia 1N", hotel: "Hotel Ilunion Valencia 4 or similar" },
            { location: "Malaga 1N", hotel: "Novotel Suites Malaga Centro or Similar" },
            { location: "Seville 2N", hotel: "Hotel Sevilla Centre or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 673 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 651 per person onwards on Twin/Double sharing basis / EUR 616 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 639 per person onwards on Twin/Double sharing basis / EUR 604 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 551 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 450 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 728 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 706 per person onwards on Twin/Double sharing basis / EUR 682 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 694 per person onwards on Twin/Double sharing basis / EUR 670 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 559 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 498 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 682 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 660 per person onwards on Twin/Double sharing basis / EUR 616 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 648 per person onwards on Twin/Double sharing basis / EUR 604 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 473 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 392 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Malaga/day-1.jpg",
      "/images/Malaga/day-2.jpg",
      "/images/Malaga/day-3.jpg",
      "/images/Malaga/day-4.jpg",
      "/images/Malaga/day-5.jpg",
      "/images/Malaga/day-6.jpg",

    ],

  },


  // ============================================================
  // 3) Best of Barcelona + Madrid || 04N/05D
  // (Source: Barcelona_2N_Madrid_2N.pdf)
  // ============================================================
  {
    title: "Best of Barcelona + Madrid",
    slug: "barcelona-madrid-04n",
    price: "EUR 543 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/madrid/day-3.jpg",
    location: "Barcelona, Madrid",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 04 Nights",
        places: "Barcelona, Madrid",
      },

      pills: [
        "Breakfast Included",
        "04 Nights Accommodation",
        "Private Airport Transfers",
      ],

      highlights: [
        "Sagrada Familia",
        "Park Güell",
        "Royal Palace, Madrid",
        "Prado Museum, Madrid",
        "Puerta de Alcalá, Madrid",
        "El Retiro Park, Madrid",
        "Royal Botanic Gardens, Madrid",
        "Cibeles Palace, Madrid",
        "Almudena Cathedral, Madrid",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off Tours",
          desc: "Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi.",
        },
        {
          title: "Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
          desc: "Covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Barcelona – Arrival",
        desc: "Welcome to Barcelona – The City of Gaudí! Your adventure begins with a smooth transfer from the airport to your hotel, where you'll be ready to immerse yourself in the magic of Barcelona. Whether you're here for the art, the culture, the fashion, or the food, Barcelona offers an abundance of experiences waiting to be explored. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Barcelona hop-on hop-off tours",
        desc: "Breakfast at Hotel. After breakfast proceed to Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona - Madrid",
        desc: "After Breakfast Check-out from Barcelona Hotel. Travelling by train from Barcelona to Madrid is a breeze! The high-speed train journey takes around 2 hours and 30 minutes, covering a distance of approximately 505 kilometers. You'll have plenty of options to choose from, with around 40-50 trains operating daily, including Renfe AVE, iryo, Ouigo, and Avlo. Welcome Madrid! The vibrant capital of Spain, Madrid is a city of art, culture, and passion! Known for its stunning architecture, world-class museums, and lively nightlife, Madrid is a must-visit destination. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Madrid – Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
        desc: "After breakfast, enjoy the Madrid City Tour on SIC Basis, covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Afternoon and evening at leisure. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Madrid – Departure",
        desc: "After Breakfast Check-out from Madrid Hotel. After breakfast proceed to airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "04 Nights’ Accommodation with Breakfast",
        "Private Transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01 Day Hop on Hop off bus tour",
        "Madrid City Tour on SIC Basis (1.5hrs approx.)",
        "Private Transfer from Madrid Hotel to Madrid Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Tour (Price is not applicable during fair/Events dates)",
      items: [
        { name: "Entrance to Park Guell", price: "EUR 22 per person" },
        { name: "Entrance to Sagrada Familia", price: "EUR 30 per person" },
        { name: "Entrance to Royal Alcázar", price: "EUR 32 per person" },
        { name: "Tour Bernabéu Entry Ticket", price: "EUR 37 per person" },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "NH Barcelona Eixample or Similar" },
            { location: "Madrid 2N", hotel: "Leonardo Boutique Hotel Madrid or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 543 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 521 per person onwards on Twin/Double sharing basis / EUR 476 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 508 per person onwards on Twin/Double sharing basis / EUR 460 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 297 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 249 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 617 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 595 per person onwards on Twin/Double sharing basis / EUR 566 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 582 per person onwards on Twin/Double sharing basis / EUR 540 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 399 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 341 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 580 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 558 per person onwards on Twin/Double sharing basis / EUR 511 per person on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 545 per person onwards on Twin/Double sharing basis / EUR 465 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 268 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 210 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Madrid 2N", hotel: "Hotel Agora Juan De Austria or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 549 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 527 per person onwards on Twin/Double sharing basis / EUR 481 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 524 per person onwards on Twin/Double sharing basis / EUR 485 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 305 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 142 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 635 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 613 per person onwards on Twin/Double sharing basis / EUR 602 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 600 per person onwards on Twin/Double sharing basis / EUR 576 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 471 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 413 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 585 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 563 per person onwards on Twin/Double sharing basis / EUR 551 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 550 per person onwards on Twin/Double sharing basis / EUR 485 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 348 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 290 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/madrid/day-1.jpg",
      "/images/madrid/day-2.jpg",
      "/images/madrid/day-3.jpg",
      "/images/madrid/day-4.jpg",
      "/images/madrid/day-5.jpg",
      "/images/madrid/day-6.jpg",
      "/images/madrid/day-7.jpg",
      "/images/madrid/day-8.jpg",
      "/images/madrid/day-9.jpg",
      "/images/madrid/extra1.jpg",
      "/images/madrid/extra2.jpg",
      "/images/madrid/extra3.jpg",
    ],
  },


  // ============================================================
  // 4) Best of Barcelona + Ibiza + Madrid || 06N/07D
  // (Source: Barcelona_2N_Ibiza_2N_Madrid_2N.pdf)
  // ============================================================
  {
    title: "Best of Barcelona + Ibiza + Madrid",
    slug: "barcelona-ibiza-madrid-06n",
    price: "EUR 780 per person onwards", // lowest 02 Pax rate in PDF (3* Hotel, Twin/Double, Jan/Feb/Nov/Dec 2026)
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Ibiza/day-1.jpg",
    location: "Barcelona, Ibiza, Madrid",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Barcelona, Ibiza, Madrid",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Sagrada Familia",
        "Park Güell",
        "Ibiza Town (Eivissa)",
        "Royal Palace, Madrid",
        "Prado Museum, Madrid",
        "Puerta de Alcalá, Madrid",
        "El Retiro Park, Madrid",
        "Royal Botanic Gardens, Madrid",
        "Cibeles Palace, Madrid",
        "Almudena Cathedral, Madrid",
      ],

      experiences: [
        {
          title: "Barcelona Hop-On Hop-Off Tours",
          desc: "Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi.",
        },
        {
          title: "Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
          desc: "Covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Barcelona – Arrival",
        desc: "Welcome to Barcelona – The City of Gaudí! Your adventure begins with a smooth transfer from the airport to your hotel, where you'll be ready to immerse yourself in the magic of Barcelona. Whether you're here for the art, the culture, the fashion, or the food, Barcelona offers an abundance of experiences waiting to be explored. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Barcelona hop-on hop-off tours",
        desc: "Breakfast at Hotel. After breakfast proceed to Barcelona hop-on hop-off tours are a convenient way to see the city's main attractions using a double-decker bus that runs on two different routes. You can purchase 24- or 48-hour passes that allow unlimited stops at key landmarks like the Sagrada Familia and Park Güell, with the buses providing audio commentary and free Wi-Fi. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona - Ibiza",
        desc: "After Breakfast Check-out from Barcelona Hotel. After breakfast, check out and proceed to the airport for your flight to Ibiza. Upon arrival, take your private transfer to your hotel. Rest of the day at leisure on the island. Welcome to Ibiza! The White Island, Ibiza, is a paradise of sun, sea, and vibrant nightlife! Known for its stunning beaches, crystal-clear waters, and world-class clubs, Ibiza is a top destination for travellers. Overnight stay at Ibiza.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Ibiza – Day Free",
        desc: "Breakfast at Hotel. You've got a whole day to unwind and soak up the Ibiza vibes. Whether you want to lounge on the beach, explore the charming old town, or try some delicious local cuisine, the island is all yours! Ibiza is known for its stunning beaches, vibrant nightlife, and beautiful landscapes. The main city is called Ibiza Town, also known as Eivissa. Overnight stay at Ibiza.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Ibiza - Madrid",
        desc: "After Breakfast Check-out from Ibiza Hotel. After breakfast, check out from your hotel and take your private transfer to Ibiza Airport for your onward journey to Madrid. Upon arrival, check in at your hotel and enjoy free time in the Spanish capital. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Madrid – Madrid City Tour (SIC Basis – 1.5 hrs approx.)",
        desc: "After breakfast, enjoy the Madrid City Tour on SIC Basis, covering key highlights of Madrid including historical monuments, iconic squares, and architectural landmarks. Afternoon and evening at leisure. Experience the best of Madrid on a Big Bus open-top sightseeing tour! Sit back and soak up the city's vibrant energy as your live guide shares the stories behind iconic landmarks like the Royal Palace, Prado Museum, and Puerta de Alcalá. Cruise through lush parks like El Retiro and the Royal Botanic Gardens, and marvel at stunning architecture like Cibeles Palace and Almudena Cathedral. Overnight stay at Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Madrid – Departure",
        desc: "After Breakfast Check-out from Madrid Hotel. After breakfast proceed to airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "06 Nights’ Accommodation with Breakfast",
        "Private Transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01 Day Hop on Hop off bus tour",
        "Private Transfer from Ibiza Airport to Ibiza Hotel",
        "Private Transfer from Ibiza Hotel to Ibiza Airport",
        "Madrid City Tour on SIC Basis (1.5hrs approx.)",
        "Private Transfer from Madrid Hotel to Madrid Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Tour (Price is not applicable during fair/Events dates)",
      items: [
        { name: "Entrance to Park Guell", price: "EUR 22 per person" },
        { name: "Entrance to Sagrada Familia", price: "EUR 30 per person" },
        { name: "Entrance to Royal Alcázar", price: "EUR 32 per person" },
        { name: "Tour Bernabéu Entry Ticket", price: "EUR 37 per person" },
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Ibiza 2N", hotel: "Eurostars Ibiza or Similar" },
            { location: "Madrid 2N", hotel: "Leonardo Boutique Hotel Madrid or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 780 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 726 per person onwards on Twin/Double sharing basis / EUR 656 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 695 per person onwards on Twin/Double sharing basis / EUR 606 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 290 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 277 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 906 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 862 per person onwards on Twin/Double sharing basis / EUR 767 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 831 per person onwards on Twin/Double sharing basis / EUR 736 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 453 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 385 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 841 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 787 per person onwards on Twin/Double sharing basis / EUR 741 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 756 per person onwards on Twin/Double sharing basis / EUR 681 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 438 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 380 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 2N", hotel: "Hotel Derby or Similar" },
            { location: "Ibiza 2N", hotel: "Eurostars Ibiza or Similar" },
            { location: "Madrid 2N", hotel: "Hotel Agora Juan De Austria or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov, Dec - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 805 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 751 per person onwards on Twin/Double sharing basis / EUR 717 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 730 per person onwards on Twin/Double sharing basis / EUR 686 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 375 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 297 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 966 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 921 per person onwards on Twin/Double sharing basis / EUR 781 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 861 per person onwards on Twin/Double sharing basis / EUR 751 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 468 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 410 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sept, Oct - 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 821 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 767 per person onwards on Twin/Double sharing basis / EUR 727 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 736 per person onwards on Twin/Double sharing basis / EUR 696 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 523 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 465 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Ibiza/day-1.jpg",
      "/images/Ibiza/day-2.jpg",
      "/images/Ibiza/day-3.jpg",
      "/images/Ibiza/day-4.jpg",
      "/images/Ibiza/day-5.jpg",
      "/images/Ibiza/day-6.jpg",
      "/images/Ibiza/extra1.jpg",
      "/images/Ibiza/extra2.jpg",
      "/images/Ibiza/extra3.jpg",
      "/images/Ibiza/extra4.jpg",
    ],
  },

  {
    title: "From Gaudí’s Barcelona to Andalusian Seville",
    slug: "barcelona-madrid-seville-08n",
    price: "EUR 1066 per person onwards",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/gau/day-1.jpg",
    location: "Barcelona, Madrid, Seville",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 08 Nights",
        places: "Barcelona, Madrid, Seville",
      },

      pills: [
        "Breakfast Included",
        "08 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Sagrada Família",
        "Montserrat",
        "Girona",
        "Costa Brava",
        "Madrid Panoramic Bus Tour",
        "Royal Palace",
        "Segovia",
        "Toledo",
        "Seville Hop-On Hop-Off",
        "Royal Alcázar of Seville",
        "Flamenco Show",
      ],

      experiences: [
        {
          title: "Barcelona – City Tour with Hop-On Hop-Off & Sagrada Família",
          desc: "Explore Barcelona at your own pace on a 1-day Hop-On Hop-Off bus tour, enjoying panoramic city views and informative audio guides. Later, visit the Sagrada Família, celebrated for its unique architecture, intricate façades, and stunning interior designed by Antoni Gaudí.",
        },
        {
          title: "Barcelona – Day Trip to Montserrat, Girona & Costa Brava",
          desc: "Take a full day SIC tour to Montserrat, Girona, and the Costa Brava, exploring breathtaking landscapes, historic landmarks, and charming Mediterranean coves. Discover the mountain monastery of Montserrat, stroll through Girona’s medieval streets, and relax along the picturesque beaches and seaside towns of the Costa Brava.",
        },
        {
          title: "Madrid – Panoramic Bus Tour & Royal Palace",
          desc: "Start your day with a panoramic bus tour of Madrid, enjoying views of the city’s iconic landmarks, historic streets, and cultural highlights with a live guide. Later, visit the Royal Palace to admire its grand architecture, opulent interiors, and centuries of royal history.",
        },
        {
          title: "Madrid – Day Trip to Segovia & Toledo",
          desc: "Enjoy a full day SIC tour to Segovia and Toledo, two of Spain’s most historic cities. In Segovia, marvel at the Roman aqueduct and explore the medieval castle. In Toledo, wander through ancient alleys, admiring its cathedrals, synagogues, and historic architecture.",
        },
        {
          title: "Seville – City Tour with Hop-On Hop-Off, Royal Alcázar & Flamenco Show",
          desc: "Explore Seville on a 1-day Hop-On Hop-Off bus tour. Later, visit the Royal Alcázar of Seville, renowned for its stunning Mudejar architecture and lush gardens. End the day with an authentic flamenco show at Teatro Flamenco Sevilla.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Barcelona",
        desc: "Welcome to Barcelona – The Cosmopolitan Jewel of Spain! Upon arrival at Barcelona Airport, you’ll be met for a private transfer to your city centre hotel. Settle in and get ready to explore a city famed for its architecture, culture, and vibrant energy. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – City Tour with Hop-On Hop-Off & Sagrada Família",
        desc: "Breakfast at the hotel. Explore Barcelona at your own pace on a 1-day Hop-On Hop-Off bus tour, enjoying panoramic city views and informative audio guides. Later, visit the Sagrada Família, the world’s largest unfinished Catholic church, celebrated for its unique architecture, intricate façades, and stunning interior designed by Antoni Gaudí. Overnight Stay in Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona – Day Trip to Montserrat, Girona & Costa Brava",
        desc: "Breakfast at the hotel. Take a full day SIC tour to Montserrat, Girona, and the Costa Brava, exploring breathtaking landscapes, historic landmarks, and charming Mediterranean coves. Discover the mountain monastery of Montserrat, stroll through Girona’s medieval streets, and relax along the picturesque beaches and seaside towns of the Costa Brava. Overnight stay at Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Barcelona – Madrid",
        desc: "Breakfast at the hotel. Private transfer to Barcelona Sants station and board the high-speed train to Madrid Atocha. On arrival, enjoy a private transfer to your Madrid city centre hotel for check-in and relaxation. Overnight in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Madrid - Panoramic Bus Tour & Royal Palace Visit",
        desc: "Breakfast at the hotel. Start your day with a panoramic bus tour of Madrid, enjoying views of the city’s iconic landmarks, historic streets, and cultural highlights with a live guide. Later, visit the Royal Palace to admire its grand architecture, opulent interiors, and centuries of royal history. Overnight stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Madrid - Day Trip to Segovia & Toledo from Madrid",
        desc: "Breakfast at the hotel. Enjoy a full day SIC tour to Segovia and Toledo, two of Spain’s most historic cities. In Segovia, marvel at the Roman aqueduct and explore the medieval castle. In Toledo, wander through ancient alleys, admiring its cathedrals, synagogues, and historic architecture, and experience the city’s unique cultural heritage. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Madrid – Seville",
        desc: "Breakfast at the hotel. Private transfer from your Madrid city centre hotel to the train station. Board the high-speed train from Madrid Atocha to Sevilla Santa Justa. On arrival, a private transfer will take you to your Seville hotel to relax and settle in. Overnight Stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Seville – City Tour with Hop-On Hop-Off, Royal Alcázar & Flamenco Show",
        desc: "Breakfast at the hotel. Explore Seville on a 1-day Hop-On Hop-Off bus tour, enjoying panoramic city views and the flexibility to explore at your own pace. Later, visit the Royal Alcázar of Seville. End the day with an authentic flamenco show at Teatro Flamenco Sevilla. Overnight Stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Seville – Departure",
        desc: "Breakfast at the hotel. Private transfer from your Seville hotel to Seville Airport (SVQ) for your onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    inclusions: {
      included: [
        "08 Nights Accommodation with Breakfast",
        "Private transfers between airports, hotels, and train stations",
        "01 Day Barcelona Hop-on Hop-off Bus ticket",
        "Sagrada Família entrance ticket",
        "Day trip to Montserrat, Girona & Costa Brava from Barcelona on SIC basis",
        "Madrid Panoramic Bus tour ticket – Single ride",
        "Royal Palace entrance ticket",
        "Day trip to Segovia and Toledo from Madrid on SIC basis",
        "01 Day Seville Hop-on Hop-off Bus ticket",
        "Royal Alcázar of Seville entrance ticket",
        "Flamenco show ticket",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    supplementaryTours: {
      note: "Optional Cost for Train (Price is not applicable during fair/Events dates)",
      items: [
        {
          name: "Barcelona – Madrid – Seville 02nd class train ticket – on actual basis",
          price: "EUR 135 – 185 onwards per person",
        },
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            { location: "Barcelona 3N", hotel: "Barcelona Century Hotel or similar" },
            { location: "Madrid 3N", hotel: "Petit Palace Preciados or similar" },
            { location: "Seville 2N", hotel: "Patio De La Alameda or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1066 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 955 per person onwards on Twin/Double sharing basis / EUR 937 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 921 per person onwards on Twin/Double sharing basis / EUR 901 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 622 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 459 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1514 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1402 per person onwards on Twin/Double sharing basis / EUR 1219 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1369 per person onwards on Twin/Double sharing basis / EUR 1184 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 577 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 885 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1333 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1222 per person onwards on Twin/Double sharing basis / EUR 1208 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1188 per person onwards on Twin/Double sharing basis / EUR 1179 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 906 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 713 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            { location: "Barcelona 3N", hotel: "Leonardo Royal Hotel Barcelona or similar" },
            { location: "Madrid 3N", hotel: "Hotel ILUNION Suites Madrid or similar" },
            { location: "Seville 2N", hotel: "Hotel Exe Sevilla Palmera or similar" },
          ],
          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1091 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 980 per person onwards on Twin/Double sharing basis / EUR 959 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 946 per person onwards on Twin/Double sharing basis / EUR 927 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 655 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 486 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1615 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1494 per person onwards on Twin/Double sharing basis / EUR 1448 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1470 per person onwards on Twin/Double sharing basis / EUR 1426 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1171 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 984 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct: 2026",
              rows: [
                { pax: "02 Pax", price: "EUR 1386 per person onwards on Twin/Double sharing basis" },
                { pax: "04 Pax", price: "EUR 1276 per person onwards on Twin/Double sharing basis / EUR 1264 per person onwards on Triple sharing basis" },
                { pax: "06 Pax", price: "EUR 1242 per person onwards on Twin/Double sharing basis / EUR 1232 per person onwards on Triple sharing basis" },
                { pax: "Child Sharing with Extra Bed", price: "EUR 1040 per child onwards" },
                { pax: "Single Room Supplement", price: "EUR 766 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/gau/day-1.jpg",
      "/images/gau/day-2.jpg",
      "/images/gau/day-3.jpg",
      "/images/gau/day-4.jpg",
      "/images/gau/day-5.jpg",
      "/images/gau/day-6.jpg",
      "/images/gau/day-7.jpg",
      "/images/gau/day-8.jpg",
      "/images/gau/extra1.jpg",
      "/images/gau/extra2.jpg",
      "/images/gau/extra3.jpg",
    ],
  },

  {
    title: "Spanish–French Riviera Delight",
    slug: "barcelona-nice-06n",
    price: "EUR 715 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Spanish/day-1.jpg",
    location: "Barcelona, Nice",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "Barcelona, Nice",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Sagrada Familia",
        "Barcelona Hop-on Hop-off",
        "Montserrat",
        "Cogwheel Train",
        "Black Madonna",
        "Nice Hop-on Hop-off",
        "French Riviera",
        "Èze",
        "Monaco",
        "Monte Carlo",
        "Saint-Paul-De-Vence",
        "Cannes",
      ],

      experiences: [
        {
          title: "Barcelona – Sagrada Familia & Hop-on Hop-off Tour",
          desc: "After breakfast, proceed for your full-day experience of Barcelona with the 01-Day Hop on Hop off bus tour, offering the perfect way to explore the city’s major highlights at your own pace. Your visit includes the Sagrada Familia Entry Ticket, allowing you to witness Antoni Gaudí’s masterpiece up close.",
        },
        {
          title: "Barcelona – Montserrat Tour",
          desc: "After breakfast, proceed for the Montserrat Tour with Cogwheel & Black Madonna on SIC basis. This journey takes you to Catalonia’s most famous mountain sanctuary, offering panoramic views, ancient Benedictine traditions, and the revered statue of the Black Madonna.",
        },
        {
          title: "Nice – Hop on Hop off Tour",
          desc: "After breakfast, proceed for your Nice 01-Day Hop on Hop off Bus Tour. This flexible sightseeing experience allows you to explore Nice's iconic landmarks including the Promenade des Anglais, Castle Hill, Old Town, and more, all while enjoying stunning coastal views along the way.",
        },
        {
          title: "Nice – French Riviera Day Tour",
          desc: "Today, proceed for the French Riviera Day Tour on SIC basis. Visit Èze, Monaco, Monte Carlo, Saint-Paul-De-Vence and Cannes, exploring charming seaside towns, scenic views and the timeless elegance of the Côte d’Azur.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Barcelona",
        desc: "Arrival in Barcelona. Upon arrival at Barcelona Airport, you will enjoy a smooth and comfortable private transfer to your hotel. Your first evening offers the perfect introduction to Barcelona with time to admire the illuminated streets, stroll along La Rambla, or soak in the energy of Plaça Catalunya. Overnight Stay in Barcelona.",
        tags: [],
      },
      {
        day: "02",
        title: "Barcelona – Sagrada Familia Entry Ticket & Barcelona Hop-on Hop-off Tour",
        desc: "Breakfast at Hotel. After breakfast, proceed for your full-day experience of Barcelona with the 01-Day Hop on Hop off bus tour. Your visit includes the Sagrada Familia Entry Ticket, allowing you to witness Antoni Gaudí’s masterpiece up close. Overnight Stay in Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Barcelona – Montserrat Tour",
        desc: "Breakfast at Hotel. After breakfast, proceed for the Montserrat Tour with Cogwheel & Black Madonna on SIC basis. The scenic cog-wheel train ride enhances the experience with breathtaking landscapes and peaceful surroundings. Overnight Stay in Barcelona.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Barcelona – Nice",
        desc: "Breakfast at Hotel. After breakfast, enjoy a private transfer from your Barcelona hotel to Barcelona Airport for your flight to Nice. Upon arrival in Nice, a private transfer will take you to your hotel. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Nice – Hop on Hop off Tour",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Nice 01-Day Hop on Hop off Bus Tour. Explore Nice's iconic landmarks including the Promenade des Anglais, Castle Hill, Old Town, and more. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Nice – French Riviera Day Tour",
        desc: "Breakfast at Hotel. Today, proceed for the French Riviera Day Tour on SIC basis. Visit the medieval village of Èze, the Principality of Monaco, Monte Carlo, Saint-Paul-De-Vence and Cannes. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Nice – Departure",
        desc: "Breakfast at Hotel. After breakfast, proceed to Nice Airport with a private transfer for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights’ Accommodation with breakfast",
        "Private transfer from Barcelona Airport to Barcelona Hotel",
        "Barcelona 01-Day Hop on Hop off bus tour",
        "Sagrada Familia entry ticket",
        "Montserrat Tour with Cogwheel & Black Madonna from Barcelona on SIC basis",
        "Private transfer from Barcelona Hotel to Barcelona Airport",
        "Private transfer from Nice Airport to Nice Hotel",
        "Nice 01-Day Hop on Hop off bus tour",
        "French Riviera Day tour from Nice on SIC basis",
        "Private transfer from Nice Hotel to Nice Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            {
              location: "Barcelona 3N",
              hotel: "Hotel Glories Barcelona or similar",
            },
            {
              location: "Nice 3N",
              hotel: "Hotel Relais Acropolis or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 960 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 912 per person onwards on Twin/Double sharing basis / EUR 761 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 888 per person onwards on Twin/Double sharing basis / EUR 737 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 335 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 564",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 882 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 834 per person onwards on Twin/Double sharing basis / EUR 723 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 810 per person onwards on Twin/Double sharing basis / EUR 699 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 377 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 486",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 715 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 667 per person onwards on Twin/Double sharing basis / EUR 622 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 643 per person onwards on Twin/Double sharing basis / EUR 598 per person onwards on Triple sharing basis",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            {
              location: "Barcelona",
              hotel: "Hotel Gotico or similar",
            },
            {
              location: "Nice",
              hotel: "Novotel Nice Centre Vieux Nice or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1153 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1105 per person onwards on Twin/Double sharing basis / EUR 1090 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1081 per person onwards on Twin/Double sharing basis / EUR 1066 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 936 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 757",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 932 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 934 per person onwards on Twin/Double sharing basis / EUR 918 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 910 per person onwards on Twin/Double sharing basis / EUR 894 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 862 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 536",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 915 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 867 per person onwards on Twin/Double sharing basis / EUR 734 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 843 per person onwards on Twin/Double sharing basis / EUR 710 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 344 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 519",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Spanish/day-1.jpg",
      "/images/Spanish/day-2.jpg",
      "/images/Spanish/day-3.jpg",
      "/images/Spanish/day-4.jpg",
      "/images/Spanish/day-5.jpg",
      "/images/Spanish/day-6.jpg",
      "/images/Spanish/extra1.jpg",
      "/images/Spanish/extra2.jpg",
    ],
  },

  {
    title: "Best of Seville + Lisbon + Porto",
    slug: "seville-lisbon-porto-05n",
    price: "EUR 638 per person onwards",
    days: "05 Nights / 06 Days",
    rating: "4.9",
    image: "/images/porto/day-1.jpg",
    location: "Seville, Lisbon, Porto",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 05 Nights",
        places: "Seville, Lisbon, Porto",
      },

      pills: [
        "Breakfast Included",
        "05 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Seville Hop-on Hop-off",
        "Plaza de España",
        "Maria Luisa Park",
        "Santa Cruz",
        "Lisbon Hop-on Hop-off",
        "Jerónimos Monastery",
        "Belém Tower",
        "Baixa",
        "Porto",
        "Ribeira",
        "Douro River",
      ],

      experiences: [
        {
          title: "Seville – 01 Day Hop on Hop off Bus Tour",
          desc: "Hop aboard the iconic red double-decker bus and explore Seville’s most celebrated landmarks at your own pace. With 14 convenient stops, you can visit prestigious Islamic monuments, lush gardens, and enjoy the essence of Andalusian culture. Additional free walking tours cover Plaza de España, Maria Luisa Park, and the Jewish Quarter of Santa Cruz.",
        },
        {
          title: "Lisbon – 01 Day Hop-On Hop-Off Bus Tour",
          desc: "Discover Lisbon’s highlights aboard an open-top sightseeing bus, offering the flexibility to explore iconic attractions such as the Jerónimos Monastery, Belém Tower, and the historic Baixa district.",
        },
        {
          title: "Lisbon – Porto",
          desc: "Travel from Lisbon to Porto. Travelling from Lisbon to Porto by train is a fantastic option, with trains running frequently throughout the day. Porto is known for its enchanting old town, stunning riverfront, and world-famous port wine.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Seville – Arrival",
        desc: "Welcome to Seville – The Pearl of Andalusia! Your adventure begins with a smooth private transfer from Seville Airport to your hotel. Once you arrive, settle in and get ready to experience one of Spain’s most enchanting cities, famous for its Moorish architecture, flamenco rhythms, and historic charm. Overnight stay in Seville.",
        tags: [],
      },
      {
        day: "02",
        title: "Seville – Seville 01 Day Hop on Hop Off Bus Tour",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Seville Hop On Hop Off Bus Tour. Hop aboard the iconic red double-decker bus and explore Seville’s most celebrated landmarks at your own pace. Enjoy open-top views, onboard audio commentary, free Wi-Fi, and additional free walking tours covering Plaza de España, Maria Luisa Park, and the atmospheric Jewish Quarter of Santa Cruz. Overnight stay in Seville.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Seville – Lisbon",
        desc: "Breakfast at Hotel. After breakfast, check out from the hotel. A private transfer will take you to Seville Airport for your onward flight to Lisbon. Upon arrival in Lisbon, a private transfer will comfortably take you to your hotel. Enjoy your day at leisure to explore the city’s atmospheric neighborhoods or relax at your hotel. Overnight stay in Lisbon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Lisbon – Lisbon 01 Day Hop-On Hop-Off Bus Tour",
        desc: "Breakfast at Hotel. After breakfast, proceed for your Lisbon Hop-On Hop-Off Bus Tour. Discover Lisbon’s highlights aboard an open-top sightseeing bus, offering the flexibility to explore iconic attractions such as the Jerónimos Monastery, Belém Tower, and the historic Baixa district. Overnight stay in Lisbon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Lisbon – Porto",
        desc: "Breakfast at Hotel. After breakfast, check out from the hotel and travel to Porto. Travelling from Lisbon to Porto by train is a fantastic option, with trains running frequently throughout the day. Welcome to Porto – Portugal’s city of bridges, wine, and riverside charm! Overnight stay in Porto.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Porto – Departure",
        desc: "Breakfast at Hotel. After breakfast, check out from the hotel. A private transfer will take you from your Porto hotel to Porto Airport for your departure flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "05 Nights’ Accommodation with Breakfast",
        "Private Transfer from Seville Airport to Seville Hotel",
        "Seville 01 Day Hop on Hop off bus tour",
        "Private Transfer from Seville Hotel to Seville Airport",
        "Private Transfer from Lisbon Airport to Lisbon Hotel",
        "Lisbon 01 Day Hop-On Hop-Off Bus Tour",
        "Private Transfer from Porto Hotel to Porto Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            {
              location: "Seville 2N",
              hotel: "ibis Styles Sevilla Santa Justa or similar",
            },
            {
              location: "Lisbon 2N",
              hotel: "Ibis Styles Lisboa Centro Liberdade Ne or similar",
            },
            {
              location: "Porto 1N",
              hotel: "Holiday Inn Express Porto City Centre or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 638 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 596 per person onwards on Twin/Double sharing basis / EUR 511 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 572 per person onwards on Twin/Double sharing basis / EUR 487 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 354 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 165 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 643 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 601 per person onwards on Twin/Double sharing basis / EUR 591 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 577 per person onwards on Twin/Double sharing basis / EUR 567 per person onwards on Triple sharing basis",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 643 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 591 per person onwards on Twin/Double sharing basis / EUR 531 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 557 per person onwards on Twin/Double sharing basis / EUR 507 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 324 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 210 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            {
              location: "Seville 2N",
              hotel: "Hotel Sevilla Center or similar",
            },
            {
              location: "Lisbon 2N",
              hotel: "Novotel Lisboa or similar",
            },
            {
              location: "Porto 1N",
              hotel: "Eurostars das Artes or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 648 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 606 per person onwards on Twin/Double sharing basis / EUR 571 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 582 per person onwards on Twin/Double sharing basis / EUR 547 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 434 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 385 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 698 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 646 per person onwards on Twin/Double sharing basis / EUR 571 per person onwards on Triple sharing basis",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 658 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 616 per person onwards on Twin/Double sharing basis / EUR 591 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 592 per person onwards on Twin/Double sharing basis / EUR 567 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 384 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 384 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Lisbon – Porto Standard Class Train Ticket",
        price: "EUR 76 – 90 per person onwards",
        note: "On actual basis",
      },
      {
        name: "Entrance to Park Guell",
        price: "EUR 22 per person",
      },
      {
        name: "Entrance to Sagrada Familia",
        price: "EUR 30 per person",
      },
      {
        name: "Entrance to Royal Alcázar",
        price: "EUR 32 per person",
      },
      {
        name: "Tour Bernabéu Entry Ticket",
        price: "EUR 37 per person",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/porto/day-1.jpg",
      "/images/porto/day-2.jpg",
      "/images/porto/day-3.jpg",
      "/images/porto/day-4.jpg",
      "/images/porto/day-5.jpg",
      "/images/porto/extra1.jpg",
    ]
  },

  {
    title: "From Spain’s Royal Cities to Portugal’s Coastal Wonders",
    slug: "madrid-lisbon-faro-08n",
    price: "EUR 1003 per person onwards",
    days: "08 Nights / 09 Days",
    rating: "",
    image: "/images/royal/day-1.jpg",
    location: "Madrid, Lisbon, Faro",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 08 Nights",
        places: "Madrid, Lisbon, Faro",
      },

      pills: [
        "Breakfast Included",
        "08 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Madrid Panoramic Bus Tour",
        "Royal Palace",
        "Segovia",
        "Toledo",
        "Lisbon Hop-on Hop-off",
        "Jerónimos Monastery",
        "Belém Tower",
        "Sintra",
        "Pena Palace",
        "Quinta da Regaleira",
        "Cabo da Roca",
        "Cascais",
        "Benagil Cave",
        "Marinha Beach",
      ],

      experiences: [
        {
          title: "Madrid – Panoramic Bus Tour & Royal Palace",
          desc: "Start your day with a panoramic bus tour of Madrid, giving you an excellent overview of the city’s iconic landmarks, historic streets, and cultural highlights. Later, visit the Royal Palace and admire its grand architecture, lavish interiors, and priceless art collections.",
        },
        {
          title: "Madrid – Day Trip to Segovia & Toledo",
          desc: "Embark on a full-day SIC tour to Segovia and Toledo. In Segovia, see the remarkable Roman aqueduct and explore the Alcázar of Segovia. In Toledo, stroll through cobblestone streets, visit magnificent cathedrals and synagogues, and admire the city’s blend of Christian, Jewish, and Muslim architecture.",
        },
        {
          title: "Lisbon – Hop-On Hop-Off & Monuments",
          desc: "Discover Lisbon at your own pace on a 1-day Hop-On Hop-Off bus tour. Visit the Jerónimos Monastery and Belém Tower and explore Lisbon’s historic landmarks, architecture, and culture.",
        },
        {
          title: "Lisbon – Sintra, Pena, Regaleira, Cabo da Roca & Cascais",
          desc: "Take a full-day SIC tour to explore Sintra, Pena Palace, Quinta da Regaleira, Cabo da Roca and Cascais. Discover royal gardens, fairytale architecture, the Initiation Well, Atlantic views and the picturesque seaside town of Cascais.",
        },
        {
          title: "Faro – Benagil Cave & Marinha Beach",
          desc: "Embark on a half-day shared tour from Faro to Benagil Cave and Marinha Beach. Marvel at the stunning cliffs, turquoise waters, hidden grottos and pristine sands of Marinha Beach.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Madrid",
        desc: "Welcome to Madrid – The Heart of Spain! Upon arrival at Madrid Airport, you’ll be met for a private transfer to your city centre hotel. Take some time to settle in and enjoy the atmosphere of Madrid. Overnight Stay in Madrid.",
        tags: [],
      },
      {
        day: "02",
        title: "Madrid – Panoramic Bus Tour & Royal Palace",
        desc: "Breakfast at the hotel. Start your day with a panoramic bus tour of Madrid, giving you an excellent overview of the city’s iconic landmarks, historic streets, and cultural highlights. Later, visit the Royal Palace, the official residence of Spain’s royal family. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Madrid – Day Trip to Segovia & Toledo",
        desc: "Breakfast at the hotel. Embark on a full-day SIC tour to Segovia and Toledo. In Segovia, see the remarkable Roman aqueduct and explore the Alcázar of Segovia. In Toledo, stroll through cobblestone streets, visit magnificent cathedrals and synagogues, and admire the city’s blend of Christian, Jewish, and Muslim architecture. Overnight Stay in Madrid.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Madrid – Lisbon",
        desc: "Breakfast at the hotel. Private transfer from your Madrid hotel to Madrid Airport (MAD) for your flight to Lisbon. Upon arrival at Lisbon Airport, enjoy a private transfer to your city centre hotel. Overnight Stay in Lisbon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Lisbon – Hop-On Hop-Off & Monuments",
        desc: "Breakfast at the hotel. Discover Lisbon at your own pace on a 1-day Hop-On Hop-Off bus tour. Admire sights like Belém Tower, Jerónimos Monastery, and São Jorge Castle. Visit the Jerónimos Monastery and continue to Belém Tower. Overnight Stay in Lisbon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Lisbon – Sintra, Pena, Regaleira, Cabo da Roca & Cascais",
        desc: "Breakfast at the hotel. Take a full-day SIC tour to explore the magical town of Sintra, the romantic Pena Palace, the mystical Quinta da Regaleira, the breathtaking cliffs of Cabo da Roca, and the charming seaside town of Cascais. Overnight Stay in Lisbon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Lisbon – Faro",
        desc: "Breakfast at the hotel. Private transfer from your Lisbon hotel to Lisbon Train Station. Board the train from Lisboa Oriente to Faro. On arrival, a private transfer to your Faro hotel will bring you to the heart of the Algarve region. Overnight Stay in Faro.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Faro – Benagil Cave & Marinha Beach",
        desc: "Breakfast at the hotel. Embark on a half-day shared tour from Faro to Benagil Cave and Marinha Beach, two of the Algarve’s most iconic coastal attractions. Overnight Stay in Faro.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Faro – Departure",
        desc: "Breakfast at the hotel. Private transfer from your Faro hotel to Faro Airport (FAO) for your onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "08 Nights Accommodation with Breakfast",
        "Private transfers between airports, hotels, and train stations",
        "Madrid Panoramic Bus tour ticket – Single ride",
        "Royal Palace entrance ticket",
        "Day trip to Segovia and Toledo from Madrid on SIC basis",
        "Lisbon 1-Day Hop-on Hop-off Bus ticket",
        "Jerónimos Monastery entrance ticket",
        "Belém Tower entrance ticket",
        "Day trip to Sintra, Pena, Regaleira, Cabo da Roca & Cascais from Lisbon on SIC basis",
        "Half-day trip to Benagil Cave & Marinha Beach from Faro on shared basis",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 3* Hotel",
          hotels: [
            {
              location: "Madrid 3N",
              hotel: "Petit Palace Preciados or similar",
            },
            {
              location: "Lisbon 3N",
              hotel: "Avenida Park or similar",
            },
            {
              location: "Faro 2N",
              hotel: "Hotel Occidental Faro or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1003 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 954 per person onwards on Twin/Double sharing basis / EUR 885 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 913 per person onwards on Twin/Double sharing basis / EUR 843 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 493 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 458 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1239 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1173 per person onwards on Twin/Double sharing basis / EUR 1151 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1132 per person onwards on Twin/Double sharing basis / EUR 1112 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 917 onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 665 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1214 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1146 per person onwards on Twin/Double sharing basis / EUR 1104 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1105 per person onwards on Twin/Double sharing basis / EUR 1068 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 612 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 635 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",
          hotels: [
            {
              location: "Madrid 3N",
              hotel: "Hotel ILUNION Suites Madrid or similar",
            },
            {
              location: "Lisbon 3N",
              hotel: "Eurostars Lisboa Parque or similar",
            },
            {
              location: "Faro 2N",
              hotel: "Hotel Occidental Faro",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1006 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 938 per person onwards on Twin/Double sharing basis / EUR 908 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 897 per person onwards on Twin/Double sharing basis / EUR 866 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 595 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 442 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1334 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1268 per person onwards on Twin/Double sharing basis / EUR 1232 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1227 per person onwards on Twin/Double sharing basis / EUR 1193 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 980 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 755 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1284 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1216 per person onwards on Twin/Double sharing basis / EUR 1174 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1175 per person onwards on Twin/Double sharing basis / EUR 1138 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1101 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 705 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Lisbon - Faro 02nd class train ticket",
        price: "EUR 65 – 80 onwards",
        note: "On actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable.",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly.",
      "Driver tips to be paid directly.",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract.",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/royal/day-1.jpg",
      "/images/royal/day-2.jpg",
      "/images/royal/day-3.jpg",
      "/images/royal/day-4.jpg",
      "/images/royal/day-5.jpg",
      "/images/royal/day-6.jpg",
      "/images/royal/day-7.jpg",
      "/images/royal/day-8.jpg",
      "/images/royal/extra1.jpg",
    ]
  },


  {
    title: "Best of Paris + Lyon + Marseille",
    slug: "paris-lyon-marseille-06n",
    price: "EUR 974 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/pari/day-1.jpg",
    location: "Paris, Lyon, Marseille",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Paris, Lyon, Marseille",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Paris City Tour",
        "Seine River Cruise",
        "Eiffel Tower 2nd Level",
        "Lyon Walking Tour",
        "Old Lyon",
        "Traboules",
        "Fourvière Hill",
        "Presqu’île",
        "Marseille Walking Food Tour",
        "Food Tastings",
      ],

      experiences: [
        {
          title: "Paris – City Tour with River Cruise & Eiffel Tower",
          desc: "Explore Paris on a city tour covering iconic landmarks including the Eiffel Tower and Louvre, along with charming neighbourhoods such as Montmartre and Le Marais. Enjoy a Seine River Cruise and Eiffel Tower 2nd Level entry.",
        },
        {
          title: "Lyon – City Highlights Walking Tour",
          desc: "Explore Old Lyon, its famous traboules, Fourvière Hill exterior, and the Presqu’île district on a shared walking tour.",
        },
        {
          title: "Marseille – Walking Food Tour with Tastings",
          desc: "Experience Marseille with a local guide while exploring historic eateries, modern cafes and trendy restaurants. Sample local gastronomic specialties and learn about the city’s history and culinary culture.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Paris",
        desc: "Welcome to Paris – The City of Lights! Your adventure begins with a smooth transfer from the airport to your hotel. Explore Paris through its art, culture, fashion and food. Overnight Stay in Paris.",
        tags: [],
      },
      {
        day: "02",
        title: "Paris – City tour with river cruise & Eiffel Tower",
        desc: "Breakfast at Hotel. After breakfast proceed to Paris city tour on SIC basis. Explore iconic landmarks like the Eiffel Tower and Louvre and charming neighbourhoods like Montmartre and Le Marais. Enjoy the Seine River Cruise and Eiffel Tower 2nd Level entry. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Paris – Lyon",
        desc: "Breakfast at Hotel. Private transfer from Paris Hotel to Paris Train Station. Train from Paris to Lyon in 2nd Class. Private transfer from Lyon Train Station to Lyon Hotel. Overnight Stay in Lyon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Lyon - City Highlights Walking Tour of Lyon",
        desc: "Breakfast at Hotel. Meeting Point: Office du Tourisme et des Congrès de la Métropole de Lyon. Explore Old Lyon, its famous traboules, Fourvière Hill exterior, and the Presqu’île district. Overnight Stay in Lyon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Lyon – Marseille",
        desc: "Breakfast at Hotel. Private transfer from Lyon Hotel to Lyon Train Station. Train from Lyon to Marseille in 2nd Class. Private transfer from Marseille Train Station to Marseille Hotel. Overnight Stay in Marseille.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Marseille – Walking Food Tour with Tastings",
        desc: "Breakfast at Hotel. Meeting Point: Meet your guide in front of the restaurant Le New Terrasse. Experience a food-lovers paradise while walking through the charming streets of Marseille with a local guide. Overnight Stay in Marseille.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Marseille – India",
        desc: "Breakfast at Hotel. Private transfer from Marseille Hotel to Marseille Airport. Flight Details: XXX | MRS – XXX | XXXHRS – XXXHRS.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights’ Accommodation with Breakfast",
        "Private transfer from Paris Airport (CDG) to Paris Hotel",
        "Paris city tour on SIC basis",
        "Seine River Cruise Ticket",
        "Eiffel Tower 2nd Level Entry Ticket",
        "Private transfer from Paris Hotel to Paris Train Station",
        "Private transfer from Lyon Train Station to Lyon Hotel",
        "City Highlights Walking Tour from Lyon on Shared basis",
        "Private transfer from Lyon Hotel to Lyon Train Station",
        "Private transfer from Marseille Train Station to Marseille Hotel",
        "Walking Food Tour with Tastings from Marseille on Shared basis",
        "Private transfer from Marseille Hotel to Marseille Airport",
        "Train/Tram/Bus ticket from Zurich hotel to airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Paris 2N",
              hotel: "Hotel vacances bleues provinces opera or Similar",
            },
            {
              location: "Lyon 2N",
              hotel: "Citadines Presqu'ile Lyon or similar",
            },
            {
              location: "Marseille 2N",
              hotel: "Ibis Marseille Centre Euroméd or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, March - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 974 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 904 per person onwards on Twin/Double sharing basis / EUR 872 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 885 per person onwards on Twin/Double sharing basis / EUR 812 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 332 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1540 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1087 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1064 per person onwards on Twin/Double sharing basis / EUR 1021 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1040 per person onwards on Twin/Double sharing basis / EUR 952 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 366 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1845 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1014 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 962 per person onwards on Twin/Double sharing basis / EUR 890 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 905 per person onwards on Twin/Double sharing basis / EUR 820 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 315 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 865 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Paris 2N",
              hotel: "BLOOM HOUSE HOTEL RESTAURANT & SPA PARIS or Similar",
            },
            {
              location: "Lyon 2N",
              hotel: "Novotel Lyon Gerland Musée des Confluences or similar",
            },
            {
              location: "Marseille 2N",
              hotel: "Novotel Marseille Centre Prado Vélodrome or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, March - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1090 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1062 per person onwards on Twin/Double sharing basis / EUR 997 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1015 per person onwards on Twin/Double sharing basis / EUR 979 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 434 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 770 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1272 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1139 per person onwards on Twin/Double sharing basis / EUR 1090 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1110 per person onwards on Twin/Double sharing basis / EUR 1079 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 384 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 844",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "Jan, Feb, March - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1112 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1019 per person onwards on Twin/Double sharing basis / EUR 999 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1010 per person onwards on Twin/Double sharing basis / EUR 989 per person onwards on Triple sharing basis",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Paris - Lyon - Marseille 02nd class train ticket",
        price: "EUR 250 - 270",
        note: "On actual basis",
      },
      {
        name: "Disneyland 01 Day 01 Park with transfer on SIC basis",
        price: "EUR 135",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/pari/day-1.jpg",
      "/images/pari/day-2.jpg",
      "/images/pari/day-3.jpg",
      "/images/pari/day-4.jpg",
      "/images/pari/day-5.jpg",
      "/images/pari/day-6.jpg",
      "/images/pari/day-7.jpg",
      "/images/pari/day-8.jpg",
      "/images/pari/extra1.jpg",
      "/images/pari/extra2.jpg",
    ]
  },

  {
    title: "France Grand Discovery: Paris, Marseille & French Riviera",
    slug: "paris-marseille-nice-09n",
    price: "EUR 1390 per person onwards",
    days: "09 Nights / 10 Days",
    rating: "",
    image: "/images/paris/day-1.jpg",
    location: "Paris, Marseille, Nice",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 09 Nights",
        places: "Paris, Marseille, Nice",
      },

      pills: [
        "Breakfast Included",
        "09 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Eiffel Tower 2nd Level",
        "Paris Hop-on Hop-off",
        "Seine River Cruise",
        "Disneyland Paris",
        "Marseille Hop-on Hop-off",
        "Musée de l’Illusion",
        "Calanques National Park",
        "Nice Hop-on Hop-off",
        "Monaco",
        "Monte-Carlo",
        "Èze",
      ],

      experiences: [
        {
          title: "Paris – Eiffel Tower & Hop-on Hop-off",
          desc: "Explore Paris with a 01-Day Hop-on Hop-off Bus Tour, Eiffel Tower 2nd Level Entry Ticket and Seine River Cruise.",
        },
        {
          title: "Paris – Disneyland",
          desc: "Enjoy a full day at Disneyland Paris with a 1-Day 1-Park Ticket including shuttle transfers.",
        },
        {
          title: "Marseille – City Tour & Musée de l’Illusion",
          desc: "Explore Marseille with a 1-day Hop On Hop Off Bus Tour covering the Old Port, Notre-Dame de la Garde, Fort Saint-Nicolas and Le Panier, followed by a visit to Musée de l’Illusion.",
        },
        {
          title: "Marseille – Calanques National Park",
          desc: "Enjoy a guided hike through Calanques National Park, exploring dramatic limestone cliffs, turquoise waters and scenic Mediterranean trails.",
        },
        {
          title: "Nice – Hop-on Hop-off",
          desc: "Explore Nice including the Old Town, Castle Hill, Matisse Museum, Cimiez Monastery and panoramic seaside views.",
        },
        {
          title: "Nice – Monaco, Monte-Carlo & Èze",
          desc: "Visit Èze, Monaco and Monte-Carlo, including the Prince’s Palace, Casino Square and scenic coastline.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Paris",
        desc: "Arrival in Paris. Upon arrival at Paris CDG Airport, a private transfer will take you to your hotel. Spend your first evening exploring the city at leisure. Overnight Stay in Paris.",
        tags: [],
      },
      {
        day: "02",
        title: "Eiffel Tower 2nd Level Entry Ticket & Paris Hop-on Hop-off Tour",
        desc: "Breakfast at Hotel. Begin your exploration of Paris with the 01-Day Hop-on Hop-off Bus Tour. Enjoy Eiffel Tower 2nd Level Entry and a Seine River Cruise offering views of Notre-Dame Cathedral, Musée d’Orsay and the Louvre. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Disneyland 1-Day 1-Park Ticket with Shuttle Transfer",
        desc: "Breakfast at Hotel. Enjoy a magical full day at Disneyland Paris with your 1-Day 1-Park Ticket including shuttle transfers. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Paris → Marseille by Train",
        desc: "After breakfast, check out and enjoy a private transfer from your Paris hotel to the train station. Board your high-speed train to Marseille. Upon arrival, private transfer from Marseille Train Station to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Marseille City Tour – Hop On Hop Off | Musée de l’Illusion",
        desc: "Breakfast at Hotel. Discover Marseille with a 1-day Hop On Hop Off Bus Tour. Explore the Old Port, Notre-Dame de la Garde, Fort Saint-Nicolas and Le Panier. Later visit Musée de l’Illusion, subject to availability.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Calanques National Park Guided Hike",
        desc: "Breakfast at Hotel. Embark on a guided hike in Calanques National Park on shared basis. Explore dramatic limestone cliffs, turquoise waters and scenic trails. Return to Marseille for an evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Marseille → Nice by Train",
        desc: "After breakfast, check out and proceed on a private transfer from your Marseille hotel to the train station. Board your train to Nice. Upon arrival, private transfer from Nice Train Station to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Nice Hop On Hop Off Tour",
        desc: "Discover Nice with a 1-day Hop on Hop Off Bus Tour on SIC basis, subject to availability. Explore the Old Town, Castle Hill, Matisse Museum, Cimiez Monastery and panoramic seaside views.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Monaco, Monte-Carlo & Èze Tour",
        desc: "Enjoy a spectacular SIC tour to Monaco, Monte-Carlo & Èze. Visit the medieval village of Èze, explore Monte-Carlo and witness the elegance of Monaco including the Prince’s Palace, Casino Square and scenic coastline.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "10",
        title: "Nice – Departure",
        desc: "After breakfast, check out from the hotel. A private transfer will take you to Nice Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "Accommodation with breakfast",
        "Private transfer from Paris CDG Airport to hotel",
        "Paris 01 day hop on hop off bus tour - SIC",
        "Seine river Cruise entry ticket only",
        "Eiffel 02 level entry ticket",
        "Disneyland 01-day 01 park entry ticket with Shuttle return transfer on Shared basis",
        "Private transfer from Paris hotel to train Station",
        "Private transfer from Marseille train Station to hotel",
        "Marseille 01 day hop on hop off bus tour",
        "Musee de l'Illusion Entry Ticket",
        "Calanques National Park Guided Hike From Marseille on Shared basis",
        "Private transfer from Marseille hotel to train Station",
        "Private transfer from Nice train Station to hotel",
        "Nice 01 day hop on hop off bus tour - SIC",
        "Monaco, Monte-Carlo & Eze Tour from Nice on SIC",
        "Private transfer from Nice Hotel to Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tours",
        "Return flight tickets",
        "Visa & insurance fees",
        "Water bottles",
        "Train ticket from Paris to Nice",
        "Optional tours",
        "Hotel city tax payable directly at the hotel",
        "Lunch & dinner",
        "Personal expenses such as laundry, drinks, telephone charges, or any item not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for coach drivers, etc.",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Paris 3N",
              hotel: "Hôtel Kabanel by HappyCulture or similar",
            },
            {
              location: "Marseille 3N",
              hotel: "ibis Marseille Centre Gare Saint-Charles or Similar",
            },
            {
              location: "Nice 3N",
              hotel: "Hotel Relais Acropolis or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1390 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1300 per person onwards on Twin/Double sharing basis / EUR 1183 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1253 per person onwards on Twin/Double sharing basis / EUR 1136 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 528 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 575 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1470 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1486 per person onwards on Twin/Double sharing basis / EUR 1336 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1439 per person onwards on Twin/Double sharing basis / EUR 1289 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 612 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 575 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1291 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1282 per person onwards on Twin/Double sharing basis / EUR 1162 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1236 per person onwards on Twin/Double sharing basis / EUR 1114 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 513 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 569 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Paris 3N",
              hotel: "Hôtel Les Matins de Paris & Spa - Paris 9e",
            },
            {
              location: "Marseille 3N",
              hotel: "Hotel NH Collection Marseille",
            },
            {
              location: "Nice 3N",
              hotel: "Hôtel Nice Excelsior by Happy Culture",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1909 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1820 per person onwards on Twin/Double sharing basis / EUR 1791 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1773 per person onwards on Twin/Double sharing basis / EUR 1746 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1380 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1070 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1470 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1486 per person onwards on Twin/Double sharing basis / EUR 1336 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1439 per person onwards on Twin/Double sharing basis / EUR 1289 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1035 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1121 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1513 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1482 per person onwards on Twin/Double sharing basis / EUR 1444 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1475 per person onwards on Twin/Double sharing basis / EUR 1376 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 983 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 748 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Paris – Marseille – Nice 02nd class train ticket",
        price: "EUR 85 - 95",
        note: "On actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/paris/day-1.jpg",
      "/images/paris/day-2.jpg",
      "/images/paris/day-3.jpg",
      "/images/paris/day-4.jpg",
      "/images/paris/day-5.jpg",
      "/images/paris/day-6.jpg",
      "/images/paris/day-7.jpg",
      "/images/paris/day-8.jpg",
      "/images/paris/day-9.jpg",
      "/images/paris/extra1.jpg",
      "/images/paris/extra2.jpg",
      "/images/paris/extra3.jpg",
      "/images/paris/extra4.jpg",
      "/images/paris/extra5.jpg",
    ]
  },

  {
    title: "France City Explorer",
    slug: "paris-nice-06n",
    price: "EUR 904 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "",
    image: "/images/france/day-1.jpg",
    location: "Paris, Nice",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "Paris, Nice",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Eiffel Tower 2nd Level",
        "Paris Hop-on Hop-off",
        "Seine River Cruise",
        "Disneyland Paris",
        "Nice Hop-on Hop-off",
        "French Riviera",
        "Èze",
        "Monaco",
        "Monte-Carlo",
        "Saint-Paul-De-Vence",
        "Cannes",
      ],

      experiences: [
        {
          title: "Paris – Eiffel Tower & Hop-on Hop-off",
          desc: "Explore Paris with a 01-Day Hop-on Hop-off Bus Tour, Eiffel Tower 2nd Level Entry Ticket and Seine River Cruise.",
        },
        {
          title: "Paris – Disneyland",
          desc: "Enjoy a full day at Disneyland Paris with a 1-Day 1-Park Ticket including shuttle transfers.",
        },
        {
          title: "Nice – Hop-on Hop-off",
          desc: "Explore Nice's iconic landmarks including the Promenade des Anglais, Castle Hill and Old Town while enjoying coastal views.",
        },
        {
          title: "Nice – French Riviera Day Tour",
          desc: "Visit Èze, Monaco, Monte-Carlo, Saint-Paul-De-Vence and Cannes on a full-day SIC tour.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Paris",
        desc: "Arrival in Paris. Upon arrival at Paris CDG Airport, a private transfer will take you to your hotel. Spend your first evening getting acquainted with Paris. Overnight Stay in Paris.",
        tags: [],
      },
      {
        day: "02",
        title: "Eiffel Tower 2nd Level Entry Ticket & Paris Hop-on Hop-off Tour",
        desc: "Breakfast at Hotel. Explore Paris with the 01-Day Hop-on Hop-off Bus Tour. Enjoy Eiffel Tower 2nd Level Entry and a Seine River Cruise offering views of Notre-Dame Cathedral, Musée d’Orsay and the Louvre. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Disneyland 1-Day 1-Park Ticket with Shuttle Transfer",
        desc: "Breakfast at Hotel. Enjoy a magical full day at Disneyland Paris with your 1-Day 1-Park Ticket including shuttle transfers. Overnight Stay in Paris.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Paris – Nice",
        desc: "Breakfast at Hotel. Enjoy a private transfer from your Paris hotel to Paris train station for your train to Nice. Upon arrival in Nice, a private transfer will take you to your hotel. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Nice – Hop on Hop off Tour",
        desc: "Breakfast at Hotel. Proceed for your Nice 01-Day Hop on Hop off Bus Tour. Explore the Promenade des Anglais, Castle Hill, Old Town and more. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Nice – French Riviera Day Tour",
        desc: "Breakfast at Hotel. Proceed for the French Riviera Day Tour on SIC basis. Visit Èze, Monaco, Monte Carlo, Saint-Paul-De-Vence and Cannes. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Nice – Departure",
        desc: "Breakfast at Hotel. Proceed to Nice Airport with a private transfer for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights’ accommodation with breakfast",
        "Private transfer from Paris CDG Airport to Paris Hotel",
        "Paris 01-Day Hop on Hop off bus tour",
        "Eiffel Tower 2nd Level entry ticket",
        "Seine River cruise entry ticket",
        "Disneyland 01-Day 01-Park ticket with shuttle transfer",
        "Private transfer from Paris Hotel to Paris train station",
        "Private transfer from Nice train station to Nice Hotel",
        "Nice 01-Day Hop on Hop off bus tour",
        "French Riviera Day Tour from Nice on SIC basis",
        "Private transfer from Nice Hotel to Nice Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tours",
        "Return flight tickets",
        "Visa & insurance fees",
        "Water bottles",
        "Train ticket from Paris to Nice",
        "Optional tours",
        "Hotel city tax payable directly at the hotel",
        "Lunch & dinner",
        "Personal expenses such as laundry, drinks, telephone charges, or any item not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for coach drivers, etc.",
      ],
    },

    pricing: {
    note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Paris 3N",
              hotel: "Hôtel Kabanel by HappyCulture or similar",
            },
            {
              location: "Nice 3N",
              hotel: "Hotel Relais Acropolis or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1042 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 991 per person onward on Twin/Double sharing basis / EUR 891 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 962 per person onward on Twin/Double sharing basis / EUR 862 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 553 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 536",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1047 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 996 per person onward on Twin/Double sharing basis / EUR 918 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 967 per person onward on Twin/Double sharing basis / EUR 889 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 646x per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 531",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 904 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 853 per person onward on Twin/Double sharing basis / EUR 784 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 824 per person onward on Twin/Double sharing basis / EUR 755 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 498 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 408",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Paris 3N",
              hotel: "Grand Hotel Lafayette or similar",
            },
            {
              location: "Nice 3N",
              hotel: "Novotel Nice Centre Vieux Nice or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1406 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1355 per person onward on Twin/Double sharing basis / EUR 1328 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1326 per person onward on Twin/Double sharing basis / EUR 1299 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1146 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 910",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1212 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1161 per person onward on Twin/Double sharing basis / EUR 1314 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1132 per person onward on Twin/Double sharing basis / EUR 1285 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1482 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 706",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "Nov, Dec, Jan & Feb – 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1149 per person onward on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1098 per person onward on Twin/Double sharing basis / EUR 1018 per person onward on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1069 per person onward on Twin/Double sharing basis / EUR 989 per person onward on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 710 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 989",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Paris - Nice 02nd class train ticket",
        price: "EUR 65 - 80",
        note: "On actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/france/day-1.jpg",
      "/images/france/day-2.jpg",
      "/images/france/day-3.jpg",
      "/images/france/day-4.jpg",
      "/images/france/day-5.jpg",
      "/images/france/day-6.jpg",
      "/images/france/extra1.jpg",
      "/images/france/extra2.jpg",
      "/images/france/extra3.jpg",
    ]
  },

  {
    title: "From the French Riviera to Milan’s Elegance",
    slug: "nice-monaco-milan-06n",
    price: "EUR 995 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/french/day-1.jpg",
    location: "Nice, Monaco, Milan",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Nice, Monaco, Milan",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "French Riviera",
        "Èze",
        "Monaco",
        "Monte Carlo",
        "Antibes",
        "Saint-Paul-de-Vence",
        "Cannes",
        "Monaco Hop-on Hop-off",
        "Milan Hop-on Hop-off",
        "Duomo di Milano",
        "Duomo Terraces",
      ],

      experiences: [
        {
          title: "Nice – Full Day French Riviera Exploration",
          desc: "Explore the highlights of the French Riviera including Èze, Monaco, Monte Carlo, Antibes, Saint-Paul-de-Vence and Cannes. Enjoy medieval lanes, coastal views, luxury marinas, perfumeries and the famous Croisette promenade.",
        },
        {
          title: "Monaco – Discover Monaco at Your Own Pace",
          desc: "Explore Monaco with a Hop-On Hop-Off sightseeing tour. Visit Monte Carlo, Fontvieille and the Rock of Monaco, including landmarks such as the Prince’s Palace and iconic Casino.",
        },
        {
          title: "Milan – City Sightseeing",
          desc: "Explore Milan with a Hop-On Hop-Off sightseeing experience covering the Duomo, Sforza Castle, La Scala Opera House and stylish shopping districts.",
        },
        {
          title: "Milan – Duomo Museum & Terraces",
          desc: "Visit the Duomo di Milano Museum & Terraces and enjoy rooftop views of Milan and the distant Alps.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Nice",
        desc: "Welcome to Nice – the glamorous gateway to the French Riviera. Upon arrival at Nice Airport, enjoy a private transfer to your hotel in the city centre. Spend the rest of the day relaxing or exploring the Promenade des Anglais and Old Town. Overnight Stay in Nice.",
        tags: [],
      },
      {
        day: "02",
        title: "Nice – Full day French Riviera Exploration",
        desc: "Breakfast at the hotel. Embark on a full-day tour exploring the highlights of the French Riviera including Èze, Monaco, Monte Carlo, Antibes, Saint-Paul-de-Vence and Cannes. Overnight Stay in Nice.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Nice – Monaco",
        desc: "Breakfast at the hotel. Transfer from Nice to the principality of Monaco while enjoying scenic views of the Mediterranean coastline. Spend the rest of the day at leisure. Overnight Stay in Monaco.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Monaco – Discover Monaco at Your Own Pace",
        desc: "Breakfast at the hotel. Explore Monaco with a Hop-On Hop-Off sightseeing tour. Visit Monte Carlo, Fontvieille and the Rock of Monaco, including historic landmarks such as the Prince’s Palace and the iconic Casino. Overnight Stay in Monaco.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Monaco – Milan",
        desc: "Breakfast at the hotel. Leave Monaco behind and travel by train across picturesque landscapes to Milan. After arriving in the city centre, check in to your hotel and enjoy the remainder of the day at leisure. Overnight Stay in Milan.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Milan City Sightseeing",
        desc: "Breakfast at the hotel. Enjoy a full day exploring Milan with a Hop-On Hop-Off sightseeing experience. Discover the Duomo, Sforza Castle, La Scala Opera House and stylish shopping districts. Later, visit the Duomo di Milano Museum & Terraces with elevator access. Overnight Stay in Milan.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Milan – India",
        desc: "Breakfast at the hotel. After checking out, proceed to Milan Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfers between airports, hotels, and train stations",
        "Full-Day French Riviera Tour from Nice on SIC basis",
        "01-Day Monaco Hop-On Hop-Off Bus Ticket",
        "01-Day Milan Hop-On Hop-Off Bus Ticket",
        "Duomo di Milano Museum & Terraces Entrance with elevator",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Luch & Dinner",
        "Extracharges/expensesof personalnaturelikelaundry,mineralwater/drinks,telephoneor any other charges/ expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Nice 2N",
              hotel: "ibis Nice Centre Gare or similar",
            },
            {
              location: "Monaco 2N",
              hotel: "Novotel Monte Carlo or similar",
            },
            {
              location: "Milan 2N",
              hotel: "Hotel ibis Milano Centro or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 995 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 886 per person onwards on Twin/Double sharing basis / EUR 850 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 842 per person onwards on Twin/Double sharing basis / EUR 821 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 580 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 522 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1321 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1212 per person onwards on Twin/Double sharing basis / EUR 1116 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1168 per person onwards on Twin/Double sharing basis / EUR 1069 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 669 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 833 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1047 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 938 per person onwards on Twin/Double sharing basis / EUR 895 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 894 per person onwards on Twin/Double sharing basis / EUR 849 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 561 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 572 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Nice 2N",
              hotel: "Novotel Nice Centre Vieux Nice or similar",
            },
            {
              location: "Monaco 2N",
              hotel: "Port Palace Hôtel or similar",
            },
            {
              location: "Milan 2N",
              hotel: "Leonardo Hotel Milan City Center or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1064 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 945 per person onwards on Twin/Double sharing basis / EUR 915 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 901 per person onwards on Twin/Double sharing basis / EUR 869 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 586 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 588 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "April, May, June, July & Aug: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1460 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1382 per person onwards on Twin/Double sharing basis / EUR 1368 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1338 per person onwards on Twin/Double sharing basis / EUR 1331 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1179 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 995 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },

            {
              months: "March, Sep & Oct: 2026",
              rows: [
                {
                  pax: "02 Pax",
                  price: "EUR 1378 per person onwards on Twin/Double sharing basis",
                },
                {
                  pax: "04 Pax",
                  price: "EUR 1296 per person onwards on Twin/Double sharing basis / EUR 1257 per person onwards on Triple sharing basis",
                },
                {
                  pax: "06 Pax",
                  price: "EUR 1252 per person onwards on Twin/Double sharing basis / EUR 1211 per person onwards on Triple sharing basis",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 914 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 913 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Monaco – Milan 02nd class train ticket",
        price: "EUR 50 - 80 onwards",
        note: "On actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/french/day-1.jpg",
      "/images/french/day-2.jpg",
      "/images/french/day-3.jpg",
      "/images/french/day-4.jpg",
      "/images/french/day-5.jpg",
      "/images/french/day-6.jpg",
      "/images/french/extra1.jpg",
    ]

  },

  {
    title: "Glimpses of Switzerland",
    slug: "lucerne-interlaken-geneva-06n",
    price: "EUR 1408 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Swit/day-1.jpg",
    location: "Lucerne, Interlaken, Geneva",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Lucerne, Interlaken, Geneva",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Swiss Travel Pass Included",
      ],

      highlights: [
        "Mt. Titlis",
        "Ice Flyer",
        "Lake Lucerne Cruise",
        "Mt. Jungfrau",
        "Jungfrau-Aletsch Glacier",
        "Sphinx Observatory",
        "Ice Palace",
        "Lake Geneva Cruise",
        "Montreux",
        "Chillon Castle",
      ],

      experiences: [
        {
          title: "Lucerne – Mt. Titlis with Ice Flyer",
          desc: "Travel from Lucerne to Engelberg and experience Mount Titlis, including the Ice Flyer chairlift, Glacier Park, hiking and panoramic alpine views.",
        },
        {
          title: "Interlaken – Mt. Jungfrau",
          desc: "Explore Jungfrau with the Swiss Pass, including the Sphinx Observatory, Ice Palace and Glacier Plateau.",
        },
        {
          title: "Geneva – Lake Geneva",
          desc: "Explore Geneva and enjoy the opportunity to cruise Lake Geneva while discovering the Old Town, Jet d'Eau and St. Pierre Cathedral.",
        },
        {
          title: "Montreux – Chillon Castle",
          desc: "Visit the medieval Château de Chillon on Lake Geneva using the Swiss Pass.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Lucerne",
        desc: "Welcome to Zurich! Take the train from Zurich to Lucerne using your Swiss Pass. Explore Lucerne's historical charm, Lake Lucerne and picturesque old town.",
        tags: [],
      },
      {
        day: "02",
        title: "Lucerne – Mt. Titlis with Ice Flyer",
        desc: "Breakfast at Hotel. Take a morning train from Lucerne to Engelberg and visit Mount Titlis. Experience the Ice Flyer chairlift, Glacier Park, hiking and panoramic alpine views. The Swiss Pass also covers boat cruises on Lake Lucerne.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Lucerne – Interlaken",
        desc: "Breakfast at Hotel. After check out, take a train to Interlaken. Enjoy the scenic journey through the Swiss Alps, lakes and mountains. Overnight Stay in Interlaken.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Interlaken – Mt. Jungfrau",
        desc: "Breakfast at Hotel. Take a morning train from Interlaken to Grindelwald and continue towards Mt. Jungfrau. Explore the Sphinx Observatory, Ice Palace and Glacier Plateau.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Interlaken – Geneva",
        desc: "Breakfast at Hotel. Travel from Interlaken to Geneva by train while enjoying scenic mountain peaks and natural landscapes. You can take a cruise on Lake Geneva. Explore Geneva's Old Town, Jet d'Eau, St. Pierre Cathedral and international institutions.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Geneva – Montreux with Swiss Pass",
        desc: "Breakfast at Hotel. Visit Montreux, a traditional resort town on Lake Geneva. Visit Chillon Castle using your Swiss Pass.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Geneva – India",
        desc: "Use the Swiss Pass from Geneva hotel to Geneva Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 nights’ accommodation with Breakfast",
        "Swiss Travel Pass 2nd class 8 consecutive days",
        "Excursion to Mt. Titlis with Ice Flyer",
        "Excursion to Mt. Jungfrau using Swiss Pass",
        "Visit to Lindt Museum Chocolate Factory ticket",
        "Rhine Falls with Swiss Pass",
        "Lake Lucerne Cruise with Swiss Pass",
        "Lake Lucerne and Geneva Cruise with Swiss Pass",
        "Lake Thun and Lake Brienz Cruise with Swiss Pass",
        "Visit Chillon castle with Swiss Pass",
        "Geneva hotel to airport using Swiss Pass",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or any other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Lucerne 2N",
              hotel: "ibis Styles Luzern City or similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Lotschberg or similar",
            },
            {
              location: "Geneva 2N",
              hotel: "Ibis Geneve Centre Gare or Similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1476 per person onwards",
                  triple: "EUR 1388 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 515 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 779",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1487 per person onwards",
                  triple: "EUR 1389 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 488 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 790",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1408 per person onwards",
                  triple: "EUR 1258 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 262 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 711",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Lucerne 2N",
              hotel: "Hotel Monopol Luzern or similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Metropole or similar",
            },
            {
              location: "Geneva 2N",
              hotel: "Novotel Suites Geneve Aeroport or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1588 per person onwards",
                  triple: "EUR 1569 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 812 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 869",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1659 per person onwards",
                  triple: "EUR 1546 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 628 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 967",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1469 per person onwards",
                  triple: "EUR 1403 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 579 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 777",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Rhine Fall 15 minutes boat ride",
        price: "EUR 12",
      },
      {
        name: "Lindt home chocolate ticket",
        price: "EUR 20",
      },
      {
        name: "Jungfraujoch with Swiss Pass ticket",
        price: "EUR 145",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Swit/day-1.jpg",
      "/images/Swit/day-2.jpg",
      "/images/Swit/day-3.jpg",
      "/images/Swit/day-4.jpg",
      "/images/Swit/day-5.jpg",
      "/images/Swit/day-6.jpg",
      "/images/Swit/day-7.jpg",

    ],
  },

  {
    title: "From Rhine Fall to Glacier 3000",
    slug: "lucerne-interlaken-montreux-07n",
    price: "EUR 1586 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/fall/day-4.jpg",
    location: "Lucerne, Interlaken, Montreux",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Lucerne, Interlaken, Montreux",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "08 Days Swiss Pass",
      ],

      highlights: [
        "Lindt Home of Chocolate",
        "Rhine Falls",
        "Mt. Titlis",
        "Ice Flyer",
        "Grindelwald",
        "Lauterbrunnen",
        "Mt. Jungfrau",
        "GoldenPass Route",
        "Glacier 3000",
        "Peak Walk by Tissot",
      ],

      experiences: [
        {
          title: "Lindt Chocolate Museum & Rhine Falls",
          desc: "Visit Lindt Home of Chocolate and Rhine Falls using the Swiss Pass. The Rhine Falls visit does not include the boat ride.",
        },
        {
          title: "Mt. Titlis with Ice Flyer",
          desc: "Experience Mt. Titlis at 3,238 meters with cable car access, Ice Flyer chairlift, Glacier Cave and snow activities.",
        },
        {
          title: "Grindelwald & Lauterbrunnen",
          desc: "Explore the alpine villages of Grindelwald and Lauterbrunnen using the Swiss Pass.",
        },
        {
          title: "Jungfraujoch – Top of Europe",
          desc: "Visit Jungfraujoch with the Swiss Pass and supplement, including Ice Palace, Sphinx Observatory and views of the Aletsch Glacier.",
        },
        {
          title: "Glacier 3000",
          desc: "Enjoy alpine panoramas, snow activities, Peak Walk by Tissot and glacier views.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Arrival in Switzerland | Zurich Airport → Lucerne",
        desc: "Upon arrival at Zurich Airport, activate your Swiss Pass and travel to Lucerne by train. Explore Lucerne at leisure, including Chapel Bridge, Lake Lucerne and the old town.",
        tags: [],
      },
      {
        day: "02",
        title: "Lindt Chocolate Museum & Rhine Falls (No Boat Ride)",
        desc: "Visit Lindt Home of Chocolate and later continue to Rhine Falls using your Swiss Pass. Explore the waterfall from various viewing platforms.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Excursion to Mt. Titlis with Ice Flyer",
        desc: "Embark on the Mt. Titlis excursion with your Swiss Pass and mountain pass. Experience the Ice Flyer chairlift, Glacier Cave and snow activities.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Lucerne → Interlaken | Visit Grindelwald & Lauterbrunnen",
        desc: "Travel from Lucerne to Interlaken using your Swiss Pass. Explore Grindelwald and Lauterbrunnen with their valleys, waterfalls and panoramic views.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Excursion to Mt. Jungfrau (Top of Europe)",
        desc: "Experience Jungfraujoch using the Swiss Pass with supplement. Explore the Ice Palace, Sphinx Observatory and views of the Aletsch Glacier.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Interlaken → Montreux",
        desc: "Travel from Interlaken to Montreux using your Swiss Pass. Enjoy lakes, vineyards and mountain scenery along the GoldenPass route. Overnight in Montreux.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Excursion to Glacier 3000",
        desc: "Enjoy Glacier 3000 with alpine panoramas, snow activities, Peak Walk by Tissot and glacier views.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Departure | Montreux → Geneva Airport",
        desc: "After breakfast, check out and proceed to Geneva Airport using your Swiss Pass.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "Accommodation with breakfast",
        "08 days continuous 02 Class Swiss Pass",
        "Zurich Airport to Lucerne hotel using Swiss pass",
        "Lindt chocolate museum entry ticket",
        "Visit Rhine fall using Swiss pass (NO boat ride)",
        "Excursion to Mt Titlis with Ice flyer conjunction to Swiss pass",
        "Lucerne Hotel to Interlaken hotel using Swiss pass",
        "Visit Grindelwald and Lauterbrunnen using Swiss pass",
        "Excursion to Mt Jungfrau with Swiss pass",
        "Interlaken to Montreux hotel using Swiss Pass",
        "Excursion to Glacier 3000 using Swiss Pass",
        "Montreux hotel to Geneva Airport using Swiss Pass",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or any other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Lucerne 3N",
              hotel: "Hotel de la Paix or Similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Weisses Kreuz or Similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Tralala Hôtel Montreux or Similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1586 per person onwards",
                  triple: "EUR 1402 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 265 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 771 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1672 per person onwards",
                  triple: "EUR 1496 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 368 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 853 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1723 per person onwards",
                  triple: "EUR 1546 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 416 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 901 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Lucerne 3N",
              hotel: "Hotel MONOPOL Luzern or Similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Metropole or Similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Hotel Victoria Glion or Similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1962 per person onwards",
                  triple: "EUR 1773 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 683 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1129 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2249 per person onwards",
                  triple: "EUR 2002 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 716 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1402 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 1791 per person onwards",
                  triple: "EUR 1646 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 571 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 966 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Rhine Fall 15 minutes boat ride",
        price: "EUR 12",
      },
      {
        name: "Lindt home chocolate ticket",
        price: "EUR 20",
      },
      {
        name: "Jungfraujoch with Swiss Pass ticket",
        price: "EUR 145",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/fall/day-1.jpg",
      "/images/fall/day-2.jpg",
      "/images/fall/day-3.jpg",
      "/images/fall/day-4.jpg",
      "/images/fall/day-5.jpg",
      "/images/fall/day-6.jpg",
      "/images/fall/day-7.jpg",
    ]
  },

  {
    title: "Explore Florence + Pisa + Rome",
    slug: "florence-pisa-rome-06n",
    price: "EUR 812 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/rome/day-1.jpg",
    location: "Florence, Pisa, Rome",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Florence, Pisa, Rome",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers Included",
      ],

      highlights: [
        "Florence Walking Tour",
        "Duomo",
        "Baptistery",
        "Pisa",
        "Leaning Tower of Pisa",
        "Piazza dei Miracoli",
        "Rome Hop-on Hop-off",
        "Colosseum",
        "Roman Forum",
        "Pantheon",
      ],

      experiences: [
        {
          title: "Florence – Walking Tour with Expert Guide",
          desc: "Enjoy a 1.5-hour shared walking tour with an expert guide covering Florence's iconic landmarks, historic centre and charming piazzas.",
        },
        {
          title: "Pisa – Leaning Tower",
          desc: "Visit the Leaning Tower of Pisa with entry ticket access and enjoy panoramic views of Piazza dei Miracoli.",
        },
        {
          title: "Rome – Hop-on Hop-off",
          desc: "Explore Rome at your own pace with a 24-hour Hop-on Hop-off bus ticket covering the city's major landmarks.",
        },
        {
          title: "Rome – Colosseum",
          desc: "Visit the iconic Colosseum and explore its ancient corridors, arches and underground passages.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Florence",
        desc: "Arrival at Florence Airport followed by a private transfer to the hotel. Spend the evening exploring Florence at leisure, including the Duomo, Arno River and Renaissance streets.",
        tags: [],
      },
      {
        day: "02",
        title: "Florence – Florence Walking Tour with Expert Guide – 1.5 Hour",
        desc: "Breakfast at Hotel. Enjoy a 1.5-hour shared walking tour with an expert guide covering Florence's iconic landmarks, Duomo, Baptistery, historic centre and charming piazzas.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Florence – Pisa",
        desc: "Breakfast at Hotel. Travel by train from Florence to Pisa. The journey is approximately 85 km and typically takes between 50 minutes and 1 hour 10 minutes.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Pisa – Leaning Tower of Pisa Entry Ticket",
        desc: "Breakfast at Hotel. Visit the Leaning Tower of Pisa and climb to the top for panoramic views of Piazza dei Miracoli, cathedral and baptistery.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Pisa – Rome",
        desc: "Breakfast at Hotel. Travel from Pisa to Rome by train. The journey is approximately 350 km and takes around 2 hours 45 minutes to 3 hours on high-speed services.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Rome – Hop-on Hop-off Bus Tour – 24 Hours",
        desc: "Breakfast at Hotel. Explore Rome with a 24-hour Hop-on Hop-off bus tour. Later visit the Colosseum with entry ticket.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Rome – India",
        desc: "Breakfast at Hotel. After breakfast proceed to Rome airport with private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Transfer from Florence airport to hotel on private basis",
        "Florence Walking Tour with Expert Guide - 1.5 Hour on Shared Basis",
        "Transfer from Florence hotel to train station on private basis",
        "Train from Florence to Pisa",
        "Transfer from Pisa train station to hotel on private basis",
        "Leaning Tower of Pisa Entry Ticket",
        "Transfer from Pisa hotel to train station on private basis",
        "Train from Pisa to Rome",
        "Transfer from Rome train station to hotel on private basis",
        "Rome hop on hop off bus tour - 24 hours",
        "Colosseum Entry Ticket",
        "Private Transfer from Rome Hotel to Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or any other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Florence 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
            {
              location: "Pisa 2N",
              hotel: "Hotel Alessandro Della Spina or similar",
            },
            {
              location: "Rome 2N",
              hotel: "Hotel Luxor Florence or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 812 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 724 per person onwards",
                  triple: "EUR 639 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 675 per person onwards",
                  triple: "EUR 590 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 271 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 451 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 941 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 843 per person onwards",
                  triple: "EUR 764 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 793 per person onwards",
                  triple: "EUR 720 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 381 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 558 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 848 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 757 per person onwards",
                  triple: "EUR 692 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 705 per person onwards",
                  triple: "EUR 645 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 352 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 469 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Florence 2N",
              hotel: "Hotel San Giovanni Roma or similar",
            },
            {
              location: "Pisa 2N",
              hotel: "Bologna Hotel or similar",
            },
            {
              location: "Rome 2N",
              hotel: "Cellai Boutique Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 819 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 733 per person onwards",
                  triple: "EUR 676 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 652 per person onwards",
                  triple: "EUR 608 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 338 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 368 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 946 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 851 per person onwards",
                  triple: "EUR 773 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 803 per person onwards",
                  triple: "EUR 728 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 329 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 563 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 852 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 759 per person onwards",
                  triple: "EUR 723 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 713 per person onwards",
                  triple: "EUR 672 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 434 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 473 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Florence - Pisa – Rome 02nd Class train ticket",
        price: "EUR 65 - 75",
        note: "On actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/rome/day-1.jpg",
      "/images/rome/day-2.jpg",
      "/images/rome/day-3.jpg",
      "/images/rome/day-4.jpg",
      "/images/rome/day-5.jpg",
      "/images/rome/day-6.jpg",
      "/images/rome/extra1.jpg",
      "/images/rome/extra2.jpg",
      "/images/rome/extra3.jpg",
      "/images/rome/extra4.jpg",
      "/images/rome/extra5.jpg",
    ]
  },

  {
    title: "Explore Geneva + Montreux + Zermatt",
    slug: "geneva-montreux-zermatt-06n",
    price: "EUR 1408 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/gene/day-1.jpg",
    location: "Geneva, Montreux, Zermatt",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Geneva, Montreux, Zermatt",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Swiss Travel Pass Included",
      ],

      highlights: [
        "Swiss Travel Pass",
        "Mont-Blanc",
        "Mer de Glace",
        "Montenvers Cogwheel Train",
        "Glacier 3000",
        "Peak Walk",
        "Zermatt",
        "Matterhorn Glacier Paradise",
        "Glacier Palace",
      ],

      experiences: [
        {
          title: "Geneva – Mont-Blanc & Mer de Glace",
          desc: "Enjoy a full-day shared excursion to Mont-Blanc and Mer de Glace, travelling through Chamonix and ascending by the historic Montenvers Cogwheel Train.",
        },
        {
          title: "Montreux – Glacier 3000",
          desc: "Experience Glacier 3000 with panoramic alpine views, Peak Walk suspension bridge and glacier activities.",
        },
        {
          title: "Zermatt – Matterhorn Glacier Paradise",
          desc: "Ascend to Matterhorn Glacier Paradise, the highest cable car station in Europe, and explore the glacier palace and surrounding alpine scenery.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Geneva",
        desc: "Arrival at Geneva Airport followed by a private transfer to the hotel. Spend the evening exploring Geneva, Lake Geneva and the Old Town at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Geneva – Swiss Travel Pass – 06 Days Continuous | 02nd Class",
        desc: "After breakfast, begin exploring Switzerland using the 6-day continuous Swiss Travel Pass. Enjoy a full-day shared excursion to Mont-Blanc and Mer de Glace with the Montenvers Cogwheel Train.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Geneva – Montreux",
        desc: "After breakfast, travel from Geneva to Montreux using the Swiss Travel Pass. Enjoy scenic Lake Geneva and vineyard views along the journey.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Montreux – Excursion to Glacier 3000 Using Swiss Pass",
        desc: "After breakfast, enjoy a full-day shared excursion to Glacier 3000 using the Swiss Travel Pass. Experience alpine panoramas, Peak Walk and glacier activities.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Montreux – Zermatt",
        desc: "After breakfast, travel from Montreux to Zermatt using the Swiss Travel Pass. Enjoy scenic views of lakes, vineyards and alpine landscapes. Overnight Stay in Zermatt.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Zermatt – Excursion to Matterhorn Glacier Paradise Using Swiss Pass",
        desc: "After breakfast, embark on a full-day shared excursion to Matterhorn Glacier Paradise. Ascend to the highest cable car station in Europe and explore the Glacier Palace and surrounding peaks.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Zermatt – Geneva",
        desc: "After breakfast, travel from Zermatt to Geneva using your Swiss Travel Pass. Upon arrival proceed to Geneva Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Transfer from Geneva airport to hotel on private basis",
        "Swiss Travel Pass - 06 Days Continuous | 02nd Class",
        "Day Trip to Mont-Blanc and Cogwheel Ticket Mer de Glace Tour",
        "Train from Geneva to Montreux Using Swiss Pass",
        "Excursion to Glacier 3000 Using Swiss Pass",
        "Train from Montreux to Zermatt Using Swiss Pass",
        "Excursion to Matterhorn Glacier Paradise Using Swiss Pass",
        "Train from Zermatt to Geneva Using Swiss Pass",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or any other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers, etc.",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Geneva 2N",
              hotel: "Hotel Eden Geneve or similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Tralala Hotel Montreux or similar",
            },
            {
              location: "Zermatt 2N",
              hotel: "Hotel Bristol or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1408 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1385 per person onwards",
                  triple: "EUR 1325 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1374 per person onwards",
                  triple: "EUR 1315 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 581 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 642 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1783 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1762 per person onwards",
                  triple: "EUR 1626 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1751 per person onwards",
                  triple: "EUR 1618 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 658 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 932 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1539 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1518 per person onwards",
                  triple: "EUR 1458 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1506 per person onwards",
                  triple: "EUR 1437 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 713 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 768 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Geneva 2N",
              hotel: "Wellness Hotel Alpenhof or similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Hotel du Grand Lac Excelsior or similar",
            },
            {
              location: "Zermatt 2N",
              hotel: "Hotel Ambassador Zermatt or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1711 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1688 per person onwards",
                  triple: "EUR 1569 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1675 per person onwards",
                  triple: "EUR 1557 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 702 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 934 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1917 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1894 per person onwards",
                  triple: "EUR 1747 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1883 per person onwards",
                  triple: "EUR 1735 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 841 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1109 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1892 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1880 per person onwards",
                  triple: "EUR 1873 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1869 per person onwards",
                  triple: "EUR 1860 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1398 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1111 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/gene/day-1.jpg",
      "/images/gene/day-2.jpg",
      "/images/gene/day-3.jpg",
      "/images/gene/day-4.jpg",
      "/images/gene/day-5.jpg",
      "/images/gene/day-6.jpg",
      "/images/gene/extra1.jpg",
      "/images/gene/extra2.jpg",
      "/images/gene/extra3.jpg",
      "/images/gene/extra4.jpg",
      "/images/gene/extra5.jpg",
      "/images/gene/extra6.jpg",
    ]
  },

  {
    title: "Best of Engelberg + Grindelwald + Zurich",
    slug: "engelberg-grindelwald-zurich-06n",
    price: "EUR 1640 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/eng/day-1.jpg",
    location: "Engelberg, Grindelwald, Zurich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Engelberg, Grindelwald, Zurich",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "06 Days Swiss Pass",
      ],

      highlights: [
        "Mt. Titlis",
        "Titlis Cliff Walk",
        "Mt. Jungfrau",
        "Top of Europe",
        "Ice Palace",
        "Sphinx Observatory",
        "Rhine Falls",
        "Lindt Home of Chocolate",
        "Zurich Old Town",
        "Lake Zurich",
      ],

      experiences: [
        {
          title: "Engelberg – Mt. Titlis",
          desc: "Experience Mt. Titlis with panoramic gondola rides, snowy mountain views and the famous Titlis Cliff Walk.",
        },
        {
          title: "Grindelwald – Alpine Village",
          desc: "Travel to Grindelwald through the scenic Berner Oberland region and enjoy views of the Eiger North Face.",
        },
        {
          title: "Jungfraujoch – Top of Europe",
          desc: "Visit Jungfraujoch using the Swiss Pass and explore the Ice Palace, Sphinx Observatory and panoramic glacier views.",
        },
        {
          title: "Zurich – Rhine Falls",
          desc: "Visit Rhine Falls using the Swiss Pass. Boat tour is not included.",
        },
        {
          title: "Zurich – Lindt Home of Chocolate",
          desc: "Visit the Lindt Home of Chocolate and explore interactive exhibits and the famous chocolate fountain.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zurich – Engelberg",
        desc: "Arrival at Zurich Airport and travel to Engelberg using your Swiss Pass. Enjoy a scenic train journey through Switzerland's rolling hills and lakes. Spend the evening surrounded by Engelberg's mountain scenery.",
        tags: [],
      },
      {
        day: "02",
        title: "Engelberg – Mt. Titlis Excursion",
        desc: "Breakfast at Hotel. Enjoy an excursion to Mt. Titlis using your Swiss Pass, including panoramic gondola rides, snowy vistas and the famous Titlis Cliff Walk.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Engelberg – Grindelwald",
        desc: "Breakfast at Hotel. Travel from Engelberg to Grindelwald using your Swiss Pass through the scenic Berner Oberland region. Enjoy the mountain scenery surrounding Grindelwald and the Eiger North Face.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Grindelwald – Excursion to Mt. Jungfrau",
        desc: "Breakfast at Hotel. Visit Jungfraujoch – Top of Europe using your Swiss Pass. Explore the Ice Palace, Sphinx Observatory and panoramic viewpoints overlooking glaciers and snow-covered mountains.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Grindelwald – Zurich",
        desc: "Breakfast at Hotel. Travel from Grindelwald to Zurich using your Swiss Pass. In the afternoon visit Rhine Falls using your Swiss Pass. Boat tour is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Zurich – Lindt Home of Chocolate",
        desc: "Breakfast at Hotel. Visit the Lindt Home of Chocolate and explore its interactive exhibits and chocolate fountain. Spend the rest of the day exploring Zurich at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Zurich – India",
        desc: "Breakfast at Hotel. Private transfer from Zurich hotel to Zurich Airport for your onward journey to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "06 Days Consecutive 2nd Class Swiss Pass",
        "Zurich Airport to Engelberg Hotel Using Swiss Pass",
        "Excursion to Mt. Titlis with Swiss Pass",
        "Engelberg to Grindelwald Using Swiss Pass",
        "Excursion to Mt. Jungfrau with Swiss Pass",
        "Grindelwald to Zurich Using Swiss Pass",
        "Lindt Home of Chocolate Entrance Tickets (Subject to Availability)",
        "Visit to Rhine Falls with Swiss Pass (Without Boat Tour)",
        "Private Transfer from Zurich Hotel to Zurich Airport",
        "Train/Tram/Bus ticket from Zurich hotel to airport",
      ],

      excluded: [
        "Tours on SIC/Shared basis where client needs to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or other expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Engelberg 2N",
              hotel: "Hotel Crystal Engelberg or Similar",
            },
            {
              location: "Grindelwald 2N",
              hotel: "Hotel Bernerhof Grindelwald or similar",
            },
            {
              location: "Zurich 2N",
              hotel: "ibis Zurich Messe Airport or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb & March - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1640 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1602 per person onwards",
                  triple: "EUR 1398 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1467 per person onwards",
                  triple: "EUR 1376 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 174 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 910 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1610 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1595 per person onwards",
                  triple: "EUR 1474 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1564 per person onwards",
                  triple: "EUR 1449 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 136 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 880 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1592 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1572 per person onwards",
                  triple: "EUR 1390 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1487 per person onwards",
                  triple: "EUR 1376 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 244 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1309 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Engelberg 2N",
              hotel: "Hotel Bellevue Terminus or Similar",
            },
            {
              location: "Grindelwald 2N",
              hotel: "Belvedere Swiss Quality Hotel Grindelwald or similar",
            },
            {
              location: "Zurich 2N",
              hotel: "Novotel Zurich Airport Messe - récemment rénové or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1816 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1796 per person onwards",
                  triple: "EUR 1737 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1785 per person onwards",
                  triple: "EUR 1708 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 139 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1030 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1787 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1747 per person onwards",
                  triple: "EUR 1719 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1737 per person onwards",
                  triple: "EUR 1704 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 182 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 805 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1757 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1727 per person onwards",
                  triple: "EUR 1696 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1708 per person onwards",
                  triple: "EUR 1686 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 174 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1260 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/eng/day-1.jpg",
      "/images/eng/day-2.jpg",
      "/images/eng/day-3.jpg",
      "/images/eng/day-4.jpg",
      "/images/eng/day-5.jpg",
      "/images/eng/extra1.jpg",
      "/images/eng/extra2.jpg",
      "/images/eng/extra3.jpg",
      "/images/eng/extra4.jpg",
    ]
  },

  {
    title: "From Zurich's Charm to Mont Blanc Views",
    slug: "zurich-bern-geneva-06n",
    price: "EUR 1230 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/charm/day-2.jpg",
    location: "Zurich, Bern, Geneva",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Zurich, Bern, Geneva",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Swiss Travel Pass",
      ],

      highlights: [
        "Rhine Falls",
        "Lindt Home of Chocolate",
        "Bern Old Town",
        "Zytglogge",
        "Mt. Jungfrau",
        "Top of Europe",
        "Aletsch Glacier",
        "Ice Palace",
        "Mont Blanc",
        "Chamonix",
        "Aiguille du Midi",
        "Lake Geneva",
      ],

      experiences: [
        {
          title: "Zurich – Rhine Falls",
          desc: "Visit Rhine Falls using your Swiss Pass. Boat rides are not included.",
        },
        {
          title: "Zurich – Lindt Home of Chocolate",
          desc: "Visit the Lindt Home of Chocolate with entry to the chocolate fountain and interactive exhibits.",
        },
        {
          title: "Bern – Jungfraujoch",
          desc: "Travel to Jungfrau via Interlaken Ost, Grindelwald Terminal, Eiger Express and Jungfrau Bahn. Explore the Aletsch Glacier and Ice Palace.",
        },
        {
          title: "Geneva – Mont Blanc",
          desc: "Take an SIC day trip from Geneva to Chamonix and ride the Aiguille du Midi cable car for panoramic alpine views.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zurich",
        desc: "Arrival in Zurich and check-in at the hotel. Enjoy Zurich at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Zurich – Rhine Falls & Lindt Home of Chocolate",
        desc: "Breakfast at Hotel. Visit Rhine Falls using your Swiss Pass, followed by the Lindt Home of Chocolate in Kilchberg.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zurich – Bern",
        desc: "Breakfast at Hotel. Travel by train from Zurich to Bern using the Swiss Pass. Explore Bern's UNESCO-listed Old Town, Zytglogge clock tower and Aare River.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Bern – Excursion to Mt. Jungfrau",
        desc: "Breakfast at Hotel. Take a full-day excursion to Mt. Jungfrau – Top of Europe using your Swiss Pass. Travel via Interlaken Ost, Grindelwald Terminal, Eiger Express and Jungfrau Bahn. Explore the Aletsch Glacier and Ice Palace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Bern – Geneva",
        desc: "Breakfast at Hotel. Travel from Bern to Geneva using your Swiss Pass. Explore Geneva including Jet d'Eau, Flower Clock, Old Town and Lake Geneva.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Geneva – Mont Blanc Excursion",
        desc: "Breakfast at Hotel. Embark on an SIC day trip to Mont Blanc from Geneva. Travel to Chamonix and enjoy the Aiguille du Midi cable car with ticket included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Geneva – India",
        desc: "Breakfast at Hotel. Proceed to the airport using your Swiss Pass for the onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Swiss Travel Pass 2nd class 4 consecutive days",
        "Rhine Falls with Swiss Pass",
        "Lindt Home of Chocolate entry ticket",
        "Zurich to Bern by Train using Swiss Pass",
        "Excursion to Mt. Jungfrau with Swiss Pass",
        "Bern to Geneva by Train using Swiss Pass",
        "Day trip to Mont Blanc from Geneva on SIC basis",
        "Aiguille du Midi cable car ticket included",
        "Tram/Bus ticket from Zurich & Geneva hotel to airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or other expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Zurich 2N",
              hotel: "ibis Styles Zurich City Center or similar",
            },
            {
              location: "Bern 2N",
              hotel: "ibis Styles Bern City or similar",
            },
            {
              location: "Geneva 2N",
              hotel: "ibis Genève Centre Nations or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1230 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1190 per person onwards",
                  triple: "EUR 1166 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1172 per person onwards",
                  triple: "EUR 1156 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 513 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 382 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1553 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1510 per person onwards",
                  triple: "EUR 1445 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1496 per person onwards",
                  triple: "EUR 1430 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 564 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 690 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1454 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1411 per person onwards",
                  triple: "EUR 1349 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1396 per person onwards",
                  triple: "EUR 1334 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 481 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 595 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Zurich 2N",
              hotel: "Sheraton Zurich Hotel or similar",
            },
            {
              location: "Bern 2N",
              hotel: "ibis Bern Expo or similar",
            },
            {
              location: "Geneva 2N",
              hotel: "Novotel Genève Centre or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1610 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1572 per person onwards",
                  triple: "EUR 1460 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1552 per person onwards",
                  triple: "EUR 1444 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 498 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 744 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1898 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1857 per person onwards",
                  triple: "EUR 1674 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1853 per person onwards",
                  triple: "EUR 1658 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 538 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1030 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1715 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1672 per person onwards",
                  triple: "EUR 1535 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1657 per person onwards",
                  triple: "EUR 1520 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 514 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 844 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Rhine Fall 15 minutes boat ride",
        price: "EUR 10 onwards",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/charm/day-1.jpg",
      "/images/charm/day-2.jpg",
      "/images/charm/day-3.jpg",
      "/images/charm/day-4.jpg",
      "/images/charm/day-5.jpg",
      "/images/charm/day-6.jpg",
    ]
  },

  {
    title: "Scenic Switzerland Discovery",
    slug: "lucerne-interlaken-zermatt-montreux-09n",
    price: "EUR 2028 per person onwards",
    days: "09 Nights / 10 Days",
    rating: "4.9",
    image: "/images/Switzerland/day-1.jpg",
    location: "Lucerne, Interlaken, Zermatt, Montreux",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "4 Destinations, 09 Nights",
        places: "Lucerne, Interlaken, Zermatt, Montreux",
      },

      pills: [
        "Breakfast Included",
        "09 Nights Accommodation",
        "Swiss Pass Included",
      ],

      highlights: [
        "Lindt Home of Chocolate",
        "Rhine Falls",
        "Mt. Titlis",
        "Ice Flyer",
        "Grindelwald",
        "Lauterbrunnen",
        "Mt. Jungfrau",
        "Jungfrau-Aletsch Glacier",
        "Matterhorn Glacier Paradise",
        "Matterhorn",
        "Glacier 3000",
        "Peak Walk by Tissot",
      ],

      experiences: [
        {
          title: "Lucerne – Lindt & Rhine Falls",
          desc: "Visit Lindt Home of Chocolate and Rhine Falls using your Swiss Pass. Rhine Falls boat ride is not included.",
        },
        {
          title: "Mt. Titlis with Ice Flyer",
          desc: "Experience Mt. Titlis and the Ice Flyer with alpine snow views.",
        },
        {
          title: "Grindelwald & Lauterbrunnen",
          desc: "Explore the scenic twin valleys of Grindelwald and Lauterbrunnen.",
        },
        {
          title: "Jungfraujoch – Top of Europe",
          desc: "Visit Jungfraujoch at 3,454 metres, including the Ice Palace and views of the Aletsch Glacier.",
        },
        {
          title: "Matterhorn Glacier Paradise",
          desc: "Visit Europe's highest cable car station and enjoy panoramic snowfields and ice sculptures.",
        },
        {
          title: "Glacier 3000",
          desc: "Experience Glacier 3000, snow activities and the Peak Walk by Tissot.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zurich – Lucerne",
        desc: "Arrive at Zurich Airport and activate your Swiss Pass for the scenic train journey to Lucerne. Explore Lucerne Old Town, Chapel Bridge and the lakeside promenade.",
        tags: [],
      },
      {
        day: "02",
        title: "Lindt Chocolate Museum & Rhine Falls",
        desc: "Breakfast at Hotel. Visit Lindt Home of Chocolate and later use your Swiss Pass to visit Rhine Falls. Boat ride is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Excursion to Mt. Titlis with Ice Flyer",
        desc: "Breakfast at Hotel. Enjoy the Mt. Titlis excursion with Ice Flyer. The source itinerary then continues the journey towards Interlaken and the surrounding alpine valleys.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Lucerne – Interlaken | Grindelwald & Lauterbrunnen",
        desc: "Breakfast at Hotel. Travel to Interlaken using your Swiss Pass. Explore Grindelwald and Lauterbrunnen with waterfalls, scenic meadows and mountain views.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Excursion to Mt. Jungfrau – Top of Europe",
        desc: "Breakfast at Hotel. Visit Jungfraujoch and explore the Ice Palace, views of the Aletsch Glacier and snowy peaks at 3,454 metres.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Interlaken – Zermatt",
        desc: "Breakfast at Hotel. Travel to the car-free resort town of Zermatt using your Swiss Pass and enjoy views of the Matterhorn.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Excursion to Matterhorn Glacier Paradise",
        desc: "Use your Swiss Pass with applicable reductions to visit Matterhorn Glacier Paradise, the highest cable car station in Europe. Enjoy ice sculptures and panoramic snowfields.",
        tags: [],
      },
      {
        day: "08",
        title: "Zermatt – Montreux",
        desc: "Check out and travel to Montreux through the scenic Lake Geneva region. Enjoy the lakeside promenade and town.",
        tags: [],
      },
      {
        day: "09",
        title: "Excursion to Glacier 3000",
        desc: "Experience Glacier 3000, snow activities, Peak Walk by Tissot and stunning Alpine views.",
        tags: [],
      },
      {
        day: "10",
        title: "Montreux – Geneva Airport – India",
        desc: "After breakfast, proceed to Geneva Airport using your Swiss Pass for the onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "15 days consecutive 02nd class Swiss Pass",
        "Zurich Airport to Lucerne hotel using Swiss Pass",
        "Lindt chocolate museum entry ticket (Subject to availability)",
        "Visit Rhine Falls using Swiss Pass (NO boat ride)",
        "Excursion to Mt Titlis with Ice Flyer conjunction to Swiss Pass",
        "Lucerne Hotel to Interlaken hotel using Swiss Pass",
        "Visit Grindelwald and Lauterbrunnen using Swiss Pass",
        "Excursion to Mt Jungfrau with Swiss Pass",
        "Interlaken to Zermatt hotel using Swiss Pass",
        "Excursion to Matterhorn with Swiss Pass",
        "Zermatt to Montreux hotel using Swiss Pass",
        "Excursion to Glacier 3000 using Swiss Pass",
        "Montreux hotel to Geneva Airport using Swiss Pass",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or other expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Lucerne 3N",
              hotel: "ibis Styles Luzern City or similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Lotschberg or similar",
            },
            {
              location: "Zermatt 2N",
              hotel: "Hotel Butterfly or Similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Hôtel Villa Toscane Montreux or Similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2028 per person onwards",
                  triple: "EUR 1811 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 482 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1084 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2154 per person onwards",
                  triple: "EUR 1977 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 716 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1204 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2039 per person onwards",
                  triple: "EUR 1873 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 639 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1094 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Lucerne 3N",
              hotel: "Hotel Monopol Luzern or similar",
            },
            {
              location: "Interlaken 2N",
              hotel: "Hotel Metropole or similar",
            },
            {
              location: "Zermatt 2N",
              hotel: "Ambassador Zermatt or Similar",
            },
            {
              location: "Montreux 2N",
              hotel: "Mona Montreux or Similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2537 per person onwards",
                  triple: "EUR 2322 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 967 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1569 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2562 per person onwards",
                  triple: "EUR 2381 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1095 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1592 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                {
                  pax: "02 – 08 Pax",
                  twinDouble: "EUR 2537 per person onwards",
                  triple: "EUR 2392 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1156 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1569 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Rhine Fall 15 minutes boat ride",
        price: "EUR 12",
      },
      {
        name: "Lindt home chocolate ticket",
        price: "EUR 20",
      },
      {
        name: "Jungfraujoch with Swiss Pass ticket",
        price: "EUR 145",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Switzerland/day-1.jpg",
      "/images/Switzerland/day-2.jpg",
      "/images/Switzerland/day-3.jpg",
      "/images/Switzerland/day-4.jpg",
      "/images/Switzerland/day-5.jpg",
      "/images/Switzerland/day-6.jpg",
      "/images/Switzerland/day-7.jpg",
      "/images/Switzerland/day-8.jpg",
      "/images/Switzerland/day-9.jpg",
    ],
  },

  {
    title: "Swiss Panorama Experience: Montreux, Lausanne & Geneva",
    slug: "montreux-lausanne-geneva-06n",
    price: "EUR 1289 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "",
    image: "/images/Swiss/day-1.jpg",
    location: "Montreux, Lausanne, Geneva",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Montreux, Lausanne, Geneva",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "06 Days Swiss Pass",
      ],

      highlights: [
        "Glacier 3000",
        "Mont Blanc Views",
        "Matterhorn Views",
        "Mt. Titlis",
        "Rotair Cable Car",
        "Ice Flyer",
        "Glacier Cave",
        "Chillon Castle",
        "Lake Geneva",
        "Geneva Old Town",
        "Jet d'Eau",
        "Flower Clock",
      ],

      experiences: [
        {
          title: "Montreux – Glacier 3000",
          desc: "Enjoy panoramic Alpine views including Mont Blanc and the Matterhorn, along with snow-covered landscapes and summit activities.",
        },
        {
          title: "Lausanne – Mt. Titlis",
          desc: "Travel to Mt. Titlis, ride the Rotair cable car, experience the Ice Flyer chairlift and explore the Glacier Cave.",
        },
        {
          title: "Lausanne – Chillon Castle",
          desc: "Visit Chillon Castle on the shores of Lake Geneva using the Swiss Pass.",
        },
        {
          title: "Geneva – Leisure Day",
          desc: "Explore Geneva's Jet d'Eau, United Nations area, Flower Clock and Old Town at leisure.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Geneva – Montreux",
        desc: "Arrival at Geneva Airport and travel to Montreux using your Swiss Pass. Check in and enjoy the lakeside surroundings at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Montreux – Excursion to Glacier 3000",
        desc: "Breakfast at Hotel. Proceed to Glacier 3000 using your Swiss Pass. Enjoy panoramic views of the Alps, Mont Blanc and Matterhorn, along with snow-covered landscapes and summit activities.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Montreux – Lausanne",
        desc: "Breakfast at Hotel. Travel from Montreux to Lausanne using your Swiss Pass. Check in and explore Lausanne at your own pace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Lausanne – Excursion to Mt. Titlis with Ice Flyer",
        desc: "Breakfast at Hotel. Enjoy a scenic journey to Mt. Titlis, ride the Rotair cable car, experience the Ice Flyer chairlift and explore the Glacier Cave.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Lausanne – Geneva | Chillon Castle",
        desc: "Breakfast at Hotel. Visit Chillon Castle using your Swiss Pass, then travel from Lausanne to Geneva. Explore Geneva's lakeside promenades, gardens and Old Town.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Geneva – Day at Leisure",
        desc: "Breakfast at Hotel. Enjoy a full day at leisure in Geneva. Explore Jet d'Eau, the United Nations area, Flower Clock and Old Town.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Geneva – India",
        desc: "Breakfast at Hotel. Private transfer from Geneva hotel to Geneva Airport for your return flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "02nd Class 06 Days Consecutive Swiss Pass",
        "Geneva Airport to Montreux by using Swiss Pass",
        "Excursion to Glacier 3000 with Swiss Pass",
        "Montreux to Lausanne by using Swiss Pass",
        "Excursion to Mt. Titlis with Ice Flyer",
        "Lausanne to Geneva by using Swiss Pass",
        "Visit Chillon Castle with Swiss Pass",
        "Private transfer from Geneva Hotel to Geneva Airport",
      ],

      excluded: [
        "Tours on SIC/Shared basis where client needs to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Personal expenses such as laundry, mineral water, drinks, telephone or other expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Montreux 2N",
              hotel: "Villa Toscane or Similar",
            },
            {
              location: "Lausanne 2N",
              hotel: "Ibis Lausanne Centre or Similar",
            },
            {
              location: "Geneva 2N",
              hotel: "Hotel Bernina Geneva or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1289 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1269 per person onwards",
                  triple: "EUR 1154 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1261 per person onwards",
                  triple: "EUR 1145 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 342 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 675 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1233 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1213 per person onwards",
                  triple: "EUR 1139 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1206 per person onwards",
                  triple: "EUR 1126 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 402 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 624 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1240 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1220 per person onwards",
                  triple: "EUR 1152 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1213 per person onwards",
                  triple: "EUR 1139 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 427 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 631 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Montreux 2N",
              hotel: "Mona Montreux or Similar",
            },
            {
              location: "Lausanne 2N",
              hotel: "Hotel Continental or Similar",
            },
            {
              location: "Geneva 2N",
              hotel: "Novotel Geneve Centre or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1530 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1510 per person onwards",
                  triple: "EUR 1341 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1502 per person onwards",
                  triple: "EUR 1333 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 429 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 906 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1419 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1399 per person onwards",
                  triple: "EUR 1300 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1398 per person onwards",
                  triple: "EUR 1292 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 518 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 800 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1508 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1488 per person onwards",
                  triple: "EUR 1373 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1487 per person onwards",
                  triple: "EUR 1365 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 559 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 889 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Capitals/day-1.jpg",
      "/images/Capitals/day-2.jpg",
      "/images/Capitals/day-3.jpg",
      "/images/Capitals/day-4.jpg",
      "/images/Capitals/day-5.jpg",
      "/images/Capitals/day-6.jpg",
    ]
  },

  {
    title: "Explore Brussels + Antwerp + Rotterdam",
    slug: "brussels-antwerp-rotterdam-06n",
    price: "EUR 634 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/bru/day-1.jpg",
    location: "Brussels, Antwerp, Rotterdam",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Brussels, Antwerp, Rotterdam",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers",
      ],

      highlights: [
        "Grand Place",
        "Atomium",
        "Royal Palace",
        "European Parliament",
        "Brussels Art Nouveau",
        "Antwerp Cathedral of Our Lady",
        "Grote Markt",
        "Scheldt Riverfront",
        "Cube Houses",
        "Erasmus Bridge",
        "Markthal",
        "Rotterdam Architecture",
        "World War II History",
      ],

      experiences: [
        {
          title: "Brussels – Hop-On Hop-Off Bus Tour",
          desc: "Enjoy a flexible 24-hour Brussels Hop-On Hop-Off Bus Tour covering major attractions including Grand Place, Atomium, Royal Palace, European Parliament and Art Nouveau neighbourhoods.",
        },
        {
          title: "Brussels – Antwerp",
          desc: "Travel by train from Brussels to Antwerp. The journey takes approximately 40–50 minutes and Antwerp offers historic architecture, fashion, art and gastronomy.",
        },
        {
          title: "Antwerp – Leisure Day",
          desc: "Enjoy a full day at leisure in Antwerp and explore its historic centre, architecture, markets, culture and attractions.",
        },
        {
          title: "Antwerp – Rotterdam",
          desc: "Travel by train from Antwerp to Rotterdam. Explore Rotterdam's modern architecture, Cube Houses, Erasmus Bridge, Markthal and waterfront.",
        },
        {
          title: "Rotterdam Walking Tour",
          desc: "Enjoy a shared-basis walking tour covering Rotterdam's highlights, hidden gems, architecture and World War II history.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Brussels",
        desc: "Arrival at Brussels Airport followed by a private transfer to the hotel. Enjoy the first evening exploring Brussels, including the Grand Place and historic cobblestone streets.",
        tags: [],
      },
      {
        day: "02",
        title: "Brussels – Brussels Hop-On Hop-Off Bus Tour – 24 Hours",
        desc: "Breakfast at Hotel. Proceed for the Brussels Hop-On Hop-Off Bus Tour on shared basis. Explore major Brussels landmarks including Grand Place, Atomium, Royal Palace, European Parliament and Art Nouveau neighbourhoods.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Brussels – Antwerp",
        desc: "Breakfast at Hotel. Travel by train from Brussels to Antwerp. The journey takes approximately 40–50 minutes. Explore Antwerp's Cathedral of Our Lady, Grote Markt and Scheldt riverfront.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Antwerp – Day Free for Leisure",
        desc: "Breakfast at Hotel. Enjoy a full day at leisure in Antwerp and explore the city at your own pace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Antwerp – Rotterdam",
        desc: "Breakfast at Hotel. Travel by train from Antwerp to Rotterdam. The journey takes approximately 1 hour to 1 hour 15 minutes. Explore Rotterdam's modern architecture and waterfront.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Rotterdam – Walking Tour: Highlights, Gems, Architecture & WW2 History",
        desc: "Breakfast at Hotel. Enjoy a shared-basis Rotterdam walking tour lasting approximately 2–3 hours, covering iconic sites, architecture, World War II history, hidden streets, vibrant squares and riverfronts.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Rotterdam – India",
        desc: "Breakfast at Hotel. Proceed to Rotterdam Airport by private transfer for the onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Transfer from Brussels Airport to Hotel on Private Basis",
        "Brussels Hop-On Hop-Off Bus Tour – 24 Hours",
        "Transfer from Brussels Hotel to Train Station on Private Basis",
        "Train from Brussels to Antwerp",
        "Transfer from Antwerp Train Station to Hotel on Private Basis",
        "Day Free at Leisure",
        "Transfer from Antwerp Hotel to Train Station on Private Basis",
        "Train from Antwerp to Rotterdam",
        "Transfer from Rotterdam Train Station to Hotel on Private Basis",
        "Rotterdam Walking Tour – Highlights, Gems, Architecture & History WW2 on Shared Basis",
        "Private Transfer from Rotterdam Hotel to Airport",
      ],

      excluded: [
        "Hotel pick-up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Brussels 2N",
              hotel: "B&B HOTEL Brussels Centre Louise or similar",
            },
            {
              location: "Antwerp 2N",
              hotel: "B&B HOTEL Antwerpen Zuid or similar",
            },
            {
              location: "Rotterdam 2N",
              hotel: "Ibis Rotterdam City Centre or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 634 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 545 per person onwards",
                  triple: "EUR 536 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 503 per person onwards",
                  triple: "EUR 492 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 337 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 310 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 895 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 825 per person onwards",
                  triple: "EUR 813 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 765 per person onwards",
                  triple: "EUR 740 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 430 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 592 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 741 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 653 per person onwards",
                  triple: "EUR 636 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 596 per person onwards",
                  triple: "EUR 582 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 438 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 429 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Brussels 2N",
              hotel: "The Liman Hotel or similar",
            },
            {
              location: "Antwerp 2N",
              hotel: "Crowne Plaza Antwerp or similar",
            },
            {
              location: "Rotterdam 2N",
              hotel: "Leonardo Hotel Rotterdam Savoy or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 722 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 633 per person onwards",
                  triple: "EUR 607 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 593 per person onwards",
                  triple: "EUR 556 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 356 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 395 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 903 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 833 per person onwards",
                  triple: "EUR 821 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 769 per person onwards",
                  triple: "EUR 752 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 333 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 492 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 753 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 664 per person onwards",
                  triple: "EUR 642 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 603 per person onwards",
                  triple: "EUR 590 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 335 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 428 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Brussels – Antwerp – Rotterdam 2nd Class Train Ticket",
        price: "EUR 100 - 110 per person",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/bru/day-1.jpg",
      "/images/bru/day-2.jpg",
      "/images/bru/day-3.jpg",
      "/images/bru/day-4.jpg",
      "/images/bru/day-5.jpg",
      "/images/bru/day-6.jpg",
    ]
  },

  {
    title: "Best of Denmark and Germany",
    slug: "copenhagen-hamburg-berlin-07n",
    price: "EUR 989 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/germany/day-4.jpg",
    location: "Copenhagen, Hamburg, Berlin",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Copenhagen, Hamburg, Berlin",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "Private Transfers",
      ],

      highlights: [
        "Copenhagen Walking Tour",
        "Copenhagen Canal Cruise",
        "Forest Tower",
        "Forgotten Giants Trolls",
        "Hamburg Old Town",
        "Rathausmarkt",
        "Berlin Hop-On Hop-Off Bus Tour",
        "Brandenburg Gate",
        "Berlin Wall Memorial",
        "Checkpoint Charlie",
        "Museum Island",
        "Alexanderplatz",
        "Berlin TV Tower",
      ],

      experiences: [
        {
          title: "Copenhagen – Walking Tour & Canal Cruise",
          desc: "Explore central Copenhagen through a shared-basis walking tour followed by a Copenhagen Canal Cruise with ticket included.",
        },
        {
          title: "Copenhagen – Forest Tower & Forgotten Giants",
          desc: "Take a shared/SIC day trip to Denmark's Forest Tower and Forgotten Giants. Forest Tower entrance is not included and guests need to reach the meeting point on their own.",
        },
        {
          title: "Hamburg – Old Town Walking Tour",
          desc: "Explore Hamburg's historic Old Town, architecture and landmarks through a shared-basis guided walking tour.",
        },
        {
          title: "Berlin – Hop-On Hop-Off & TV Tower",
          desc: "Explore Berlin's major landmarks using a one-day Hop-On Hop-Off Bus Tour and visit Berlin TV Tower with standard entrance ticket.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Copenhagen",
        desc: "Arrival in Copenhagen followed by a private transfer from the airport to the hotel. Evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Copenhagen – Group Walking Tour & Copenhagen Canal Cruise",
        desc: "Breakfast at Hotel. Join a shared-basis Copenhagen Group Walking Tour covering central Copenhagen highlights. After lunch on your own, enjoy the Copenhagen Canal Cruise with ticket included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Copenhagen – Forest Tower & Forgotten Giants Trolls Trip",
        desc: "Breakfast at Hotel. Proceed for the Forest Tower & Forgotten Giants Trolls Trip from Copenhagen on SIC basis. Guest needs to reach the meeting point on their own. Forest Tower entrance is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Copenhagen – Hamburg",
        desc: "Breakfast at Hotel. Check out and take a private transfer from hotel to airport. Fly from Copenhagen to Hamburg. On arrival, enjoy a private transfer to the hotel and spend the evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Hamburg – Hamburg Old Town Guided Walking Tour",
        desc: "Breakfast at Hotel. Join a shared-basis guided walking tour of Hamburg Old Town starting at Rathausmarkt. Evening at leisure to explore Hamburg further.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Hamburg – Berlin",
        desc: "Breakfast at Hotel. Private transfer from Hamburg Hotel to Hamburg Train Station. Board the train to Berlin. Private transfer from Berlin Train Station to hotel after arrival.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Berlin – Hop-On Hop-Off Bus Tour & Berlin TV Tower",
        desc: "Breakfast at Hotel. Enjoy a one-day Berlin Hop-On Hop-Off Bus Tour. Guest needs to reach the meeting point on their own. Visit Berlin TV Tower with standard entrance ticket. Remaining time at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Berlin – India",
        desc: "Breakfast at Hotel. Check out and proceed by private transfer from Berlin Hotel to Berlin Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "07 Night Accommodation with Breakfast",
        "Private Transfer from Copenhagen Airport to Hotel",
        "Copenhagen Group Walking Tour on Shared Basis",
        "Copenhagen Canal Cruise Ticket",
        "Forest Tower & Forgotten Giants Trolls Trip from Copenhagen on SIC Basis",
        "Private Transfer from Copenhagen Hotel to Airport",
        "Private Transfer from Hamburg Airport to Hotel",
        "Hamburg Old Town Guided Walking Tour on Shared Basis",
        "Private Transfer from Hamburg Hotel to Train Station",
        "Train from Hamburg to Berlin",
        "Private Transfer from Berlin Train Station to Hotel",
        "Berlin 01 Day Hop-On Hop-Off Bus Tour",
        "Berlin TV Tower Standard Entrance Ticket",
        "Private Transfer from Berlin Hotel to Airport",
      ],

      excluded: [
        "Tours on SIC/Shared basis where client needs to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Best Western Hotel Hebron or Similar",
            },
            {
              location: "Hamburg 2N",
              hotel: "ibis Hamburg Alster Centrum or similar",
            },
            {
              location: "Berlin 2N",
              hotel: "Novotel Suites Berlin City Potsdamer Platz or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 989 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 881 per person onwards",
                  triple: "EUR 822 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 816 per person onwards",
                  triple: "EUR 767 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 470 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 418 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1226 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1103 per person onwards",
                  triple: "EUR 974 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1043 per person onwards",
                  triple: "EUR 924 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 470 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 645 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1141 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1008 per person onwards",
                  triple: "EUR 929 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 958 per person onwards",
                  triple: "EUR 879 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 505 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 560 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Crowne Plaza Copenhagen Towers by IHG or Similar",
            },
            {
              location: "Hamburg 2N",
              hotel: "Hotel NH Collection Hamburg City or similar",
            },
            {
              location: "Berlin 2N",
              hotel: "Novotel Berlin Mitte or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1046 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 923 per person onwards",
                  triple: "EUR 868 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 873 per person onwards",
                  triple: "EUR 818 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 492 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 475 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1271 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1148 per person onwards",
                  triple: "EUR 1080 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1093 per person onwards",
                  triple: "EUR 1015 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 638 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 675 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1231 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1118 per person onwards",
                  triple: "EUR 1042 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1068 per person onwards",
                  triple: "EUR 987 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 629 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 660 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "2nd Class Train Ticket from Hamburg to Berlin",
        price: "EUR 45 - 55 per person",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/germany/day-1.jpg",
      "/images/germany/day-2.jpg",
      "/images/germany/day-3.jpg",
      "/images/germany/day-4.jpg",
      "/images/germany/day-5.jpg",
      "/images/germany/day-6.jpg",
      "/images/germany/day-7.jpg",
    ]

  },

  {
    title: "Explore Denmark, Sweden and Norway",
    slug: "copenhagen-stockholm-oslo-07n",
    price: "EUR 1158 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/denmark/day-1.jpg",
    location: "Copenhagen, Stockholm, Oslo",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Copenhagen, Stockholm, Oslo",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "Private Transfers",
      ],

      highlights: [
        "Copenhagen Walking Tour",
        "Copenhagen Canal Cruise",
        "Forest Tower",
        "Forgotten Giants Trolls",
        "Stockholm Old Town",
        "Medieval Streets",
        "Oslo Guided Walking Tour",
        "Oslofjord Scenic Cruise",
        "Oslo Islands",
        "Norwegian Coastline",
      ],

      experiences: [
        {
          title: "Copenhagen – Walking Tour & Canal Cruise",
          desc: "Explore central Copenhagen through a shared-basis walking tour followed by a canal cruise with ticket included.",
        },
        {
          title: "Copenhagen – Forest Tower & Forgotten Giants",
          desc: "Enjoy a shared-basis day trip to Forest Tower and Forgotten Giants. Forest Tower entrance is not included and guests need to reach the meeting point on their own.",
        },
        {
          title: "Stockholm – Old Town Walking Tour",
          desc: "Explore Stockholm's historic Old Town, narrow medieval streets and vintage buildings through a shared-basis walking tour.",
        },
        {
          title: "Oslo – Walking Tour & Fjord Cruise",
          desc: "Explore Oslo through a shared-basis guided walking tour followed by an approximately 2-hour scenic Oslofjord cruise.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Copenhagen",
        desc: "Arrival in Copenhagen followed by a private transfer from the airport to the hotel. Evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Copenhagen – Group Walking Tour & Copenhagen Canal Cruise",
        desc: "Breakfast at Hotel. Join a shared-basis Copenhagen Group Walking Tour covering central Copenhagen. After lunch on your own, enjoy the Copenhagen Canal Cruise with ticket included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Copenhagen – Forest Tower & Forgotten Giants Trolls Trip",
        desc: "Breakfast at Hotel. Proceed for the Forest Tower & Forgotten Giants Trolls Trip on SIC basis. Guests need to reach the meeting point on their own. Forest Tower entrance is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Copenhagen – Stockholm",
        desc: "Breakfast at Hotel. Check out and take private transfer to Copenhagen Airport for the flight to Stockholm. On arrival, private transfer to the Stockholm hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Stockholm – Stockholm Old Town Walking Tour",
        desc: "Breakfast at Hotel. Join a shared-basis walking tour through Stockholm Old Town, exploring medieval streets and historic buildings. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Stockholm – Oslo",
        desc: "Breakfast at Hotel. Check out and take private transfer from Stockholm Hotel to airport/transport hub. Travel to Oslo and take private transfer to the Oslo hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Oslo – Guided Walking Tour & Scenic Fjord Cruise",
        desc: "Breakfast at Hotel. Enjoy a shared-basis guided walking tour of Oslo followed by an approximately 2-hour shared-basis Oslofjord scenic cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Oslo – India",
        desc: "Breakfast at Hotel. Check out and take private transfer from Oslo Hotel to Oslo Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "07-Night Accommodation with Breakfast",
        "Private Transfer from Copenhagen Airport to Hotel on Arrival",
        "Shared-Basis Copenhagen City Walking Tour",
        "Copenhagen Canal Cruise – Ticket Included",
        "Shared-Basis Forest Tower & Forgotten Giants Day Trip from Copenhagen including Transport & Tour",
        "Forest Tower Entrance Fee Excluded",
        "Private Transfer from Copenhagen Hotel to Airport on Departure",
        "Private Transfer from Stockholm Airport to Hotel on Arrival",
        "Shared-Basis Stockholm Old Town Walking Tour",
        "Private Transfer from Stockholm Hotel to Airport / Onward Transport Hub on Departure",
        "Private Transfer from Oslo Airport to Hotel on Arrival",
        "Shared-Basis Oslo Guided Walking Tour",
        "Shared-Basis Oslofjord Scenic Cruise",
        "Private Transfer from Oslo Hotel to Airport on Departure",
      ],

      excluded: [
        "Tours on SIC/Shared basis where client needs to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Best Western Hotel Hebron or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "ibis Styles Stockholm Odenplan or similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Thon Hotel Europa or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1158 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 974 per person onwards",
                  triple: "EUR 934 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 896 per person onwards",
                  triple: "EUR 861 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 518 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 475 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1218 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1084 per person onwards",
                  triple: "EUR 1059 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1006 per person onwards",
                  triple: "EUR 981 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 758 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 535 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1188 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1004 per person onwards",
                  triple: "EUR 984 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 926 per person onwards",
                  triple: "EUR 906 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 593 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 505 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Crowne Plaza Copenhagen Towers by IHG or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "Courtyard by Marriott Stockholm Kungsholmen or similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Radisson Blu Plaza Hotel, Oslo or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1193 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1016 per person onwards",
                  triple: "EUR 989 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 936 per person onwards",
                  triple: "EUR 904 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 562 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 510 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1308 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1134 per person onwards",
                  triple: "EUR 1095 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1046 per person onwards",
                  triple: "EUR 1012 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 671 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 625 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1328 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1189 per person onwards",
                  triple: "EUR 1063 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1066 per person onwards",
                  triple: "EUR 985 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 550 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 645 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/denmark/day-1.jpg",
      "/images/denmark/day-2.jpg",
      "/images/denmark/day-3.jpg",
      "/images/denmark/day-4.jpg",
      "/images/denmark/day-5.jpg",
      "/images/denmark/day-6.jpg",
      "/images/denmark/day-7.jpg",
    ]
  },

  {
    title: "Glimpses of Denmark, Sweden & Germany",
    slug: "copenhagen-stockholm-hamburg-07n",
    price: "EUR 1032 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/mark/day-1.jpg",
    location: "Copenhagen, Stockholm, Hamburg",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Copenhagen, Stockholm, Hamburg",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "Private Transfers",
      ],

      highlights: [
        "Copenhagen Walking Tour",
        "Copenhagen Canal Cruise",
        "Forest Tower",
        "Forgotten Giants Trolls",
        "Stockholm Old Town",
        "Medieval Streets",
        "Hamburg Old Town",
        "Historic Architecture",
        "City Centre Landmarks",
      ],

      experiences: [
        {
          title: "Copenhagen – Walking Tour & Canal Cruise",
          desc: "Explore central Copenhagen through a shared-basis walking tour followed by a canal cruise with ticket included.",
        },
        {
          title: "Copenhagen – Forest Tower & Forgotten Giants",
          desc: "Enjoy a shared-basis day trip to Forest Tower and Forgotten Giants. Forest Tower entrance is not included and guests need to reach the meeting point on their own.",
        },
        {
          title: "Stockholm – Old Town Walking Tour",
          desc: "Explore Stockholm's historic Old Town, narrow medieval streets and vintage buildings through a shared-basis walking tour.",
        },
        {
          title: "Hamburg – Old Town Walking Tour",
          desc: "Explore Hamburg's historic architecture, city-centre landmarks and learn about the city's past and present through a shared-basis guided walking tour.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Copenhagen",
        desc: "Arrival in Copenhagen followed by a private transfer from the airport to the hotel. Evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Copenhagen – Group Walking Tour & Copenhagen Canal Cruise",
        desc: "Breakfast at Hotel. Join a shared-basis Copenhagen Group Walking Tour covering central Copenhagen. After lunch on your own, enjoy the Copenhagen Canal Cruise with ticket included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Copenhagen – Forest Tower & Forgotten Giants Trolls Trip",
        desc: "Breakfast at Hotel. Proceed for the Forest Tower & Forgotten Giants Trolls Trip on SIC basis. Guests need to reach the meeting point on their own. Forest Tower entrance is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Copenhagen – Stockholm",
        desc: "Breakfast at Hotel. Check out and take private transfer to Copenhagen Airport for the flight to Stockholm. On arrival, private transfer to Stockholm Hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Stockholm – Stockholm Old Town Walking Tour",
        desc: "Breakfast at Hotel. Join a shared-basis walking tour through Stockholm Old Town, exploring narrow medieval streets and historic buildings. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Stockholm – Hamburg",
        desc: "Breakfast at Hotel. Check out and take private transfer from Stockholm Hotel to airport or transport hub. Travel to Hamburg and take the included private transfer from Hamburg Airport to the hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Hamburg – Hamburg Old Town Guided Walking Tour",
        desc: "Breakfast at Hotel. Join a shared-basis guided walking tour of Hamburg Old Town covering historic architecture, city-centre landmarks and the city's past and present. Free time afterwards.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Hamburg – India",
        desc: "Breakfast at Hotel. Check out and take private transfer from Hamburg Hotel to Hamburg Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "07-night accommodation with breakfast for the entire trip as per chosen hotels",
        "Private Transfer from Copenhagen Airport to Hotel upon arrival",
        "Shared-Basis Copenhagen City Walking Tour",
        "Copenhagen Canal Cruise Ticket",
        "Shared-Basis Forest Tower & Forgotten Giants Day Trip from Copenhagen including Transport & Tour",
        "Forest Tower Entrance Not Included",
        "Private Transfer from Copenhagen Hotel to Airport for Departure",
        "Private Transfer from Stockholm Airport to Hotel on Arrival",
        "Shared-Basis Stockholm Old Town Walking Tour",
        "Private Transfer from Stockholm Hotel to Airport / Departure Transport",
        "Private Transfer from Hamburg Airport to Hotel on Arrival",
        "Shared-Basis Hamburg Old Town Guided Walking Tour",
        "Private Transfer from Hamburg Hotel to Airport / Onward Transport",
      ],

      excluded: [
        "Tours on SIC/Shared basis where client needs to reach the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Best Western Hotel Hebron or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "ibis Styles Stockholm Odenplan or similar",
            },
            {
              location: "Hamburg 2N",
              hotel: "ibis Hamburg Alster Centrum or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1032 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 859 per person onwards",
                  triple: "EUR 853 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 794 per person onwards",
                  triple: "EUR 778 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 553 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 390 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1227 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1039 per person onwards",
                  triple: "EUR 1004 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 969 per person onwards",
                  triple: "EUR 934 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 621 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 575 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1152 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 964 per person onwards",
                  triple: "EUR 936 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 894 per person onwards",
                  triple: "EUR 866 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 567 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 500 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Copenhagen 3N",
              hotel: "Crowne Plaza Copenhagen Towers by IHG or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "Courtyard by Marriott Stockholm Kungsholmen or similar",
            },
            {
              location: "Hamburg 2N",
              hotel: "Hotel NH Collection Hamburg City or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1177 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 996 per person onwards",
                  triple: "EUR 947 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 914 per person onwards",
                  triple: "EUR 870 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 530 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 525 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1332 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1149 per person onwards",
                  triple: "EUR 1084 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1079 per person onwards",
                  triple: "EUR 1009 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 636 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 680 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                {
                  pax: "02 Pax",
                  twinDouble: "EUR 1342 per person onwards",
                },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1129 per person onwards",
                  triple: "EUR 1026 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1054 per person onwards",
                  triple: "EUR 955 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 502 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 660 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/mark/day-1.jpg",
      "/images/mark/day-2.jpg",
      "/images/mark/day-3.jpg",
      "/images/mark/day-4.jpg",
      "/images/mark/day-5.jpg",
      "/images/mark/day-6.jpg",
      "/images/mark/day-7.jpg",
    ]
  },

  {
    title: "Scandinavian Capitals Express",
    slug: "helsinki-stockholm-oslo-06n",
    price: "EUR 1088 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Express/day-1.jpg",
    location: "Helsinki, Stockholm, Oslo",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Helsinki, Stockholm, Oslo",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Private Transfers",
      ],

      highlights: [
        "Helsinki Hop-On Hop-Off",
        "Senate Square",
        "Rock Church",
        "Sibelius Monument",
        "Market Square",
        "Helsinki Cathedral",
        "Stockholm Old Town",
        "Gamla Stan",
        "Royal Palace",
        "Oslo Walking Tour",
        "Oslofjord Scenic Cruise",
        "Oslo Islands",
        "Coastal Landscapes",
      ],

      experiences: [
        {
          title: "Helsinki – Hop-On Hop-Off Sightseeing",
          desc: "Explore Helsinki with a 1-day Hop-On Hop-Off Bus Pass covering Senate Square, Rock Church, Sibelius Monument, Market Square, Helsinki Cathedral, Waterfront and Old Market Hall.",
        },
        {
          title: "Stockholm – Old Town Walking Tour",
          desc: "Enjoy a shared walking tour through Gamla Stan, medieval alleys, colorful buildings, Royal Palace surroundings and historic squares.",
        },
        {
          title: "Oslo – Guided Walking Tour",
          desc: "Explore Oslo through a shared-basis guided walking tour covering the Norwegian capital's central sights.",
        },
        {
          title: "Oslo – Scenic Fjord Cruise",
          desc: "Enjoy a shared-basis scenic cruise through Oslofjord, passing islands, coastal landscapes and traditional summer houses.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Helsinki",
        desc: "Arrive at Helsinki Airport and meet your driver for a private transfer to the hotel. After check-in, relax or explore Helsinki's streets, waterfront promenades and Market Square at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Helsinki – Hop-On Hop-Off Sightseeing",
        desc: "Breakfast at Hotel. Enjoy the Helsinki Hop-On Hop-Off Bus Pass valid for 1 day. Explore Senate Square, Rock Church, Sibelius Monument, Market Square, Helsinki Cathedral, Waterfront and Old Market Hall.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Helsinki – Stockholm",
        desc: "Breakfast at Hotel. Private transfer from Helsinki Hotel to the airport for the flight to Stockholm. On arrival, private transfer from Stockholm Airport to the hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Stockholm – Old Town Walking Tour",
        desc: "Breakfast at Hotel. Join a shared Old Town (Gamla Stan) Walking Tour covering medieval alleys, colorful buildings, Royal Palace surroundings and historic squares.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Stockholm – Oslo",
        desc: "Breakfast at Hotel. Private transfer from Stockholm Hotel to the airport for the flight to Oslo. On arrival, private transfer to the Oslo hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Oslo – Walking Tour + Scenic Fjord Cruise",
        desc: "Breakfast at Hotel. Enjoy the Oslo Guided Walking Tour on shared basis followed by the Oslo Scenic Fjord Cruise on shared basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Oslo – India",
        desc: "Breakfast at Hotel. Check out and proceed by private transfer from Oslo Hotel to the airport for the return flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private Transfer from Helsinki Airport to Hotel",
        "Helsinki Hop on Hop off Bus Valid for 1 Day",
        "Private Transfer from Helsinki Hotel to Airport",
        "Private Transfer from Stockholm Airport to Hotel",
        "Stockholm Old Town Walking Tour on Shared Basis",
        "Private Transfer from Stockholm Hotel to Airport",
        "Private Transfer from Oslo Airport to Hotel",
        "Oslo Guided Walking Tour on Shared Basis",
        "Oslo Scenic Fjord Cruise on Shared Basis",
        "Private Transfer from Oslo Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Helsinki 2N",
              hotel: "Scandic Kallio or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "ibis Styles Stockholm Odenplan or similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Thon Hotel Europa or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1088 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 909 per person onwards",
                  triple: "EUR 893 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 831 per person onwards",
                  triple: "EUR 730 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 430 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 490 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 983 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 978 per person onwards",
                  triple: "EUR 864 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 825 per person onwards",
                  triple: "EUR 756 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 390 per child",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 453",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 920 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 892 per person onwards",
                  triple: "EUR 793 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 728 per person onwards",
                  triple: "EUR 681 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 289 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 355",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Helsinki 2N",
              hotel: "Scandic Park Helsinki or Similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "Courtyard by Marriott Stockholm Kungsholmen or similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Radisson Blu Plaza Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1096 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1002 per person onwards",
                  triple: "EUR 917 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 912 per person onwards",
                  triple: "EUR 754 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 445 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 512 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1005 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 995 per person onwards",
                  triple: "EUR 886 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 912 per person onwards",
                  triple: "EUR 832 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 415 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 490 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 986 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 912 per person onwards",
                  triple: "EUR 856 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 761 per person onwards",
                  triple: "EUR 712 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 295 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 355 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Express/day-1.jpg",
      "/images/Express/day-2.jpg",
      "/images/Express/day-3.jpg",
      "/images/Express/day-4.jpg",
      "/images/Express/day-5.jpg",
      "/images/Express/day-6.jpg",
    ]
  },

  {
    title: "Finland Getaway Plus",
    slug: "helsinki-rovaniemi-saariselka-08n",
    price: "EUR 2295 per person onwards",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/gate/day-2.jpg",
    location: "Helsinki, Rovaniemi, Saariselkä",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 08 Nights",
        places: "Helsinki, Rovaniemi, Saariselkä",
      },

      pills: [
        "Breakfast Included",
        "08 Nights Accommodation",
        "Northern Lights",
        "Glass Igloo Stay",
      ],

      highlights: [
        "Helsinki Walking Tour",
        "Tallinn Guided Day Tour",
        "Ferry Crossing",
        "Northern Lights Tour",
        "Santa Claus Village",
        "Arctic Circle",
        "Husky Sled Ride",
        "Reindeer Sled Ride",
        "Ranua Wildlife Park",
        "Glass Igloo",
        "Arctic Landscape",
      ],

      experiences: [
        {
          title: "Helsinki – Walking Tour",
          desc: "Explore Helsinki through a shared-basis walking tour covering key attractions, historic streets, waterfronts and the city's urban atmosphere.",
        },
        {
          title: "Helsinki – Tallinn Guided Day Tour",
          desc: "Travel by ferry across the Gulf of Finland to Tallinn and explore the medieval Old Town, historic lanes, churches and old city walls.",
        },
        {
          title: "Rovaniemi – Northern Lights Tour",
          desc: "Enjoy an included shared-basis Northern Lights tour, subject to weather and solar activity conditions.",
        },
        {
          title: "Rovaniemi – Santa Claus Village",
          desc: "Visit Santa Claus Village, cross the Arctic Circle and experience a husky or reindeer sled ride subject to operational conditions.",
        },
        {
          title: "Rovaniemi – Ranua Wildlife Park",
          desc: "Visit Ranua Wildlife Park with included tickets and see Arctic wildlife including polar bears, lynx and moose.",
        },
        {
          title: "Saariselkä – Glass Igloo",
          desc: "Stay in a glass igloo and enjoy the Arctic sky, snow-covered surroundings and potential Northern Lights viewing in favourable conditions.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Helsinki",
        desc: "Arrive at Helsinki Airport and take a private transfer to the hotel. Evening at leisure to relax or explore Helsinki.",
        tags: [],
      },
      {
        day: "02",
        title: "Helsinki – Walking Tour on Shared Basis",
        desc: "Breakfast at Hotel. Join a shared-basis walking tour of Helsinki covering key attractions, historic streets, waterfronts and urban highlights. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Helsinki – Tallinn Guided Day Tour with Ferry Crossing",
        desc: "Breakfast at Hotel. Proceed to the ferry terminal and travel across the Gulf of Finland to Tallinn. Explore Tallinn Old Town, medieval buildings, historic lanes, churches and old city walls before returning to Helsinki by ferry.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Helsinki – Rovaniemi",
        desc: "Breakfast at Hotel. Check out and transfer to Helsinki Airport. Travel to Rovaniemi by domestic flight or as per travel arrangement. Private transfer from Rovaniemi Airport to hotel. Evening at leisure followed by the included Northern Lights Tour, subject to weather and solar activity.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Rovaniemi – Santa Claus Village + Husky & Reindeer Sled Ride",
        desc: "Breakfast at Hotel. Visit Santa Claus Village, cross the Arctic Circle and enjoy a husky or reindeer sled ride, subject to operational conditions.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Rovaniemi – Ranua Zoo with Tickets",
        desc: "After breakfast, proceed on SIC basis to Ranua Wildlife Park with included tickets. Explore Arctic wildlife including polar bears, lynx and moose.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Rovaniemi – Saariselkä",
        desc: "Breakfast at Hotel. Check out and take private transfer from Rovaniemi Hotel to the Saariselkä resort. Check in and settle for the night.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Saariselkä – Day at Leisure",
        desc: "Breakfast at the resort. Spend the day at leisure in the Arctic surroundings. Enjoy the glass-igloo experience, resort amenities, snow landscapes and potential Northern Lights viewing.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Saariselkä – India",
        desc: "Breakfast at Hotel. Check out and take a private transfer from Saariselkä Hotel to Ivalo Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "08 Night Accommodation with Breakfast",
        "Private Transfer from Helsinki Airport to Hotel",
        "Helsinki Walking Tour on Shared Basis",
        "Tallinn Guided Day Tour with Ferry Crossing on Shared Basis from Helsinki",
        "Private Transfer from Helsinki Hotel to Airport",
        "Private Transfer from Rovaniemi Airport to Hotel",
        "Northern Lights Tour from Rovaniemi on SIC Basis",
        "Santa Claus Village + Husky & Reindeer Sled Ride from Rovaniemi on Shared Basis",
        "Trip to Ranua Zoo with Tickets from Rovaniemi on SIC Basis",
        "Private Transfer from Rovaniemi Hotel to Saariselkä Hotel",
        "Private Transfer from Saariselkä Hotel to Ivalo Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Helsinki 3N",
              hotel: "Scandic Pasila or Similar",
            },
            {
              location: "Rovaniemi 3N",
              hotel: "Scandic Rovaniemi City or similar",
            },
            {
              location: "Saariselkä 2N",
              hotel: "Kakslauttanen Arctic Resort (Glass Igloo) or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2295 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 2041 per person onwards",
                  triple: "EUR 1995 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1954 per person onwards",
                  triple: "EUR 1824 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1263 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1135 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2145 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1896 per person onwards",
                  triple: "EUR 1715 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1809 per person onwards",
                  triple: "EUR 1554 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 743 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 990 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2180 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1931 per person onwards",
                  triple: "EUR 1736 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1839 per person onwards",
                  triple: "EUR 1575 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 736 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1025 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Helsinki 3N",
              hotel: "Radisson Blu Seaside Hotel, Helsinki or Similar",
            },
            {
              location: "Rovaniemi 3N",
              hotel: "Original Sokos Hotel Vaakuna, Rovaniemi or similar",
            },
            {
              location: "Saariselkä 2N",
              hotel: "Kakslauttanen Arctic Resort (Glass Igloo) or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2205 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1951 per person onwards",
                  triple: "EUR 1880 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1864 per person onwards",
                  triple: "EUR 1709 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1098 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 1045 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2085 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1831 per person onwards",
                  triple: "EUR 1755 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1744 per person onwards",
                  triple: "EUR 1594 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 973 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 935 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 2105 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1841 per person onwards",
                  triple: "EUR 1783 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1744 per person onwards",
                  triple: "EUR 1617 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 1042 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 935 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/gate/day-1.jpg",
      "/images/gate/day-2.jpg",
      "/images/gate/day-3.jpg",
      "/images/gate/day-4.jpg",
      "/images/gate/day-5.jpg",
      "/images/gate/day-6.jpg",
      "/images/gate/day-7.jpg",
      "/images/gate/day-8.jpg",
    ]
  },

  {
    title: "Mesmerizing Finland and Sweden",
    slug: "helsinki-rovaniemi-stockholm-08n",
    price: "EUR 1640 per person onwards",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/Sweden/day-1.jpg",
    location: "Helsinki, Rovaniemi, Stockholm",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 08 Nights",
        places: "Helsinki, Rovaniemi, Stockholm",
      },

      pills: [
        "Breakfast Included",
        "08 Nights Accommodation",
        "Northern Lights",
        "Arctic Experiences",
      ],

      highlights: [
        "Helsinki Walking Tour",
        "Tallinn Guided Day Tour",
        "Ferry Crossing",
        "Northern Lights Tour",
        "Santa Claus Village",
        "Arctic Circle",
        "Husky Sled Ride",
        "Reindeer Sled Ride",
        "Ranua Wildlife Park",
        "Stockholm Old Town",
        "Gamla Stan",
        "Medieval Streets",
      ],

      experiences: [
        {
          title: "Helsinki – Walking Tour",
          desc: "Explore Helsinki through a shared-basis walking tour covering key attractions, historic streets, waterfronts and the city's urban atmosphere.",
        },
        {
          title: "Helsinki – Tallinn Guided Day Tour",
          desc: "Take a ferry across the Gulf of Finland to Tallinn and explore its medieval Old Town, historic lanes, churches and old city walls.",
        },
        {
          title: "Rovaniemi – Northern Lights",
          desc: "Enjoy a shared-basis Northern Lights tour from Rovaniemi, subject to operational and weather conditions.",
        },
        {
          title: "Rovaniemi – Santa Claus Village",
          desc: "Visit Santa Claus Village, cross the Arctic Circle and enjoy a husky or reindeer sled ride subject to operational conditions.",
        },
        {
          title: "Rovaniemi – Ranua Zoo",
          desc: "Visit Ranua Wildlife Park with tickets included and explore Arctic wildlife.",
        },
        {
          title: "Stockholm – Old Town Walking Tour",
          desc: "Explore Stockholm's historic Old Town through charming narrow alleys, historic buildings, waterfront districts and cultural landmarks.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Helsinki",
        desc: "Arrive at Helsinki Airport and take a private transfer to the hotel. Evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Helsinki – Walking Tour on Shared Basis",
        desc: "Breakfast at Hotel. Join a shared-basis Helsinki walking tour covering key attractions, historic streets, waterfronts and the city's urban vibe. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Helsinki – Tallinn Guided Day Tour with Ferry Crossing",
        desc: "Breakfast at Hotel. Proceed to the ferry terminal and travel across the Gulf of Finland to Tallinn. Explore Tallinn Old Town and return to Helsinki by ferry.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Helsinki – Rovaniemi",
        desc: "Breakfast at Hotel. Check out and transfer to Helsinki Airport. Travel to Rovaniemi by domestic flight or as per travel arrangement. Private transfer to hotel. Evening Northern Lights Tour on shared basis, subject to weather and solar activity.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Rovaniemi – Santa Claus Village + Husky & Reindeer Sled Ride",
        desc: "Breakfast at Hotel. Visit Santa Claus Village, cross the Arctic Circle and enjoy a husky or reindeer sled ride subject to operational conditions.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Rovaniemi – Ranua Zoo with Tickets",
        desc: "After breakfast, proceed to Ranua Wildlife Park on SIC basis with tickets included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Rovaniemi – Stockholm",
        desc: "Breakfast at Hotel. Check out and take private transfer from Rovaniemi to the next destination, Stockholm. On arrival, check in to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Stockholm – Old Town Walking Tour",
        desc: "Breakfast at Hotel. Join a shared-basis walking tour of Stockholm's historic Old Town covering narrow alleys, historic buildings, waterfront districts and cultural heritage. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Stockholm – India",
        desc: "Breakfast at Hotel. Check out and take private transfer from Stockholm Hotel to Stockholm Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "08 Night Accommodation with Breakfast",
        "Private Transfer from Helsinki Airport to Hotel",
        "Helsinki Walking Tour on Shared Basis",
        "Tallinn Guided Day Tour with Ferry Crossing on Shared Basis",
        "Private Transfer from Helsinki Hotel to Airport",
        "Private Transfer from Rovaniemi Airport to Hotel",
        "Northern Lights Tour from Rovaniemi on SIC Basis",
        "Santa Claus Village + Husky & Reindeer Sled Ride from Rovaniemi on Shared Basis",
        "Trip to Ranua Zoo with Tickets from Rovaniemi on SIC Basis",
        "Private Transfer from Rovaniemi Hotel to Airport",
        "Private Transfer from Stockholm Airport to Hotel",
        "Stockholm Old Town Walking Tour on Shared Basis",
        "Private Transfer from Stockholm Hotel to Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "Helsinki 3N",
              hotel: "Scandic Pasila or Similar",
            },
            {
              location: "Rovaniemi 3N",
              hotel: "Scandic Rovaniemi City or similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "ibis Styles Stockholm Odenplan or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1640 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1500 per person onwards",
                  triple: "EUR 1420 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1448 per person onwards",
                  triple: "EUR 1358 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 937 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 700 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1453 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1308 per person onwards",
                  triple: "EUR 1195 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1241 per person onwards",
                  triple: "EUR 1128 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 691 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 523 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1557 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1411 per person onwards",
                  triple: "EUR 1205 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1348 per person onwards",
                  triple: "EUR 1138 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 510 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 625 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "Helsinki 3N",
              hotel: "Radisson Blu Seaside Hotel, Helsinki or Similar",
            },
            {
              location: "Rovaniemi 3N",
              hotel: "Original Sokos Hotel Vaakuna, Rovaniemi or similar",
            },
            {
              location: "Stockholm 2N",
              hotel: "Best Western Time Hotel or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1580 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1425 per person onwards",
                  triple: "EUR 1325 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1363 per person onwards",
                  triple: "EUR 1283 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 842 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 635 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1480 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1335 per person onwards",
                  triple: "EUR 1285 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1273 per person onwards",
                  triple: "EUR 1218 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 892 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 550 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "EUR 1495 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "EUR 1345 per person onwards",
                  triple: "EUR 1292 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "EUR 1283 per person onwards",
                  triple: "EUR 1225 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "EUR 893 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "EUR 560 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Sweden/day-1.jpg",
      "/images/Sweden/day-2.jpg",
      "/images/Sweden/day-3.jpg",
      "/images/Sweden/day-4.jpg",
      "/images/Sweden/day-5.jpg",
      "/images/Sweden/day-6.jpg",
      "/images/Sweden/day-7.jpg",
      "/images/Sweden/day-8.jpg",
    ]
  },

  {
    title: "Classic Europe Escape: London & Amsterdam Highlights",
    slug: "london-amsterdam-06n",
    price: "GBP 1340 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/dam/day-1.jpg",
    location: "London, Amsterdam",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "London, Amsterdam",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "London Eye",
        "Canal Cruise",
      ],

      highlights: [
        "London City Tour",
        "London Eye",
        "London River Cruise",
        "Madame Tussauds",
        "Tower Bridge",
        "Amsterdam Hop-On Hop-Off",
        "Amsterdam Canal Cruise",
        "Zaanse Schans",
        "Edam",
        "Volendam",
        "Marken",
      ],

      experiences: [
        {
          title: "London – City Tour + London Eye + River Cruise",
          desc: "Enjoy a London city tour on SIC basis with London Eye Standard Entry and a London River Cruise along the River Thames.",
        },
        {
          title: "London – Madame Tussauds + Tower Bridge",
          desc: "Explore London with Madame Tussauds Standard Entry and Tower Bridge Entry, including the iconic high-level glass walkways.",
        },
        {
          title: "Amsterdam – Hop-On Hop-Off + Canal Cruise",
          desc: "Explore Amsterdam using the 1-day Hop-On Hop-Off City Tour and enjoy a classic Amsterdam Canal Cruise.",
        },
        {
          title: "Amsterdam – Zaanse Schans, Edam, Volendam & Marken",
          desc: "Enjoy a full-day SIC tour through the Dutch countryside, visiting windmills, cheese factories, wooden houses and traditional fishing villages.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrive in London where a private driver will meet you at the arrivals hall and transfer you directly to the hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "London – City Tour with London Eye and London River Cruise",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis. Enjoy the London Eye Experience with standard entry and a London River Cruise along the River Thames.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – City Tour with Madame Tussauds and Tower Bridge",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis including Madame Tussauds Standard Entry and Tower Bridge Entry.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "London – Amsterdam",
        desc: "Breakfast at Hotel. Private transfer from London Hotel to London Train Station. Board the train to Amsterdam. On arrival, meet your private driver at Amsterdam Train Station for transfer to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Amsterdam – Hop-On Hop-Off City Tour & Canal Cruise",
        desc: "Breakfast at Hotel. Enjoy the 1-day Amsterdam Hop-On Hop-Off City Tour followed by an Amsterdam Canal Cruise through the city's canal network.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Amsterdam – Zaanse Schans, Edam, Volendam & Marken",
        desc: "Breakfast at Hotel. Proceed for a full-day SIC tour to Zaanse Schans, Edam, Volendam and Marken.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Amsterdam – India",
        desc: "Breakfast at Hotel. Private transfer from Amsterdam Hotel to Amsterdam Airport for the return flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from London Airport (LHR) to London Hotel",
        "02 Days London Hop On Hop Off City Tour",
        "London Eye Standard Entry Ticket",
        "London River Cruise Ticket",
        "Madame Tussauds Standard Entry Ticket",
        "London Tower Bridge Entry Ticket",
        "Private transfer from London Hotel to London Train Station",
        "Private transfer from Amsterdam Train Station to Amsterdam Hotel",
        "01 Day Amsterdam Hop On Hop Off City Tour",
        "Amsterdam Canal Cruise Ticket",
        "Zaanse Schans, Edam, Volendam & Marken Tour from Amsterdam on SIC Basis",
        "Private transfer from Amsterdam Hotel to Amsterdam Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water, drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 3* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "Hampton by Hilton London Waterloo or Similar",
            },
            {
              location: "Amsterdam 3N",
              hotel: "The Highlander Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1340 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1277 per person onwards",
                  triple: "GBP 1056 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1249 per person onwards",
                  triple: "GBP 1025 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 411 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 903 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1086 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1102 per person onwards",
                  triple: "GBP 1092 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1079 per person onwards",
                  triple: "GBP 1064 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 1025 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 653 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1284 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1245 per person onwards",
                  triple: "GBP 1208 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1194 per person onwards",
                  triple: "GBP 1179 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 953 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 851 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 4* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "The Clermont Charing Cross or Similar",
            },
            {
              location: "Amsterdam 3N",
              hotel: "Park Plaza Victoria Amsterdam or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1420 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1417 per person onwards",
                  triple: "GBP 1387 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1374 per person onwards",
                  triple: "GBP 1364 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 1246 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 1009 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1625 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1574 per person onwards",
                  triple: "GBP 1416 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1549 per person onwards",
                  triple: "GBP 1388 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 878 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 1199 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1668 per person onwards" },
                {
                  pax: "04 Pax",
                  twinDouble: "GBP 1617 per person onwards",
                  triple: "GBP 1549 per person onwards",
                },
                {
                  pax: "06 Pax",
                  twinDouble: "GBP 1592 per person onwards",
                  triple: "GBP 1521 per person onwards",
                },
                {
                  pax: "Child Sharing with Extra Bed",
                  price: "GBP 1191 per child onwards",
                },
                {
                  pax: "Single Room Supplement",
                  price: "GBP 1242 onwards",
                },
                {
                  pax: "Below 2-year child",
                  price: "Free of cost",
                },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "London - Amsterdam 02nd Class Train Ticket",
        price: "GBP 105 - 115 per adult",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/dam/day-1.jpg",
      "/images/dam/day-2.jpg",
      "/images/dam/day-3.jpg",
      "/images/dam/day-4.jpg",
      "/images/dam/day-5.jpg",
      "/images/dam/day-6.jpg",
    ]
  },

  {
    title: "Classic UK Explorer",
    slug: "london-birmingham-manchester-07n",
    price: "GBP 1086 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/explore/day-1.jpg",
    location: "London, Birmingham, Manchester",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "London, Birmingham, Manchester",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "London Hop-On Hop-Off",
        "Manchester City Stadium Tour",
      ],

      highlights: [
        "London Hop On Hop Off Tour",
        "London Eye",
        "Madame Tussauds",
        "Tower of London",
        "Tower Bridge",
        "Birmingham Guided Walking Tour",
        "St Philip’s Cathedral",
        "Broad Street",
        "Centenary Square",
        "Symphony Hall",
        "Victoria Square",
        "Ikon Gallery",
        "Manchester City Stadium Tour",
        "Etihad Stadium",
      ],

      experiences: [
        {
          title: "London – Hop On Hop Off + London Eye + Madame Tussauds",
          desc: "Explore London with a 2-day Hop On Hop Off Tour, including London Eye and Madame Tussauds entrance.",
        },
        {
          title: "London – Tower of London & Tower Bridge",
          desc: "Continue sightseeing with the Tower of London and Tower Bridge, including the high-level glass walkways and Victorian Engine Rooms.",
        },
        {
          title: "Birmingham – Guided Walking Tour",
          desc: "Explore Birmingham on a shared-basis guided walking tour covering Cathedral Square, Broad Street, Centenary Square, Symphony Hall, Victoria Square and Ikon Gallery.",
        },
        {
          title: "Manchester – City Stadium Tour",
          desc: "Enjoy a behind-the-scenes Manchester City Stadium Tour with access to the players' tunnel, dugouts, dressing room and press conference room.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrive at London Heathrow Airport and enjoy a private transfer to your London hotel. Evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "London – Hop On Hop Off Day 1 + London Eye + Madame Tussauds",
        desc: "Breakfast at Hotel. Proceed for Day 1 of the London Hop On Hop Off Tour. Visit the London Eye and Madame Tussauds, then continue exploring London through the Hop On Hop Off routes.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – Hop On Hop Off Day 2 + Tower of London + Tower Bridge",
        desc: "Breakfast at Hotel. Continue Day 2 of the London Hop On Hop Off Tour. Visit the Tower of London and Tower Bridge, then enjoy the remainder of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "London – Birmingham",
        desc: "Breakfast at Hotel. Private transfer from London Hotel to London Train Station. Travel to Birmingham and receive a private transfer from Birmingham Train Station to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Birmingham – Guided Walking Tour",
        desc: "Breakfast at Hotel. Enjoy a shared-basis guided walking tour covering Cathedral Square, St Philip’s Cathedral, Broad Street, Centenary Square, Symphony Hall, Victoria Square, Town Hall, Council House and Ikon Gallery.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Birmingham – Manchester",
        desc: "Breakfast at Hotel. Private transfer from Birmingham Hotel to the train station. Upon arrival in Manchester, private transfer to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Manchester – Manchester City Stadium Tour",
        desc: "Breakfast at Hotel. Enjoy the Manchester City Stadium Tour with behind-the-scenes access to the stadium, players' tunnel, dugouts, dressing room and press conference room.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Manchester – India",
        desc: "Breakfast at Hotel. Private transfer from Manchester Hotel to Manchester Airport for the return journey to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "7 Nights’ Accommodation with Breakfast",
        "Private transfer from London Heathrow Airport to London hotel",
        "London Hop on Hop Off Bus Tour – 2 Days",
        "London Eye Entrance Ticket",
        "Madame Tussauds Entrance Ticket",
        "Tower of London Entrance Ticket",
        "Tower Bridge Entrance Ticket",
        "Private transfer from London hotel to London train station",
        "Private transfer from Birmingham train station to Birmingham hotel",
        "Guided Walking Tour on Shared Basis",
        "Private transfer from Birmingham hotel to Birmingham train station",
        "Private transfer from Manchester train station to Manchester hotel",
        "Manchester City Stadium Tour on Shared Basis",
        "Private transfer from Manchester hotel to Manchester Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "City London Hotel or similar",
            },
            {
              location: "Birmingham 2N",
              hotel: "Hampton by Hilton Birmingham Broad Street or similar",
            },
            {
              location: "Manchester 2N",
              hotel: "Holiday Inn Express Manchester City Centre – Arena or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1086 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 957 per person onwards", triple: "GBP 841 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 906 per person onwards", triple: "GBP 790 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 401 per child" },
                { pax: "Single Room Supplement", price: "GBP 544" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1004 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 915 per person onwards", triple: "GBP 824 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 864 per person onwards", triple: "GBP 773 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 424 per child" },
                { pax: "Single Room Supplement", price: "GBP 492" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1201 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1072 per person onwards", triple: "GBP 953 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1021 per person onwards", triple: "GBP 902 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 507 per child" },
                { pax: "Single Room Supplement", price: "GBP 659" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "DoubleTree by Hilton London - West End or similar",
            },
            {
              location: "Birmingham 2N",
              hotel: "Hilton Garden Inn Birmingham Brindleyplace or similar",
            },
            {
              location: "Manchester 2N",
              hotel: "Holiday Inn Express Manchester City Centre – Arena or similar",
            },
          ],

          seasons: [
            {
              months: "Apr, May, Jun, Jul & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1278 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1169 per person onwards", triple: "GBP 1063 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1118 per person onwards", triple: "GBP 1002 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 653 per child" },
                { pax: "Single Room Supplement", price: "GBP 706" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1187 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1050 per person onwards", triple: "GBP 1037 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 989 per person onwards", triple: "GBP 976 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 813 per child" },
                { pax: "Single Room Supplement", price: "GBP 617" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Nov, Dec, Jan & Feb - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1107 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 988 per person onwards", triple: "GBP 977 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 947 per person onwards", triple: "GBP 931 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 782 per child" },
                { pax: "Single Room Supplement", price: "GBP 565" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "London - Birmingham – Manchester 02nd class train ticket",
        price: "GBP 150 - 200 per person",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/explore/day-1.jpg",
      "/images/explore/day-2.jpg",
      "/images/explore/day-3.jpg",
      "/images/explore/day-4.jpg",
      "/images/explore/day-5.jpg",
      "/images/explore/day-6.jpg",
      "/images/explore/day-7.jpg",
    ]
  },

  {
    title: "British Isles Grand Discovery: London, Dublin & Belfast",
    slug: "london-dublin-belfast-09n",
    price: "GBP 1578 per person onwards",
    days: "09 Nights / 10 Days",
    rating: "4.9",
    image: "/images/fast/day-1.jpg",
    location: "London, Dublin, Belfast",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 09 Nights",
        places: "London, Dublin, Belfast",
      },

      pills: [
        "Breakfast Included",
        "09 Nights Accommodation",
        "London Eye",
        "Cliffs of Moher",
        "Giant’s Causeway",
      ],

      highlights: [
        "London City Tour",
        "London Eye",
        "London River Cruise",
        "Madame Tussauds",
        "Tower Bridge",
        "Cliffs of Moher",
        "Burren",
        "Galway City",
        "Howth Village",
        "Giant’s Causeway",
        "Carrickfergus Castle",
        "Glenarm Castle",
        "Carnlough Harbour",
        "Dark Hedges",
        "A History of Terror Walking Tour",
      ],

      experiences: [
        {
          title: "London – City Tour + London Eye + River Cruise",
          desc: "Enjoy a London City Tour on SIC basis with London Eye entry and a scenic River Thames Cruise.",
        },
        {
          title: "London – Madame Tussauds + Tower Bridge",
          desc: "Visit Madame Tussauds and explore Tower Bridge including its high-level glass walkways.",
        },
        {
          title: "Dublin – Cliffs of Moher, Burren & Galway",
          desc: "Enjoy a full-day SIC tour covering the dramatic Cliffs of Moher, Burren landscapes and Galway City.",
        },
        {
          title: "Dublin – Howth Coastal Tour",
          desc: "Explore Howth Summit and the fishing village with a coastal walking experience overlooking Dublin Bay.",
        },
        {
          title: "Belfast – Giant’s Causeway & Game of Thrones",
          desc: "Explore Giant’s Causeway, Carrickfergus Castle, Glenarm Castle, Carnlough Harbour, Waterfoot Caves, Cushendun, Rope Bridge and The Dark Hedges.",
        },
        {
          title: "Belfast – A History of Terror Walking Tour",
          desc: "Learn about Belfast’s complex history and The Troubles through a shared-basis historical walking tour.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrive in London and receive a private transfer from the airport to your hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "London – City Tour with London Eye & River Cruise",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis. Enjoy the London Eye and River Thames Cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – Madame Tussauds & Tower Bridge",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis including Madame Tussauds and Tower Bridge.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "London – Dublin",
        desc: "Breakfast at Hotel. Private transfer from London Hotel to London Airport (LHR). Fly to Dublin and receive a private transfer from Dublin Airport to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Dublin – Cliffs of Moher, Burren & Galway City",
        desc: "Breakfast at Hotel. Enjoy the full-day Cliffs of Moher, Burren & Galway City Day Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dublin – Howth Village Coastal Tour",
        desc: "Breakfast at Hotel. Enjoy a half-day coastal tour to Howth Village on SIC basis, including Howth Summit and its fishing village.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Dublin – Belfast",
        desc: "Breakfast at Hotel. Private transfer from Dublin Hotel to Belfast Hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Belfast – Giant’s Causeway & Game of Thrones Tour",
        desc: "Breakfast at Hotel. Enjoy the full-day Giant’s Causeway and Game of Thrones Day Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Belfast – A History of Terror Walking Tour",
        desc: "Join the A History of Terror Walking Tour on a shared basis and learn about Belfast’s complex and turbulent past.",
        tags: [],
      },
      {
        day: "10",
        title: "Belfast – India",
        desc: "Breakfast at Hotel. Private transfer from Belfast Hotel to Belfast Airport for the return flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "09 Nights Accommodation with Breakfast",
        "Private transfer from London Airport (LHR) to London Hotel",
        "02 Days London Hop on Hop off City Tour",
        "London Eye Standard Entry Ticket",
        "London River Cruise Ticket",
        "Madame Tussauds Standard Entry Ticket",
        "London Tower Bridge Entry Ticket",
        "Private transfer from London Hotel to London Airport (LHR)",
        "Private transfer from Dublin Airport to Dublin Hotel",
        "Cliffs of Moher, Burren & Galway City Day Tour from Dublin on SIC Basis",
        "Half Day Coastal Tour to Howth Village from Dublin on SIC Basis",
        "Private transfer from Dublin Hotel to Belfast Hotel",
        "Giant’s Causeway and Game of Thrones Day Tour from Belfast on SIC Basis",
        "A History of Terror Walking Tour from Belfast on Shared Basis",
        "Private transfer from Belfast Hotel to Belfast Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "Hampton by Hilton London Waterloo or Similar",
            },
            {
              location: "Dublin 3N",
              hotel: "Maldron Hotel Pearse Street or similar",
            },
            {
              location: "Belfast 3N",
              hotel: "Holiday Inn Express Belfast City - Queen's Quarter or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1578 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1431 per person onwards", triple: "GBP 1369 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1355 per person onwards", triple: "GBP 1291 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 908 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 838 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1541 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1398 per person onwards", triple: "GBP 1215 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1323 per person onwards", triple: "GBP 1135 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 526 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 807 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1545 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1402 per person onwards", triple: "GBP 1220 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1327 per person onwards", triple: "GBP 1140 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 533 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 811 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "The Clermont Charing Cross or Similar",
            },
            {
              location: "Dublin 3N",
              hotel: "The Croke Park or similar",
            },
            {
              location: "Belfast 3N",
              hotel: "voco Belfast or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 2082 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1953 per person onwards", triple: "GBP 1769 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1953 per person onwards", triple: "GBP 1769 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 1051 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1338 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1932 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1783 per person onwards", triple: "GBP 1502 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1711 per person onwards", triple: "GBP 1472 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 609 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1178 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1967 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1818 per person onwards", triple: "GBP 1587 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1746 per person onwards", triple: "GBP 1512 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 791 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1213 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/fast/day-1.jpg",
      "/images/fast/day-2.jpg",
      "/images/fast/day-3.jpg",
      "/images/fast/day-4.jpg",
      "/images/fast/day-5.jpg",
      "/images/fast/day-6.jpg",
      "/images/fast/day-7.jpg",
      "/images/fast/day-8.jpg",
      "/images/fast/day-9.jpg",
    ]
  },

  {
    title: "Grand Britain Experience: England & Scotland Highlights",
    slug: "london-edinburgh-glasgow-07n",
    price: "GBP 1174 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/Scotland/day-1.jpg",
    location: "London, Edinburgh, Glasgow",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "London, Edinburgh, Glasgow",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "London Eye",
        "Edinburgh Castle",
        "Loch Lomond",
      ],

      highlights: [
        "London Hop On Hop Off",
        "London Eye",
        "London River Cruise",
        "Madame Tussauds",
        "Tower Bridge",
        "Edinburgh Hop On Hop Off",
        "Edinburgh Castle",
        "Royal Mile",
        "Holyrood Palace",
        "Loch Lomond",
        "Trossachs",
        "Stirling Castle",
        "Luss",
      ],

      experiences: [
        {
          title: "London – City Tour + London Eye + River Cruise",
          desc: "Explore London on a SIC-basis city tour with London Eye and Thames River Cruise.",
        },
        {
          title: "London – Madame Tussauds + Tower Bridge",
          desc: "Visit Madame Tussauds and explore Tower Bridge including its high-level glass walkways.",
        },
        {
          title: "Edinburgh – Hop On Hop Off + Edinburgh Castle",
          desc: "Explore Edinburgh with a 1-day Hop On Hop Off City Tour and Edinburgh Castle Entry.",
        },
        {
          title: "Glasgow – Loch Lomond, Trossachs & Stirling Castle",
          desc: "Enjoy a full-day SIC tour through Scottish countryside, Loch Lomond, the Trossachs and Stirling Castle, without entrance.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrive in London and receive a private transfer from London Airport to your hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "London – City Tour with London Eye & River Cruise",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis, including London Eye and Thames River Cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – Madame Tussauds & Tower Bridge",
        desc: "Breakfast at Hotel. Proceed for the London City Tour on SIC basis including Madame Tussauds and Tower Bridge.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "London – Edinburgh",
        desc: "Breakfast at Hotel. Private transfer from London Hotel to London Train Station. Board the train to Edinburgh. On arrival, private transfer to your Edinburgh Hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Edinburgh – Hop On Hop Off + Edinburgh Castle",
        desc: "Breakfast at Hotel. Enjoy the 1-day Edinburgh Hop On Hop Off City Tour and Edinburgh Castle Entry Ticket.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Edinburgh – Glasgow",
        desc: "Breakfast at Hotel. Private transfer from Edinburgh Hotel to Edinburgh Train Station. Travel by train to Glasgow and receive a private transfer to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Glasgow – Loch Lomond, Trossachs & Stirling Castle",
        desc: "Breakfast at Hotel. Enjoy a full-day Loch Lomond, Trossachs & Stirling Castle Tour from Glasgow on SIC basis without entrance.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Glasgow – India",
        desc: "Breakfast at Hotel. Private transfer from Glasgow Hotel to Glasgow Airport for the onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "07 Nights Accommodation with Breakfast",
        "Private transfer from London Airport (LHR) to London Hotel",
        "02 Days London Hop on Hop off City Tour",
        "London Eye Standard Entry Ticket",
        "London River Cruise Ticket",
        "Madame Tussauds Standard Entry Ticket",
        "London Tower Bridge Entry Ticket",
        "Private transfer from London Hotel to London Train Station",
        "Private transfer from Edinburgh Train Station to Edinburgh Hotel",
        "01 Day Edinburgh Hop on Hop off City Tour",
        "Edinburgh Castle Entry Ticket",
        "Private transfer from Edinburgh Hotel to Edinburgh Train Station",
        "Private transfer from Glasgow Train Station to Glasgow Hotel",
        "Loch Lomond, Trossachs & Stirling Castle Tour from Glasgow on SIC Basis (Without Entrance)",
        "Private transfer from Glasgow Hotel to Glasgow Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "Hampton by Hilton London Waterloo or Similar",
            },
            {
              location: "Edinburgh 2N",
              hotel: "Holiday Inn Express Edinburgh City Centre or similar",
            },
            {
              location: "Glasgow 2N",
              hotel: "Holiday Inn Express Glasgow - City Centre Riverside or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1174 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1087 per person onwards", triple: "GBP 1068 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1049 per person onwards", triple: "GBP 1028 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 807 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 689 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1232 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1144 per person onwards", triple: "GBP 1047 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1106 per person onwards", triple: "GBP 1008 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 640 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 741 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1275 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1187 per person onwards", triple: "GBP 1075 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1149 per person onwards", triple: "GBP 1036 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 647 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 784 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "The Clermont Charing Cross or Similar",
            },
            {
              location: "Edinburgh 2N",
              hotel: "Hilton Edinburgh Carlton or similar",
            },
            {
              location: "Glasgow 2N",
              hotel: "Glasgow, BW Signature Collection by Best Western or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1389 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1328 per person onwards", triple: "GBP 1243 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1300 per person onwards", triple: "GBP 1215 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 883 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 948 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1561 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1501 per person onwards", triple: "GBP 1254 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1473 per person onwards", triple: "GBP 1225 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 950 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1501 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1617 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1557 per person onwards", triple: "GBP 1302 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1529 per person onwards", triple: "GBP 1273 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 612 onwards per child" },
                { pax: "Single Room Supplement", price: "GBP 1166" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "London – Edinburgh - Glasgow 02nd class train ticket",
        price: "GBP 110 – 120 per adult",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Scotland/day-1.jpg",
      "/images/Scotland/day-2.jpg",
      "/images/Scotland/day-3.jpg",
      "/images/Scotland/day-4.jpg",
      "/images/Scotland/day-5.jpg",
      "/images/Scotland/day-6.jpg",
      "/images/Scotland/day-7.jpg",
    ]
  },

  {
    title: "Explore London + Ireland Combination",
    slug: "london-dublin-06n",
    price: "GBP 1279 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Ire/day-1.jpg",
    location: "London, Dublin",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "London, Dublin",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "London Eye",
        "Windsor Castle",
        "Cliffs of Moher",
      ],

      highlights: [
        "London Hop On Hop Off",
        "London Eye",
        "Thames River Cruise",
        "Windsor Castle",
        "Bath",
        "Stonehenge",
        "Cliffs of Moher",
        "Burren",
        "Galway City",
        "Dublin Hop On Hop Off",
        "Trinity College",
        "St. Patrick’s Cathedral",
        "Dublin Castle",
        "Temple Bar",
      ],

      experiences: [
        {
          title: "London – Hop On Hop Off + London Eye + Thames Cruise",
          desc: "Explore London with a one-day Hop On Hop Off city tour, London Eye entry and Thames River Cruise.",
        },
        {
          title: "London – Windsor Castle, Bath & Stonehenge",
          desc: "Enjoy a full-day SIC tour covering Windsor Castle, Bath and Stonehenge with all tickets included.",
        },
        {
          title: "Dublin – Cliffs of Moher, Burren & Galway",
          desc: "Enjoy a full-day SIC tour through the Cliffs of Moher, Burren and Galway City.",
        },
        {
          title: "Dublin – Hop On Hop Off",
          desc: "Explore Dublin on a one-day Hop On Hop Off tour covering major city attractions.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – London",
        desc: "Arrive at London Heathrow Airport and enjoy a private transfer to your London hotel. London Eye, Thames River Cruise and Hop On Hop Off are planned subject to availability.",
        tags: [],
      },
      {
        day: "02",
        title: "London – Hop On Hop Off + London Eye + Thames River Cruise",
        desc: "Breakfast at Hotel. Proceed for the one-day London Hop On Hop Off city tour on SIC basis. Visit the London Eye and enjoy the Thames River Cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "London – Windsor Castle, Bath & Stonehenge",
        desc: "Breakfast at Hotel. Enjoy the full-day Windsor Castle, Bath and Stonehenge Tour on SIC basis with all tickets included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "London – Dublin",
        desc: "Breakfast at Hotel. Private transfer from London Hotel to London Heathrow Airport for the onward flight to Dublin. Private transfer from Dublin Airport to the hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Dublin – Cliffs of Moher, Burren & Galway City",
        desc: "Breakfast at Hotel. Enjoy a full-day Cliffs of Moher, Burren and Galway City Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dublin – Hop On Hop Off Tour",
        desc: "Breakfast at Hotel. Enjoy a one-day Dublin Hop On Hop Off Tour on SIC basis covering landmarks including Trinity College, St. Patrick’s Cathedral, Dublin Castle and Temple Bar.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Dublin – India",
        desc: "Breakfast at Hotel. Private transfer to Dublin Airport for the return journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06-night accommodation with breakfast",
        "Private transfer from London LHR Airport to London Hotel",
        "London 01 Day Hop on Hop off City tour on SIC Basis",
        "London Eye entry ticket Only",
        "Thames River Cruise ticket Entrance",
        "Windsor Castle, Bath and Stonehenge Tour from London on SIC Basis (all Ticket are included)",
        "Private transfer from London Hotel to London LHR Airport",
        "Private Transfer from Dublin Airport to Dublin Hotel",
        "Cliffs of Moher, Burren & Galway City Day Tour from Dublin on SIC Basis",
        "Dublin 01 Day Hop on Hop off city tour on SIC Basis",
        "Private Transfer from Dublin Hotel to Dublin Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "Royal National Hotel or similar",
            },
            {
              location: "Dublin 3N",
              hotel: "Waterloo Lodge Townhouse or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1279 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1170 per person onwards", triple: "GBP 964 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1128 per person onwards", triple: "GBP 940 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 688 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 614 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1109 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1060 per person onwards", triple: "GBP 999 per person" },
                { pax: "06 Pax", twinDouble: "GBP 1040 per person onwards", triple: "GBP 975 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 582 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 530 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1219 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1185 per person onwards", triple: "GBP 1035 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1120 per person onwards", triple: "GBP 1025 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 607 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 760 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "London 3N",
              hotel: "Thistle London Holborn or similar",
            },
            {
              location: "Dublin 3N",
              hotel: "Clayton Hotel Charlemont or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1019 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1005 per person onwards", triple: "GBP 991 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 985 per person onwards", triple: "GBP 971 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 633 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 385 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1324 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1289 per person onwards", triple: "GBP 1235 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1254 per person onwards", triple: "GBP 1219 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 551 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 735 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1199 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1140 per person onwards", triple: "GBP 1100 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1104 per person onwards", triple: "GBP 1090 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 645 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 780 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Ire/day-1.jpg",
      "/images/Ire/day-2.jpg",
      "/images/Ire/day-3.jpg",
      "/images/Ire/day-4.jpg",
      "/images/Ire/day-5.jpg",
      "/images/Ire/day-6.jpg",
    ]
  },

  {
    title: "Celtic Wonders Journey: Dublin, Cliffs of Moher & Giant’s Causeway",
    slug: "dublin-belfast-06n",
    price: "GBP 966 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/cel/day-1.jpg",
    location: "Dublin, Belfast",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "Dublin, Belfast",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Cliffs of Moher",
        "Howth Village",
        "Giant’s Causeway",
        "Game of Thrones",
      ],

      highlights: [
        "Cliffs of Moher",
        "Burren",
        "Galway City",
        "Howth Village",
        "Howth Summit",
        "Dublin Bay",
        "Giant’s Causeway",
        "Carrickfergus Castle",
        "Glenarm Castle",
        "Carnlough Harbour",
        "Waterfoot Caves",
        "Cushendun",
        "Rope Bridge",
        "The Dark Hedges",
        "A History of Terror Walking Tour",
      ],

      experiences: [
        {
          title: "Dublin – Cliffs of Moher, Burren & Galway",
          desc: "Enjoy a full-day SIC tour covering the Cliffs of Moher, Burren and Galway City.",
        },
        {
          title: "Dublin – Howth Village Coastal Tour",
          desc: "Explore Howth Summit and the picturesque fishing village with guided coastal walking and free time.",
        },
        {
          title: "Belfast – Giant’s Causeway & Game of Thrones",
          desc: "Explore Giant’s Causeway, Carrickfergus Castle, Glenarm Castle, Carnlough Harbour, Waterfoot Caves, Cushendun, Rope Bridge and The Dark Hedges.",
        },
        {
          title: "Belfast – A History of Terror Walking Tour",
          desc: "Explore Belfast’s complex history and The Troubles through a shared-basis historical walking tour.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Dublin",
        desc: "Arrive at Dublin Airport and enjoy a private transfer to your Dublin hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "Dublin – Cliffs of Moher, Burren & Galway City",
        desc: "Breakfast at hotel. Enjoy a full-day Cliffs of Moher, Burren & Galway City Day Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Dublin – Half Day Coastal Tour to Howth Village",
        desc: "Breakfast at hotel. Enjoy a half-day coastal tour to Howth Village on SIC basis, including Howth Summit, fishing village and guided coastal walking.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Dublin – Belfast",
        desc: "Breakfast at hotel. Private transfer from Dublin Hotel to Belfast Hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Belfast – Giant’s Causeway & Game of Thrones",
        desc: "Breakfast at hotel. Enjoy the full-day Giant’s Causeway and Game of Thrones Day Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Belfast – A History of Terror Walking Tour",
        desc: "Join the A History of Terror Walking Tour on a shared basis and learn about Belfast’s complex and turbulent past.",
        tags: [],
      },
      {
        day: "07",
        title: "Belfast – India",
        desc: "Breakfast at hotel. Private transfer from Belfast Hotel to Belfast Airport for the return flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from Dublin Airport to Dublin Hotel",
        "Cliffs of Moher, Burren & Galway City Day Tour from Dublin on SIC Basis",
        "Half Day Coastal Tour to Howth Village from Dublin on SIC Basis",
        "Private transfer from Dublin Hotel to Belfast Hotel",
        "Giant’s Causeway and Game of Thrones Day Tour from Belfast on SIC Basis",
        "A History of Terror Walking Tour from Belfast on Shared Basis",
        "Private transfer from Belfast Hotel to Belfast Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Dublin 3N",
              hotel: "Maldron Hotel Pearse Street or similar",
            },
            {
              location: "Belfast 3N",
              hotel: "Holiday Inn Express Belfast City - Queen's Quarter or Similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 966 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 856 per person onwards", triple: "GBP 811 per person" },
                { pax: "06 Pax", twinDouble: "GBP 800 per person onwards", triple: "GBP 751 per person" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 488 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 493 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 986 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 856 per person onwards", triple: "GBP 730 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 800 per person onwards", triple: "GBP 671 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 257 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 493 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 969 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 856 per person onwards", triple: "GBP 735 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 800 per person onwards", triple: "GBP 676 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 272 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 493 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Dublin 3N",
              hotel: "The Croke Park or similar",
            },
            {
              location: "Belfast 3N",
              hotel: "voco Belfast or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1295 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1186 per person onwards", triple: "GBP 1034 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1130 per person onwards", triple: "GBP 975 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 497 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 808 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July, Aug & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1027 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 917 per person onwards", triple: "GBP 830 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 860 per person onwards", triple: "GBP 770 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 429 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 551 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1027 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 917 per person onwards", triple: "GBP 830 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 860 per person onwards", triple: "GBP 770 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 429 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 551 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/cel/day-1.jpg",
      "/images/cel/day-2.jpg",
      "/images/cel/day-3.jpg",
      "/images/cel/day-4.jpg",
      "/images/cel/day-5.jpg",
      "/images/cel/day-6.jpg",
    ]
  },

  {
    title: "Explore Edinburgh + Glasgow + Inverness",
    slug: "edinburgh-glasgow-inverness-06n",
    price: "GBP 776 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/ness/day-1.jpg",
    location: "Edinburgh, Glasgow, Inverness",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Edinburgh, Glasgow, Inverness",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Edinburgh Castle",
        "Edinburgh Hop On Hop Off",
        "Glasgow Hop On Hop Off",
        "Inverness Hop On Hop Off",
      ],

      highlights: [
        "Edinburgh Castle",
        "Edinburgh Hop On Hop Off",
        "Old Town",
        "New Town",
        "George Square",
        "Glasgow Cathedral",
        "Riverside Museum",
        "University of Glasgow",
        "Kelvingrove Art Gallery and Museum",
        "River Ness",
        "Inverness Castle",
        "Caledonian Canal",
        "Scottish Highlands",
      ],

      experiences: [
        {
          title: "Edinburgh – Hop On Hop Off + Edinburgh Castle",
          desc: "Explore Edinburgh on a one-day Hop On Hop Off city tour and visit Edinburgh Castle.",
        },
        {
          title: "Glasgow – Hop On Hop Off",
          desc: "Explore Glasgow's major attractions including George Square, Glasgow Cathedral, Riverside Museum, University of Glasgow and Kelvingrove Art Gallery and Museum.",
        },
        {
          title: "Inverness – Hop On Hop Off",
          desc: "Explore River Ness, Inverness Castle exterior, Caledonian Canal and scenic Highland viewpoints.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Edinburgh",
        desc: "Arrive at Edinburgh Airport and enjoy a private transfer to your Edinburgh hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "Edinburgh – Hop On Hop Off Tour & Castle Visit",
        desc: "Breakfast at Hotel. Enjoy Edinburgh's one-day Hop On Hop Off tour on SIC basis and Edinburgh Castle entry.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Edinburgh – Glasgow",
        desc: "Breakfast at Hotel. Private transfer from Edinburgh Hotel to the train station. Travel to Glasgow and receive a private transfer from Glasgow Train Station to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Glasgow – Hop On Hop Off Tour",
        desc: "Breakfast at Hotel. Enjoy Glasgow's one-day Hop On Hop Off tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Glasgow – Inverness",
        desc: "Breakfast at Hotel. Private transfer to Glasgow Train Station and train to Inverness. Private transfer from Inverness Train Station to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Inverness – Hop On Hop Off Tour",
        desc: "Breakfast at Hotel. Enjoy the one-day Inverness Hop On Hop Off city tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Inverness – India",
        desc: "Breakfast at Hotel. Private transfer from Inverness Hotel to Inverness Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night accommodation with breakfast",
        "Private transfer from Edinburgh Airport to Edinburgh Hotel",
        "Edinburgh 01-day Hop On Hop Off city tour on SIC basis",
        "Edinburgh Castle entry ticket (subject to availability)",
        "Private transfer from Edinburgh Hotel to Edinburgh Train Station",
        "Private transfer from Glasgow Train Station to Glasgow Hotel",
        "Glasgow 01-day Hop On Hop Off city tour on SIC basis",
        "Private transfer from Glasgow Hotel to Glasgow Train Station",
        "Private transfer from Inverness Train Station to Inverness Hotel",
        "Inverness 01-day Hop On Hop Off city tour on SIC basis",
        "Private transfer from Inverness Hotel to Inverness Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Edinburgh 2N",
              hotel: "Holiday Inn Express Edinburgh - Royal Mile by IHG or similar",
            },
            {
              location: "Glasgow 2N",
              hotel: "Holiday Inn Express Glasgow - City Ctr Riverside by IHG or similar",
            },
            {
              location: "Inverness 2N",
              hotel: "Royal Highland Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 776 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 728 per person onwards", triple: "GBP 676 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 688 per person onwards", triple: "GBP 632 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 313 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 445" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1036 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1009 per person onwards", triple: "GBP 973 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 938 per person onwards", triple: "GBP 915 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 321 per child" },
                { pax: "Single Room Supplement", price: "GBP 570" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March-Oct & Sep - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 998 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 961 per person onwards", triple: "GBP 915 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 930 per person onwards", triple: "GBP 893 per person onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Edinburgh 2N",
              hotel: "Novotel Edinburgh Centre or similar",
            },
            {
              location: "Glasgow 2N",
              hotel: "YOTEL Glasgow or similar",
            },
            {
              location: "Inverness 2N",
              hotel: "River Ness Hotel, a member of Radisson Individuals or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 816 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 739 per person onwards", triple: "GBP 672 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 697 per person onwards", triple: "GBP 624 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 315 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 321 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1190 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1128 per person onwards", triple: "GBP 1009 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1086 per person onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1001 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 924 per person onwards", triple: "GBP 754 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 852 per person onwards", triple: "GBP 716 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 325 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 450 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Edinburgh - Glasgow - Inverness 02nd class train ticket",
        price: "GBP 60-70 per person, on actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/ness/day-1.jpg",
      "/images/ness/day-2.jpg",
      "/images/ness/day-3.jpg",
      "/images/ness/day-4.jpg",
      "/images/ness/day-5.jpg",
      "/images/ness/day-6.jpg",
    ]
  },

  {
    title: "Best of Edinburgh & Glasgow",
    slug: "edinburgh-glasgow-06n",
    price: "GBP 845 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/edin/day-1.jpg",
    location: "Edinburgh, Glasgow",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 06 Nights",
        places: "Edinburgh, Glasgow",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Edinburgh Hop On Hop Off",
        "Loch Ness",
        "Glencoe",
        "Glenfinnan Viaduct",
      ],

      highlights: [
        "Edinburgh Hop On Hop Off",
        "Edinburgh Castle",
        "Royal Mile",
        "Grassmarket",
        "Loch Ness",
        "Glencoe",
        "Fort William",
        "Scottish Highlands",
        "Glasgow Hop On Hop Off",
        "Glasgow Cathedral",
        "Riverside Museum",
        "Kelvingrove Art Gallery",
        "Glasgow University",
        "Glenfinnan Viaduct",
        "Glenfinnan Monument",
        "Loch Lomond",
        "Neptune’s Staircase",
      ],

      experiences: [
        {
          title: "Edinburgh – Hop On Hop Off",
          desc: "Explore Edinburgh at your own pace with an open-top Hop On Hop Off tour covering major city sights.",
        },
        {
          title: "Edinburgh – Loch Ness, Glencoe & Scottish Highlands",
          desc: "Enjoy a full-day SIC tour through Callander, Glencoe, Fort William, Loch Ness, Inverness and Pitlochry.",
        },
        {
          title: "Glasgow – Hop On Hop Off",
          desc: "Explore Glasgow's museums, galleries, parks and major landmarks on a city Hop On Hop Off tour.",
        },
        {
          title: "Glasgow – Glenfinnan, Fort William & Glencoe",
          desc: "Travel through the Scottish Highlands, Glencoe, Fort William and Glenfinnan Viaduct, with views of Loch Shiel and Loch Lomond.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Edinburgh",
        desc: "Arrive in Edinburgh and enjoy a smooth transfer from the airport to your hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "Edinburgh – 01 Day Hop On Hop Off Bus",
        desc: "Breakfast at Hotel. Enjoy Edinburgh's one-day Hop On Hop Off city tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Edinburgh – Loch Ness, Glencoe & Scottish Highlands",
        desc: "Breakfast at Hotel. Enjoy a full-day Loch Ness, Glencoe & Scottish Highlands Tour from Edinburgh on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Edinburgh – Glasgow",
        desc: "Breakfast at Hotel. Private transfer to Edinburgh Train Station, train to Glasgow and private transfer from Glasgow Train Station to hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Glasgow – 01 Day Hop On Hop Off City Tour",
        desc: "Breakfast at Hotel. Enjoy Glasgow's one-day Hop On Hop Off city tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Glasgow – Glenfinnan, Fort William & Glencoe",
        desc: "Breakfast at Hotel. Enjoy the full-day Glenfinnan, Fort William and Glencoe Day Trip from Glasgow on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Glasgow – India",
        desc: "Breakfast at Hotel. Private transfer from Glasgow Hotel to Glasgow Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 nights’ accommodation with breakfast",
        "Private transfer from Edinburgh Airport to Edinburgh Hotel",
        "Loch Ness, Glencoe & the Scottish Highlands Tour from Edinburgh on SIC Basis",
        "Private transfer from Edinburgh Hotel to Edinburgh Train station",
        "Private transfer from Glasgow Train station to Glasgow Hotel",
        "Glasgow 01 Day Hop on Hop off City tour on SIC Basis",
        "Glenfinnan, Fort William, and Glencoe Day Trip from Glasgow on SIC Basis",
        "Private Transfer from Glasgow Hotel to Glasgow Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Edinburgh 3N",
              hotel: "Hampton by Hilton Edinburgh West End or Similar",
            },
            {
              location: "Glasgow 3N",
              hotel: "Sandyford Lodge Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 960 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 932 per person onwards", triple: "GBP 892 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 901 per person onwards", triple: "GBP 849 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 571 per child" },
                { pax: "Single Room Supplement", price: "GBP 795" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 935 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 892 per person onwards", triple: "GBP 844 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 876 per person onwards", triple: "GBP 804 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 569 per child" },
                { pax: "Single Room Supplement", price: "GBP 1241" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 845 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 827 per person onwards", triple: "GBP 819 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 811 per person onwards", triple: "GBP 791 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 554 per child" },
                { pax: "Single Room Supplement", price: "GBP 760" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Edinburgh 3N",
              hotel: "The Caledonian Edinburgh, Curio Collection by Hilton or Similar",
            },
            {
              location: "Glasgow 3N",
              hotel: "Clayton Hotel Glasgow or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1025 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 997 per person onwards", triple: "GBP 937 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 985 per person onwards", triple: "GBP 913 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 348 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1701 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1229 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1200 per person onwards", triple: "GBP 1110 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1190 per person onwards", triple: "GBP 1093 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 450 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1671 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1015 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1002 per person onwards", triple: "GBP 927 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 981 per person onwards", triple: "GBP 903 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 354 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1671 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Edinburgh to Glasgow 02nd class train ticket",
        price: "GBP 30–40 per person, on actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/edin/day-1.jpg",
      "/images/edin/day-2.jpg",
      "/images/edin/day-3.jpg",
      "/images/edin/day-4.jpg",
      "/images/edin/day-5.jpg",
      "/images/edin/day-6.jpg",
      "/images/edin/day-7.jpg",
    ]
  },

  {
    title: "Ireland Signature Journey: From Belfast to the Cliffs of Moher",
    slug: "belfast-dublin-galway-07n",
    price: "GBP 1491 per person onwards",
    days: "07 Nights / 08 Days",
    rating: "4.9",
    image: "/images/journey/day-1.jpg",
    location: "Belfast, Dublin, Galway",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 07 Nights",
        places: "Belfast, Dublin, Galway",
      },

      pills: [
        "Breakfast Included",
        "07 Nights Accommodation",
        "Titanic Belfast",
        "Giant’s Causeway",
        "Cliffs of Moher",
        "Galway",
      ],

      highlights: [
        "Belfast Hop-On Hop-Off",
        "Titanic Belfast Experience",
        "City Hall",
        "Cathedral Quarter",
        "Peace Walls",
        "Crumlin Road Gaol",
        "Giant’s Causeway",
        "Game of Thrones Locations",
        "Dublin Hop-On Hop-Off",
        "Trinity College",
        "Temple Bar",
        "Phoenix Park",
        "St. Patrick’s Cathedral",
        "Guinness Storehouse",
        "Galway",
        "Cliffs of Moher",
        "The Burren",
      ],

      experiences: [
        {
          title: "Belfast – Hop-On Hop-Off + Titanic Belfast",
          desc: "Explore Belfast's major attractions with a one-day Hop-On Hop-Off tour followed by the Titanic Belfast Experience.",
        },
        {
          title: "Belfast – Giant’s Causeway & Game of Thrones",
          desc: "Enjoy a full-day SIC tour covering Giant’s Causeway and famous coastal and Game of Thrones locations.",
        },
        {
          title: "Dublin – Hop-On Hop-Off",
          desc: "Explore Dublin's major landmarks including Trinity College, Temple Bar, Phoenix Park, St. Patrick’s Cathedral and the Guinness Storehouse.",
        },
        {
          title: "Galway – Cliffs of Moher & Burren",
          desc: "Enjoy a full-day SIC tour to the Cliffs of Moher and the unique rocky landscapes of the Burren.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Ireland / Belfast",
        desc: "Arrive at Belfast Airport and enjoy a private transfer to your Belfast hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "Belfast – Hop-On Hop-Off + Titanic Belfast",
        desc: "Breakfast at Hotel. Enjoy a one-day Belfast Hop-On Hop-Off Bus Tour followed by the Titanic Belfast Experience.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Belfast – Giant’s Causeway & Game of Thrones",
        desc: "Breakfast at Hotel. Enjoy a full-day Giant’s Causeway & Game of Thrones Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Belfast – Dublin",
        desc: "Breakfast at Hotel. Private transfer from Belfast Hotel to Dublin Hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Dublin – Hop-On Hop-Off Bus Tour",
        desc: "Breakfast at Hotel. Enjoy a one-day Dublin Hop-On Hop-Off Bus Tour covering major city landmarks.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dublin – Galway",
        desc: "Breakfast at Hotel. Private transfer from Dublin Hotel to Galway Hotel. Evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Galway – Cliffs of Moher & Burren",
        desc: "Breakfast at Hotel. Enjoy a full-day Cliffs of Moher & Burren Tour on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Galway – Dublin Airport – India",
        desc: "Private transfer from Galway Hotel to Dublin Airport for the onward flight.",
        tags: [],
      },
    ],

    inclusions: {
      included: [
        "Private transfer from Belfast Airport to hotel",
        "01-day Belfast Hop On Hop Off bus tour",
        "Belfast Titanic Experience entry ticket",
        "Giant’s Causeway and Game of Thrones Day Tour from Belfast on SIC Basis",
        "Private transfer from Belfast hotel to Dublin",
        "Dublin 01 Hop On Hop Off bus tour",
        "Private transfer from Dublin hotel to Galway hotel",
        "Day trip to Cliffs of Moher & Burren from Galway on SIC Basis",
        "Private transfer from Galway hotel to Dublin Airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or other charges not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Belfast 3N",
              hotel: "Hampton by Hilton Belfast City Centre or Similar",
            },
            {
              location: "Dublin 2N",
              hotel: "Hilton Garden Inn Dublin City Centre or Similar",
            },
            {
              location: "Galway 2N",
              hotel: "Claregalway Hotel or Similar",
            },
          ],

          seasons: [
            {
              months: "Nov – Feb 2026 / 2027",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1491 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1198 per person onwards", triple: "GBP 1144 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1037 per person onwards", triple: "GBP 980 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 499 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 543 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1737 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1340 per person onwards", triple: "GBP 1252 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1193 per person onwards", triple: "GBP 1095 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 552 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 689 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1849 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1452 per person onwards", triple: "GBP 1328 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1305 per person onwards", triple: "GBP 1171 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 556 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 801 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Belfast 3N",
              hotel: "Clayton Hotel Belfast or Similar",
            },
            {
              location: "Dublin 2N",
              hotel: "Hotel Riu Plaza The Gresham Dublin or Similar",
            },
            {
              location: "Galway 2N",
              hotel: "Madron Hotel Sandy Road Galway or Similar",
            },
          ],

          seasons: [
            {
              months: "Nov – Feb 2026 / 2027",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1547 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1146 per person onwards", triple: "GBP 1128 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 987 per person onwards", triple: "GBP 976 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 611 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 496 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 1736 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1338 per person onwards", triple: "GBP 1199 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1178 per person onwards", triple: "GBP 1039 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 392 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 655 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "Mar, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "GBP 2226 per person onwards" },
                { pax: "04 Pax", twinDouble: "GBP 1828 per person onwards", triple: "GBP 1542 per person onwards" },
                { pax: "06 Pax", twinDouble: "GBP 1668 per person onwards", triple: "GBP 1382 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "GBP 441 per child onwards" },
                { pax: "Single Room Supplement", price: "GBP 1145 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/journey/day-1.jpg",
      "/images/journey/day-2.jpg",
      "/images/journey/day-3.jpg",
      "/images/journey/day-4.jpg",
      "/images/journey/day-5.jpg",
      "/images/journey/day-6.jpg",
      "/images/journey/day-7.jpg",
    ]
  },

  {
    title: "From Munich’s Majesty to Innsbruck’s Alps",
    slug: "munich-salzburg-innsbruck-06n",
    price: "Euro 815 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/majesty/day-1.jpg",
    location: "Munich, Salzburg, Innsbruck",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Munich, Salzburg, Innsbruck",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Munich Hop-On Hop-Off",
        "Nymphenburg Palace",
        "Sound of Music Tour",
        "Swarovski Crystal Worlds",
      ],

      highlights: [
        "Munich",
        "Munich Hop-On Hop-Off",
        "Nymphenburg Palace",
        "Salzburg Old Town",
        "The Original Sound of Music Tour",
        "Salzach River",
        "Innsbruck Old Town",
        "Golden Roof",
        "Swarovski Crystal Worlds",
        "Chambers of Wonder",
        "Crystal Cloud",
        "Alpine Mountain Views",
      ],

      experiences: [
        {
          title: "Munich – City Exploration",
          desc: "Explore Munich with a Hop-On Hop-Off sightseeing tour followed by a visit to the magnificent Nymphenburg Palace.",
        },
        {
          title: "Salzburg – The Original Sound of Music Tour",
          desc: "Enjoy a half-day guided tour inspired by The Sound of Music, visiting iconic film locations and scenic Austrian countryside.",
        },
        {
          title: "Innsbruck – Swarovski Crystal Worlds",
          desc: "Visit Swarovski Crystal Worlds and explore the Chambers of Wonder, crystal installations and Crystal Cloud.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Munich",
        desc: "Arrive at Munich Airport and enjoy a private transfer to your city centre hotel. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Munich – City Exploration",
        desc: "Breakfast at hotel. Enjoy a Munich Hop-On Hop-Off sightseeing tour followed by a visit to Nymphenburg Palace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Munich – Salzburg",
        desc: "Breakfast at hotel. Travel from Munich to Salzburg by train. Transfer to hotel and enjoy the remainder of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Salzburg – The Original Sound of Music Tour",
        desc: "Breakfast at hotel. Enjoy a half-day guided Original Sound of Music Tour from Salzburg on SIC basis.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Salzburg – Innsbruck",
        desc: "Breakfast at hotel. Travel by train to Innsbruck. After hotel check-in, explore the medieval Old Town, Golden Roof and surrounding mountain views.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Innsbruck – Swarovski Crystal Worlds Experience",
        desc: "Breakfast at hotel. Visit Swarovski Crystal Worlds and explore the Chambers of Wonder and Crystal Cloud.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Innsbruck – India",
        desc: "Breakfast at hotel. Check out and proceed to Innsbruck Airport for your onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfers between airports, hotels, and train stations",
        "01-Day Munich Hop-On Hop-Off Bus Ticket",
        "Nymphenburg Palace Entrance Ticket",
        "Half-Day Guided Original Sound of Music Tour from Salzburg on SIC basis",
        "Swarovski Crystal Worlds Visit from Innsbruck on SIC basis",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Munich 2N",
              hotel: "Arthotel Munich or similar",
            },
            {
              location: "Salzburg 2N",
              hotel: "Altstadt Hotel Hofwirt or similar",
            },
            {
              location: "Innsbruck 2N",
              hotel: "Hotel Goldene Krone or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 815 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 751 per person onwards", triple: "Euro 718 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 710 per person onwards", triple: "Euro 684 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 456 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 457 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 926 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 837 per person onwards", triple: "Euro 763 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 796 per person onwards", triple: "Euro 720 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 400 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 539 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 897 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 809 per person onwards", triple: "Euro 746 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 768 per person onwards", triple: "Euro 711 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 430 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 512 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Munich 2N",
              hotel: "Hotel München City Center or similar",
            },
            {
              location: "Salzburg 2N",
              hotel: "Wyndham Grand Salzburg Conference Centre or similar",
            },
            {
              location: "Innsbruck 2N",
              hotel: "Hotel Central - Innsbruck or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 838 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 750 per person onwards", triple: "Euro 699 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 709 per person onwards", triple: "Euro 667 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 416 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 456 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 974 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 886 per person onwards", triple: "Euro 842 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 845 per person onwards", triple: "Euro 802 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 542 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 558 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 913 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 828 per person onwards", triple: "Euro 752 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 789 per person onwards", triple: "Euro 713 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 416 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 525 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Munich – Salzburg – Innsbruck 02nd class train ticket",
        price: "Euro 95 - 125 per person, on actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/majesty/day-1.jpg",
      "/images/majesty/day-2.jpg",
      "/images/majesty/day-3.jpg",
      "/images/majesty/day-4.jpg",
      "/images/majesty/day-5.jpg",
      "/images/majesty/day-6.jpg",
    ]
  },

  {
    title: "From Medieval Streets to Imperial Palaces",
    slug: "prague-vienna-budapest-09n",
    price: "Euro 1067 per person onwards",
    days: "09 Nights / 10 Days",
    rating: "",
    image: "/images/imperial/day-1.jpg",
    location: "Prague, Vienna, Budapest",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 09 Nights",
        places: "Prague, Vienna, Budapest",
      },

      pills: [
        "Breakfast Included",
        "09 Nights Accommodation",
        "Prague Castle",
        "Vltava River Cruise",
        "Český Krumlov",
        "Schönbrunn Palace",
        "Bratislava",
        "Danube Cruise",
        "Széchenyi Thermal Bath",
      ],

      highlights: [
        "Prague Old Town",
        "Prague Castle",
        "Mala Strana",
        "Vltava River Cruise",
        "Český Krumlov",
        "Vienna State Opera",
        "Belvedere Palace",
        "Ringstrasse",
        "Schönbrunn Palace",
        "Danube Canal Cruise",
        "Bratislava Old Town",
        "Budapest Buda & Pest",
        "St. Stephen’s Basilica",
        "Danube River Cruise",
        "Széchenyi Thermal Spa",
      ],

      experiences: [
        {
          title: "Prague – City Tour, Castle & Vltava Cruise",
          desc: "Explore Prague by Hop-On Hop-Off, visit Prague Castle and enjoy an evening Vltava River cruise.",
        },
        {
          title: "Prague – Český Krumlov",
          desc: "Enjoy a full-day trip to the UNESCO-listed medieval town of Český Krumlov.",
        },
        {
          title: "Vienna – City Tour, Schönbrunn Palace & Cruise",
          desc: "Explore Vienna by Hop-On Hop-Off, visit Schönbrunn Palace and enjoy a Danube Canal cruise.",
        },
        {
          title: "Vienna – Bratislava",
          desc: "Take a day trip to Bratislava and explore its historic Old Town and surrounding landscapes.",
        },
        {
          title: "Budapest – City, Basilica, Cruise & Thermal Bath",
          desc: "Explore both Buda and Pest, visit St. Stephen’s Basilica, cruise the Danube and relax at Széchenyi Thermal Bath.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Prague",
        desc: "Arrive at Prague Airport and enjoy a private transfer to your city centre hotel. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Prague – City Tour, Castle Visit & Vltava Cruise",
        desc: "Breakfast at hotel. Enjoy a Prague Hop-On Hop-Off tour, Prague Castle visit and evening Vltava River cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Prague – Day Trip to Český Krumlov",
        desc: "Breakfast at hotel. Enjoy a full-day trip to Český Krumlov.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Prague – Vienna",
        desc: "Breakfast at hotel. Travel by train from Prague to Vienna and enjoy the remainder of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Vienna – Hop-On Hop-Off, Schönbrunn Palace & City Cruise",
        desc: "Breakfast at hotel. Enjoy Vienna Hop-On Hop-Off, Schönbrunn Palace and Danube Canal cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Vienna – Day Trip to Bratislava",
        desc: "Breakfast at hotel. Take a day trip to Bratislava with free time to explore the Old Town.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Vienna – Budapest",
        desc: "Breakfast at hotel. Board the train to Budapest, transfer to hotel and enjoy the evening at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Budapest – Hop-On Hop-Off, Basilica Visit & Danube Cruise",
        desc: "Breakfast at hotel. Enjoy Day 1 of the 2-Day Hop-On Hop-Off, visit St. Stephen’s Basilica and take an evening Danube River cruise.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Budapest",
        desc: "Breakfast at hotel. Enjoy Day 2 of Hop-On Hop-Off followed by a visit to Széchenyi Thermal Spa.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "10",
        title: "Budapest – India",
        desc: "Breakfast at hotel. Check out and transfer to Budapest Airport for your onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "09 Nights Accommodation with Breakfast",
        "Private transfers between airports, hotels, and train stations",
        "01-Day Prague Hop-On Hop-Off Bus Ticket",
        "Prague Castle Entrance Ticket",
        "Vltava River Cruise on shared basis",
        "Day Trip to Český Krumlov from Prague on SIC basis",
        "01-Day Vienna Hop-On Hop-Off Bus Ticket",
        "Schönbrunn Palace Entrance Ticket",
        "Vienna City Cruise on shared basis",
        "Day Trip to Bratislava from Vienna on SIC basis",
        "02-Days Budapest Hop-On Hop-Off Bus Ticket",
        "St. Stephen’s Basilica Entrance Ticket",
        "Danube River Cruise on shared basis",
        "Széchenyi Thermal Bath Entrance Ticket",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Prague 3N",
              hotel: "Hotel Atlantic Prague Old Town or similar",
            },
            {
              location: "Vienna 3N",
              hotel: "Garten- und Kunsthotel Gabriel or similar",
            },
            {
              location: "Budapest 2N",
              hotel: "Triple M Hotel or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1067 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 934 per person onwards", triple: "Euro 851 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 905 per person onwards", triple: "Euro 820 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 520 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 437 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1234 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1101 per person onwards", triple: "Euro 1004 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1071 per person onwards", triple: "Euro 973 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 622 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 596 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1152 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1019 per person onwards", triple: "Euro 919 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 960 per person onwards", triple: "Euro 888 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 535 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 518 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Prague 3N",
              hotel: "Amigo City Centre Hotel or similar",
            },
            {
              location: "Vienna 3N",
              hotel: "Garner Hotel Vienna - Prinz Eugen or similar",
            },
            {
              location: "Budapest 2N",
              hotel: "Eurostars Palazzo Zichy or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 974 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 865 per person onwards", triple: "Euro 831 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 832 per person onwards", triple: "Euro 813 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 674 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 348 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1307 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1173 per person onwards", triple: "Euro 1144 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1159 per person onwards", triple: "Euro 1116 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 979 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 665 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1124 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 990 per person onwards", triple: "Euro 922 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 960 per person onwards", triple: "Euro 891 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 600 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 490 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        name: "Prague – Vienna – Budapest 02nd class train ticket",
        price: "Euro 55 - 80 onwards per person, on actual basis",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/imperial/day-1.jpg",
      "/images/imperial/day-2.jpg",
      "/images/imperial/day-3.jpg",
      "/images/imperial/day-4.jpg",
      "/images/imperial/day-5.jpg",
      "/images/imperial/day-6.jpg",
      "/images/imperial/day-7.jpg",
      "/images/imperial/day-8.jpg",
      "/images/imperial/day-9.jpg",
    ]
  },

  {
    title: "Coast & Islands",
    slug: "split-hvar-dubrovnik-06n",
    price: "Euro 969 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/coast/day-1.jpg",
    location: "Split, Hvar, Dubrovnik",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Split, Hvar, Dubrovnik",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Trogir Old Town",
        "Hvar Island",
        "Wine & Olive Oil Tasting",
        "Mostar",
        "Kravica Waterfalls",
      ],

      highlights: [
        "Split",
        "Diocletian’s Palace",
        "Trogir Old Town",
        "Hvar Town",
        "Napoleon Fortress",
        "Stari Grad Plain",
        "Jelsa",
        "Duboković Winery",
        "Wine Tasting",
        "Olive Oil Tasting",
        "Dubrovnik Old Town",
        "Mostar Old Town",
        "Old Bridge",
        "Kravica Waterfalls",
        "Neum",
      ],

      experiences: [
        {
          title: "Split – Trogir Old Town",
          desc: "Enjoy a half-day SIC tour of Trogir Old Town with an English-speaking professional guide.",
        },
        {
          title: "Hvar – Island Tour with Wine & Olive Oil Tasting",
          desc: "Explore Hvar’s villages, lavender fields, Napoleon Fortress, St. Roko’s Chapel, Stari Grad Plain and Jelsa, with wine tasting at Duboković Winery.",
        },
        {
          title: "Dubrovnik – Mostar & Kravica Waterfall",
          desc: "Explore Mostar Old Town and the famous Old Bridge before visiting the Kravica Waterfalls in Bosnia-Herzegovina.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Split",
        desc: "Arrive in Split and enjoy a private transfer to your hotel. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Split – Half-Day Tour of Trogir Old Town",
        desc: "Breakfast at hotel. Enjoy a half-day Trogir Old Town tour on SIC basis with an English-speaking professional guide.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Split – Hvar",
        desc: "Breakfast at hotel. Travel by ferry from Split to Hvar. Explore Hvar Town and enjoy the remainder of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Hvar – Island Tour with Wine & Olive Oil Tasting",
        desc: "Breakfast at hotel. Enjoy an island tour covering Napoleon Fortress, villages, lavender fields, St. Roko’s Chapel, Stari Grad Plain and Jelsa with wine tasting.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Hvar – Dubrovnik",
        desc: "Breakfast at hotel. Travel by ferry from Hvar to Dubrovnik and explore the historic coastal city.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dubrovnik – Mostar & Kravica Waterfall",
        desc: "Breakfast at hotel. Enjoy a SIC day tour to Mostar and Kravica Waterfalls. Entrance to the waterfall is not included.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Dubrovnik – India",
        desc: "Breakfast at hotel. Proceed to Dubrovnik Airport with a private transfer.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from Split Airport to Split Hotel",
        "Half-Day Tour of Trogir Old Town from Split on SIC Basis",
        "Private transfer from Split Hotel to Split Ferry Port",
        "2nd Class Ferry Tickets from Split - Hvar",
        "Private transfer from Hvar Ferry Port to Hvar Hotel",
        "Island tour with Wine & Olive Oil Tasting from Hvar on SIC Basis",
        "Private transfer from Hvar Hotel to Hvar Ferry Port",
        "2nd Class Ferry Tickets from Hvar - Dubrovnik",
        "Private transfer from Dubrovnik Ferry Port to Dubrovnik Hotel",
        "Mostar and Kravica Waterfall Day Tour from Dubrovnik on SIC Basis",
        "Private transfer from Dubrovnik Hotel to Dubrovnik Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Kravica Waterfall entrance",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers",
      ],
    },

    pricing: {
      note: "Price is not applicable during fair/Events dates.",note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",
      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
            {
              location: "Hvar 2N",
              hotel: "Park Hvar or similar",
            },
            {
              location: "Dubrovnik 2N",
              hotel: "Prijeko Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 969 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 939 per person onwards", triple: "Euro 911 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 900 per person onwards", triple: "Euro 872 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 323 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 354 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1378 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1298 per person onwards", triple: "Euro 1100 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1259 per person onwards", triple: "Euro 1061 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 485 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 769 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1311 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1231 per person onwards", triple: "Euro 1207 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1192 per person onwards", triple: "Euro 1168 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 435 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 702 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
            {
              location: "Hvar 2N",
              hotel: "Park Hvar or similar",
            },
            {
              location: "Dubrovnik 2N",
              hotel: "Prijeko Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 943 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 923 per person onwards", triple: "Euro 912 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 884 per person onwards", triple: "Euro 873 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 360 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 328 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1384 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1304 per person onwards", triple: "Euro 1099 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1265 per person onwards", triple: "Euro 1061 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 490 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 775 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1744 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1664 per person onwards", triple: "Euro 1414 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1625 per person onwards", triple: "Euro 1375 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 491 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 1135 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/coast/day-1.jpg",
      "/images/coast/day-2.jpg",
      "/images/coast/day-3.jpg",
      "/images/coast/day-4.jpg",
      "/images/coast/day-5.jpg",
      "/images/coast/day-6.jpg",
    ]

  },

  {
    title: "Two Cities, One Coast",
    slug: "zadar-split-04n",
    price: "Euro 399 per person onwards",
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/TwoCities/day-1.jpg",
    location: "Zadar, Split",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 04 Nights",
        places: "Zadar, Split",
      },

      pills: [
        "Breakfast Included",
        "04 Nights Accommodation",
        "Zadar Old Town",
        "Preko",
        "Osljak",
        "Kali Island",
        "Blue Lagoon",
        "Borko Beach",
        "Šolta",
      ],

      highlights: [
        "Zadar",
        "Zadar Old Town",
        "Sea Organ",
        "Preko Island",
        "Osljak Island",
        "Kali Island",
        "Adriatic Coastline",
        "Split",
        "Diocletian’s Palace",
        "Blue Lagoon",
        "Borko Beach",
        "Šolta Island",
        "Snorkeling",
        "Dalmatian Coast",
      ],

      experiences: [
        {
          title: "Zadar – Preko, Osljak & Kali Island Boat Tour",
          desc: "Enjoy a shared boat excursion covering Preko, Osljak and Kali, with opportunities for swimming, sightseeing and exploring local island communities.",
        },
        {
          title: "Split – Blue Lagoon, Borko Beach & Šolta",
          desc: "Enjoy a shared full-day boat tour with turquoise waters, coastal landscapes, island views, snorkeling and relaxation.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zadar",
        desc: "Arrive at Zadar Airport and enjoy a private transfer to your hotel. Spend the rest of the day at leisure exploring the Old Town and waterfront.",
        tags: [],
      },
      {
        day: "02",
        title: "Zadar – Preko, Osljak & Kali Island Boat Tour",
        desc: "Breakfast at hotel. Enjoy a shared boat tour to Preko, Osljak and Kali islands. Return to Zadar in the afternoon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zadar – Split",
        desc: "Breakfast at hotel. Check out and enjoy a private transfer to Split. Check in and explore Split’s old town, cafes or nearby beaches.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Split – Blue Lagoon, Borko Beach & Šolta",
        desc: "Breakfast at hotel. Enjoy a shared full-day boat tour to Blue Lagoon, Borko Beach and Šolta Island.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Split – India",
        desc: "Breakfast at hotel. Proceed to Split Airport with a private transfer for your onward flight.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "4 Nights Accommodation with Breakfast",
        "Private transfer from Zadar Airport to Zadar Hotel",
        "Preko, Osljak, and Kali Island Boat Tour from Zadar on Shared Basis",
        "Private transfer from Zadar Hotel to Split Hotel",
        "Blue Lagoon, Borko Beach & Šolta Tour on Shared Basis from Split",
        "Private transfer from Split Hotel to Split Airport",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tours unless mentioned",
        "Flight tickets",
        "Visa and insurance fees",
        "Water bottles",
        "Lunch and Dinner",
        "Optional tours",
        "Local city taxes payable directly at the hotel",
        "Personal expenses such as laundry, drinks, or telephone charges",
        "Any service not mentioned in the inclusions",
      ],
    },

    pricing: {
     note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Zadar 2N",
              hotel: "Porto or similar",
            },
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 399 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 357 per person onwards", triple: "Euro 348 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 325 per person onwards", triple: "Euro 316 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 125 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 146 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 546 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 504 per person onwards", triple: "Euro 428 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 478 per person onwards", triple: "Euro 402 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 155 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 277 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 551 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 520 per person onwards", triple: "Euro 439 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 494 per person onwards", triple: "Euro 413 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 160 per child onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Zadar 2N",
              hotel: "Teatro Verdi Boutique Hotel or similar",
            },
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 418 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 376 per person onwards", triple: "Euro 369 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 344 per person onwards", triple: "Euro 337 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 114 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 165 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 606 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 580 per person onwards", triple: "Euro 501 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 554 per person onwards", triple: "Euro 475 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 158 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 353 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 614 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 588 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 562 per person onwards", triple: "Euro 535 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 226 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 361 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/TwoCities/day-1.jpg",
      "/images/TwoCities/day-2.jpg",
      "/images/TwoCities/day-3.jpg",
      "/images/TwoCities/day-4.jpg",
    ]
  },

  {
    title: "Norway Discovery: From the Arctic Circle to the Fjords",
    slug: "tromso-alesund-bergen-06n",
    price: "Euro 1140 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/Arctic/day-1.jpg",
    location: "Tromsø, Ålesund, Bergen",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Tromsø, Ålesund, Bergen",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Northern Lights Tour",
        "Sommarøy & Fjords Tour",
        "Salmon Picnic",
        "Ålesund Sightseeing Cruise",
        "Bergen Hop On Hop Off",
      ],

      highlights: [
        "Tromsø",
        "Northern Lights",
        "Arctic Cathedral",
        "Tromsø Harbor",
        "Sommarøy Islands",
        "Fjords",
        "Salmon Picnic",
        "Ålesund",
        "Ålesund Sightseeing Cruise",
        "Bergen",
        "Bryggen Wharf",
        "Mount Fløyen",
        "Fish Market",
        "Hanseatic Quarter",
      ],

      experiences: [
        {
          title: "Tromsø – Northern Lights Tour",
          desc: "Join a Northern Lights Tour on SIC basis and travel beyond the city lights to selected Aurora viewing locations.",
        },
        {
          title: "Tromsø – Sommarøy & Fjords",
          desc: "Explore the Sommarøy Islands and surrounding fjords with coastal scenery, fishing villages, crystal-blue waters and a Salmon Picnic.",
        },
        {
          title: "Ålesund – Sightseeing Cruise",
          desc: "Enjoy spectacular views of fjords and mountains during the Ålesund Sightseeing Cruise.",
        },
        {
          title: "Bergen – Hop On Hop Off",
          desc: "Explore Bergen with a 1-day Hop On Hop Off bus pass covering attractions such as Bryggen Wharf, Mount Fløyen and the Fish Market.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Tromsø",
        desc: "Arrive in Tromsø and enjoy a private transfer from the airport to your hotel. Spend the remainder of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Tromsø – Northern Lights Tour",
        desc: "Breakfast at hotel. Enjoy free time in Tromsø before joining a Northern Lights Tour on SIC basis in the evening.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Tromsø – Sommarøy & Fjords Tour – Ålesund",
        desc: "Breakfast at hotel. Enjoy the Fjords and Sommarøy Islands Tour with Salmon Picnic on SIC basis. Later transfer to Tromsø Airport and fly to Ålesund, followed by private transfer to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Ålesund – Sightseeing Cruise",
        desc: "Breakfast at hotel. Proceed for the Ålesund Cruise and enjoy spectacular views of fjords and mountains.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Ålesund – Bergen",
        desc: "Breakfast at hotel. Private transfer to Ålesund Airport for your departure to Bergen. On arrival, private transfer to your hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Bergen – Hop On Hop Off Tour",
        desc: "Breakfast at hotel. Enjoy a 1-day Bergen Hop On Hop Off Bus Pass and explore Bryggen Wharf, Mount Fløyen, the Fish Market and the old Hanseatic quarter.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Bergen – India",
        desc: "Breakfast at hotel. Private transfer from Bergen Hotel to Bergen Airport for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private transfer from Tromso airport to Tromso hotel",
        "Northern Light Tour on SIC basis (Operational only from Nov-Feb)",
        "Fjords and Sommarøy Islands Tour with Salmon Picnic on SIC basis",
        "Private transfer from Tromso hotel to Tromso airport",
        "Private transfer from Alesund airport to Alesund hotel",
        "Alesund Sightseeing Cruise",
        "Private transfer from Alesund hotel to Alesund airport",
        "Private transfer from Bergen airport to Bergen hotel",
        "Bergen Hop on Hop off bus valid for 1 Day",
        "Private transfer from Bergen hotel to Bergen airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "Price is not applicable during fair/Events dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Tromsø 2N",
              hotel: "Scandic Grand Tromsø or Similar",
            },
            {
              location: "Ålesund 2N",
              hotel: "Hotel Noreg or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1140 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1018 per person onwards", triple: "Euro 927 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 950 per person onwards", triple: "Euro 859 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 350 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 521 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1194 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1062 per person onwards", triple: "Euro 1022 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 994 per person onwards", triple: "Euro 954 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 435 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 452 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 947 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 815 per person onwards", triple: "Euro 801 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 747 per person onwards", triple: "Euro 733 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 320 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 318 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Tromsø 2N",
              hotel: "Radisson Blu Tromsø or Similar",
            },
            {
              location: "Ålesund 2N",
              hotel: "Quality Hotel Ålesund or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1155 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1023 per person onwards", triple: "Euro 990 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 955 per person onwards", triple: "Euro 912 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 411 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 480 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1202 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1070 per person onwards", triple: "Euro 1016 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1001 per person onwards", triple: "Euro 948 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 464 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 558 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1008 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 875 per person onwards", triple: "Euro 910 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 865 per person onwards", triple: "Euro 812 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 450 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 365 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Arctic/day-1.jpg",
      "/images/Arctic/day-2.jpg",
      "/images/Arctic/day-3.jpg",
      "/images/Arctic/day-4.jpg",
    ]
  },

  {
    title: "Discover Norway",
    slug: "tromso-oslo-bergen-06n",
    price: "Euro 1413 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/discover/day-1.jpg",
    location: "Tromsø, Oslo, Bergen",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Tromsø, Oslo, Bergen",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Northern Lights Tour",
        "Oslofjord Cruise",
        "Norway in a Nutshell",
        "Bergen Hop On Hop Off",
      ],

      highlights: [
        "Tromsø",
        "Northern Lights",
        "Arctic Culture",
        "Oslo",
        "Oslofjord",
        "Scenic Fjord Cruise",
        "Norway in a Nutshell",
        "Bergen",
        "Bryggen Wharf",
        "Mount Fløyen",
        "Fish Market",
        "Hanseatic Quarter",
      ],

      experiences: [
        {
          title: "Tromsø – Northern Lights",
          desc: "Join a Northern Light Tour on SIC basis and travel outside the city to selected viewing spots for the Aurora Borealis.",
        },
        {
          title: "Oslo – Oslofjord Cruise",
          desc: "Enjoy a scenic Oslofjord cruise with audio guide commentary and panoramic views of coastlines, islands and landscapes.",
        },
        {
          title: "Oslo – Bergen by Norway in a Nutshell",
          desc: "Travel from Oslo to Bergen through dramatic fjords, mountains, waterfalls and charming villages.",
        },
        {
          title: "Bergen – Hop On Hop Off",
          desc: "Explore Bergen with a 1-day Hop On Hop Off Bus Pass covering Bryggen Wharf, Mount Fløyen, the Fish Market and Hanseatic quarter.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Tromsø",
        desc: "Arrive in Tromsø and enjoy a private transfer from the airport to your hotel. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Tromsø – Northern Lights Tour",
        desc: "Breakfast at hotel. Explore Tromsø at your own pace before joining the Northern Light Tour on SIC basis in the evening.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Tromsø – Oslo",
        desc: "Breakfast at hotel. Private transfer to Tromsø Airport and flight to Oslo. On arrival, private transfer to hotel followed by a Scenic Fjord Cruise with Audio Guide Commentary.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Oslo – Sightseeing Cruise",
        desc: "Breakfast at hotel. Enjoy a relaxing cruise through the Oslofjord with panoramic views and audio guide commentary.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Oslo – Bergen",
        desc: "Breakfast at hotel. Private transfer to Oslo Train Station and board the Norway in a Nutshell Train to Bergen. On arrival, private transfer to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Bergen – Hop On Hop Off Tour",
        desc: "Breakfast at hotel. Enjoy a 1-day Bergen Hop On Hop Off Bus Pass covering major attractions.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Bergen – India",
        desc: "Breakfast at hotel. Private transfer from Bergen Hotel to Bergen Airport for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private transfer from Tromso airport to Tromso hotel",
        "Northern Light Tour on SIC basis (Operational only from Nov-Feb)",
        "Fjords and Sommarøy Islands Tour with Salmon Picnic on SIC basis",
        "Private transfer from Tromso hotel to Tromso airport",
        "Private transfer from Alesund airport to Alesund hotel",
        "Alesund Sightseeing Cruise",
        "Private transfer from Alesund hotel to Alesund airport",
        "Private transfer from Bergen airport to Bergen hotel",
        "Bergen Hop on Hop off bus valid for 1 Day",
        "Private transfer from Bergen hotel to Bergen airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. Etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Tromsø 2N",
              hotel: "Scandic Grand Tromsø or Similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Anker Hotel or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1413 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1287 per person onwards", triple: "Euro 1244 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1223 per person onwards", triple: "Euro 1180 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 430 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 540 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1418 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1292 per person onwards", triple: "Euro 1240 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1228 per person onwards", triple: "Euro 1176 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 450 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 545 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1223 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1097 per person onwards", triple: "Euro 1080 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1033 per person onwards", triple: "Euro 1016 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 320 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 350 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Tromsø 2N",
              hotel: "Radisson Blu Tromsø or Similar",
            },
            {
              location: "Oslo 2N",
              hotel: "Radisson Blu Plaza Oslo or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1426 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1300 per person onwards", triple: "Euro 1298 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1235 per person onwards", triple: "Euro 1212 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 490 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 523 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1536 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1410 per person onwards", triple: "Euro 1354 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1490 per person onwards", triple: "Euro 1387 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 495 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 633 onwards" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1276 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1185 per person onwards", triple: "Euro 1121 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 1128 per person onwards", triple: "Euro 1082 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 355 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 375 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/discover/day-1.jpg",
      "/images/discover/day-2.jpg",
      "/images/discover/day-3.jpg",
      "/images/discover/day-4.jpg",
      "/images/discover/day-5.jpg",
      "/images/discover/day-6.jpg",
    ]
  },

  {
    title: "Two Capitals, One Journey",
    slug: "zagreb-ljubljana-04n",
    price: "Euro 463 per person onwards",
    days: "04 Nights / 05 Days",
    rating: "",
    image: "/images/Capitals/day-2.jpg",
    location: "Zagreb, Ljubljana",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "2 Destinations, 04 Nights",
        places: "Zagreb, Ljubljana",
      },

      pills: [
        "Breakfast Included",
        "04 Nights Accommodation",
        "Zagreb City Tour",
        "WWII Tunnels",
        "Ljubljana Old Town",
        "Postojna Cave",
        "Predjama Castle",
      ],

      highlights: [
        "Zagreb",
        "Ban Jelačić Square",
        "WWII Tunnels",
        "Zagreb Old Town",
        "Ljubljana",
        "Ljubljana Riverfront",
        "Ljubljana Castle",
        "Postojna Cave",
        "Underground Train Ride",
        "Predjama Castle",
      ],

      experiences: [
        {
          title: "Zagreb – City & WWII Tunnels Walking Tour",
          desc: "Explore Zagreb's notable landmarks and historic WWII tunnels on a shared walking tour.",
        },
        {
          title: "Ljubljana – City Exploration",
          desc: "Discover Ljubljana's riverfront, elegant bridges, café culture and picturesque Old Town.",
        },
        {
          title: "Postojna Cave & Predjama Castle",
          desc: "Explore Postojna Cave with its underground train ride and guided walk, followed by the dramatic Predjama Castle.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zagreb",
        desc: "Arrive at Zagreb Airport and enjoy a private transfer to your hotel. Spend the remainder of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Zagreb – City & WWII Tunnels Walking Tour",
        desc: "Breakfast at hotel. Proceed for the City and WWII Tunnels Walking Tour on shared basis, followed by free time to explore Zagreb.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zagreb – Ljubljana",
        desc: "Breakfast at hotel. Private transfer from Zagreb Hotel to Zagreb Airport and onward journey to Ljubljana. Private transfer to your Ljubljana hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Postojna Cave & Predjama Castle Tour",
        desc: "Breakfast at hotel. Enjoy the Postojna Cave and Predjama Castle Tour on shared basis from Ljubljana.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Ljubljana – India",
        desc: "Breakfast at hotel. Private transfer to Ljubljana Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "4 Nights Accommodation with Breakfast",
        "Private transfer from Zagreb Airport to Zagreb Hotel",
        "City and WWII Tunnels Walking Tour on Shared Basis from Zagreb",
        "Private transfer from Zagreb Hotel to Ljubljana Hotel",
        "Private transfer from Ljubljana Airport to Ljubljana Hotel",
        "Postojna Cave & Predjama Castle Tour on SIC Basis from Ljubljana",
        "Private transfer from Ljubljana Hotel to Ljubljana Airport",
      ],

      excluded: [
        "Hotel pick-up for shared/SIC tours (unless mentioned)",
        "International flight tickets",
        "Visa & travel insurance fees",
        "Water bottles",
        "Lunch & Dinner",
        "Optional tours",
        "Hotel city tax to be paid directly at the hotel",
        "Personal expenses such as laundry, drinks, telephone charges, etc.",
        "Any service not mentioned in the inclusions",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Zagreb 2N",
              hotel: "Canopy By Hilton Zagreb City Centre or similar",
            },
            {
              location: "Ljubljana 2N",
              hotel: "Antiq Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 463 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 424 per person onwards", triple: "Euro 409 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 405 per person onwards", triple: "Euro 390 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 100 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 180 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 559 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 520 per person onwards", triple: "Euro 468 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 501 per person onwards", triple: "Euro 449 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 122 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 276 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 571 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 532 per person onwards", triple: "Euro 476 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 513 per person onwards", triple: "Euro 457 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 126 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 288 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Zagreb 2N",
              hotel: "Canopy By Hilton Zagreb City Centre or similar",
            },
            {
              location: "Ljubljana 2N",
              hotel: "Antiq Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 590 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 583 per person onwards", triple: "Euro 575 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 564 per person onwards", triple: "Euro 556 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 126 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 307 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 664 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 657 per person onwards", triple: "Euro 636 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 638 per person onwards", triple: "Euro 617 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 130 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 381 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 708 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 701 per person onwards", triple: "Euro 659 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 662 per person onwards", triple: "Euro 640 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 100 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 425 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Capitals/day-1.jpg",
      "/images/Capitals/day-2.jpg",
      "/images/Capitals/day-3.jpg",
      "/images/Capitals/day-4.jpg",
    ]
  },

  {
    title: "Croatia in a Week Zagreb",
    slug: "zagreb-split-dubrovnik-06n",
    price: "Euro 589 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/week/day-1.jpg",
    location: "Zagreb, Split, Dubrovnik",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Zagreb, Split, Dubrovnik",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Zagreb City Tour",
        "WWII Tunnels",
        "Diocletian's Palace",
        "Split Old Town",
        "Adriatic Ferry",
        "Dubrovnik Old Town",
        "Game of Thrones Tour",
      ],

      highlights: [
        "Zagreb",
        "Ban Jelačić Square",
        "Dolac Market",
        "Stone Gate",
        "WWII Tunnels",
        "Split",
        "Diocletian's Palace",
        "Dalmatian Coast",
        "Adriatic Coastline",
        "Dubrovnik",
        "Fort Lovrijenac",
        "Pile Gate",
        "Dubrovnik City Walls",
        "Game of Thrones Locations",
      ],

      experiences: [
        {
          title: "Zagreb – City & WWII Tunnels",
          desc: "Explore Zagreb's key landmarks and hidden WWII tunnels on a shared walking tour.",
        },
        {
          title: "Split – Old Town & Diocletian's Palace",
          desc: "Discover the ancient Diocletian's Palace, historic squares, temples, courtyards and medieval lanes.",
        },
        {
          title: "Split – Dubrovnik Ferry",
          desc: "Travel from Split to Dubrovnik by 2nd Class Ferry while enjoying views of the Adriatic coastline.",
        },
        {
          title: "Dubrovnik – Game of Thrones Tour",
          desc: "Explore famous filming locations including Fort Lovrijenac, Pile Gate and the city walls.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Zagreb",
        desc: "Arrive at Zagreb Airport and enjoy a private transfer to your hotel. Spend the remainder of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Zagreb – City and WWII Tunnels Walking Tour",
        desc: "Breakfast at hotel. Enjoy the City and WWII Tunnels Walking Tour on shared basis covering Ban Jelačić Square, Dolac Market, Stone Gate and the historic Old Town.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Zagreb – Split",
        desc: "Breakfast at hotel. Private transfer from Zagreb Hotel to Zagreb Airport for your flight to Split. On arrival, private transfer to your Split hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Split – Old Town and Diocletian Palace Walking Tour",
        desc: "Breakfast at hotel. Enjoy a shared walking tour of Split's Old Town and Diocletian's Palace, followed by leisure time.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Split – Dubrovnik",
        desc: "Breakfast at hotel. Private transfer to Split Ferry Station and board the 2nd Class Ferry to Dubrovnik. On arrival, private transfer to your hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Dubrovnik – The Ultimate Game of Thrones City Walking Tour",
        desc: "Breakfast at hotel. Enjoy the Ultimate Game of Thrones City Walking Tour on shared basis covering famous filming locations including Fort Lovrijenac, Pile Gate and the city walls.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Dubrovnik – India",
        desc: "Breakfast at hotel. Private transfer from Dubrovnik Hotel to Dubrovnik Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Nights Accommodation with Breakfast",
        "Private transfer from Zagreb Airport to Zagreb Hotel",
        "City and WWII Tunnels Walking Tour on Shared Basis from Zagreb",
        "Private transfer from Zagreb Hotel to Zagreb Airport",
        "Private transfer from Split Airport to Split Hotel",
        "Old Town and Diocletian Palace Walking Tour on Shared Basis from Split",
        "Private transfer from Split Hotel to Split Ferry Station",
        "2nd Class Ferry Ticket from Split to Dubrovnik",
        "Private transfer from Dubrovnik Ferry Station to Dubrovnik Hotel",
        "The Ultimate Game of Thrones City Walking Tour from Dubrovnik on Shared Basis",
        "Private transfer from Dubrovnik Hotel to Dubrovnik Airport",
      ],

      excluded: [
        "Return Flight Tickets",
        "Visa and Insurance fees",
        "Hotel pick up for shared/SIC tours",
        "Optional tours",
        "Hotel City Tax to be paid directly at the hotel",
        "Lunch and Dinner",
        "Water bottles",
        "Expenses of personal nature such as laundry, drinks, telephone, etc.",
        "Anything not mentioned in the Inclusions",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Zagreb 2N",
              hotel: "Art Hotel Like or similar",
            },
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
            {
              location: "Dubrovnik 2N",
              hotel: "Prijeko Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 589 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 551 per person onwards", triple: "Euro 540 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 521 per person onwards", triple: "Euro 510 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 153 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 276 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 875 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 799 per person onwards", triple: "Euro 688 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 769 per person onwards", triple: "Euro 658 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 235 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 562 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1031 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 955 per person onwards", triple: "Euro 819 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 925 per person onwards", triple: "Euro 790 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 260 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 700 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Zagreb 2N",
              hotel: "Canopy By Hilton Zagreb City Centre or similar",
            },
            {
              location: "Split 2N",
              hotel: "Boban Luxury Suites or similar",
            },
            {
              location: "Dubrovnik 2N",
              hotel: "Prijeko Palace or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 643 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 617 per person onwards", triple: "Euro 609 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 587 per person onwards", triple: "Euro 579 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 185 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 322 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 905 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 829 per person onwards", triple: "Euro 746 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 799 per person onwards", triple: "Euro 716 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 239 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 592 onwards" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1061 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 985 per person onwards", triple: "Euro 880 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 955 per person onwards", triple: "Euro 850 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 265 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 730 onwards" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/week/day-1.jpg",
      "/images/week/day-2.jpg",
      "/images/week/day-3.jpg",
      "/images/week/day-4.jpg",
      "/images/week/day-5.jpg",
      "/images/week/day-6.jpg",
    ]
  },

  {
    title: "Scenic Norway: Lofoten Islands to Fjord Capitals",
    slug: "svolvaer-alesund-bergen-06n",
    price: "Euro 923 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "",
    image: "/images/Norway/day-1.jpg",
    location: "Svolvær, Ålesund, Bergen",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Svolvær, Ålesund, Bergen",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Lofoten Trollfjord Safari",
        "Sea Eagle Safari",
        "Ålesund Sightseeing Cruise",
        "Bergen Hop On Hop Off",
      ],

      highlights: [
        "Svolvær",
        "Lofoten Islands",
        "Trollfjord",
        "Sea Eagle Safari",
        "Arctic Landscapes",
        "Ålesund",
        "Art Nouveau Architecture",
        "Ålesund Fjords",
        "Bergen",
        "Bryggen Wharf",
        "Mount Fløyen",
        "Fish Market",
        "Hanseatic Quarter",
      ],

      experiences: [
        {
          title: "Svolvær – Trollfjord Sea Eagle Safari",
          desc: "Enjoy an exciting RIB boat adventure through the stunning Trollfjord, surrounded by towering cliffs, with opportunities to spot majestic Sea Eagles.",
        },
        {
          title: "Ålesund – Sightseeing Cruise",
          desc: "Enjoy spectacular views of the fjords and mountains during the Ålesund Sightseeing Cruise.",
        },
        {
          title: "Bergen – Hop On Hop Off",
          desc: "Explore Bergen at your own pace with a 1-day Hop On Hop Off Bus Pass covering Bryggen Wharf, Mount Fløyen, the Fish Market and the old Hanseatic quarter.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Svolvær",
        desc: "Arrive at Svolvær Airport and enjoy a private transfer to your hotel. After check-in, relax or explore the local town at your own pace.",
        tags: [],
      },
      {
        day: "02",
        title: "Svolvær – RIB Boat Lofoten Trollfjord Sea Eagle Safari",
        desc: "Enjoy the RIB Boat Lofoten Trollfjord Sea Eagle Safari through the dramatic Trollfjord, with an opportunity to spot Sea Eagles. In the evening, private transfer to Svolvær Airport for your onward journey.",
        tags: [],
      },
      {
        day: "03",
        title: "Svolvær – Ålesund",
        desc: "Breakfast at hotel. Check out and proceed to Svolvær Airport for your flight to Ålesund. On arrival, private transfer to your hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Ålesund – Sightseeing Cruise",
        desc: "Breakfast at hotel. Proceed for the Ålesund Cruise and enjoy spectacular views of the fjords and mountains.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Ålesund – Bergen",
        desc: "Breakfast at hotel. Private transfer from Ålesund Hotel to Ålesund Airport for your departure to Bergen. On arrival, private transfer to your hotel. Rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Bergen – Hop On Hop Off Tour",
        desc: "Breakfast at hotel. Enjoy a 1-day Bergen Hop On Hop Off Bus Pass covering Bryggen Wharf, Mount Fløyen, the Fish Market and the old Hanseatic quarter.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Bergen – India",
        desc: "Breakfast at hotel. Private transfer from Bergen Hotel to Bergen Airport for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Private transfer from Tromso airport to Tromso hotel",
        "Northern Light Tour on SIC basis (Operational only from Nov-Feb)",
        "Fjords and Sommarøy Islands Tour with Salmon Picnic on SIC basis",
        "Private transfer from Tromso hotel to Tromso airport",
        "Private transfer from Alesund airport to Alesund hotel",
        "Alesund Sightseeing Cruise",
        "Private transfer from Alesund hotel to Alesund airport",
        "Private transfer from Bergen airport to Bergen hotel",
        "Bergen Hop on Hop off bus valid for 1 Day",
        "Private transfer from Bergen hotel to Bergen airport",
      ],

      excluded: [
        "The tours which are on SIC/Shared basis for them client need to reach at the pickup point",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Svolvær 2N",
              hotel: "Nordis Hotel Lofoten or Similar",
            },
            {
              location: "Ålesund 2N",
              hotel: "Hotel Noreg or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 923 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 791 per person onwards", triple: "Euro 714 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 723 per person onwards", triple: "Euro 646 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 250 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 379 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 860 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 728 per person onwards", triple: "Euro 714 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 660 per person onwards", triple: "Euro 646 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 289 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 315 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1194 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1062 per person onwards", triple: "Euro 981 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 994 per person onwards", triple: "Euro 913 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 415 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 440 onwards" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Svolvær 2N",
              hotel: "Quality Hotel Richard withs or Similar",
            },
            {
              location: "Ålesund 2N",
              hotel: "Quality Hotel Ålesund or similar",
            },
            {
              location: "Bergen 2N",
              hotel: "Comfort Hotel Bergen or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 975 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 843 per person onwards", triple: "Euro 832 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 775 per person onwards", triple: "Euro 764 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 411 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 430" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 1134 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 1002 per person onwards", triple: "Euro 953 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 934 per person onwards", triple: "Euro 885 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 464 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 558 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 936 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 804 per person onwards", triple: "Euro 770 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 736 per person onwards", triple: "Euro 692 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 320 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 392 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/Norway/day-1.jpg",
      "/images/Norway/day-2.jpg",
      "/images/Norway/day-3.jpg",
      "/images/Norway/day-4.jpg",
      "/images/Norway/day-5.jpg",
      "/images/Norway/day-6.jpg",
    ],
  },

  {
    title: "Explore Frankfurt, Heidelberg & Munich",
    slug: "frankfurt-heidelberg-munich-06n",
    price: "Euro 716 per person onwards",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/he/day-1.jpg",
    location: "Frankfurt, Heidelberg, Munich",
    nextDate: "Available on Request",

    highlightsData: {
      locationCard: {
        meta: "3 Destinations, 06 Nights",
        places: "Frankfurt, Heidelberg, Munich",
      },

      pills: [
        "Breakfast Included",
        "06 Nights Accommodation",
        "Frankfurt Hop On Hop Off",
        "Heidelberg Old Town",
        "Heidelberg Walking Tour",
        "Direct Train Journey",
        "Munich Hop On Hop Off",
      ],

      highlights: [
        "Frankfurt",
        "Römerberg",
        "St. Paul's Church",
        "Goethe House",
        "Main Tower",
        "Financial District",
        "Heidelberg",
        "Marktplatz",
        "Church of the Holy Spirit",
        "Heidelberg University",
        "Old Bridge",
        "Heidelberg Castle",
        "Munich",
        "Marienplatz",
        "Nymphenburg Palace",
        "Königsplatz",
        "BMW Museum",
        "Englischer Garten",
      ],

      experiences: [
        {
          title: "Frankfurt – Hop On Hop Off Bus Tour",
          desc: "Enjoy a 24-hour flexible sightseeing experience covering Römerberg, St. Paul's Church, Goethe House, Main Tower and the financial district.",
        },
        {
          title: "Heidelberg – Old Town Walking Tour",
          desc: "Explore Heidelberg's historic Old Town, including Marktplatz, the Church of the Holy Spirit, Heidelberg University, the Old Bridge and lanes beneath Heidelberg Castle.",
        },
        {
          title: "Frankfurt – Heidelberg – Munich by Train",
          desc: "Travel between the three destinations by direct train services, with private transfers between stations and hotels.",
        },
        {
          title: "Munich – Hop On Hop Off Bus Tour",
          desc: "Enjoy a 24-hour Munich sightseeing experience covering Marienplatz, Nymphenburg Palace, Königsplatz, BMW Museum and Englischer Garten.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "India – Frankfurt",
        desc: "Arrive at Frankfurt Airport and enjoy a private transfer to your hotel. Spend the evening exploring or relaxing at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Frankfurt – Hop On Hop Off Bus Tour – 24 Hours",
        desc: "Breakfast at hotel. Enjoy the Frankfurt Hop-On Hop-Off Bus Tour on shared basis and explore the city's major landmarks at your own pace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Frankfurt – Heidelberg",
        desc: "Breakfast at hotel. Catch a direct train from Frankfurt to Heidelberg. On arrival, continue to your hotel and enjoy the remainder of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Heidelberg – Heidelberg Old Town Walking Tour",
        desc: "Breakfast at hotel. Enjoy the Heidelberg Old Town Walking Tour on shared basis covering Marktplatz, Church of the Holy Spirit, Heidelberg University, Old Bridge and the historic lanes beneath Heidelberg Castle.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Heidelberg – Munich",
        desc: "Breakfast at hotel. Catch a direct train from Heidelberg to Munich. On arrival, transfer to your hotel and enjoy the rest of the day at leisure.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Munich – Hop On Hop Off Bus Tour – 24 Hours",
        desc: "Breakfast at hotel. Enjoy the Munich Hop-On Hop-Off Bus Tour on shared basis and explore Marienplatz, Nymphenburg Palace, Königsplatz, BMW Museum and Englischer Garten.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Munich – India",
        desc: "Breakfast at hotel. Proceed to Munich Airport with a private transfer for your onward flight to India.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    inclusions: {
      included: [
        "06 Night Accommodation with Breakfast",
        "Transfer from Frankfurt airport to hotel on private basis",
        "Frankfurt hop on hop off bus tour - 24 Hours",
        "Transfer from Frankfurt hotel to train station on private basis",
        "Train from Frankfurt to Heidelberg",
        "Transfer from Heidelberg train station to hotel on private basis",
        "Heidelberg old town walking tour",
        "Transfer from Heidelberg hotel to train station on private basis",
        "Train from Heidelberg to Munich",
        "Transfer from Munich train station to hotel on private basis",
        "Munich hop on hop off bus tour - 24 hours",
        "Transfer from Munich hotel to airport on private basis",
      ],

      excluded: [
        "Hotel pick up for shared/SIC tour",
        "Return Flight Tickets",
        "Visa & Insurance fees",
        "Water Bottles",
        "Train ticket",
        "Optional tours",
        "Hotel City Tax is not included in the cost to be paid on the spot at the hotel",
        "Lunch & Dinner",
        "Extra charges/expenses of personal nature like laundry, mineral water/drinks, telephone or any other charges/expenses not mentioned in Inclusions",
        "Mandatory tips of Euro 2-3 per person per day for Coach Drivers. Etc",
      ],
    },

    pricing: {
      note: "All prices are per person and are based on 02 Pax twin/double sharing at the lowest available season, unless otherwise stated. Final pricing may vary depending on travel dates, hotel availability, room type and number of travellers. Prices are not applicable during fair/event dates.",

      options: [
        {
          category: "Option 1 – 03* Hotel",

          hotels: [
            {
              location: "Frankfurt 2N",
              hotel: "ibis Frankfurt Centrum or similar",
            },
            {
              location: "Heidelberg 2N",
              hotel: "Boarding House Heidelberg or similar",
            },
            {
              location: "Munich 2N",
              hotel: "Arthotel Munich or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 716 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 606 per person onwards", triple: "Euro 545 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 563 per person onwards", triple: "Euro 497 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 254 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 387 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 847 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 740 per person onwards", triple: "Euro 666 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 699 per person onwards", triple: "Euro 626 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 355 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 491 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 812 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 698 per person onwards", triple: "Euro 625 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 656 per person onwards", triple: "Euro 581 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 301 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 479 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },

        {
          category: "Option 2 – 04* Hotel",

          hotels: [
            {
              location: "Frankfurt 2N",
              hotel: "Leonardo Royal Hotel Frankfurt or similar",
            },
            {
              location: "Heidelberg 2N",
              hotel: "Hilton Heidelberg or similar",
            },
            {
              location: "Munich 2N",
              hotel: "Hotel Munchen City Center, Affiliated or similar",
            },
          ],

          seasons: [
            {
              months: "Jan, Feb, Nov & Dec - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 722 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 622 per person onwards", triple: "Euro 617 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 582 per person onwards", triple: "Euro 576 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 467 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 393 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "April, May, June, July & Aug - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 856 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 773 per person onwards", triple: "Euro 672 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 707 per person onwards", triple: "Euro 638 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 361 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 485 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
            {
              months: "March, Sep & Oct - 2026",
              rows: [
                { pax: "02 Pax", twinDouble: "Euro 820 per person onwards" },
                { pax: "04 Pax", twinDouble: "Euro 707 per person onwards", triple: "Euro 660 per person onwards" },
                { pax: "06 Pax", twinDouble: "Euro 665 per person onwards", triple: "Euro 615 per person onwards" },
                { pax: "Child Sharing with Extra Bed", price: "Euro 387 per child onwards" },
                { pax: "Single Room Supplement", price: "Euro 487 onwards" },
                { pax: "Below 2-year child", price: "Free of cost" },
              ],
            },
          ],
        },
      ],
    },

    supplementaryTours: [
      {
        title: "Optional Train Cost",
        route: "Frankfurt – Heidelberg – Munich",
        description: "02nd Class train ticket – on actual basis",
        price: "Euro 95 – 105 per person",
      },
    ],

    terms: [
      "Booking should be received 45 days prior to arrival.",
      "A 10% deposit of the total booking amount is required at the time of confirmation.",
      "The Offered rates are net and non-commissionable",
      "Hotel City Tax is not included in the cost to be paid on the spot at the hotel.",
      "Rates and availability of the services are subject to change before any confirmation.",
      "No bookings are made at the time of quotation.",
      "Any extra services to be paid directly",
      "Driver tips to be paid directly",
      "Anything that is not mentioned in the inclusions list is always not included.",
      "Cancellation Policy: As per our trading contract",
      "05% GST + TCS declaration required if payment will be in INR. ROE will be considered the day when the payment will be processed, ROE is subject to change.",
    ],

    images: [
      "/images/he/day-1.jpg",
      "/images/he/day-2.jpg",
      "/images/he/day-3.jpg",
      "/images/he/day-4.jpg",
      "/images/he/day-5.jpg",
      "/images/he/day-6.jpg",
    ]
  },

  {
    title: "Egypt",
    slug: "egypt",
    price: "INR 1,48,300/- + TCS (Refundable)",
    days: "08 Nights / 09 Days",
    rating: "4.9",
    image: "/images/egypt/day-1.jpg",
    location: "Egypt",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "08 Nights",
        places: "Cairo, Alexandria, Aswan, Nile River, Luxor, Hurghada",
      },

      pills: [
        "03 Nights Accommodation in Cairo",
        "03 Nights Nile Cruise",
        "02 Nights Accommodation in Hurghada",
      ],

      highlights: [
        "Giza Pyramids",
        "Sphinx",
        "Valley Temple",
        "Grand Egyptian Museum",
        "Catacomb of Kom El-Shokafa",
        "Qaitbay Citadel from Outside",
        "Alexandria Library",
        "The High Dam",
        "Philae Temple",
        "Kom Ombo Temple",
        "Edfu Temple",
        "Valley of the Kings",
        "Hatshepsut Temple",
        "Colossi of Memnon",
        "Luxor Temple",
        "Giftun Island Snorkeling Trip from Hurghada",
      ],

      experiences: [
        {
          title: "Abu Simple Temple Tour",
          desc: "",
        },
        {
          title: "Karnak Sound & Light Show",
          desc: "",
        },
        {
          title: "Hot Air Balloon Ride",
          desc: "",
        },
        {
          title: "Giftun Island Snorkeling Trip",
          desc: "Swim with the dolphins before docking at Giftun Island for sports.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrive Cairo",
        desc: "After your flight arrives at Cairo International Airport, a representative from Egypt Office will be waiting for you in the international arrival hall holding a sign with your name to meet & greet you before the passport control and finish all formalities with you, transfer to your hotel, check-in @ 15:00 PM & overnight in Cairo.",
        tags: [],
      },
      {
        day: "02",
        title: "Cairo Day Tour",
        desc: "After Early breakfast, Meet Egypt Office representative at the hotel lobby and accompany your English speaking Egyptologist to visit the Pyramids of Giza, the great tombs of Cheops, Chephren and Mykerinos, standing as one of the Seven Wonders of the World. Continue to the Sphinx, the famous guardian with the body of a lion and the head of a king, then see the Valley Temple, where the kings were prepared for mummification, Continue your exploration with a visit to The Grand Egyptian Museum (GEM), showcasing a vast collection of ancient treasures, including artifacts from the tomb of Tutankhamun, It is located about two kilometers from the Giza Pyramid Complex; back to the hotel & overnight in Cairo.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Alexandria Day Tour",
        desc: "After breakfast at the hotel, depart by private air-conditioned vehicle to Alexandria, Begin your visit with the renowned Bibliotheca Alexandrina, a modern architectural masterpiece that commemorates the ancient Library of Alexandria. Continue to the Catacombs of Kom El Shoqafa, one of Alexandria's most remarkable archaeological sites, featuring a unique blend of Egyptian, Greek, and Roman influences. Proceed to the Citadel of Qaitbay (from Outside). Built in the 15th century on the site of the ancient Lighthouse of Alexandria, After completing your sightseeing, return to Cairo and transfer to your hotel. Overnight in Cairo.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Nile Cruise (Start from Aswan Every: Wednesday, Friday)",
        desc: "Take a morning flight to Aswan, up on Arrival, visit the High Dam, the great engineering project that gave Egypt power and protection from the Nile floods. Continue to the Temple of Philae, built in honor of the goddess Isis and beautifully relocated to its island. Afterwards, embark on your Nile Cruise and enjoy lunch, dinner, and overnight on board in Aswan.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "05",
        title: "Kom Ombo Temples Tour",
        desc: "enjoy your Breakfast, sailing along the Nile to Kom Ombo. Here, visit the Temple of Kom Ombo, dedicated to the crocodile god Sobek and the falcon god Horus, famous for its twin design. Continue sailing to Edfu. dinner, and overnight on your Nile Cruise.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "06",
        title: "Edfu & Luxor Temple",
        desc: "Enjoy breakfast, then visit the Temple of Horus at Edfu, the best-preserved temple in Egypt with stunning reliefs. Sail onward to Luxor and enjoy lunch on board. Arrive Luxor then continue to the enchanting Luxor Temple, built by pharaohs and later adorned by Alexander the Great, beautifully lit up at night. Dinner and overnight on your cruise in Luxor.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "07",
        title: "West Bank Tour & Transfer to Hurghada",
        desc: "Savor a delightful breakfast on board before disembarking at 08:00 AM. and begin your tour of the West Bank. Discover the Valley of the Kings, where the pharaohs of the New Kingdom were buried in richly decorated tombs. Continue to the Temple of Queen Hatshepsut, the stunning terraced monument of Egypt’s only female pharaoh. Stop to view the Colossi of Memnon, two massive statues that once guarded the mortuary temple of Amenhotep III. At the end of the tour, transfer to Hurghada. On arrival at Hurghada, check into the hotel. Overnight in Hurghada.",
        tags: [
          { label: "Breakfast" },
          { label: "Dinner" },
        ],
      },
      {
        day: "08",
        title: "Hurghada",
        desc: "Today your day is free at leisure. You can opt to take a snorkeling trip at Giftun Island. Swim with the dolphins before docking at Giftun Island for sports. In the evening, you have free time to enjoy the unique nightlife of Hurghada. Overnight in Hurghada.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "09",
        title: "Final Departure",
        desc: "Today, we bid farewell to Egypt. After enjoying your delicious breakfast, please check out by 12:00 PM. Egypt Office representative will accompany you to Sharm El Sheikh International Airport for your Final departure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Please note that no booking has been held at this time.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "03 Nights’ accommodation in Cairo based on Bed & Breakfast Basis.",
        "03 Nights’ accommodation at 05 stars Nile Cruise on Full board including Breakfast, Lunch, Dinner.",
        "02 Nights’ accommodation in Hurghada on Breakfast Basis.",
        "Meet at Cairo, Asxwan Airports plus transfer to hotel by private air-conditioned Vehicle.",
        "Transfer Cairo / Alexandria / Cairo by prívate A/C Vehicle.",
        "Transfer to Hurghada hotel private transfers",
        "01 Day Excursion in Cairo as mentioned at the above itinerary.",
        "01 Day Excursion in Alexandria as mentioned at the above itinerary.",
        "01 Day Excursion in Hurghada as mentioned at the above itinerary.",
        "Sightseeing Tours on Board the Nile Cruise include visits as mentioned at the above itinerary.",
        "Private English-speaking Egyptologist in Cairo, Alexandria & the Nile Cruise Only during your sightseeing tours.",
        "Entrance fees to the above-mentioned sites as mentioned in the itinerary.",
        "A Bottle of Mineral Water for each person.",
        "Service charges and all taxes.",
        "Entry Visa to Egypt",
        "Travel Insurance",
        "GST",
      ],

      excluded: [
        "TCS 2 % (Refundable against PAN card)",
        "International flight tickets",
        "Domestic flight tickets CAIRO - ASWAN – HURGHADA - CAIRO",
        "Drinks, Beverages & Mineral water during all the meals.",
        "Any optional tours if required",
        "Entrance inside any of the pyramids will be with extra fees (Tickets can be booked on the Spot)",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [
        "Abu Simple Temple Tour",
        "Karnak Sound & Light Show",
        "Hot Air Balloon Ride",
      ],
    },

    accommodation: [
      {
        hotel: "Azal Cairo Pyramids 4*",
        city: "Cairo",
        nights: "2",
        meal: "Breakfast",
        room: "Standard Room",
      },
      {
        hotel: "Nile Cruise 5*",
        city: "Nile River",
        nights: "3",
        meal: "Breakfast, Lunch & Dinner",
        room: "",
      },
      {
        hotel: "Sonesta Pharaoh Beach Resort 5*",
        city: "Hurghada",
        nights: "2",
        meal: "Breakfast",
        room: "Standard Room",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Total Cost",
          price: "INR 1,48,300/- + TCS (Refundable)",
          unit: "",
        },
      ],
      note: "",
    },

    terms: [
      "Please note that no booking has been held at this time.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    images: [
      "/images/egypt/day-1.jpg",
      "/images/egypt/day-2.jpg",
      "/images/egypt/day-3.jpg",
      "/images/egypt/day-4.jpg",
      "/images/egypt/day-5.jpg",
      "/images/egypt/day-6.jpg",
      "/images/egypt/day-7.jpg",
      "/images/egypt/day-8.jpg",
      "/images/egypt/day-9.jpg",
      "/images/egypt/extra1.jpg",
      "/images/egypt/extra2.jpg",
      "/images/egypt/extra3.jpg",
      "/images/egypt/extra4.jpg",
      "/images/egypt/extra5.jpg",
      // "/images/egypt/extra6.jpg",
    ],
  },

  {
    title: "Morocco",
    slug: "morocco",
    price: "INR 2,69,100/- + TCS (Refundable)",
    childPrice: "INR 1,09,200/- + TCS (Refundable)",
    days: "10 Nights / 11 Days",
    rating: "4.9",
    image: "/images/morocco/day-1.jpg",
    location: "Morocco",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "10 Nights",
        places: "Casablanca, Rabat, Chefchaouen, Volubilis, Meknes, Fes, Ifrane, Merzouga, Todra Gorges, Dades Valley, Ait Ben Haddou, Marrakech",
      },

      pills: [
        "10 Nights Accommodation",
        "Breakfast",
        "Private Driver/Guide",
      ],

      highlights: [
        "Hassan II Mosque",
        "Chefchaouen",
        "Volubilis",
        "Meknes",
        "Fes",
        "Ifrane",
        "Cedar Forest",
        "Sahara Desert",
        "Todra Gorges",
        "Dades Valley",
        "Ait Ben Haddou",
        "Marrakech",
      ],

      experiences: [
        {
          title: "Sahara Desert Experience",
          desc: "Experience the magic of the Sahara in Merzouga with a camel ride, sunset views, and an overnight stay in a luxury desert camp.",
        },
        {
          title: "Blue City of Chefchaouen",
          desc: "Spend a relaxed day exploring the picturesque streets and blue alleys of Chefchaouen at your own pace.",
        },
        {
          title: "Atlas Mountains & Scenic Drives",
          desc: "Travel through Ifrane and the scenic Cedar Forest en route to Merzouga, enjoying beautiful Atlas Mountain landscapes.",
        },
        {
          title: "Cultural Immersion in Fes & Marrakech",
          desc: "",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Casablanca",
        desc: "Arrive in Casablanca and transfer to your hotel for check-in, followed by a relaxed evening at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "Casablanca – Rabat – Chefchaouen",
        desc: "Visit the iconic Hassan II Mosque, then travel via Rabat to the charming blue town of Chefchaouen for an overnight stay.",
        tags: [],
      },
      {
        day: "03",
        title: "Chefchaouen Exploration",
        desc: "Spend a relaxed day exploring the picturesque streets and blue alleys of Chefchaouen at your own pace.",
        tags: [],
      },
      {
        day: "04",
        title: "Chefchaouen – Volubilis – Meknes – Fes",
        desc: "Depart for Fes, visiting the ancient Roman ruins of Volubilis and stopping at Meknes en route.",
        tags: [],
      },
      {
        day: "05",
        title: "Fes Exploration",
        desc: "Enjoy a guided cultural tour of Fes, exploring its historic medina and vibrant souks.",
        tags: [],
      },
      {
        day: "06",
        title: "Fes – Ifrane – Cedar Forest – Merzouga",
        desc: "Travel through Ifrane and the scenic Cedar Forest en route to Merzouga, enjoying beautiful Atlas Mountain landscapes.",
        tags: [],
      },
      {
        day: "07",
        title: "Sahara Desert Experience",
        desc: "Experience the magic of the Sahara in Merzouga with a camel ride, sunset views, and an overnight stay in a luxury desert camp.",
        tags: [],
      },
      {
        day: "08",
        title: "Merzouga – Todra Gorges – Dades Valley",
        desc: "Explore the dramatic Todra Gorges before continuing to the scenic Dades Valley for an overnight stay.",
        tags: [],
      },
      {
        day: "09",
        title: "Dades – Ait Ben Haddou – Marrakech",
        desc: "Visit the famous Ait Ben Haddou and cross the Atlas Mountains to reach Marrakech.",
        tags: [],
      },
      {
        day: "10",
        title: "Marrakech Exploration",
        desc: "Discover Marrakech with a guided tour and enjoy optional experiences such as gardens and local souks.",
        tags: [],
      },
      {
        day: "11",
        title: "Departure",
        desc: "Transfer to from Marrakech to Casablanca airport for your onward journey.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Prices are subject to availability and may change at the time of booking.",
      "For any further inquiries please reach out to us.",
    ],

    inclusions: {
      included: [
        "10 Nights’ accommodation along with Breakfast",
        "Airport pick-up and travel in a comfortable, air-conditioned vehicle",
        "Entrance fees to all historical sites as outlined in the itinerary",
        "Local guides where required (such as Volubilis, Fes, and Marrakech)",
        "Services of a private Deep Morocco Tours driver/guide throughout, with maximum ϐlexibility",
        "Sahara Desert with camel ride & luxury camp",
        "Blue city of Chefchaouen",
        "Atlas Mountains & scenic drives",
        "Cultural immersion in Fes & Marrakech",
        "Family-friendly pace with ϐlexibility",
        "Sahara Desert experience",
        "Optional lunch with a local Berber family",
        "All tourist city taxes",
        "All VAT",
        "No hidden fees or extras",
        "Travel Insurance",
        "Tourist visa",
        "GST",
      ],

      excluded: [
        "TCS 2% Refundable",
        "Airfare",
        "Meals",
        "Hotel accommodation",
        "Tips",
        "Anything not mentioned in inclusions",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [
        "Optional lunch with a local Berber family",
        "Optional experiences such as gardens and local souks",
      ],
    },

    accommodation: [
      {
        hotel: "",
        city: "Casablanca",
        nights: "01",
        meal: "Breakfast",
        room: "",
      },
      {
        hotel: "",
        city: "Chefchaouen",
        nights: "02",
        meal: "Breakfast",
        room: "",
      },
      {
        hotel: "",
        city: "Fes",
        nights: "02",
        meal: "Breakfast",
        room: "",
      },
      {
        hotel: "",
        city: "Merzouga",
        nights: "01",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "",
        city: "Camp",
        nights: "01",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "",
        city: "Dades Valley",
        nights: "01",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "",
        city: "Marrakech",
        nights: "02",
        meal: "Breakfast",
        room: "",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Adult",
          price: "INR 2,69,100/- + TCS (Refundable)",
          unit: "per person",
        },
        {
          category: "Child",
          price: "INR 1,09,200/- + TCS (Refundable)",
          unit: "per person",
        },
      ],
      note: "",
    },

    terms: [
      "Prices are subject to availability and may change at the time of booking.",
      "For any further inquiries please reach out to us.",
    ],

    images: [
      "/images/morocco/day-1.jpg",
      "/images/morocco/day-2.jpg",
      "/images/morocco/day-3.jpg",
      "/images/morocco/day-4.jpg",
      "/images/morocco/day-5.jpg",
      "/images/morocco/day-6.jpg",
      "/images/morocco/day-7.jpg",
      "/images/morocco/day-8.jpg",
      "/images/morocco/day-9.jpg",
      "/images/morocco/day-10.jpg",
      "/images/morocco/day-11.jpg",

    ],
  },

  {
    title: "Amazing Nepal",
    slug: "Amazing-Nepal",
    price: "RS.28,000 PER PERSON",
    days: "5 Nights / 6 Days",
    rating: "4.9",
    image: "/images/nepal/day-1.jpg",
    location: "Kathmandu, Pokhara",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "Kathmandu (2Nights)-Pokhara (2Nights)-Kathmandu(1Night)",
        places: "Kathmandu, Pokhara",
      },

      pills: [
        "5 Nights / 6 Days",
        "Daily Breakfast & Dinner",
        "Private AC Vehicle",
      ],

      highlights: [
        "Pashupatinath Temple",
        "Budanilkantha",
        "Guheshwori (Shakti Peeth)",
        "Kathmandu Durbar Square",
        "Swayambhunath",
        "Manakamana Temple",
        "Sarangkot",
        "Davis Fall",
        "Fewa Lake",
        "Pumdikot Shiva Statue",
        "Gupteshwor Mahadev",
        "Bindabasini Temple",
      ],

      experiences: [
        {
          title: "Sandhya Aarti",
          desc: "Transfer to Pashupatinath temple for Sandhya Aarti.",
        },
        {
          title: "Kathmandu City Tour",
          desc: "City tour of Kathmandu covering Budanilkantha, Pashupatinath, Guheshwori (Shakti Peeth), Kathmandu Durbar Square and Swayambhunath.",
        },
        {
          title: "Pokhara City Tour",
          desc: "City tour covering Davis fall, Fewa lake, Pumdikot Shiva Statue, Gupteshwor Mahadev & Bindabasini temple.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival & Sandhya Aarti",
        desc: "Upon arrival at airport, you will be met by our representative & transferred to your hotel. Check in at Hotel & later transfer to Pashupatinath temple for Sandhya Aarti, then transfer back to hotel. Overnight stay at Hotel.",
        tags: [],
      },
      {
        day: "02",
        title: "Kathmandu City Tour (7Hrs Max)",
        desc: "After breakfast get ready for the city tour of Kathmandu which will take you to the world heritage sites like Budanilkantha, Pashupatinath, Guheshwori (Shakti Peeth) Kathmandu Durbar Square & Swayambhunath (monkey temple). Evening free. Overnight at hotel in Kathmandu.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Transfer to Pokhara (8hrs)",
        desc: "After Breakfast Transfer to Pokhara Which Is 8 Hrs. (200 Km) Drive from Kathmandu, On the way Manakamana Temple Visit (Tickets on your own). Evening is Free. Overnight at Hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "City Tour of Pokhara (6Hrs Max)",
        desc: "Early in the morning around 05:00 am you will be taken to Sarangkot (25min drive) from where you can enjoy the sun rise then return to hotel. after breakfast proceed for city tour of Pokhara which will cover Davis fall, Fewa lake, Pumdikot Shiva Statue, Gupteshwor Mahadev & Bindabasini temple. Overnight at hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Transfer Back to Kathmandu (8 Hrs. Drive)",
        desc: "After breakfast head back to Kathmandu, Check in to your Hotel & rest of the time free for shopping & other activities. Overnight at Hotel.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Departure",
        desc: "Today after breakfast you will be transferred to airport as per your flight schedule.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Vehicle is used strictly as per itinerary and not for disposal.",
      "Entry and tickets cost payable extra and directly.",
      "Transportation is point-to-point only as per the package inclusions; vehicle is not at disposal.",
      "Rates are valid and applicable to Indian passport/ID holders only.",
      "In case of flight cancellations, delays, or natural disasters, any extra expenses must be borne by the guest.",
      "Rates and availability are subject to change at the time of confirmation.",
      "Only ₹100 INR currency notes are accepted in Nepal. Denominations above ₹100 are not accepted.",
      "If the specified hotel is unavailable, a similar category hotel will be provided.",
      "Hotel availability is subject to confirmation at the time of booking.",
      "Scanned ID copies, rooming list, and meal preferences must be emailed prior to arrival.",
      "Any itinerary changes must be communicated in advance.",
      "No vehicle stops for lunch during arrival or departure transfers.",
      "Rooms and rates are subject to availability.",
    ],

    inclusions: {
      included: [
        "All Transfers & Sightseeing By Pvt Ac Vehicle (Not for Disposal)",
        "Daily Breakfast & Dinner at Hotel",
        "3 Night Accommodation in Kathmandu.",
        "2 Night Accommodation in Pokhara.",
        "GST Included",
      ],

      excluded: [
        "International & domestic air ticket/ GST bill / Meals other than specified",
        "Tips, drink, laundry Fee",
        "Entrance fee at the monument",
        "Medical and travelling Insurance/Boat Ride / cable car ticket",
        "All the entry tickets cost are mentioned below and are payable directly at the time of sightseeings.",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Hotel Ramada By Wyndham Dhumbarahi",
        city: "Kathmandu",
        nights: "3",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "Temple Himalaya Resort and Spa /Atithi Resort and Spa",
        city: "Pokhara",
        nights: "2",
        meal: "Breakfast & Dinner",
        room: "",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "4* Hotels",
          price: "RS.28,000 PER PERSON",
        },
      ],
    },

    terms: [
      "Rates, services and operations are subject to change as per change in Bhutan Govt. rules and regulations.",
    ],

    images: [
      "/images/nepal/day-1.jpg",
      "/images/nepal/day-2.jpg",
      "/images/nepal/day-3.jpg",
      "/images/nepal/day-4.jpg",
      "/images/nepal/day-5.jpg",
     
    ],
  },

  {
    title: "Malaysia & Singapore With Cruise",
    slug: "malaysia-singapore",
    price: "INR 1,44,800/- + TCS (refundable)",
    days: "08 Nights /09 Days",
    rating: "4.9",
    image: "/images/sing/day-1.jpg",
    location: "Kuala Lumpur, Singapore",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "08 Nights /09 Days",
        places: "Kuala Lumpur, Singapore",
      },

      pills: [
        "04 Nights Singapore",
        "02 Nights Malaysia",
        "02 Nights Cruise",
        "Breakfast",
      ],

      highlights: [
        "Kuala Lumpur City Tour",
        "Genting Highlands",
        "Batu Caves",
        "Genting Dream Cruise",
        "Singapore City Tour",
        "Night Safari",
        "Gardens by the Bay",
        "Marina Bay Sands",
        "Sentosa Island",
        "Singapore Oceanarium",
        "Universal Studios",
      ],

      experiences: [
        {
          title: "Genting Highlands Excursion",
          desc: "Full-day excursion to Genting Highlands with Batu Caves photo opportunity and 2-way cable car ride.",
        },
        {
          title: "Genting Dream Cruise",
          desc: "Enjoy a full day onboard the Genting Dream cruise.",
        },
        {
          title: "Sentosa Island Experience",
          desc: "Sentosa Tour including Skypass Round Trip, Standard Ticket, Digiphoto, Wings of Time and Singapore Oceanarium.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Kuala Lumpur",
        desc: "Upon arrival in Kuala Lumpur, you will be welcomed and transferred for a half-day city tour, exploring the major attractions and landmarks of the city. After the tour, proceed to your hotel for check-in and relaxation.",
        tags: [],
      },
      {
        day: "02",
        title: "Genting Highlands Excursion",
        desc: "Enjoy a full-day excursion to Genting Highlands. En route, stop at Batu Caves for a 30-minute photo opportunity. Continue your journey with a 2-way cable car ride (standard gondola only) offering scenic views before spending time at Genting Highlands.",
        tags: [],
      },
      {
        day: "03",
        title: "Kuala Lumpur to Singapore & Cruise Embarkation",
        desc: "Depart from Kuala Lumpur to Singapore by flight. Upon arrival, spend approximately 2 hours at the airport. Later, transfer at 2:00 PM for a half-day Singapore city tour, followed by your cruise embarkation.",
        tags: [],
      },
      {
        day: "04",
        title: "Onboard Genting Dream Cruise",
        desc: "Enjoy a full day onboard the Genting Dream cruise, experiencing various entertainment, dining, and leisure activities available on the ship.",
        tags: [],
      },
      {
        day: "05",
        title: "Cruise Disembarkation & Night Safari",
        desc: "After disembarkation, transfer to your hotel and complete check-in. In the evening, head out to enjoy the exciting Night Safari experience.",
        tags: [],
      },
      {
        day: "06",
        title: "Gardens by the Bay & Marina Bay Sands",
        desc: "Visit Gardens by the Bay, including access to the two domes, followed by the OCBC Skywalk. Later, proceed to Marina Bay Sands SkyPark for panoramic city views.",
        tags: [],
      },
      {
        day: "07",
        title: "Sentosa Island Experience",
        desc: "Spend a full day at Sentosa Island, enjoying its attractions including the SEA Aquarium and other leisure activities.",
        tags: [],
      },
      {
        day: "08",
        title: "Universal Studios",
        desc: "Experience a fun-filled day at Universal Studios, enjoying thrilling rides, shows, and attractions.",
        tags: [],
      },
      {
        day: "09",
        title: "Departure from Singapore",
        desc: "Enjoy the day at leisure for shopping and personal activities. Later, transfer to the Singapore airport for your departure.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Please note that no booking has been held at this time.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "04 Nights’ accommodation at Singapore along with Breakfast",
        "02 Nights’ accommodation at Malaysia along with Breakfast",
        "02 Nights’ accommodation at Cruise along with Breakfast",
        "English Speaking Guide Services",
        "KLIA1/KLIA2 to KL Hotel - Pick up & Hotel Transfer",
        "KL Hotel to Half Day KL City Tour: 4 Hrs - With Return Transfers",
        "Full Day Genting Highland Tour - En-route Batu Caves 30mins *photo-stop only*",
        "Genting Cable Car Entrance - 2 Way Cable Car",
        "PVT transfer from Changi airport – Cruise Pier",
        "PVT Half Day city tour with English Speaking Guide [3 hrs] – after city tour drop guest at Cruise pier",
        "PVT Night Safari Tour [3.5 hrs] – include admission + tram ride",
        "Pvt Sentosa Tour – include admission + Skypass Round Trip (Mount Faber Line + Sentosa Line) + Standard Ticket + Digiphoto + wings of times (Standard seat) + Singapore Oceanarium",
        "PVT Universal Studios – standard admission ticket",
        "PVT Combine Marina Bay Sands Deck + SIC Garden by the Bay - Flower Dome + Cloud Forest (with Jurassic World: The Exhibition) + OCBC Skyway with 02 way transfers",
        "Travel Insurance",
        "Singapore tourist Visa",
        "GST",
        "04 Complimentary meals a day",
        "Port Charges",
        "Usage of specified cruise facilities",
        "Usage of Rope Course, Zip Lining, Rock Climbing, Swimming Pool, Jacuzzi, Gymnasium, Water Slides, Mini Golf, Basketball",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "Airfare",
        "Cruise gratuities to be paid on board",
        "Meals",
        "Personal expenses, Optional Activities",
        "Anything not mentioned in inclusions",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "VERDANT HILL 4*",
        city: "Kula Lumpur",
        nights: "2",
        meal: "Breakfast",
        room: "Superior Queen",
      },
      {
        hotel: "Genting Dream",
        city: "Dream Cruise",
        nights: "2",
        meal: "Breakfast",
        room: "Balcony",
      },
      {
        hotel: "NOVOTEL SINGAPORE ON KITCHENER 4*",
        city: "Singapore",
        nights: "4",
        meal: "Breakfast",
        room: "Superior Room",
      },
    ],

pricing: {
  rows: [
    {
      category: "Per Person",
      price: "INR 1,44,800/- + TCS (refundable)",
      unit: "per person",
    },
  ],
  note: "",
},

    terms: [
      "Please note that no booking has been held at this time.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    images: [
      "/images/sing/day-1.jpg",
       "/images/sing/day-2.jpg",
       "/images/sing/day-3.jpg",
       "/images/sing/day-4.jpg",
       "/images/sing/day-5.jpg",
       "/images/sing/day-6.jpg",
       "/images/sing/day-7.jpg",
       "/images/sing/day-8.jpg",
       "/images/sing/day-9.jpg",

    ],
  },

  {
    title: "Dubai",
    slug: "dubai",
    price: "INR 59,950/- + TCS",
    childPrice: "INR 40,350/- + TCS",
    days: "6 NIGHTS/ 7 DAYS",
    rating: "4.9",
    image:  "/images/dubai/day-1.jpg",
    location: "Dubai",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "6 Nights / 7 Days",
        places: "Dubai, Abu Dhabi",
      },

      pills: [
        "6 Nights Accommodation",
        "Marina Dhow Cruise",
        "Desert Safari",
        "Burj Khalifa",
      ],

      highlights: [
        "Marina Dhow Cruise with Dinner",
        "Dubai City Tour",
        "Burj Khalifa 124th Floor",
        "Museum of the Future",
        "Desert Safari",
        "The View at The Palm",
        "Miracle Garden",
        "Global Village",
        "Abu Dhabi Day Trip",
        "1 Theme Park Access",
      ],

      experiences: [
        {
          title: "Marina Dhow Cruise with Dinner",
          desc: "Standard Marina Dhow Cruise with Dinner.",
        },
        {
          title: "Desert Safari",
          desc: "Standard Dubai Desert Safari with Dinner.",
        },
        {
          title: "Abu Dhabi Day Trip",
          desc: "Abu Dhabi City Tour - Grand Mosque Tour with Ferrari on Sic.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival | Marina Dhow Cruise with Dinner (Upper Deck)",
        desc: "",
        tags: [],
      },
      {
        day: "02",
        title: "Dubai City Tour | Burj Khalifa 124th Floor (Non-Prime Hours)",
        desc: "",
        tags: [],
      },
      {
        day: "03",
        title: "Museum of the Future | Desert Safari",
        desc: "",
        tags: [],
      },
      {
        day: "04",
        title: "View at The Palm | Miracle Garden | Global Village",
        desc: "",
        tags: [],
      },
      {
        day: "05",
        title: "Abu Dhabi Day Trip with 1 Theme Park Access",
        desc: "",
        tags: [],
      },
      {
        day: "06",
        title: "Day Free at Leisure",
        desc: "",
        tags: [],
      },
      {
        day: "07",
        title: "Departure",
        desc: "",
        tags: [],
      },
    ],

    pointsToRemember: [],

    inclusions: {
      included: [
        "6 Nights’ accommodation as mentioned above hotel",
        "Return airport transfers are on private basis",
        "Abu Dhabi City Tour - Grand Mosque Tour with Ferrari on Sic",
        "Burj Khalifa - Nrf - At the Top - Normal Hour on Sic",
        "Half Day Dubai City Tour on Seat in Coach Basis with",
        "Standard Dubai Desert Safari with Dinner",
        "Miracle Garden and Global Village Combo on Sic",
        "Standard Marina Dhow Cruise with Dinner",
        "Museum Of the Future",
        "The view at the palm",
        "GST",
      ],

      excluded: [
        "TCS",
        "Airfare",
        "Tourist visa",
        "Tourism Dirham",
        "Travel Insurance",
        "OK to Board charges",
        "Personal expenses",
        "Any other items not included under the column \"Inclusions\"",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Smana Hotel Al Raffa",
        city: "Dubai",
        nights: "6",
        meal: "BB",
        room: "Standard room",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "Adult",
          price: "INR 59,950/- + TCS",
        },
        {
          category: "Child",
          price: "INR 40,350/- + TCS",
        },
        {
          category: "Hotel Rate",
          price: "USD 370.00 per room on double sharing with child on existing bed for 6 nights",
        },
      ],
    },

    terms: [],

    images: [
      "/images/dubai/day-1.jpg",
      "/images/dubai/day-2.jpg",
      "/images/dubai/day-3.jpg",
      "/images/dubai/day-4.jpg",
      "/images/dubai/day-5.jpg",
      "/images/dubai/day-6.jpg",
      "/images/dubai/day-7.jpg",
    ],
  },

  {
    title: "Hongkong and Macau",
    slug: "hongkong-and-macau",
    price: "INR 1,32,800/-",
    days: "05Nights/ 06Days",
    rating: "4.9",
    image: "/images/hongkong/day-1.jpg",
    location: "Hong Kong, Macau",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "05 Nights / 06 Days",
        places: "Macau, Hong Kong",
      },

      pills: [
        "02 Nights Macau",
        "03 Nights Hong Kong",
        "Breakfast",
        "English Speaking Guide",
      ],

      highlights: [
        "Ruins of St. Paul's",
        "A-Ma Temple",
        "The Venetian Macao",
        "Macau Tower",
        "Victoria Peak",
        "Madame Tussauds Hong Kong",
        "Star Ferry",
        "Tsim Sha Tsui Clock Tower",
        "Avenue of Stars",
        "Hong Kong Disneyland",
        "Ocean Park Hong Kong",
      ],

      experiences: [
        {
          title: "Macau City Tour",
          desc: "Half-day Macau city tour including Ruins of St. Paul's, A-Ma Temple, The Venetian Macao and Macau Tower.",
        },
        {
          title: "Hong Kong Night Tour",
          desc: "Victoria Peak with one-way Peak Tram, Madame Tussauds Hong Kong, one-way Star Ferry, Tsim Sha Tsui Clock Tower and Avenue of Stars.",
        },
        {
          title: "Hong Kong Disneyland",
          desc: "Full day at Hong Kong Disneyland with a 1-day park ticket and two-way transfers.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Hong Kong to Macau",
        desc: "Arrive at Hong Kong International Airport and take a one-way direct transit bus (Sharing) from the airport to Macau Port via the Hong Kong–Zhuhai–Macau Bridge. Upon arrival at the Macau pier, proceed on your own and take the hotel’s complimentary shuttle bus to your hotel. Hotel check-in time is after 15:00 hrs. Overnight stay in Macau.",
        tags: [],
      },
      {
        day: "02",
        title: "Macau",
        desc: "After breakfast, proceed for a half-day Macau city tour. Visit the famous Ruins of St. Paul's, stop at a local souvenir shop, explore the historic A-Ma Temple, and visit the grand The Venetian Macao casino complex. Later, enjoy panoramic views of the city with an included ticket to Macau Tower. Overnight stay in Macau.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Macau to Hong Kong",
        desc: "Take the hotel’s complimentary shuttle bus to the Macau ferry pier on your own and board your one-way ferry to Hong Kong. Upon arrival in Hong Kong, meet your representative and proceed to the hotel for check-in. In the evening, enjoy the Hong Kong Night Tour, visiting Victoria Peak with a one-way ride on the Peak Tram, explore Madame Tussauds Hong Kong, take a one-way ride on the Star Ferry, and see the Tsim Sha Tsui Clock Tower and Avenue of Stars. Overnight stay in Hong Kong.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Hong Kong",
        desc: "Enjoy a full day at Hong Kong Disneyland with a 1-day park ticket and two-way transfers. Experience exciting rides, themed attractions, and live entertainment throughout the park. Overnight stay in Hong Kong.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Hong Kong",
        desc: "Today visit Ocean Park Hong Kong with a 1-day admission ticket and two-way transfers. Spend the day enjoying thrilling rides, marine life exhibits, and spectacular shows at one of Hong Kong’s most popular attractions. Overnight stay in Hong Kong.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Hong Kong Departure",
        desc: "After breakfast, transfer to Hong Kong International Airport for your departure flight (ETD after 10:00 hrs). Tour ends with wonderful memories.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Please note that no booking has been held at this time.",
    ],

    inclusions: {
      included: [
        "02 Nights hotel accommodation along with Breakfast at Macau",
        "03 Nights hotel accommodation along with Breakfast at Hong Kong",
        "1 way ticket Direct Transit Bus",
        "Half day Macau city tour",
        "1 way ferry ticket to Hong Kong",
        "Evening Hong Kong night tour",
        "1 day Disneyland Ticket",
        "1 day Ocean park ticket",
        "All transfers, tickets, Sightseeing as per the itinerary",
        "All applicable transfer by private coach (except direct transit bus from HK Airport to Macau)",
        "English Speaking guide",
        "Travel Insurance",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "Airfare",
        "Personal Expenses",
        "Anything not mentioned in the itinerary",
        "Tips",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Venetian Hotel 5*",
        city: "Macau",
        nights: "2",
        meal: "Breakfast",
        room: "Royale suite",
      },
      {
        hotel: "Harbour Plaza Metropolis Hotel 4*",
        city: "Hong Kong",
        nights: "3",
        meal: "Breakfast",
        room: "Twin Sharing Standard Room",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "Adult",
          price: "INR 1,32,800/-",
        },
      ],
    },

    terms: [],

    images: [
      "/images/hongkong/day-1.jpg",
      "/images/hongkong/day-2.jpg",
      "/images/hongkong/day-3.jpg",
      "/images/hongkong/day-4.jpg",
      "/images/hongkong/day-5.jpg",
      "/images/hongkong/day-6.jpg",
    ],
  },

  {
    title: "Amazing 06 Days in Vietnam",
    slug: "",
    price: "RS 59,200/- PP",
    days: "06 Days",
    rating: "",
    image: "",
    location: "Danang, Hanoi, Halong",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "06 Days",
        places: "Danang, Hoi An, Ba Na Hills, Hanoi, Halong",
      },

      pills: [
        "Daily Breakfast",
        "Indian Meals",
        "English-speaking Tour Guides",
        "Travel Insurance",
      ],

      highlights: [
        "Dragon Bridge",
        "Han River Bridge",
        "Love Lock Bridge",
        "Tran Thi Ly Bridge",
        "APEC Sculpture Garden",
        "Hoi An Ancient Town",
        "Ba Na Hills",
        "Golden Bridge",
        "Ho Chi Minh Complex",
        "Tran Quoc Pagoda",
        "Hoan Kiem Lake",
        "Old Quarter of Hanoi",
        "Halong Bay",
        "Thien Cung Cave",
        "Dau Go Cave",
      ],

      experiences: [
        {
          title: "Basket Boat & Hoi An Ancient Town",
          desc: "Learn how to paddle the Vietnamese unique bamboo basket boat and visit Hoi An ancient town.",
        },
        {
          title: "Ba Na Hills & Golden Bridge",
          desc: "Cable car to Ba Na Hills, visit Old Villas, French Stable, Tinh Tam Garden, Golden Bridge, Linh Ung Pagoda, Loc Uyen Garden, Quan Am Pavilion, Nui Chua Peak and Fantasy Park.",
        },
        {
          title: "Halong Day Trip",
          desc: "Private cruise through Halong Bay with visits to Thien Cung and Dau Go Cave.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival Danang – Dragon Bridge",
        desc: "On arrival Danang, pick up by our guide and driver from the airport and transfer to the city centre. Lunch at an Indian restaurant (Set menu). Transfer to check in hotel. Standard check-in time is 14h00/15h00. As the sun starts to go down, we visit the 4 famous bridges of the city: Han River Bridge, Love Lock Bridge, Tran Thi Ly Bridge. Stop for photoshoot at APEC Sculpture Garden. Dinner at an Indian restaurant (Set menu). Overnight in Danang.",
        tags: [
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "02",
        title: "Da Nang – Basket Boat - Hoi An Ancient Town",
        desc: "Breakfast at the hotel. Free time at leisure. Lunch at an Indian restaurant (Set menu). After lunch, heading to Cam Thanh village and Bay Mau coconut forest. Here we will learn how to paddle the Vietnamese unique bamboo basket boat and explore the now tranquil coconut-palm flanking the waterways. Next, visit Hoian ancient town. Dinner at an Indian restaurant (Set menu). Transfer back to Danang. Overnight in Danang.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "03",
        title: "Danang – Bana Hills & Golden Bridge – Danang",
        desc: "After breakfast, transfer to Ba Na hills and take Cable Car. Visit the Old Villas, French Stable, Tinh Tam Garden, Golden Bridge, Linh Ung Pagoda, Loc Uyen Garden, Quan Am Pavilion and Nui Chua Peak. Have lunch at Ba Na Hills restaurant (Indian and Vietnamese buffet). Discover the Bana Brew House and Fantasy Park. Optional Alpine roller coaster, Wax Museum entrance fee, Debay Wine Cellar entrance fee and coin games at Fantasy Park are not included. Go downhill by cable car and return to our hotel. Dinner at an Indian restaurant (Set menu). Overnight in Danang.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "04",
        title: "Danang – Flight to Hanoi – Half Day City Tour",
        desc: "After breakfast, check out the hotel. Transfer with our guide and driver to the airport for our departure flight. On arrival, pick up by our guide and driver from the airport and transfer to the city center. Lunch at an Indian restaurant (Set menu). Transfer to the hotel for check in. This afternoon, visit the Ho Chi Minh Complex, Ba Dinh Square, Ho Chi Minh’s Mausoleum (from outside as closed in the afternoon), private residence, One Pillar Pagoda, Tran Quoc Pagoda, Hoan Kiem Lake and Old Quarter of Hanoi. Dinner at an Indian restaurant (Set menu). Overnight in Hanoi.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "05",
        title: "Hanoi – Halong Day Trip – Hanoi",
        desc: "After breakfast, transfer to Halong through Old way (3,5 – 4 hours). Upon arrival in Halong, transfer to the pier and board a charming traditional wooden junk for cruising through the Bay. The cruise passes by Stone Dog, Incense Burner (Dinh Huong), and Fighting Cock (Ga Choi). Indian Lunch on board (Set menu). Visit Thien Cung and Dau Go Cave or relax on the boat. After 4 hours of cruising and exploring the Bay, disembark at Halong pier and return to Hanoi through Highway. Dinner at an Indian restaurant (Set menu). Overnight in Hanoi.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "06",
        title: "Hanoi – Shopping - Departure",
        desc: "After breakfast, at leisure until checking out of hotel. Standard check-out time is 11h00/12h00. Shopping drop at the Old Quarter. Lunch at an Indian restaurant (Set menu). Transfer with our guide and driver to the airport for our departure flight.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
        ],
      },
    ],

    pointsToRemember: [
      "No room or service is held until receiving your official confirmation.",
      "If any service is not available at time of booking, an alternative will be offered.",
      "No refunds or exchanges can be made in respect of accommodation, meals, sightseeing tours, transport or any other services which are included in the tour prices but not utilized by the tour member.",
      "Tour rates are based on current fuel rates and subject to change if the fuel rates increase by 10%.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "English-speaking tour guides (airport to airport)",
        "Accommodation in TRIPLE room with daily breakfast at hotels",
        "Day trip Ha Long bay in 4 hours including Indian lunch (set menu)",
        "Meals as per person: L = lunch, D = dinner",
        "Airport and other touring transfers in AC vehicles: 01 coach of 35 seats",
        "Entrance fees as per program",
        "Cable car 2 ways for BaNa Hills tour with buffet lunch",
        "Drinking water during transfers: 02 bottles of 500ml water per pax/day to be supplied on coach",
        "Visa to Vietnam",
        "Travel Insurance",
        "Tips for guide and driver: 3USD/pax/day",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable aginst PAN card)",
        "International, domestic flights and airport departure tax.",
        "Meals & drinks not mentioned in Detailed Program.",
        "Early check in & Late check-out surcharge.",
        "Other expense not mentioned in the program.",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [
        "Alpine roller coaster (USD 3/pax)",
        "Wax Museum entrance fee (USD 5/pax)",
        "Debay Wine Cellar entrance fee (USD 5/pax for Silver ticket)",
        "Coin games at Fantasy Park",
      ],
    },

    accommodation: [
      {
        hotel: "Fortuna hotel/Deluxe Royal lotus/ Premium",
        city: "Hanoi",
        nights: "",
        meal: "Breakfast",
        room: "4*",
      },
      {
        hotel: "",
        city: "Danang",
        nights: "",
        meal: "Breakfast",
        room: "4*",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "4* Hotel",
          price: "RS 59,200/- PP",
        },
      ],
    },

    terms: [],

    images: [],
  },

  {
    title: "Malaysia",
    slug: "majestic-malaysia",
    price: "RS.49,000 PER PERSON",
    days: "04 NIGHTS / 05 DAYS",
    rating: "4.9",
    image: "/images/malaysia/day-1.jpg",
    location: "Kuala Lumpur",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "04 Nights / 05 Days",
        places: "Kuala Lumpur, Genting Highlands, Malacca",
      },

      pills: [
        "04 Nights Accommodation",
        "Breakfast",
        "05 Lunches & 04 Dinner",
        "English Speaking Guide",
      ],

      highlights: [
        "Petronas Twin Towers",
        "Genting Highlands",
        "Batu Caves",
        "Awana SkyWay",
        "Malacca",
        "Melaka River Cruise",
        "Sunway Lagoon",
        "Water Park",
        "Amusement Park",
        "Wildlife Park",
        "Extreme Park",
        "Scream Park",
        "Nickelodeon Lost Lagoon",
      ],

      experiences: [
        {
          title: "Kuala Lumpur City Tour",
          desc: "Half-day Kuala Lumpur city tour with Petronas Twin Towers standard tickets.",
        },
        {
          title: "Genting Highlands",
          desc: "Full-day Genting Highlands excursion with Batu Caves photo stop and two-way cable car ride via Awana SkyWay.",
        },
        {
          title: "Sunway Lagoon",
          desc: "Full-day excursion with access to all six parks.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Kuala Lumpur",
        desc: "Upon arrival at KLIA1 or KLIA2, you will be welcomed by an English-speaking guide and transferred to your hotel in Kuala Lumpur by a 14-seater van. Standard hotel check-in time is after 3:00 PM. Later, proceed for a half-day Kuala Lumpur city tour (5 hours) with return transfers, including a visit to the iconic Petronas Twin Towers with standard tickets.",
        tags: [],
      },
      {
        day: "02",
        title: "Genting Highlands",
        desc: "After breakfast, depart from your hotel with an English-speaking guide for a full-day excursion to Genting Highlands in a 14-seater van. En route, enjoy a 30-minute photo stop at the famous Batu Caves. Continue your journey and experience a scenic two-way cable car ride via Awana SkyWay using standard gondola tickets. After exploring Genting Highlands, return to your hotel in Kuala Lumpur.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Malacca",
        desc: "Today, embark on a full-day historical tour to Malacca with your English-speaking guide. Discover the cultural and historical charm of the city and enjoy a relaxing ride on the Melaka River Cruise. Entrance fees to other attractions are not included and must be paid directly at the counter.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Sunway Lagoon",
        desc: "After breakfast, proceed for a full-day excursion to Sunway Lagoon with your English-speaking guide. Enjoy access to all six parks, including the Water Park, Amusement Park, Wildlife Park, Extreme Park, Scream Park, and Nickelodeon Lost Lagoon.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Departure",
        desc: "After breakfast, check out from your hotel in Kuala Lumpur. Standard check-out time is 12:00 PM. You will then be transferred to KLIA1 or KLIA2 by a 14-seater van for your departure, accompanied by an English-speaking guide.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Standard hotel check-in time is after 3:00 PM.",
      "Early check-in is not guaranteed; it is subject to availability and any additional charges must be paid directly at the hotel.",
      "Entrance fees to other attractions are not included and must be paid directly at the counter.",
      "Late check-out is not included.",
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "04 Nights’ accommodation along with Breakfast",
        "05 Lunches & 04 Dinner included",
        "Guide to 1 x English Speaking Guide Services",
        "KL Hotel to Half Day KL City Tour + Petronas Twin Tower: 5 Hrs - With Return Transfers",
        "Petronas Twin Tower - STANDARD TICKET",
        "Full Day Genting Highland Tour",
        "Genting Cable Car Entrance - 2 Way Cable Car (Standard Gondola Only)",
        "Full Day Historical Malacca Tour",
        "Melaka Tour - Melaka River Cruise",
        "Full Day Sunway Lagoon Tour - With Return Transfers",
        "Sunway Lagoon - 6 Parks Admission Tickets (Nickelodeon + Water + Amusement + Wildlife + Extreme + Scream)",
        "Travel insurance",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "Airfare",
        "Meals",
        "Personal expenses, Optional Activities",
        "Anything not mentioned in inclusions",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "VERDANT HILL 4*",
        city: "Kuala Lumpur",
        nights: "4",
        meal: "Bed and Breakfast (BB)",
        room: "Premier Triple",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "Per Person",
          price: "RS.49,000 PER PERSON",
        },
      ],
    },

    terms: [],

    images: [
      "/images/malaysia/day-1.jpg",
      "/images/malaysia/day-2.jpg",
      "/images/malaysia/day-3.jpg",
      "/images/malaysia/day-4.jpg",
      "/images/malaysia/day-5.jpg",
    ],
  },

  {
    title: "Bhutan Package",
    slug: "bhutan-package",
    price: "63,500/-",
    childPrice: "14,200/-",
    days: "7 Nights / 8 Days",
    rating: "4.9",
    image: "/images/bhutan/day-1.jpg",
    location: "Phuentsholing, Thimphu, Punakha/Wangdue, Paro",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "Phuentsholing 2N – Thimphu 2N – Wangdue / Punakha 1N – Paro 2N",
        places: "Phuentsholing, Thimphu, Punakha/Wangdue, Paro",
      },

      pills: [
        "7 Nights / 8 Days",
        "4* Equivalent Services",
        "Breakfast and Dinner",
        "Indian Nationals",
      ],

      highlights: [
        "Kuensel Phodrang (Buddha Dordenma)",
        "National Memorial Chorten",
        "Folk Heritage Museum",
        "Sangaygang View Point",
        "Takin Preserve Centre",
        "Changangkha Lhakhang",
        "Tashichho Dzong",
        "Dochu-La-Pass",
        "Punakha Dzong",
        "Chhimi Lhakhang",
        "Royal Botanical Park",
        "Ta Dzong - National Museum",
        "Rinpung Dzong",
        "Taktshang Monastery",
        "Drukgyel Dzong",
        "Kyichu Lhakhang",
      ],

      experiences: [
        {
          title: "Thimphu Sightseeing",
          desc: "Visit Kuensel Phodrang, National Memorial Chorten, Folk Heritage Museum, Sangaygang View Point, Takin Preserve Centre, Changangkha Lhakhang and Tashichho Dzong.",
        },
        {
          title: "Punakha/Wangdue Sightseeing",
          desc: "Visit Dochu-La-Pass, Punakha Dzong and Chhimi Lhakhang.",
        },
        {
          title: "Taktshang Monastery",
          desc: "Excursion to Taktshang Monastery with a 2-3 hours hike uphill.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "NJP Rly Station / IXB Airport - Phuentsholing",
        desc: "Meet & Greet on arrival at NJP Railway Station / IXB Airport and transfer to Phuentsholing (961 ft.) - The Gateway of Bhutan by Road from India. On arrival check in at the hotel. In the evening, you may choose to relax at the hotel or walk around the Phuentsholing town. Overnight stay at Phuentsholing.",
        tags: [],
      },
      {
        day: "02",
        title: "Phuentsholing - Thimphu",
        desc: "After breakfast, complete the immigration formalities and transfer to Thimphu (7,710 ft.) the capital city of Bhutan. On the way, stop at places to view scenery and for Photography. On arrival check in at the hotel. Rest of the day at leisure. Overnight stay at Thimphu.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Thimphu Sightseeing",
        desc: "After breakfast visit the Kuensel Phodrang (Buddha Dordenma), National Memorial Chorten, Folk Heritage Museum, Sangaygang View Point, Takin Preserve Centre, Changangkha Lhakhang and Tashichho Dzong. Overnight stay at Thimphu.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Thimphu - Punakha/Wangdue Sightseeing",
        desc: "After breakfast drive to Punakha/Wangdue. Stop at Dochu-La-Pass to view the higher Himalayas and the 108 chorten/stupas. On arrival at Punakha, check in at the hotel. Afternoon, visit Punakha Dzong and take a short and easy hike to visit Chhimi Lhakhang. Evening free for leisure. Overnight stay at Punakha / Wangdue.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Punakha/Wangdue - Paro Sightseeing",
        desc: "After breakfast drive to Paro. On the way stop at Lamperi to visit Royal Botanical Park. On arrival check in at the hotel. Afternoon visit Ta Dzong - National Museum and Rinpung Dzong. Rest of the evening at leisure. Overnight stay at Paro.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Excursion to Taktshang Monastery",
        desc: "After breakfast, drive to the base of the abode of gods and monks, the Taktshang Monastery. The monastery is a 2 -3 hours hike uphill from here. Afternoon (If time permits), visit the Drukgyel Dzong. On the way back, visit Kyichu Lhakhang. Overnight stay at Paro.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Paro - Phuentsholing",
        desc: "After breakfast check out from hotel and transfer to Phuentsholing. On arrival check in at the hotel. In the evening, you may choose to relax at the hotel or walk around the Phuentsholing town. Overnight stay at Phuentsholing.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "08",
        title: "Phuentsholing - NJP Rly Station / IXB Airport",
        desc: "After breakfast check out from the hotel and drive to NJP Railway Station / IXB Airport for your onward journey.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Rates, services and operations are subject to change as per change in Bhutan Govt. rules and regulations.",
      "The above rates are valid for Indian nationals only.",
      "The above-mentioned hotels will be confirmed as per the room availability. Otherwise we will confirm similar category.",
      "The rates quoted in the packages are on per person basis & valid for Indian nationals from 01st Mar 2026 to 30th Jun 2026.",
      "High seasons surcharge will be applicable during the Festivals (Tshechu) & Peak season.",
    ],

    inclusions: {
      included: [
        "Accommodation on twin Sharing Basis.",
        "Meal Plan (as per mentioned above).",
        "Exclusive Non-a/c vehicle for transfers & sightseeing as per itinerary.",
        "All permit fees & hotel taxes (as per itinerary).",
        "Guide charges (Only Bhutan Portion).",
        "Sustainable Development fee” (SDF)",
        "Rates are valid for INDIAN NATIONALS only.",
        "GST inclusive**.",
      ],

      excluded: [
        "Air Fare/ Train fare.",
        "Personal Expenses such as Laundry, telephone calls, tips & gratuity, mineral water, soft & hard drinks, rafting, rock climbing, paragliding, porterage.",
        "Additional sightseeing or extra usage of vehicle, other than mentioned in the itinerary.",
        "Entrance Fees.",
        "Any cost arising due to natural calamities like, landslides, road blockage, political disturbances (strikes), etc.",
        "Any increase in taxes or fuel price, leading to increase in cost on surface transportation & land arrangements.",
        "TCS & Travel Insurance.",
        "Anything which is not include in the inclusion.",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Bhutan Ga Me Ga (Standard) / Lotus Villa / Khamsum (Deluxe) / Similar",
        city: "Phuentsholing",
        nights: "2",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "Ariya / Tashi-Yid Wong / Similar",
        city: "Thimphu",
        nights: "2",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "Zhingkham Resort / River valley (Deluxe) / Khuru Resort / Similar",
        city: "Punakha",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "",
      },
      {
        hotel: "Kichu Resort / Tenzinling Resort (Luxury)/ Resort Thim-Dorji / Similar",
        city: "Paro",
        nights: "2",
        meal: "Breakfast & Dinner",
        room: "",
      },
    ],

  pricing: {
    rows: [
      {
        category: "02 PAX",
        price: "INR 63,500/-",
        unit: "per person",
      },
      {
        category: "CHILD NO BED (CNB)",
        price: "INR 14,200/-",
        unit: "per child",
      },
    ],
    note: "",
  },

    terms: [],

    images: [
      "/images/bhutan/day-1.jpg",
      "/images/bhutan/day-2.jpg",
      "/images/bhutan/day-3.jpg",
      "/images/bhutan/day-4.jpg",
      "/images/bhutan/day-5.jpg",
      "/images/bhutan/day-6.jpg",
      "/images/bhutan/day-7.jpg",
      "/images/bhutan/day-8.jpg",
    ],
  },

  {
    title: "Bali Tour Package Quotation",
    slug: "",
    price: "",
    days: "3 Nights Seminyak and 2 Nights Ubud",
    rating: "",
    image: "",
    location: "Seminyak, Ubud",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "3 Nights Seminyak + 2 Nights Ubud",
        places: "Seminyak, Ubud",
      },

      pills: [
        "05 Nights Accommodation",
        "Breakfast",
        "Private Basis Tours",
        "13 Seater Vehicle",
      ],

      highlights: [
        "Authentic Balinese Massage",
        "Kintamani Volcano",
        "Ubud Village",
        "Nusa Penida West Island",
        "Taman Safari Bali",
        "Bedugul Temple",
        "Tanah Lot Temple",
      ],

      experiences: [
        {
          title: "Authentic Balinese Massage",
          desc: "Half Day Authentic Balinese Massage on Private Basis including 60 Minutes Baliness Massage.",
        },
        {
          title: "Kintamani Volcano Tour",
          desc: "Full Day Kintamani Volcano Tour with Ubud Village including Mount Batur Viewing Only, Ubud Monkey Forest, Tirtha Empul, Tegenungan Water Fall and Swing by Aloha Swing.",
        },
        {
          title: "Nusa Penida Tour",
          desc: "Full Day Nusa Penida West Island Tour with SIC West Island Tour + Lunch.",
        },
        {
          title: "Taman Safari Bali",
          desc: "Half Day Taman Safari Bali - Night Safari Pass on Private Basis.",
        },
        {
          title: "Bedugul Temple & Tanah Lot",
          desc: "Full Day Bedugul Temple with Tanah Lot Sunset Tour including Tanah Lot Temple and Ulun Danu Temple/Bedugul Lake Temple.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival",
        desc: "Airport To Seminyak The Bali Dream Villa Seminyak on Private Basis. Half Day Authentic Balinese Massage on Private Basis including 60 Minutes Baliness Massage. Arrival Flight should reach on or before 1300 hrs in order to operate the Tour. Accommodation The Bali Dream Villa Seminyak.",
        tags: [],
      },
      {
        day: "02",
        title: "Kintamani Volcano Tour with Ubud Village",
        desc: "Full Day Kintamani Volcano Tour with Ubud Village on Private Basis. Includes Mount Batur Viewing Only, Ubud Monkey Forest, Tirtha Empul, Tegenungan Water Fall, Swing by Aloha Swing. Accommodation The Bali Dream Villa Seminyak.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Nusa Penida Tour",
        desc: "Full Day Nusa Penida Tour. Includes SIC West Island Tour + Lunch. Visit Kelingking beach, Angel’s billabong, Broken beach and Crystal Bay. Fast Boat transfer is on Sharing Basis. Accommodation The Bali Dream Villa Seminyak.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Seminyak To Ubud",
        desc: "Transfers: Seminyak To Ubud. Half Day Taman Safari Bali - Night Safari Pass on Private Basis including Night Safari Pass. Accommodation Impiana Private Villas Ubud.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Bedugul Temple with Tanah Lot Sunset",
        desc: "Full Day Bedugul Temple with Tanah Lot Sunset Tour on Private Basis including Tanah Lot Temple and Ulun Danu Temple/Bedugul Lake Temple. Accommodation Impiana Private Villas Ubud.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Departure",
        desc: "Impiana Private Villas Ubud Ubud To Airport on Private Basis. Day at Leisure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Arrival Day Tour Restriction: Your Arrival Flight should reach on or before 1300 hrs in order to operate the Tour.",
      "Transfers to Nusa Penida are based on shared PUBLIC fast boats.",
      "Rooms and rates are subject to availability.",
    ],

    inclusions: {
      included: [
        "Meet & Greet Assistance at the Airport",
        "05 Nights accommodation as per above details on BB basis",
        "One Way Transfer from Airport to Seminyak - The Bali Dream Villa Seminyak on Private Basis",
        "One Way Transfer from Seminyak - The Bali Dream Villa Seminyak to Ubud - Impiana Private Villas Ubud on Private Basis",
        "One Way Transfer from Ubud - Impiana Private Villas Ubud to Airport on Private Basis",
        "Half Day Authentic Balinese Massage on Private Basis - Pick Up from Seminyak Includes : 60 Minutes Baliness Massage",
        "Full Day Kintamani Volcano Tour with Ubud Village on Private Basis",
        "Full Day Nusa Penida Tour - Includes : SIC West Island Tour + Lunch",
        "Half Day Taman Safari Bali - Night Safari Pass on Private Basis",
        "Full Day Bedugul Temple with Tanah Lot Sunset Tour on Private Basis",
        "All transfer and tour services in Bali are based on 13 Seater Vehicle - Toyota Hiace and are offered with a guide.",
        "All transfers and tours in Nusa Penida are provided in 6-seater vehicles and do not include guide services.",
        "VAT in Indonesia and all other taxes",
        "All Services based on Selected Itinerary only",
        "TOURIST VISA",
        "GST",
      ],

      excluded: [
        "Airfare, airport taxes, Visa charges, Bali Tourist Levy",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "The Bali Dream Villa Seminyak",
        city: "Seminyak",
        nights: "3",
        meal: "Breakfast",
        room: "One Bedroom Pool Villa",
      },
      {
        hotel: "Impiana Private Villas Ubud",
        city: "Ubud",
        nights: "2",
        meal: "Breakfast",
        room: "Garden Pool Villa",
      },
    ],

    pricing: {
      note: "",
      options: [],
    },

    terms: [],

    images: [],
  },

  {
    title: "Thailand",
    slug: "simply-thailand",
    price: "RS.29,500 PER PERSON APPX INCLUDING PACKAGE+VISA+GST+TCS TAX",
    days: "4 Nights / 5 Days",
    rating: "4.9",
    image: "/images/thailand/day-1.jpg",
    location: "Bangkok, Pattaya",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "2 Nights Bangkok - 2 Nights Pattaya",
        places: "Bangkok, Pattaya",
      },

      pills: [
        "Daily Breakfast",
        "Thailand Visa Included",
        "Airport Transfers",
      ],

      highlights: [
        "Alcazar Show",
        "Coral Island",
        "Pattaya",
        "Bangkok City Tour",
        "Golden Buddha",
        "Marble Buddha",
        "Safari World Marine Park",
      ],

      experiences: [
        {
          title: "Alcazar Show",
          desc: "Alcazar Show (Normal Seat).",
        },
        {
          title: "Coral Island Tour",
          desc: "Coral Island tour by Speed Boat with Indian Lunch.",
        },
        {
          title: "Safari World Marine Park",
          desc: "Safari World Marine Park with Lunch (Monday Closed).",
        },
      ],
    },

    itinerary: [],

    pointsToRemember: [
      "The above is just a quote and we are not holding any booking.",
      "Accommodations/Hotel are subject to availability at the time of booking.",
      "Day by day activity might change.",
      "If Any change in no. of pax, duration or date of journey then plz check quote price again before Booking.",
      "While you want to confirm the booking plz send the flight details along with All Pax/Persons Passport & Pan card copy.",
      "Request you to plz keep all the conversations in a single mail & reply all to avoid any delay in mail.",
    ],

    inclusions: {
      included: [
        "Alcazar Show (Normal Seat)",
        "Coral Island tour 1 by Speed Boat with Indian Lunch",
        "En-route Pattaya-Bangkok (Half Day Bangkok City tour (Golden + Marble Buddha))",
        "Safari World Marine Park with Lunch (Monday Closed)",
        "Daily Breakfast",
        "Airport Transfers",
        "Thailand visa included",
        "Premium PVT (3 Way BKK Apt to Pattaya Hotel to Bangkok Hotel to BKK Apt",
      ],

      excluded: [],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Mike Garden Resort",
        city: "Pattaya",
        nights: "2",
        meal: "Breakfast",
        room: "1 Double Bed",
      },
      {
        hotel: "IBIS Bangkok Sukhumvit(4)",
        city: "Bangkok",
        nights: "2",
        meal: "Breakfast",
        room: "1 Double Bed",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "Per Person",
          price: "RS.29,500 PER PERSON APPX INCLUDING PACKAGE+VISA+GST+TCS TAX",
        },
      ],
    },

    terms: [],

    images: [
      "/images/thailand/day-1.jpg",
      "/images/thailand/day-2.jpg",
      "/images/thailand/day-3.jpg",
      "/images/thailand/day-4.jpg",
      "/images/thailand/day-5.jpg",
    ],
  },

  {
    title: "Singapore",
    slug: "",
    price: "INR 97,600/-",
    days: "06 Nights / 07 Days",
    rating: "",
    image: "",
    location: "Singapore",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "06 Nights / 07 Days",
        places: "Singapore",
      },

      pills: [
        "06 Nights Accommodation",
        "Breakfast",
        "Private Transfers",
        "English Speaking Guide",
      ],

      highlights: [
        "Merlion Park",
        "Chinatown",
        "Little India",
        "Orchard Road",
        "Marina Bay Sands SkyPark",
        "Gardens by the Bay",
        "Flower Dome",
        "Cloud Forest",
        "Jurassic World: The Exhibition",
        "Sentosa Island",
        "Madame Tussauds Singapore",
        "Wings of Time",
        "Universal Studios Singapore",
        "Singapore Zoo",
        "Night Safari Singapore",
      ],

      experiences: [
        {
          title: "Sentosa Island Experience",
          desc: "One-way cable car via Mt. Faber Line, Madame Tussauds Singapore 4-in-1 combo and Wings of Time.",
        },
        {
          title: "Universal Studios Singapore",
          desc: "Standard admission ticket.",
        },
        {
          title: "Singapore Zoo & Night Safari",
          desc: "Private combined visit with admission and tram ride.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Singapore",
        desc: "Upon arrival in Singapore, you will be greeted and transferred to your hotel on a private basis. After check-in, the rest of the day is free at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "City Tour & Marina Bay Attractions",
        desc: "Start your day with a private half-day city tour (3 hours) accompanied by an English-speaking guide. Visit Merlion Park, Chinatown, Little India, and Orchard Road. Later, proceed for your private visit to the Marina Bay Sands SkyPark and Gardens by the Bay, including Flower Dome and Cloud Forest with Jurassic World: The Exhibition.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Sentosa Island Experience",
        desc: "Enjoy a full-day private tour to Sentosa Island. Begin with a scenic one-way cable car ride via the Mt. Faber Line. Continue with entry to Madame Tussauds Singapore 4-in-1 combo. In the evening, enjoy Wings of Time with standard seating.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Universal Studios Singapore",
        desc: "Spend an exciting day at Universal Studios Singapore with your standard admission ticket.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Singapore Zoo & Night Safari",
        desc: "Experience Singapore Zoo and Night Safari Singapore with a private combined visit, admission and tram ride.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Day at Leisure",
        desc: "This day is free for you to explore Singapore at your own pace.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Departure",
        desc: "After breakfast, check out from your hotel and proceed with your private transfer to the airport for your departure from Singapore.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "06 Nights hotel accommodation along with Breakfast",
        "PVT Return airport transfer [apt-Htl-apt]",
        "PVT Half day city tour with English Speaking Guide [3 hrs]",
        "PVT Sentosa Tour – include admission + 1 way cable car (Mt Faber line) + Madam Tussad 4-1 Combo + wings of times (Standard seat)",
        "PVT Universal Studios – standard admission ticket",
        "PVT Combined Pvt Combine Singapore Zoo + Night Safari with adm + tram ride",
        "PVT Combine Marina Bay Sands Deck + Garden by the Bay with Flower Dome + Cloud Forest (with Jurassic World: The Exhibition) with 02 way transfers",
        "Travel Insurance",
        "Singapore Visa",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "All flights tickets",
        "Personal Expenses",
        "Tips to drivers & guides (At the discretion of guests, not compulsory)",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Novotel Singapore On Kitchener",
        city: "Singapore",
        nights: "6",
        meal: "Breakfast",
        room: "Superior Room",
      },
    ],

    pricing: {
      note: "",
      options: [
        {
          category: "Adult",
          price: "INR 97,600/-",
        },
      ],
    },

    terms: [],

    images: [],
  },

  {
    title: "Thailand Gateway - Krabi Phuket",
    slug: "thailand-gateway-krabi-phuket",
    price: "INR 66000 PP FOR WEBSITE",
    days: "",
    rating: "4.9",
    image: "/images/gateway/day-1.jpg",
    location: "Krabi, Phuket",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "",
        places: "Krabi, Phuket",
      },

      pills: [
        "4 Island Tour",
        "Rain Forest Tour",
        "Tiger Kingdom",
        "Phi Phi Island Tour",
        "Airport Transfers",
      ],

      highlights: [
        "4 Island Tour",
        "Hot Spring Waterfall",
        "Emerald Pool",
        "Tiger Cave",
        "Tiger Kingdom",
        "Maya Bay",
        "Khai Island",
      ],

      experiences: [
        {
          title: "4 Island Tour",
          desc: "4 Island tour by Speed Boat with Lunch (National Park Fee Included) (Pier Transfers on Pvt).",
        },
        {
          title: "Rain Forest Tour",
          desc: "One Day Rain Forest Tour covering Hot Spring Waterfall, Emerald Pool and Tiger Cave with Lunch.",
        },
        {
          title: "Phi Phi Island Tour",
          desc: "Phi Phi Island tour, Maya Bay & Khai Island tour with Lunch by Speed Boat (National Park Fee Included) (Pier Transfers on Pvt).",
        },
      ],
    },

    itinerary: [],

    pointsToRemember: [],

    inclusions: {
      included: [
        "4 Island tour 8 by Speed Boat with Lunch (National Park Fee Included) (Pier Transfers on Pvt) Pvt PVT",
        "One Day Rain Forest Tour 2 (Hot Spring Waterfall + Emerald Pool + Tiger Cave) with Lunch (NPF Inc.) PVT",
        "Tiger Kingdom 2 (Medium/Small Size Tiger) (Age 16+ only) Pvt PVT",
        "Phi Phi Island tour 122 Maya Bay & Khai Island tour with Lunch by Speed Boat (National Park Fee Included) (Pier Transfers on Pvt) PVT",
        "3 Way HKT Apt to Krabi Hotel to Phuket Hotel to HKT Apt",
      ],

      excluded: [],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Holiday Ao Nang Beach Resort, Krabi",
        city: "Krabi",
        nights: "3",
        meal: "",
        room: "2 Double Bed + 1 Extra Bed / FAMILY GARDEN VIEW",
      },
      {
        hotel: "Diamond Cliff Resort & Spa",
        city: "Phuket",
        nights: "3",
        meal: "",
        room: "2 Double Bed + 1 Extra Bed / SUPER DELUXE SEA VIEW",
      },
    ],

pricing: {
  rows: [
    {
      category: "Double Bed CPA",
      price: "550.70 USD",
      unit: "",
    },
    {
      category: "Adult Extra Bed CPA",
      price: "462.60 USD",
      unit: "",
    },
    {
      category: "Grand Total",
      price: "2,665.41 USD",
      unit: "",
    },
    {
      category: "Website Price",
      price: "INR 66000 PP FOR WEBSITE",
      unit: "per person",
    },
  ],
  note: "",
},

    terms: [],

    images: [
      "/images/gateway/day-1.jpg",
      "/images/gateway/day-2.jpg",
      "/images/gateway/day-3.jpg",
      "/images/gateway/day-4.jpg",
      "/images/gateway/day-5.jpg",
      "/images/gateway/day-6.jpg",
      "/images/gateway/day-7.jpg",
    ],
  },

  {
    title: "Explore Srilanka",
    slug: "explore-srilanka",
    price: "INR 68,500/-",
    days: "05 Nights / 06 Days",
    rating: "4.9",
    image: "/images/srilanka/day-3.jpg",
    location: "Kandy, Nuwara Eliya, Ella, Bentota, Colombo",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "05 Nights / 06 Days",
        places: "Kandy, Nuwara Eliya, Ella, Bentota, Colombo",
      },

      pills: [
        "05 Nights Accommodation",
        "Breakfast & Dinner",
        "English-speaking Chauffeur Guide",
        "Travel Insurance",
      ],

      highlights: [
        "Pinnawala Elephant Orphanage",
        "Temple of the Sacred Tooth Relic",
        "International Gem Museum & Lapidary",
        "Kandy Cultural Dance Show",
        "Ramboda Waterfall",
        "Tea Plantation & Tea Factory",
        "Seetha Amman Temple",
        "Gregory Lake Park",
        "Victoria Park",
        "Scenic Hill Country Train Ride",
        "Nine Arch Bridge",
        "Bentota Beach",
        "Madu River Boat Safari",
        "Kosgoda Turtle Hatchery",
        "Galle Face Green",
        "Independence Square",
        "Lotus Tower",
        "Port City waterfront",
      ],

      experiences: [
        {
          title: "Kandy Experience",
          desc: "Pinnawala Elephant Orphanage, Temple of the Sacred Tooth Relic, International Gem Museum & Lapidary and Kandy Cultural Dance Show.",
        },
        {
          title: "Scenic Train Experience",
          desc: "Afternoon train from Ambewela to Ella through tea plantations, mist-covered mountains, pine forests, tunnels, bridges and rolling countryside landscapes.",
        },
        {
          title: "Bentota & Colombo",
          desc: "Madu River Boat Safari, Kosgoda Turtle Hatchery and Colombo experiences.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival – Colombo – Kandy",
        desc: "Arrival at Bandaranaike International Airport. Meet & greet by your personal chauffeur-guide. Proceed to Kandy. Visit Pinnawala Elephant Orphanage. Check-in at hotel & relax. Evening sightseeing in Kandy including Temple of the Sacred Tooth Relic, International Gem Museum & Lapidary and Kandy Cultural Dance Show. Optional evening stroll around Kandy Lake. Overnight stay in Kandy.",
        tags: [],
      },
      {
        day: "02",
        title: "Kandy – Nuwara Eliya",
        desc: "Breakfast at hotel & check-out. Proceed to Nuwara Eliya via the scenic hill country route. Visit Ramboda Waterfall, Tea Plantation & Tea Factory and Seetha Amman Temple. Check-in at hotel. Evening leisure by the town center or Gregory Lake area. Overnight stay in Nuwara Eliya.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "Nuwara Eliya Sightseeing – Afternoon Train Ride – Ella",
        desc: "Breakfast at hotel & check-out. Visit Gregory Lake Park, Victoria Park and colonial surroundings and local market area. Proceed to Ambewela Railway Station and board the afternoon train from Ambewela to Ella. Your chauffeur-guide will collect you from Ella Railway Station. Visit Nine Arch Bridge and enjoy leisure time in Ella. Overnight stay in Ella.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Ella – Bentota",
        desc: "Breakfast at hotel & check-out. Proceed to Bentota via the scenic southern route. Enjoy breathtaking mountain-to-coastal landscape transitions and optional photo stops at waterfalls and viewpoints. Check-in at beach resort & relax. Evening leisure at Bentota Beach. Overnight stay in Bentota.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Bentota – Colombo",
        desc: "Breakfast at hotel & check-out. Enjoy a Madu River Boat Safari through mangroves, small islands, and traditional village surroundings. Visit the Kosgoda Turtle Hatchery. Proceed to Colombo. Check-in at hotel. Optional Colombo experiences include shopping, Galle Face Green, Independence Square, Lotus Tower exterior and Port City waterfront. Overnight stay in Colombo.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Colombo – Departure",
        desc: "Breakfast at hotel. Depending on flight timing, enjoy leisure or last-minute shopping. Transfer to Bandaranaike International Airport for departure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [],

    inclusions: {
      included: [
        "Accommodation at hotels mentioned on above Breakfast & Dinner basis.",
        "Transportation in a Micro Flat Roof Van.",
        "Entrance Fees to Temple of the Tooth, Pinnawala Elephant Orphanage, Seeta Amman Temple, Victoria Park, Gregory Lake, Turtle Hatchery, Madu River Boat Safari and Ambewela to Ella Train Ride as scheduled.",
        "Service of an English-speaking chauffeur guide.",
        "All Taxes + Government charges.",
        "Around-the-clock support is available at the airport.",
        "Two 500ml water bottles are provided per person per day.",
        "Benefit from free public liability insurance coverage valued at $3 million per person for the entire round tour in case of an incident.",
        "VISA Fees",
        "Travel Insurance",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "Meals and Snacks (extra meals / not mentioned in inclusions)",
        "Entrance / Activity fees",
        "Any additional meals not specified above",
        "Video camera permits",
        "Any other transport not mentioned in the itinerary",
        "Any other services not mentioned above",
        "Early check-in/check-out",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [
        "High tea experience",
        "Horse riding",
        "Café hopping",
        "Strawberry farms",
        "Ayurvedic spa treatments",
        "Riverfront dining",
        "Beach clubs & cafés",
        "Shopping at Colombo malls & local boutiques",
        "Optional rooftop dining or café experience",
      ],
    },

    accommodation: [
      {
        hotel: "Grand Kandyan 5*",
        city: "Kandy",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "Deluxe",
      },
      {
        hotel: "Araliya Green City 5*",
        city: "Nuwara Eliya",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "Superior",
      },
      {
        hotel: "Newburgh Ella 5*",
        city: "Ella",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "Bronze Tip",
      },
      {
        hotel: "Blue Water Resort & Spa 5*",
        city: "Bentota",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "Deluxe",
      },
      {
        hotel: "Cinnamon Lakeside 5*",
        city: "Colombo",
        nights: "1",
        meal: "Breakfast & Dinner",
        room: "Superior",
      },
    ],

pricing: {
  rows: [
    {
      category: "Price Per Person Sharing DBL",
      price: "INR 68,500/-",
      unit: "per person",
    },
  ],
  note: "Minimum based 04 adults",
},

    terms: [],

    images: [
      "/images/srilanka/day-1.jpg",
      "/images/srilanka/day-2.jpg",
      "/images/srilanka/day-3.jpg",
      "/images/srilanka/day-4.jpg",
      "/images/srilanka/day-5.jpg",
      "/images/srilanka/day-6.jpg",
    ],
  },

  {
    title: "Wonderful New Zealand",
    slug: "wonderful-new-zealand",
    price: "INR 1,90,000/- + 5% TCS",
    days: "13 Nights / 14 Days",
    rating: "4.9",
    image: "/images/wonderful/day-1.jpg",
    location: "Auckland, Rotorua, Queenstown, Mount Cook, Christchurch, Kaikoura",
    nextDate: "11 Dec 25",

    highlightsData: {
      locationCard: {
        meta: "13 Nights / 14 Days",
        places: "Auckland, Waiheke Island, Rotorua, Queenstown, Mount Cook, Christchurch, Kaikoura",
      },

      pills: [
        "13 Nights / 14 Days",
        "Travel Insurance",
        "GST Included",
        "Adventure Activities",
      ],

      highlights: [
        "Sky Tower Admission",
        "Waiheke Island",
        "Waitomo Glowworm Caves",
        "Kaituna White Water Rafting",
        "Polynesian Spa",
        "Shotover Jetboat Ride",
        "Skyline Gondola Ride + 3 Luge",
        "Individual Shark Ride",
        "Kawarau Bungy + Nevis Swing Combo",
        "Onsen Hot Pools",
        "Alpine Vista Heli Flight",
        "Tandem Skydive 16,500ft",
        "Whale Watch Kaikoura",
      ],

      experiences: [
        {
          title: "Waiheke Island",
          desc: "Auckland to Waiheke Island and return to Auckland.",
        },
        {
          title: "Waitomo Glowworm Caves",
          desc: "Guided tour of the Waitomo Glowworm Caves.",
        },
        {
          title: "Queenstown Adventure",
          desc: "Shotover Jetboat Ride, Skyline Gondola Ride with 3 Luge, Individual Shark Ride, Kawarau Bungy + Nevis Swing Combo and Onsen Hot Pools.",
        },
        {
          title: "Mount Cook Adventure",
          desc: "Alpine Vista Heli Flight for 20 minutes and Tandem Skydive from 16,500ft.",
        },
        {
          title: "Kaikoura Whale Watching",
          desc: "Whale Watch Tour using Ocean Cabin.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival Auckland",
        desc: "Arrival in Auckland.",
        tags: [],
      },
      {
        day: "02",
        title: "Auckland – Waiheke Island – Auckland",
        desc: "Visit Waiheke Island from Auckland and return to Auckland.",
        tags: [],
      },
      {
        day: "03",
        title: "Auckland to Rotorua via Waitomo",
        desc: "Travel from Auckland to Rotorua via Waitomo. Enjoy the Waitomo Glowworm Caves Guided Tour.",
        tags: [],
      },
      {
        day: "04",
        title: "Rotorua",
        desc: "Kaituna White Water Rafting – Grade 5 followed by a Deluxe Romantic Package at Polynesian Spa.",
        tags: [],
      },
      {
        day: "05",
        title: "Rotorua to Queenstown",
        desc: "Transfer from Rotorua to Queenstown.",
        tags: [],
      },
      {
        day: "06",
        title: "Queenstown",
        desc: "Shotover Jetboat Ride followed by Skyline Gondola Ride + 3 Luge.",
        tags: [],
      },
      {
        day: "07",
        title: "Queenstown",
        desc: "Individual Shark Ride, Kawarau Bungy + Nevis Swing Combo and Original Onsen Exclusive Indoor Pool.",
        tags: [],
      },
      {
        day: "08",
        title: "Queenstown",
        desc: "No specific activity is listed in the itinerary for this day.",
        tags: [],
      },
      {
        day: "09",
        title: "Queenstown to Mount Cook",
        desc: "Travel from Queenstown to Mount Cook.",
        tags: [],
      },
      {
        day: "10",
        title: "Mount Cook",
        desc: "Alpine Vista Heli Flight for 20 minutes and Tandem Skydive from 16,500ft.",
        tags: [],
      },
      {
        day: "11",
        title: "Mount Cook to Christchurch",
        desc: "Travel from Mount Cook to Christchurch.",
        tags: [],
      },
      {
        day: "12",
        title: "Christchurch – Kaikoura – Christchurch",
        desc: "Travel from Christchurch to Kaikoura for Whale Watch Tour – Ocean Cabin, then return to Christchurch.",
        tags: [],
      },
      {
        day: "13",
        title: "Christchurch at Leisure",
        desc: "Day at leisure in Christchurch.",
        tags: [],
      },
      {
        day: "14",
        title: "Depart Christchurch by Rental Car",
        desc: "Depart Christchurch by rental car. End of services.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Skyline Queenstown complex is undergoing construction and the Luge operation may open as late as 12pm on weekdays.",
      "All flights require a minimum number of passengers for departures.",
      "Prices are subject to availability at the time of booking.",
      "Full names of all passengers, ages of children if applicable, passenger weights if applicable and full flight details including New Zealand domestic flights are required for booking.",
      "Adventure activities may involve inherent risks and operators provide a Risk Disclosure statement.",
      "Any deposit requirement will be advised at the time of booking.",
      "One amendment is permitted without a service fee; supplier fees may apply.",
      "Subsequent amendments incur an NZD 100 fee per file.",
      "Amendments made within 7 days of arrival incur an NZD 200 fee per file.",
      "Full payment must be received no later than 15 days prior to travel.",
      "Cancellations between 10 days and 72 hours of arrival incur NZD 500 per person plus applicable supplier cancellation charges.",
      "Cancellations within 72 hours of arrival incur a 100% cancellation fee.",
    ],

    inclusions: {
      included: [
        "Accommodation as specified",
        "Meals as specified",
        "Sightseeing and attractions as specified",
        "Arrival documents",
        "Auckland to Waiheke ferry one way",
        "Travel Insurance",
        "GST included",
      ],

      excluded: [
        "International or Domestic Airfares",
        "Any optional services quoted separately",
        "Any items or services not specified in the itinerary",
        "Early or late check-out of rooms unless specified",
        "Gratuities",
        "Personal items",
        "TCS 5% Extra (Refundable against PAN card)",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [],

    pricing: {
      rows: [
        {
          category: "Per Person",
          price: "INR 1,90,000/- + 5% TCS",
          unit: "per person",
        },
      ],
      note: "",
    },

    terms: [
      "Prices are subject to availability of services at the time of booking.",
      "Full payment must be received no later than 15 days prior to travel.",
    ],

    images: [
      "/images/wonderful/day-1.jpg",
      "/images/wonderful/day-2.jpg",
      "/images/wonderful/day-3.jpg",
      "/images/wonderful/day-4.jpg",
      "/images/wonderful/day-5.jpg",
      "/images/wonderful/day-6.jpg",
      "/images/wonderful/day-7.jpg",
      "/images/wonderful/day-8.jpg",
      "/images/wonderful/day-9.jpg",
      "/images/wonderful/day-10 to 14.jpg",
      
    ],
  },

  {
    title: "Explore Italy",
    slug: "explore-italy",
    price: "INR 3,98,000/- + TCS",
    days: "15 Nights / 16 Days",
    rating: "",
    image: "",
    location: "Milan, Canazei, Florence, Rome, Naples, Amalfi",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "15 Nights / 16 Days",
        places: "Milan, Canazei, Florence, Rome, Naples, Amalfi",
      },

      pills: [
        "15 Nights / 16 Days",
        "Breakfast",
        "Travel Insurance",
        "Train / Bus Tickets",
      ],

      highlights: [
        "Lake Como",
        "Varenna",
        "Bellagio",
        "Como",
        "Dolomite Surroundings",
        "Rifugio Friedrich August",
        "Florence Rooftop Cooking Class",
        "Iris Galerie",
        "Regoli Pasticceria",
        "Crazy Pizza Roma",
        "Fuffa Factory",
        "The Oddity Patch Bar",
        "Frigidarium",
        "Two Sizes",
        "Vecchia Trastevere",
        "Capri",
        "Anacapri",
        "Blue Grotto",
        "Pompeii",
        "Sorrento",
        "Positano",
        "Amalfi",
      ],

      experiences: [
        {
          title: "Lake Como",
          desc: "Full-day tour from Milan covering Varenna, Bellagio and Como.",
        },
        {
          title: "Florence Cooking Class",
          desc: "Florence Rooftop Cooking Class with a 360-degree view of the city.",
        },
        {
          title: "Capri & Blue Grotto",
          desc: "Day tour from Naples covering Capri, Anacapri and Blue Grotto.",
        },
        {
          title: "Amalfi Coast",
          desc: "Pompeii, Sorrento and Positano drive from Amalfi.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrive in Milan",
        desc: "Arrive in Milan, explore the city at leisure and overnight stay in Milan.",
        tags: [],
      },
      {
        day: "02",
        title: "Lake Como Full Day Tour",
        desc: "Lake Como Full Day Tour from Milan covering Varenna, Bellagio and Como.",
        tags: [],
      },
      {
        day: "03",
        title: "Milan to Canazei",
        desc: "Check out and travel by train/bus to Canazei. Explore the alpine village and Dolomite surroundings on your own.",
        tags: [],
      },
      {
        day: "04",
        title: "Canazei",
        desc: "Visit Rifugio Friedrich August for mountain views and a traditional alpine lunch on your own.",
        tags: [],
      },
      {
        day: "05",
        title: "Canazei to Florence",
        desc: "Check out and travel to Florence. Enjoy coffee at a traditional wine window and explore the historic center on your own.",
        tags: [],
      },
      {
        day: "06",
        title: "Florence",
        desc: "Join the Florence Rooftop Cooking Class with 360-degree view of the city.",
        tags: [],
      },
      {
        day: "07",
        title: "Florence to Rome",
        desc: "Travel to Rome. Visit Iris Galerie, enjoy pastries at Regoli Pasticceria and dine at Crazy Pizza Roma. Explore the city on your own.",
        tags: [],
      },
      {
        day: "08",
        title: "Rome",
        desc: "Explore Rome, shop at Fuffa Factory and The Oddity Patch Bar, and enjoy gelato from Frigidarium. Day free for shopping.",
        tags: [],
      },
      {
        day: "09",
        title: "Rome",
        desc: "Continue exploring Rome, indulge in tiramisu from Two Sizes and dinner at Vecchia Trastevere. Day free for shopping.",
        tags: [],
      },
      {
        day: "10",
        title: "Rome to Naples",
        desc: "Check out and take a train to Naples. Explore the historic center and waterfront on your own.",
        tags: [],
      },
      {
        day: "11",
        title: "Naples",
        desc: "Enjoy authentic Neapolitan pizza at L'Antica Pizzeria da Michele and continue sightseeing in Naples on your own.",
        tags: [],
      },
      {
        day: "12",
        title: "Capri, Anacapri & Blue Grotto",
        desc: "Capri, Anacapri and Blue Grotto Day Tour from Naples.",
        tags: [],
      },
      {
        day: "13",
        title: "Naples to Amalfi",
        desc: "Check out and transfer by taxi to Amalfi. Enjoy a relaxing evening by the coast.",
        tags: [],
      },
      {
        day: "14",
        title: "Pompeii, Sorrento & Positano",
        desc: "Pompeii, Sorrento and Positano drive from Amalfi.",
        tags: [],
      },
      {
        day: "15",
        title: "Amalfi",
        desc: "Relax in Amalfi, explore nearby coastal villages and enjoy gelato at Royal Gelato on your own.",
        tags: [],
      },
      {
        day: "16",
        title: "Departure",
        desc: "Check out and transfer by taxi to Naples airport for your flight back to India.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "Prices are subject to availability and may change at the time of booking.",
    ],

    inclusions: {
      included: [
        "15 Nights accommodation along with Breakfast",
        "Return airport transfers on private basis from Milan airport to hotel and Naples hotel to Naples airport",
        "Lake Como Full Day Tour from Milan – Varenna, Bellagio and Como",
        "Florence Cooking Class with 360 Degree View of the City",
        "Pompeii, Sorrento Positano Drive from Amalfi",
        "Private taxi transfers from Naples to Amalfi coast & return",
        "Travel Insurance",
        "GST",
        "Train/Bus tickets 2nd class",
        "Milan to Canazei",
        "Canazei to Florence",
        "Florence to Rome",
        "Rome to Naples",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "Air ticket",
        "Visa",
        "Tips",
        "Anything not mentioned in the inclusions",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Crowne Plaza Milan Linate",
        city: "Milan",
        nights: "2",
        meal: "Breakfast",
        room: "Standard Room",
      },
      {
        hotel: "Croce Bianca Leisure & Spa",
        city: "Canazei",
        nights: "2",
        meal: "Breakfast",
        room: "Superior Double Room",
      },
      {
        hotel: "Grand Hotel Baglioni",
        city: "Florence",
        nights: "2",
        meal: "Breakfast",
        room: "Standard Room",
      },
      {
        hotel: "Crowne Plaza St. Peters",
        city: "Rome",
        nights: "3",
        meal: "Breakfast",
        room: "Standard Room",
      },
      {
        hotel: "Ramada By Wyndham Naples",
        city: "Naples",
        nights: "3",
        meal: "Breakfast",
        room: "Standard Room",
      },
      {
        hotel: "Marina Riviera",
        city: "Amalfi",
        nights: "3",
        meal: "Breakfast",
        room: "Standard Room",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Per Person",
          price: "INR 3,98,000/- + TCS (Refundable)",
          unit: "per person",
        },
      ],
      note: "",
    },

    terms: [],

    images: [],
  },

  {
    title: "Jewels of East Europe",
    slug: "jewels-of-east-europe",
    price: "EURO 1280 PER PERSON",
    days: "07 Nights / 08 Days",
    rating: "",
    image: "",
    location: "Vienna, Budapest, Bratislava, Prague, Salzburg, Hallstatt, Munich",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "07 Nights / 08 Days",
        places: "Austria, Hungary, Slovakia, Czech Republic, Germany",
      },

      pills: [
        "07 Nights / 08 Days",
        "Superior 4-Star Hotels",
        "Daily Continental Breakfast",
        "Tour Manager",
        "Indian Jain / Veg / Non-Veg Meals",
      ],

      highlights: [
        "Schönbrunn Palace",
        "Vienna City Tour",
        "Budapest City Tour",
        "Danube River Cruise",
        "Szentendre",
        "Bratislava Castle",
        "Bratislava Old Town",
        "Prague Castle",
        "Charles Bridge",
        "Old Town Square",
        "Astronomical Clock",
        "Kutna Hora",
        "Salzburg",
        "Hallstatt",
        "Dachstein Glacier",
        "Ice Palace",
        "Stairway to Nothingness",
        "Suspension Bridge",
      ],

      experiences: [
        {
          title: "Vienna",
          desc: "Guided city tour of Vienna and visit to Schönbrunn Palace.",
        },
        {
          title: "Budapest",
          desc: "Guided city tour, Danube River cruise and orientation tour of Szentendre.",
        },
        {
          title: "Prague",
          desc: "Guided city tour, Prague Castle viewing gallery and Kutna Hora.",
        },
        {
          title: "Dachstein Glacier",
          desc: "Cable car to Dachstein Glacier with Ice Palace, Stairway to Nothingness and Suspension Bridge.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrive in Vienna",
        desc: "Arrive at Vienna Airport, meet the representative and transfer to the hotel. In the evening, enjoy dinner before returning to the hotel.",
        tags: [{ label: "Dinner" }],
      },
      {
        day: "02",
        title: "Vienna to Budapest",
        desc: "Guided Vienna city tour covering Ringstrasse, Vienna Opera House and St. Stephen’s Cathedral. Visit Schönbrunn Palace. Enjoy Indian lunch and free time before proceeding to Budapest. Dinner at an Indian restaurant.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "03",
        title: "Discovering Budapest",
        desc: "Guided Budapest city tour covering Buda Castle, Hungarian Parliament and Heroes’ Square. After lunch, enjoy a Danube River cruise followed by an orientation visit to Szentendre.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "04",
        title: "Budapest – Bratislava – Prague",
        desc: "Travel to Bratislava and enjoy an orientation tour covering Bratislava Castle and the Old Town. Continue to Prague after lunch.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "05",
        title: "Discover Prague",
        desc: "Guided Prague city tour covering Prague Castle, Charles Bridge, Old Town Square and Astronomical Clock. Visit the castle viewing gallery and drive to Kutna Hora.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "06",
        title: "Prague – Salzburg",
        desc: "Travel to Salzburg. Enjoy a guided tour covering the birthplace of Mozart, Hohensalzburg Fortress and Mirabell Palace.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "07",
        title: "Salzburg – Hallstatt – Schladming – Munich",
        desc: "Drive to Hallstatt and explore the village. Continue to Schladming and experience Dachstein Glacier via cable car, including the Ice Palace, Stairway to Nothingness and Suspension Bridge. Continue to Munich.",
        tags: [
          { label: "Breakfast" },
          { label: "Lunch" },
          { label: "Dinner" },
        ],
      },
      {
        day: "08",
        title: "Fly Back Home",
        desc: "Check out and depart for Munich Airport.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "A person below 12 years of age on the entire tour will be considered a child.",
      "As a 3rd person in a triple room, most hotels use rollaway beds and room size may be the same as the double room.",
      "Tours operate subject to all Government regulations.",
      "All local taxes, entrances and services are calculated as on 1st October 2024; increases are payable by the traveller/agent.",
      "All transfers and extensive sightseeing with specified entrance fees will be done in an air-conditioned coach.",
      "One check-in bag and one hand bag per person are suggested due to limited boot space.",
      "Services of a Tour Manager or local representatives are provided while on tour.",
      "Land surcharges may apply on certain departure dates.",
      "Tour routing may change or operate in reverse itinerary on certain departure dates.",
      "No refunds for unutilized services.",
      "Additional taxes in Europe may result in a change in price.",
    ],

    inclusions: {
      included: [
        "Superior 4-star hotel accommodation",
        "Daily Continental buffet breakfast",
        "06 Indian Jain/Vegetarian/Non-Vegetarian lunches",
        "07 Indian Jain/Vegetarian/Non-Vegetarian dinners",
        "Daily 500ml mineral water bottle per person",
        "Driver tips",
        "Professional Tour Manager",
        "Guided City tour of Vienna",
        "Schönbrunn Palace",
        "Guided City tour of Salzburg",
        "Dachstein Glacier Cable Car",
        "Ice Palace",
        "Stairway to Nothingness",
        "Suspension Bridge",
        "Guided City tour of Budapest",
        "Danube River Cruise",
        "Orientation tour of Szentendre",
        "Orientation Tour of Bratislava",
        "Guided City tour of Prague",
        "Prague Castle viewing Gallery",
        "Kutna Hora",
      ],

      excluded: [
        "Airfare",
        "Passport",
        "POE charges",
        "Visa charges",
        "Overseas Travel Insurance",
        "Personal expenses such as porterage, laundry, alcohol, food/drink outside regular menus, minibar and telephone calls",
        "Extra meals not included in itinerary",
        "Excursions, city sightseeing, entrance fees and local guides other than specified inclusions",
        "GST, TCS and other applicable taxes",
        "Anything not specified in the itinerary",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "",
        city: "Vienna",
        nights: "1",
        meal: "",
        room: "4-Star Hotel",
      },
      {
        hotel: "",
        city: "Budapest",
        nights: "2",
        meal: "",
        room: "4-Star Hotel",
      },
      {
        hotel: "",
        city: "Prague",
        nights: "2",
        meal: "",
        room: "4-Star Hotel",
      },
      {
        hotel: "",
        city: "Salzburg",
        nights: "1",
        meal: "",
        room: "4-Star Hotel",
      },
      {
        hotel: "",
        city: "Munich",
        nights: "1",
        meal: "",
        room: "4-Star Hotel",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Per Person",
          price: "EURO 1280",
          unit: "per person",
        },
      ],
      note: "Cost per person payable in EURO out of BTQ entitlement",
    },

    terms: [
      "Tours are operated subject to Reserve Bank of India / Government of India regulations.",
      "Tour cost is payable in EURO out of the passenger's BTQ entitlement.",
    ],

    images: [],
  },

  {
    title: "Switzerland With Paris",
    slug: "switzerland-with-paris",
    price: "Adult: Rs. 2,30,950/- per person",
    childPrice: "Rs. 1,12,950/- per person",
    days: "07 Nights / 08 Days",
    rating: "",
    image: "",
    location: "Lucerne, Interlaken, Paris",
    nextDate: "24 May 2025",

    highlightsData: {
      locationCard: {
        meta: "02 Nights Lucerne + 02 Nights Interlaken + 03 Nights Paris",
        places: "Lucerne, Interlaken, Paris",
      },

      pills: [
        "07 Nights / 08 Days",
        "Swiss Flexi Pass",
        "Breakfast",
        "Travel Insurance",
      ],

      highlights: [
        "Lake Lucerne Catamaran Cruise",
        "Mount Titlis",
        "Jungfraujoch",
        "Paris Seine River Sightseeing Cruise",
        "Paris Hop-on Hop-off Tour",
        "Eiffel Tower",
        "Disneyland Paris",
        "Louvre Museum",
      ],

      experiences: [
        {
          title: "Mount Titlis",
          desc: "Full-day visit to Mount Titlis from Lucerne.",
        },
        {
          title: "Jungfraujoch",
          desc: "Full-day visit to Jungfraujoch from Interlaken.",
        },
        {
          title: "Paris Sightseeing",
          desc: "Seine River sightseeing cruise, Hop-on Hop-off tour and Eiffel Tower visit.",
        },
        {
          title: "Disneyland Paris",
          desc: "Full-day visit to Disneyland Paris.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival – Zurich – Lucerne",
        desc: "Arrive at Zurich Airport and travel to Lucerne by train. Evening Lake Lucerne catamaran cruise. Overnight at Lucerne.",
        tags: [],
      },
      {
        day: "02",
        title: "Lucerne – Mount Titlis",
        desc: "Full-day visit to Mount Titlis. Overnight at Lucerne.",
        tags: [],
      },
      {
        day: "03",
        title: "Lucerne to Interlaken",
        desc: "Travel from Lucerne to Interlaken by train. Rest of the day free for leisure or own activities. Overnight at Interlaken.",
        tags: [],
      },
      {
        day: "04",
        title: "Jungfraujoch",
        desc: "Full-day visit to Jungfraujoch. Overnight at Interlaken.",
        tags: [],
      },
      {
        day: "05",
        title: "Interlaken to Paris",
        desc: "Travel from Interlaken to Paris by train. Arrive in Paris and transfer to the hotel. Evening Seine River cruise. Overnight at Paris.",
        tags: [],
      },
      {
        day: "06",
        title: "Paris Sightseeing",
        desc: "Paris Hop-on Hop-off tour and Eiffel Tower visit. Overnight at Paris.",
        tags: [],
      },
      {
        day: "07",
        title: "Disneyland Paris",
        desc: "Free day with visit to Disneyland Paris. Overnight at Paris.",
        tags: [],
      },
      {
        day: "08",
        title: "Louvre Museum – Departure",
        desc: "Morning visit to Louvre Museum for a 2-hour tour starting at 10:30 AM. Afternoon transfer to the airport for the return flight.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "TCS 5% applicable to total land package cost and refundable against PAN Card.",
      "The quoted hotel rooms were shown as blocked in the booking confirmation.",
      "The package is for 03 adults + 01 child aged 09 years, with 01 room.",
    ],

    inclusions: {
      included: [
        "02 Nights accommodation at Lucerne",
        "02 Nights accommodation at Interlaken",
        "03 Nights accommodation at Paris",
        "03 Days Swiss Flexi Pass (2nd class)",
        "Interlaken to Paris by train (2nd class)",
        "Lake Lucerne Catamaran Cruise",
        "Visit Mount Titlis in Lucerne",
        "Visit Jungfrauch in Interlaken",
        "Basel to Paris Train Ticket (2nd class)",
        "Bateaux Parisiens – Seine River Sightseeing Cruise with Audio guide",
        "Hop on Hop off tour in Paris",
        "Eiffel Tower Skip-The-Queue Ticket with Audio Guide Commentary (2nd floor)",
        "Full Day Visit to Disneyland",
        "Visit Louvre Museum",
        "Paris station to Paris Hotel transfers on private basis",
        "Paris Hotel to Paris Airport transfers on private basis",
        "Travel Insurance",
        "GST",
      ],

      excluded: [],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Monopole 4*",
        city: "Lucerne",
        nights: "2",
        meal: "",
        room: "Family Room",
      },
      {
        hotel: "Weisses Kreuz 3***",
        city: "Interlaken",
        nights: "2",
        meal: "",
        room: "Family Room",
      },
      {
        hotel: "Hotel Mercure Paris Centre Tour Eiffel 4****",
        city: "Paris",
        nights: "3",
        meal: "",
        room: "Jr. Suite Room",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Adult",
          price: "Rs. 2,30,950/-",
          unit: "per person",
        },
        {
          category: "Adult (14 Years)",
          price: "Rs. 2,06,025/-",
          unit: "per person",
        },
        {
          category: "Child (09 Years)",
          price: "Rs. 1,12,950/-",
          unit: "per person",
        },
      ],
      note: "",
    },

    terms: [],

    images: [],
  },

  {
    title: "Mauritius",
    slug: "magical-mauritius",
    price: "INR 1,38,300/- + TCS",
    days: "06 Nights / 07 Days",
    rating: "4.9",
    image: "/images/magical/day-1.jpg",
    location: "Mauritius",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "06 Nights / 07 Days",
        places: "Mauritius",
      },

      pills: [
        "06 Nights / 07 Days",
        "Breakfast & Dinner",
        "Private Transfers",
        "Travel Insurance",
      ],

      highlights: [
        "Port Louis",
        "Citadelle Fortress",
        "Caudan Waterfront",
        "Trou aux Cerfs",
        "Grand Bassin",
        "23 Colored Earth",
        "Seaplane Activity",
        "Casela Adventure Park",
        "Ile Aux Cerfs",
        "Belle Mare",
      ],

      experiences: [
        {
          title: "North Island Tour",
          desc: "Port Louis City Tour, Citadelle Fortress, Caudan Waterfront and Jumbo Mall.",
        },
        {
          title: "South Island Tour",
          desc: "Trou aux Cerfs Crater, Grand Bassin Sacred Lake & Shiv Temple and 23 Colored Earths.",
        },
        {
          title: "Ile Aux Cerfs",
          desc: "Full-day Ile Aux Cerfs excursion with combined speedboat and land transfers.",
        },
        {
          title: "Casela Adventure Park",
          desc: "Casela Adventure Park entrance included.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Mauritius",
        desc: "Arrival in Mauritius, transfer to hotel and check-in. Rest of the day at leisure.",
        tags: [],
      },
      {
        day: "02",
        title: "North Tour",
        desc: "Full-day North Island tour covering Port Louis City Tour, Citadelle Fortress and Caudan Waterfront.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "03",
        title: "South Tour",
        desc: "Full-day South Island tour covering Trou aux Cerfs, Grand Bassin and 23 Colored Earth.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "04",
        title: "Seaplane Activity – Casela Adventure Park – Hotel Change",
        desc: "Check out and proceed for a seaplane activity. Continue to Casela Adventure Park where entrance is included. Transfer to Radisson Blu Azuri Beach Resort & Spa and check in.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "05",
        title: "Ile Aux Cerfs Tour",
        desc: "Full-day excursion to Ile Aux Cerfs with speedboat transfer. Enjoy the beaches and optional water activities at Belle Mare.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "06",
        title: "Day at Leisure",
        desc: "Free day at leisure to relax at the resort or explore nearby areas.",
        tags: [{ label: "Breakfast" }],
      },
      {
        day: "07",
        title: "Departure",
        desc: "Check out and transfer to the airport for departure.",
        tags: [{ label: "Breakfast" }],
      },
    ],

    pointsToRemember: [
      "No booking has been held at this time.",
    ],

    inclusions: {
      included: [
        "06 Nights accommodation along with Breakfast & Dinner",
        "Meet and assist at the airport",
        "Return airport transfers on private basis",
        "North Tour to Citadelle Fortress, Caudan Waterfront via Port Louis City Tour and Jumbo Mall on private basis",
        "South Tour to Trou aux Cerfs Crater, Grand Bassin Sacred Lake & Shiv Temple and 23 Colored Earths on private basis",
        "Ile Aux Cerf Tour with water activities on own at Belle Mare, Ile aux Cerfs Island, combined speedboat transfers and land transfers on private basis",
        "Travel Insurance",
        "GST",
      ],

      excluded: [
        "TCS 2% (Refundable against PAN card)",
        "All flight tickets",
        "Personal Expenses",
        "Tips to drivers & guides",
      ],
    },

    supplementaryTours: {
      note: "",
      items: [
        "Tube Ride",
      ],
    },

    accommodation: [
      {
        hotel: "Outrigger Beach Resort & Spa 4*",
        city: "Mauritius",
        nights: "4",
        meal: "Breakfast & Dinner",
        room: "Ocean View King Room",
      },
      {
        hotel: "Radisson Blu Azuri Beach Resort & Spa 5*",
        city: "Mauritius",
        nights: "2",
        meal: "Breakfast & Dinner",
        room: "Premium Garden Room",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Airfare Per Adult",
          price: "INR 1,38,300/- + TCS (Refundable)",
          unit: "per person",
        },
      ],
      note: "",
    },

    terms: [],

    images: [
      "/images/magical/day-1.jpg",
      "/images/magical/day-2.jpg",
      "/images/magical/day-3.jpg",
      "/images/magical/day-4.jpg",
      "/images/magical/day-5.jpg",
      "/images/magical/day-6.jpg",
      "/images/magical/day-7.jpg",
     
    ],
  },

  {
    title: "Magnificent Maldives",
    slug: "magical-mauritius",
    price: "INR 87,700/-",
    days: "04 Nights / 05 Days",
    rating: "4.9",
    image: "/images/maldives/day-1.jpg",
    location: "Maldives",
    nextDate: "",

    highlightsData: {
      locationCard: {
        meta: "04 Nights / 05 Days",
        places: "Maldives",
      },

      pills: [
        "04 Nights / 05 Days",
        "Beach Villa",
        "All Meals",
        "Shared Speed Boat Transfers",
      ],

      highlights: [
        "Villa Nautica Paradise Island",
        "Beach Villa",
        "All Meals",
        "Shared Speed Boat Airport Transfers",
      ],

      experiences: [
        {
          title: "Maldives Island Stay",
          desc: "Stay at Villa Nautica Paradise Island in a Beach Villa with all meals included.",
        },
      ],
    },

    itinerary: [
      {
        day: "01",
        title: "Arrival in Maldives",
        desc: "Airport transfer by shared speed boat to Villa Nautica Paradise Island.",
        tags: [],
      },
      {
        day: "02",
        title: "Maldives",
        desc: "Day at the resort.",
        tags: [],
      },
      {
        day: "03",
        title: "Maldives",
        desc: "Day at the resort.",
        tags: [],
      },
      {
        day: "04",
        title: "Maldives",
        desc: "Day at the resort.",
        tags: [],
      },
      {
        day: "05",
        title: "Departure",
        desc: "Shared speed boat airport transfer.",
        tags: [],
      },
    ],

    pointsToRemember: [
      "2% TCS (Tax Collection at Source) is applicable for all payments.",
      "Compulsory PAN Card & Passport copy is required for all guests.",
      "Rates are subject to USD fluctuation at the time of booking and payment.",
      "Rooms and rates are subject to availability and may change at the time of confirmation.",
    ],

    inclusions: {
      included: [
        "04 Nights accommodation at Villa Nautica Paradise Island",
        "Beach Villa",
        "All Meals",
        "Airport Transfers by Shared Speed Boat",
      ],

      excluded: [],
    },

    supplementaryTours: {
      note: "",
      items: [],
    },

    accommodation: [
      {
        hotel: "Villa Nautica Paradise Island",
        city: "Maldives",
        nights: "4",
        meal: "All Meals",
        room: "Beach Villa",
      },
    ],

    pricing: {
      rows: [
        {
          category: "Total Cost",
          price: "INR 87,700/-",
          unit: "",
        },
      ],
      note: "",
    },

    terms: [
      "Rates are subject to USD fluctuation at the time of booking & payment.",
      "Rooms and rates are subject to availability and may change at the time of confirmation.",
    ],

    images: [
      "/images/maldives/day-1.jpg",
      "/images/maldives/day-2.jpg",
      "/images/maldives/day-3.jpg",
      "/images/maldives/day-4.jpg",
      "/images/maldives/day-5.jpg",
    ],
  },


];



